// USA
export const locale = {
  lang: 'en',
  data: {
    // Sample dashboard without sign-up, /demo (#20261023-090014).
    DEMO: {
      TAG: 'Sample',
      BAR: "You're viewing {{company}}, a fictitious company with {{employees}} employees. This is how yours would look.",
      BAR_ARIA: 'Sample dashboard',
      NAV_ARIA: 'Sample dashboard pages',
      CREATE_SPACE: 'Create my space →',
      KEEP_EXPLORING: 'Keep exploring',
      SAVE_BLOCKED: {
        TITLE: 'To save, create your space',
        TEXT: "It takes a minute. No bank details or contracts. Everything you set up will be yours.",
      },
    },
    // "View with sample data" switch in the header (#20261023-090014).
    SAMPLE_DATA: {
      TOGGLE: 'View with sample data',
      TAG: 'Sample data',
      HOME_NOTE: 'This is how your company will look with your workforce on board.',
      TURN_OFF: 'Remove',
    },
    // Free trial: banners, lock screen, header status tag and invitation confirmation (#20261023-090010).
    TRIAL: {
      BANNER: {
        WARNING: '<strong>Your trial ends on {{date}}</strong> · {{days}} days left. To keep using WAIIS, complete your account.',
        WARNING_ONE: '<strong>Your trial ends on {{date}}</strong> · 1 day left. To keep using WAIIS, complete your account.',
        PARTNER: '<strong>Your trial ends on {{date}}</strong> · {{days}} days left. {{partner}} will get in touch with you to continue.',
        PARTNER_ONE: '<strong>Your trial ends on {{date}}</strong> · 1 day left. {{partner}} will get in touch with you to continue.',
        COMPLETE: '<strong>Account complete.</strong> The Incentives Plan starts on {{date}}, when your trial ends.',
        ENDED: '<strong>Your trial ended on {{date}}.</strong> Complete your account to see your dashboard again.',
        CTA: 'Complete account',
      },
      LOCK: {
        TITLE: 'Your trial ended on {{date}}',
        TEXT: 'Get in touch with us to continue with <strong>{{company}}</strong>. In the meantime, your employees can keep using the app.',
        PARTNER_TEXT: '{{partner}} will get in touch with you to activate the annual plan for <strong>{{company}}</strong>. In the meantime, your employees can keep using the app.',
        CONTACT_TITLE: 'Your contact at WAIIS',
        TEAM: 'Team',
        TEAM_NAME: 'Business support',
        EMAIL: 'Email',
        PHONE: 'Phone',
        BOOK_CALL: 'Book a call',
        COMPLETE_ACCOUNT: 'Complete my account',
        YOUR_COMPANY: 'your company',
        MANAGER_TITLE: 'Your manager at {{partner}}',
        MANAGER_NAME: 'Name',
      },
      CALENDLY: {
        TITLE: 'Book a call',
        FRAME_TITLE: 'Calendar to book a call with WAIIS',
        CLOSE: 'Close',
      },
      TAG: {
        PRE_LAUNCH: 'Trial · starts when you add employees',
        DAYS_LEFT: 'Trial · {{days}} days left',
        DAYS_LEFT_ONE: 'Trial · 1 day left',
        PLAN_FROM: 'Incentives Plan · from {{date}}',
        ENDED: 'Trial ended',
        ACTIVE: 'Incentives Plan · active',
        PARTNER_DAYS_LEFT: 'Trial · {{days}} days left · {{partner}}',
        PARTNER_DAYS_LEFT_ONE: 'Trial · 1 day left · {{partner}}',
        PARTNER_ENDED: 'Trial ended · {{partner}} will contact you',
        PARTNER_ACTIVE: 'Annual plan · managed by {{partner}}',
      },
      // Provisional texts until Adri's (confirmation title and green box).
      INVITE: {
        TITLE: 'Send the invitation to {{count}} people',
        TITLE_ONE: 'Send the invitation to 1 person',
        TEXT: 'They will receive the email with the link to the app.',
        TEXT_ONE: 'They will receive the email with the link to the app.',
        TRIAL_STARTS: 'Your 3-month free trial starts here, not before. No commitment, no minimum term.',
        CONFIRM: 'Send invitations',
        CANCEL: 'Not yet',
        TRIAL_BOX: '<strong>3 months</strong> of unlimited trial, no commitment.',
      },
    },
    // Welcome tutorial (#20261023-090014). Own-tutorial step texts are provisional until Adri's (E2).
    WELCOME_TOUR: {
      NEXT: 'Next',
      PREV: 'Back',
      FINISH: 'Finish',
      NOT_NOW: 'Not now',
      SKIP: 'Skip',
      CLOSE: 'Close the tutorial',
      STEP_OF: 'Step {{n}} of {{total}}',
      CREATE_SPACE: 'Create my space',
      KEEP_EXPLORING: 'Keep exploring',
      OVERVIEW_ALT: 'The six Home indicators over the map',
      OWN: {
        INTRO: {
          TITLE: 'Welcome, {{company}}',
          META: 'About 5 minutes · No billing details',
          TEXT: "We'll show you where everything is and the steps to get WAIIS up and running in your company.",
          START: 'Start setting up',
        },
      },
      JOINUP: {
        INTRO: {
          TITLE: 'Welcome, {{company}}',
          META: 'About 2 minutes',
          TEXT: '{{partner}} has set up your space and manages your account. Here you follow your workforce’s participation and its results.',
          START: 'See my space',
        },
      },
      STEPS: {
        PILLS: {
          TITLE: 'Your indicators, over the map',
          TEXT: 'At a glance: CO₂ avoided, linked employees, passengers per trip, last month’s trips and routines in the last 24 h, for the whole company or one office.',
        },
        HEADQUARTERS: {
          TITLE: 'Add your head office',
          TEXT: 'Type its address and save it: that’s how we place your company on the map.',
        },
        GUIDE: {
          TITLE: 'Getting set up',
          TEXT: 'Three steps: your head office, your workforce and participation. They tick themselves off as you do them, and here you see how many you’ve done.',
        },
        EMPLOYEES: {
          TITLE: 'Add your workforce',
          TEXT: 'In Employees you upload a CSV with your workforce or add each person by hand. They get the link to the app.',
        },
        USAGE: {
          TITLE: 'Participation, in Usage',
          TEXT: 'How many employees use WAIIS, how many trips they share and how it evolves.',
        },
        TRAVEL: {
          TITLE: 'Your workforce’s trips',
          TEXT: 'Every shared journey, with its origin, its destination and who travels.',
        },
        OFFICES: {
          TITLE: 'Create your offices',
          TEXT: 'In Settings you add your workplaces to follow the participation of each one.',
        },
        OVERVIEW: {
          TITLE: 'Overview',
          TEXT: 'On Home, six indicators over the map sum up how WAIIS is doing in the company.',
        },
        DEMO_EMPLOYEES: {
          TITLE: 'Employees',
          TEXT: 'The company’s workforce: who has linked up in the app and from which office.',
        },
        FUNNEL: {
          TITLE: 'Funnel',
          TEXT: 'From the invitation to the first shared trip: where employees drop off along the way.',
        },
        PMST: {
          TITLE: 'PMST',
          TEXT: 'The sustainable commuting plan, built with the company’s data. Want it with yours?',
        },
      },
    },
    // Company "Getting set up" guide (#20261023-090014).
    LAUNCH_GUIDE: {
      PANEL_TITLE: 'Your first steps',
      PROGRESS: '{{done}} of {{total}} steps done. Carry on with the next one.',
      ALL_DONE: 'All three steps are done: your company is up and running.',
      STEP_DONE: 'Done',
      VIEW_TOUR: 'View the tutorial',
      LOADING: 'Loading your setup progress',
      STEPS: {
        HEADQUARTERS: {
          TITLE: 'Where is your head office?',
          TEXT: "That's how we place your company on the Home map and you'll see your workforce's journeys.",
          ACTION: 'Add the head office',
        },
        EMPLOYEES: {
          TITLE: 'Add your workforce',
          TEXT: 'Upload a CSV with your employees or add them by hand. They get the link to the app.',
          ACTION: 'Upload CSV',
        },
        PARTICIPATION: {
          TITLE: 'Measure participation',
          TEXT: 'Once your employees link up in the app, Usage will show how many take part and how they travel.',
          ACTION: 'View Usage',
        },
      },
    },
    // Modalidad de transporte de fraude_pooling_route_labels (equipo de datos).
    FRAUD_DATA: {
      CURRENT_DECISION_HINT: "Current",
      ORIGIN: {
        MANUAL: "Manual",
        AUTO_SCORE: "Automatic score",
        AUTO_SCORE_VALUE: "Score {{score}}",
        PVP_BONUS: "PVP bonus",
        UNKNOWN: "—",
      },
      INTRO_TITLE: 'Scores, signals and decision on each account',
      INTRO_TEXT: 'Scores and signals are sent by the data team. In the <strong>Decision</strong> column you choose what to do with the account. Click a user to open their profile, or a trip to see its route.',
      ADD_USER: 'Add user',
      ADD_SUBTITLE: 'Find them and choose a decision. They will appear in Blocks.',
      CLOSE: 'Close',
      ADD_SEARCH_PLACEHOLDER: 'Name, email or ID...',
      ADD_SEARCH_ARIA: 'Search user',
      SEARCHING_USERS: 'Searching users',
      NO_USER_MATCH: 'No user matches “{{term}}”.',
      TABLE_ARIA: 'Table',
      TABS: {
        USERS: 'Users',
        TRIPS: 'Trips',
        PAIRS: 'Collusion',
        WHITELIST: "Whitelist",
        REINFORCED: "Reinforced",
        REINFORCED_NO_COST: "Reinforced + no free trips",
        HISTORY: "History",
      },
      SEARCH_PLACEHOLDER: 'User, email or ID...',
      SEARCH_ARIA: 'Search',
      FROM_TRIP: 'Trip from',
      FROM: 'From',
      TO: 'To',
      MIN_SCORE: 'Min. score',
      MAX_SCORE: 'Max. score',
      SEGMENT: 'Segment',
      DECISION: 'Decision',
      SORT: 'Sort',
      HIGH_SIGNAL: "High risk only",
      UNPAID_ONLY: 'Unpaid money only',
      GROUP_BY_USER: 'Group by user',
      NO_SCORE: 'No score',
      ONLY_CURRENT_DECISION: 'Current decision only',
      ONLY_CURRENT_SCORE: 'Current score only',
      MIN_COLLUSION: 'Min. collusion',
      ONLY_CURRENT_PAIR: 'Latest value only',
      CLEAR_FILTERS: 'Clear filters',
      DATE_RANGE_INVALID: 'The “To” date cannot be earlier than “From”.',
      SCORE_RANGE_INVALID: 'The maximum score cannot be lower than the minimum.',
      LOADING: 'Loading…',
      COLS: {
        WITH: 'With',
        COLLUSION: 'Collusion',
        TRIPS_TOGETHER: 'Trips together',
        RECEIVED_AT: 'Date',
        USER: 'User',
        SCORE_FROM: 'Score since',
        SCORE: 'Score',
        SIGNALS: "Signals",
        SEGMENT: 'Segment',
        DECISION: 'Decision',
        DATE: 'Date',
        ROUTE: 'Route',
        ROLE: 'Role',
        PASSENGERS: 'Passengers',
        MONEY: 'Money',
        MODE: 'Mode',
        FINAL_DECISION: 'Final decision',
        PERIOD: 'Period',
        DECIDED_BY: 'Decided by',
        NOTE: 'Note',
        SINCE: "Since",
        ADDED_BY: "Added by",
        ORIGIN: "Origin",
      },
      HISTORY_UNTIL: 'History · until {{date}}',
      GROUP: 'Group {{group}}',
      TRIPS_COUNT_ONE: '{{count}} trip',
      TRIPS_COUNT_OTHER: '{{count}} trips',
      DRIVER: 'Driver',
      PASSENGER: 'Passenger',
      DRIVER_LABEL: 'Driver:',
      NO_MATCH: 'No match',
      NO_PRICE: 'No price',
      UNTIL: 'until {{date}}',
      FREE_TRIP: 'Free trip',
      PAST_DECISION_HINT: 'History: their current decision is in another row',
      NO_END: 'no end',
      AUTOMATIC: 'Automatic',
      PREV: 'Previous',
      NEXT: 'Next',
      RETRY: 'Retry',
      NO_RESULTS_FILTERS: 'No results with these filters.',
      NO_DATA: 'No data yet.',
      NOT_CALCULATED: 'not calculated',
      LOAD_ERROR: 'Could not load the data.',
      ALL_M: 'All',
      ALL_F: 'All',
      SORT_RECENT: 'Most recent',
      SORT_SIGNAL: "Highest risk first",
      SEGMENTS: {
        TRIP_IP_COLLUSION: 'Trip + IP + collusion',
        TRIP_IP: 'Trip + IP',
        TRIP_COLLUSION: 'Trip + collusion',
        TRIP: 'Trip',
        VALID: 'Valid',
      },
      DECISIONS: {
        ALLOW: 'Not fraud',
        REINFORCED_VERIFICATION: 'Enhanced verification',
        BLACKLIST: 'Blacklist',
        WHITELIST: "Whitelist",
      },
      SIGNALS: {
        MOBILITY_GPS: {
          SHORT: "GPS",
          TITLE: "GPS coverage",
          LEGEND_TITLE: "GPS coverage",
          TEXT: "% of driven trips with good GPS coverage (over 70% of the minutes with a valid point).",
        },
        COLLISION: {
          SHORT: "Collusion",
          TITLE: "Collusion",
          LEGEND_TITLE: "Collusion with passengers",
          TEXT: "% of this driver's passengers they do not seem independent from (collusion over 90, with at least 3 days of data). On a trip, it is the average of its driver-passenger pairs.",
        },
        COPRESENCE: {
          SHORT: "Co-presence",
          TITLE: "Co-presence",
          LEGEND_TITLE: "Driver-passenger co-presence",
          TEXT: "% of trips where every passenger proves they were with the driver.",
        },
        NETWORK_IP: {
          SHORT: "Network/IP",
          TITLE: "Network / IP",
          LEGEND_TITLE: "Shared IP",
          TEXT: "% of trips where the driver shares an IP with a passenger.",
        },
        ELIGIBLE_TRANSPORT: {
          SHORT: "Transport",
          TITLE: "Eligible transport",
          LEGEND_TITLE: "Eligible transport",
          TEXT: "% of trips made on a mode that earns CAE, out of those with map coverage.",
        },
      },
      PANEL: {
        PAIRS_TITLE: 'Collusion by pair',
        PAIRS_SUBTITLE: 'Pairs who, according to the data team, do not seem to be independent people. Higher = worse.',
        PAIRS_ITEMS: 'pairs',
        SCORES_TITLE: 'Users with a fraud score',
        SCORES_SUBTITLE: 'Score and signals sent by the data team. Click a user to open their profile.',
        SCORES_ITEMS: 'users',
        ROUTES_TITLE: 'Trips with fraud signals',
        ROUTES_SUBTITLE: 'Signals for each trip and the status of its money. Click a trip to see its route.',
        ROUTES_ITEMS: 'trips',
        BLOCKS_TITLE: "Decision history",
        BLOCKS_SUBTITLE: "Every decision on each account, including old ones and «No fraud»: what, who and when.",
        BLOCKS_ITEMS: "decisions",
        WHITELIST_TITLE: "Whitelist",
        WHITELIST_SUBTITLE: "Protected accounts: we know they commit fraud but we let them use the app. They never move to reinforced verification, neither by hand nor by their score.",
        WHITELIST_ITEMS: "users",
        REINFORCED_TITLE: "Reinforced verification",
        REINFORCED_SUBTITLE: "Who is under reinforced verification today and why.",
        REINFORCED_ITEMS: "users",
        REINFORCED_NO_COST_TITLE: "Reinforced + no free trips",
        REINFORCED_NO_COST_SUBTITLE: "Who is under reinforced verification and also without free trips today, and why: by hand or after cashing the full-price (PVP) bonus.",
        REINFORCED_NO_COST_ITEMS: "users",
      },
      PAGINATION: 'Showing {{shown}} of {{total}} {{items}}',
      PAGINATION_NO_TOTAL: 'Showing {{shown}} {{items}}',
      PAYOUT: {
        PAID: 'Paid',
        HELD: 'Held',
        UNPAID: 'Not collected',
      },
      DECISION_LEGEND: {
        TITLE: "What does each decision mean?",
        SUBTITLE: "What happens to the user with each option of the «Decision» dropdown.",
        NO_FRAUD: {
          TITLE: "No fraud",
          TEXT: "No restrictions: trips are paid and withdrawals work as usual, and they can invite at no cost. If a new score of {{score}} or more arrives, they move to reinforced verification.",
        },
        WHITELIST: {
          TITLE: "Whitelist",
          TEXT: "We know they commit fraud, but we let them. They use the app as «No fraud» and are never put under reinforced verification, neither by hand nor by their score.",
        },
        REINFORCED: {
          TITLE: "Reinforced verification",
          TEXT: "Trips are credited to the driver {{tripDays}} days after verification, withdrawals wait {{withdrawalDays}} days and the minimum withdrawal is {{minPayout}}. Set by hand or automatically with score ≥ {{score}}.",
        },
        REINFORCED_NO_COST: {
          TITLE: "Reinforced + no free trips",
          TEXT: "Same as reinforced verification and, on top, they cannot give or redeem free trips.",
        },
      },
      ACTIVE_RULES: {
        TITLE: "Active rules",
        AUTO_ON: "Users with <strong>score ≥ {{score}}</strong> move to reinforced verification automatically (except the whitelist).",
        AUTO_OFF: "Automatic reinforced verification by score is off.",
        REINFORCED: "Under reinforced verification, trips are credited to the driver after {{tripDays}} days, withdrawals wait {{withdrawalDays}} days and the minimum withdrawal is {{amount}}.",
        FREE_INVITE_ON: "They can still invite at no cost.",
        FREE_INVITE_OFF: "They cannot invite at no cost.",
        EDIT: "Change in Settings",
        REVIEW_DUE: "The minimum score ({{score}}) has not been reviewed for {{days}} days. Check whether it needs changing.",
        REVIEW_NEVER: "The minimum score ({{score}}) has never been reviewed. Check that it is right.",
        REVIEWED_ON: "Minimum score reviewed on {{date}}.",
        SUBTITLE: "What applies today under reinforced verification. Changed in Settings.",
        TILE_SCORE: "Automatic reinforced",
        TILE_SCORE_HINT: "With this score or more, the account moves to reinforced on its own (except the whitelist).",
        TILE_SCORE_OFF_HINT: "New scores do not put anyone under reinforced.",
        TILE_OFF: "Off",
        TILE_TRIP: "Driver payout",
        TILE_TRIP_HINT: "From when the trip is verified.",
        TILE_WITHDRAWAL: "Withdrawals",
        TILE_WITHDRAWAL_HINT: "How long a withdrawal waits before it is paid.",
        TILE_MIN: "Minimum withdrawal",
        TILE_MIN_HINT: "While under reinforced.",
        TILE_FREE: "Free trips",
        TILE_FREE_ON: "Allowed",
        TILE_FREE_OFF: "Blocked",
        TILE_FREE_HINT: "«Reinforced + no free trips» always blocks them.",
        DAYS: "{{days}} days",
      },
      WHITELIST_ADD: {
        OPEN: "Add to whitelist",
        TITLE: "Add users to the whitelist",
        HELP: "Search by name, email or ID and press «Add»; each one becomes «Whitelist» from now on.",
        IDS_PLACEHOLDER: "0990e311-1ca9-4117-9a89-88bcf1f1019b\n85ab1ced-4260-486f-a0f9-93dff87617ec",
        IDS_ARIA: "User IDs",
        NOTE_PLACEHOLDER: "Note (optional): why they are whitelisted",
        COUNT: "{{count}} users",
        SUBMIT: "Add to whitelist",
        ADDING: "Adding…",
        ADDED: "Added: {{count}}",
        ALREADY: "Already there: {{count}}",
        NOT_FOUND: "Not found: {{count}}",
        NOT_FOUND_HINT: "IDs not found were left in the box to review them.",
        TOO_MANY: "At most 1000 users at once.",
        ERROR: "Could not add them. Try again.",
        PICK: "Add",
        PICKED: "Selected",
        ALREADY_IN: "Already whitelisted",
        REMOVE_ARIA: "Remove {{name}}",
        PASTE_TOGGLE: "Or paste IDs",
        PASTE_HELP: "User IDs, one per line (commas or spaces also work).",
      },
      SIGNAL_RISK_TITLE: "{{signal}}: {{value}} ({{direction}})",
      SIGNAL_DIRECTION: {
        BETTER: "higher is better",
        WORSE: "higher is worse",
      },
      LEGEND: {
        BETTER_TAG: "↑ better",
        WORSE_TAG: "↑ worse",
        SCORE_NOTE: "The score is a review priority, not a probability: 90 or 100 = shared IP (trip_ip); 70 or 80 = collusion (trip_collusion). The higher value of each pair is when the generated CAE is over €100.",
        TITLE: 'What does each signal mean?',
        SUBTITLE: "What each signal measures and how to read its %: for some, higher is better; for others, worse.",
        HIDE: 'Hide',
        SHOW: 'Show details',
        SCALE_TITLE: "The colour is the risk of each signal, already read in its direction:",
        LOW: "Fine",
        MEDIUM: "Review",
        HIGH: "Risk",
        NOT_CALCULATED: 'Not calculated',
      },
      DECISION_SELECT: {
        ARIA: 'Decision on {{name}}',
        NO_DECISION: 'No decision',
        STATES: {
          NO_FRAUD: 'Not fraud',
          REINFORCED: 'Enhanced verification',
          REINFORCED_NO_COST: 'Enhanced + no zero-cost',
          BLACKLIST: 'Blacklist',
          WHITELIST: "Whitelist",
          NO_COST_ONLY: 'No zero-cost',
        },
        CONFIRM_TITLE: 'Change to “{{label}}”?',
        NOTE_PLACEHOLDER: 'Note (optional): why you are making this decision',
        NOTE_ARIA: 'Optional note',
        CONFIRM: 'Yes, change',
        CANCEL: 'Cancel',
        SAVING: 'Saving…',
        SAVED: 'Saved',
        SAVE_ERROR: 'Could not save the decision. Try again.',
        WHITELIST_LOCKED: "This user is whitelisted and cannot be put under reinforced verification. Move them to another decision first.",
        CONFIRM_RELIEF: "Yes, continue",
        WARN_LEAVES_FRAUD: "They leave reinforced verification: payouts and withdrawals go back to normal.",
        WARN_LEAVES_FRAUD_AND_COST: "They leave reinforced verification and can use free trips again, even if they were blocked by the PVP bonus.",
        WARN_REGAINS_COST: "They can use free trips again, even if they were blocked by the PVP bonus.",
      },
      TRANSPORT_MODE: {
        car: 'Car',
        motorbike: 'Motorbike',
        bus: 'Bus',
        train: 'Train',
        metro: 'Metro',
        tram: 'Tram',
        bike: 'Bike',
        scooter: 'Scooter',
        walk: 'On foot',
        taxi: 'Taxi',
        plane: 'Plane',
        unknown: 'Unknown',
      },
    },
    // Mismas claves (en minúsculas) que `en.json` de la app móvil, bajo
    // `routines.route.tracking`: la tarjeta de trayecto del chat de soporte
    // trae esas rutas completas en `alertTitleKey`/`alertMessageKey`/
    // `alertSuggestionKey`. Sin ellas, el dashboard en este idioma enseña la
    // clave tal cual (QA WS-2169). Mismo bloque que en `es.ts`.
    routines: {
      route: {
        tracking: {
          rejection_reason: {
            location_data_missing: 'Your phone did not share its location during the trip.',
            origin_not_confirmed: 'We did not detect your phone at the departure point at the time of the trip.',
            destination_not_confirmed: 'We did not detect your arrival at the destination.',
            location_trace_incomplete: 'We lost your phone\'s signal partway through the trip.',
            route_not_compatible: 'The route does not look like it was made by car.',
            copresence_not_confirmed: 'We could not confirm you were travelling in the same car.',
            multiple_devices: 'This trip was recorded from several phones at once.',
            mock_location: 'The location we received from your phone was not the real one.',
            network_failed: 'Your phone\'s connection did not let us check where you were.',
            trip_limit: 'You have reached the maximum number of rewardable trips for this period.',
            pattern_review: 'We are reviewing this trip because it does not look like the ones you usually take.',
            competitor_app: 'You have another carpooling app installed, and a trip can only be rewarded in one.',
            shared_with_riders: 'We could not confirm that you and your passengers made the trip together.',
            shared_with_driver: 'We could not confirm that you made the trip with your driver.',
            location_permission_missing: 'Your phone did not have permission to share its location during the trip.',
          },
          rejection_suggestion: {
            location_data_missing: 'For your next trip, check that WAIIS has location permission set to "Always" and that your phone has an internet connection.',
            origin_not_confirmed: 'For your next trip, check that location is set to "Always" and that you have an internet connection before leaving.',
            destination_not_confirmed: 'For your next trip, keep location active and an internet connection until you reach the destination.',
            location_trace_incomplete: 'For your next trip, avoid closing the app or turning on battery saver.',
            route_not_compatible: 'Remember that only trips made by car are rewarded.',
            copresence_not_confirmed: 'Remember that the driver and the passengers must have location active and an internet connection for the whole trip.',
            multiple_devices: 'For your next trip, use one phone per person.',
            mock_location: 'For your next trip, turn off apps that fake your location.',
            network_failed: 'For your next trip, turn off VPN or proxy on your phone.',
            trip_limit: 'You will be able to earn rewards again when the next period starts.',
            pattern_review: 'You do not need to do anything: we will let you know when we are done.',
            competitor_app: 'Uninstall the other app so we can reward your next trips.',
            shared_with_riders: 'Remember that the driver and the passengers must have location active and an internet connection for the whole trip.',
            shared_with_driver: 'Remember that the driver and the passengers must have location active and an internet connection for the whole trip.',
            location_permission_missing: 'For your next trip, set WAIIS location permission to "Always" in your phone settings.',
            unknown: 'If you think this is a mistake, write to us and we will look into it.',
          },
          no_match: {
            unrealized: {
              title: 'Unverified trip',
              description: 'We could not confirm that this trip took place.',
            },
          },
          assigned: {
            unrealized: {
              title: 'Unverified trip',
              description: 'We could not confirm that this trip took place.',
            },
          },
        },
      },
    },
    PARTNER_SECTION: {
      READ_ONLY_USER_TITLE: 'You have read-only access',
      READ_ONLY_USER_TEXT: 'You can see everything in {{partner}}\'s companies, but not change anything.',
      MANAGED_BY_TITLE: 'This section is managed by {{partner}}',
      MANAGED_BY_TEXT: 'You can view it, but changes are made by {{partner}}.',
    },
    // Aviso de tickets de soporte creados por agentes (WS-2415).
    AGENT_TICKET_NOTICES: {
      TITLE_ONE: 'New support ticket created by an agent',
      TITLE_MANY: '<b>{{count}}</b> unseen support tickets from agents',
      OPEN: 'Click to open it',
      BADGE: '{{count}} unseen support tickets from agents',
    },
    SIDEBAR: {
      SESSION: 'Session',
      COLLAPSE_MENU: 'Collapse menu',
      EXPAND_MENU: 'Expand menu',
      CHANGE_COMPANY: 'Change company',
      PARTNER_ADMIN: 'Partner admin',
      ALL_CENTERS: 'All centers',
      MATCH_SECTION: 'Match',
      DASHBOARD: 'Dashboard',
      ECONOMIC_DASHBOARD: 'Economic Dashboard',
      ECONOMIC_REPORTS: 'Reports',
      ECONOMIC_MOVEMENTS: 'Movements',
      ECONOMIC_USERS: 'General Users',
      ECONOMIC_COMPANIES: 'Companies',
      CORPORATIONS: 'Companies',
      PARTNERS: 'Partners',
      PARTNER_REQUESTS: 'Requests',
      PARTNER_REQUESTS_NEW: '{{count}} new requests',
      MY_PARTNER: 'My partner',
      PARTNER_USERS: 'Users',
      PARTNER_PAYMENTS: 'Payment terms',
      ECONOMIC_COMPANY_USERS: 'Company Users',
      CORPORATION_USERS: 'Company Users',
      CORPORATION_OFFICES: 'Offices',
      LAYOUT_BUILDER: 'Layout Builder',
      USERS: 'Users',
      USERS_GENERIC: 'Users',
      REPORTS_SECTION: 'Waiis Reports',
      FUNNEL: 'Funnel',
      FUNNEL_WAIIS: 'Funnel Waiis',
      TRAVEL: 'Travel',
      TRAVELS: 'Travel',
      PARKING: 'Parking',
      SUSTAINABILITY: 'Sustainability',
      CONVERSION: 'Conversion',
      USAGE: 'Usage',
      CREDITS: 'Credits',
      PROVIDERS: 'Providers',
      COUPONS: 'Gift Cards',
      GIFT_CARDS: 'Gift Cards',
      CODES: 'Codes',
      PROMOTIONAL_CODES: 'Promotional Codes',
      PARKING_SECTION: 'Parking',
      PARKING_SPACES: 'Parking Spaces',
      PARKING_RESERVATIONS: 'Parking Reservations',
      PARKING_CREDITS: 'Parking Credits',
      COMMUNICATION: 'Communication',
      PUSH: 'Push',
      NOTIFICATIONS: 'Notifications',
      TRAINING: 'Training',
      TRAINING_RESOURCES: 'Resources',
      TRAINING_LAUNCH: 'Internal Launch',
      INTERNAL_LAUNCH: 'Internal Launch',
      RESOURCES: 'Resources',
      RESOURCES_POSTER: 'Posters',
      POSTERS: 'Posters',
      RESOURCES_VIDEO: 'Videos',
      VIDEOS: 'Videos',
      RESOURCES_GUIDE: 'Guides',
      GUIDES: 'Guides',
      RESOURCES_LAUNCH: 'Promo Launch Pack',
      PROMO_LAUNCH: 'Promo Launch Pack',
      RESOURCES_CAR: 'Promo Car Pack',
      PROMO_CAR: 'Promo Car Pack',
      RESOURCES_CHALLENGE: 'Challenge Pack',
      PROMO_CHALLENGES: 'Challenge Pack',
      ACTIVITY_MANAGEMENT: 'Activity management',
      ADMINISTRATION: 'Administration',
      MONEY: 'Money',
      INTERNAL_ADMIN: 'Internal admin',
      COMPANIES: 'Companies',
      OFFICES: 'Offices',
      SHIFTS: 'Shifts',
      INCENTIVES: 'Incentives',
      INCIDENTS: 'Incidents',
      COMPLAINTS: 'Incidents',
      WAIIS_USERS: 'WAIIS Users',
      FRAUD: 'Fraud',
      ADMIN_HOME: 'Home',
      TRAVEL_LIST: 'Travels',
      RIDES: 'VTC rides',
      RIDE_BOOKING_DESK: 'Group bookings',
      PAYOUT_REVIEWS: 'Withdrawals',
      SUPPORT: 'Support',
      AGENT_CONVERSATIONS: 'Agent history',
      MARKETING: 'Marketing',
      MARKETING_USERS: 'Marketing Users',
      EMAILS: 'Emails',
      PUSH_NOTIFICATIONS: 'Push notifications',
      REFERRALS: 'Referrals',
      PVP_PROMOS: 'Full price promo',
      PROMOS: 'Promotions',
      PROMOS_PVP: 'Full price (Fraud)',
      PROMOS_TRIPS: 'Trip promo',
      ZONE_ADS: 'Zone ads',
      ZONE_ADS_SETTINGS: 'Settings',
      ZONE_ADS_IMBALANCE: 'Imbalance report',
      ZONE_ADS_DRAFTS: 'Drafts',
      ZONE_ADS_TEMPLATES: 'Templates',
      FOOTPRINT_SECTION: 'Footprint',
      FOOTPRINT: 'Footprint',
      FOOTPRINT_RAW: 'Raw Footprint',
      TRAVEL_REVIEW: 'Travel Review',
      CORRIDORS_REVIEW: 'Corridors Review',
      MATCH_REVIEW: 'Routes Review',
      MATCHES_LISTING: 'Match list',
      MATCH_LIST: 'Match Variables',
      POIS: 'POIs',
      TAGS: 'Tags',
      CONFIGURATIONS: 'Configurations',
      CREDIT_TYPES: 'Credit Types',
      COMMISSIONS: 'Commissions',
      SUBSIDIES: 'Subsidies',
      PRICING_CONFIGS: 'Prices',
      SUBSIDY_CONSUMPTIONS: 'Subsidies',
      POOLING_RUNNERS: 'Pooling Runners',
      POOLING_RUNNERS_CONFIG: 'Runners',
      CORP_SECTION_PRINCIPAL: 'MAIN',
      CORP_SECTION_CARPOOLING: 'CARPOOLING',
      CORP_SECTION_TAXI_VTC: 'TAXI / VTC',
      CORP_SECTION_PARKING: 'PARKING',
      CORP_SECTION_ACCOUNT: 'ACCOUNT',
      CORP_LAUNCH_GUIDE: 'Getting set up · {{done}}/{{total}}',
      CORP_LAUNCH_GUIDE_TITLE: 'Getting set up',
      CORP_SUSTAINABILITY: 'Sustainability',
      CORP_HOME: 'Home',
      CORP_USAGE: 'Usage',
      CORP_EMPLOYEES: 'Employees',
      CORP_TRAVEL: 'Travel',
      CORP_FUNNEL: 'Funnel',
      CORP_INCENTIVES: 'Incentives',
      CORP_PMST: 'PMST',
      CORP_SUBSIDY: 'Subsidy',
      CORP_FLEET: 'Fleet',
      CORP_TAXI_RIDES: 'Rides and spend',
      CORP_TAXI_POLICY: 'Policy',
      CORP_TAXI_BOOKINGS: 'Bookings',
      CORP_TAXI_REVIEW: 'Review',
      CORP_SETTINGS: 'Settings',
      CORP_WALLET: 'Wallet',
      CORP_PLAN: 'Plan',
      ONBOARDING_LOCKED_HINT: 'Complete the setup to unlock',
      PLAN_READ_ONLY_HINT: 'Your access is read only',
      PLAN_LOCKED_HINT: 'This feature is not included in your current plan. Change plans to unlock it.',
      PMST_DISABLED_HINT: 'This company does not implement the PMST with WAIIS. You can change this answer in the company settings.',
      PLAN_UPGRADE_MODAL: {
        TITLE: 'Feature not available in your plan',
        TEXT: 'This section is part of the <strong>Incentives Plan</strong>. Upgrade your plan to unlock it and access all the dashboard benefits.',
        CONFIRM: 'View plans',
        CANCEL: 'Not now',
      },
      CORP_COMING_SOON: 'COMING SOON',
      CONFIG_VARIABLES: 'Configuration Variables',
      APP_ANNOUNCEMENT: "In-app announcement",
      FRAUD_RULES: 'Fraud rules',
      TERMS_CONDITIONS: 'Terms and Conditions of Use',
      CONTRACT_TEMPLATES: 'Contract template',
      DATA_PROCESSING_AGREEMENT: 'Data processing agreement (DPA)',
      PMST_GOAL_CONFIG: 'PMST Goals',
      PMST_QUESTIONNAIRE_CONFIG: 'PMST Form',
      PMST_QUESTIONNAIRE_RESPONSES: 'PMST Responses',
      RIDES_CONFIG: 'Rides',
      RIDES_CONFIG_SETTINGS: 'Settings',
      RIDES_CONFIG_GUEST_PHONES: 'Guest phones',
      RIDES_CONFIG_PROVIDERS: 'Providers',
      RIDES_CONFIG_PROVIDER_ROUTING: 'Routing by tag',
      RIDES_CONFIG_BOOKINGS: 'Group bookings',
      RIDES_CONFIG_REVIEW: 'Ride review',
      FACE_VERIFICATION_CONFIG: 'Face verification',
      CRAFTED: 'Crafted',
      PAGES: 'Pages',
      PROFILE: 'Profile',
      OVERVIEW: 'Overview',
      PROJECTS: 'Projects',
      CAMPAIGNS: 'Campaigns',
      DOCUMENTS: 'Documents',
      CONNECTIONS: 'Connections',
      WIZARDS: 'Wizards',
      HORIZONTAL: 'Horizontal',
      VERTICAL: 'Vertical',
      ACCOUNTS: 'Accounts',
      SETTINGS: 'Settings',
      ERRORS: 'Errors',
      ERROR_404: 'Error 404',
      ERROR_500: 'Error 500',
      WIDGETS: 'Widgets',
      LISTS: 'Lists',
      STATISTICS: 'Statistics',
      CHARTS: 'Charts',
      MIXED: 'Mixed',
      TABLES: 'Tables',
      FEEDS: 'Feeds',
      APPS: 'Apps',
      CHAT: 'Chat',
      PRIVATE_CHAT: 'Private Chat',
      GROUP_CHAT: 'Group Chat',
      DRAWER_CHAT: 'Drawer Chat',
      USER_MANAGEMENT: 'User Management',
      USERS_MANAGEMENT: 'Users',
      ROLES: 'Roles',
      PERMISSIONS: 'Permissions',
      USER_ROLE_CORPORATIONS: 'Users',
      AUTHORIZATION_DASHBOARD: 'Authorization Dashboard',
      APP_SECTION: 'APP',
      VALORATION_LABELS: 'Ratings',
      LABELS: 'User & route labels',
      PERMISSIONS_ERROR: 'Could not load permissions',
      RELOAD: 'Reload',
      NO_ACCESS: 'No access to any page',
      UNSEEN_CORPORATIONS: '{{count}} new companies not yet reviewed',
    },
    PAGES: {
      COMING_SOON: {
        ALT: 'Coming soon',
        TITLE: 'We\'re working on it!',
        TEXT: 'This section will be available soon.',
        THANKS: 'Thank you for your patience.',
      },
      VISIT_SURVEY: {
        DEFAULT_WHO: 'Workplace mobility survey',
        CENTER: 'Site: {{name}}',
        TITLE: 'Mobility survey',
        LEAD: 'For visitors, clients and suppliers. It helps us draw up the site\'s Sustainable Workplace Mobility Plan (PMST), in line with Law 9/2025. It takes less than 2 minutes and is anonymous.',
        Q1: '1. What is the main reason for your visit?',
        Q2: '2. How often do you visit our premises?',
        Q3: '3. From which postcode do you usually travel to reach our premises?',
        Q3_PLACEHOLDER: 'E.g. 08025',
        Q3_HINT: 'We do not ask for the exact address, for privacy reasons.',
        Q4: '4. What is the main means of transport you use to get to the site?',
        Q5: '5. Have you had any difficulty accessing or carrying out your activity at our premises?',
        Q6: '6. What measure do you think could improve access or mobility for this site?',
        SUBMIT: 'Submit answer',
        THANKS_TITLE: 'Thank you!',
        THANKS_TEXT: 'Your answer has been recorded and will help improve mobility at this site. You can close this window.',
        FOOT: 'WAIIS · Survey linked to the ATM for the PMST (Law 9/2025). Data processed in aggregate and anonymously.',
        OPT: {
          CLIENT: 'Client',
          SUPPLIER: 'Supplier',
          CARRIER: 'Carrier / Logistics',
          PARTNER: 'Partner company',
          MEETING: 'Work meeting',
          TECH: 'Technical service / maintenance',
          OTHER_M: 'Other',
          OTHER_F: 'Other',
          FIRST_TIME: 'First time',
          SEVERAL_YEAR: 'Several times a year',
          SEVERAL_MONTH: 'Several times a month',
          WEEKLY: 'Weekly',
          DAILY: 'Daily or almost daily',
          CAR: 'Car',
          VAN: 'Van',
          TRUCK: 'Truck',
          MOTORBIKE: 'Motorbike',
          PUBLIC_TRANSPORT: 'Public transport',
          CARPOOL: 'Shared car',
          BIKE: 'Bicycle',
          SCOOTER: 'Scooter',
          WALK: 'On foot',
          NONE: 'None',
          TRAFFIC: 'Traffic',
          NO_PARKING: 'Lack of parking',
          POOR_PT: 'Insufficient public transport',
          HARD_ACCESS: 'Difficult access',
          NO_LOADING: 'Lack of loading and unloading space',
          WAITING: 'Waiting times',
          BETTER_ACCESS: 'Better access organisation',
          MORE_PARKING: 'More parking',
          BETTER_PT: 'Better public transport connections',
          MORE_LOADING: 'More loading and unloading space',
          BETTER_SIGNS: 'Better signage',
          LESS_WAITING: 'Shorter waiting times',
        },
      },
      DASHBOARD: {
        TITLE: 'Dashboard',
        CORPORATIONS_SECTION: 'Companies',
        CORPORATION_OFFICES_SECTION: 'Corporate Offices',
        CREATE_CORPORATION_TITLE: 'New company onboarding',
        CREATE_CORPORATION_DESCRIPTION:
          'Create a new company by entering the basic details. You can continue configuring it afterwards from the dashboard.',
        CREATE_CORPORATION_BUTTON: 'Create company',
        NO_ACCESS: 'You do not have access to Companies or Offices',
        NO_ACCESS_SUBTITLE:
          'Contact the administrator if you think this is an error',
        ROLE_LABEL: 'Role:',
        ID_LABEL: 'ID:',
        COMPANY_LABEL: 'Company:',
        HUB: {
          TITLE: 'Where do you want to go?',
          SUBTITLE: 'Choose WAIIS administration or one of your companies and offices.',
          ADMIN_SECTION: 'Administration',
          ADMIN_CARD_TITLE: 'WAIIS Administration',
          ADMIN_CARD_META: 'Global platform management',
          PARTNER_SECTION: 'Partner',
          PARTNER_CARD_META: 'Partner admin · {{count}} company(ies)',
          CORPORATIONS_SECTION: 'Companies',
          OFFICES_SECTION: 'Offices',
          NEW_CORPORATION_SECTION: 'New company',
          CREATE_CARD_TITLE: 'Create company',
          CREATE_CARD_META: 'Register a new company on the platform',
          EMPTY_TITLE: 'No access assigned',
          EMPTY_SUBTITLE: 'Contact your administrator to get permissions.',
          NO_NAME: 'No name',
          UNKNOWN_CORPORATION: 'Unknown company',
          ROLE_FALLBACK: 'Role #{{id}}',
        },
      },
      CORPORATIONS_LIST: {
        TITLE: 'Companies',
        LEGAL_NAME: 'Legal Name',
        TRADE_NAME: 'Trade Name',
        TAX_ID: 'Tax ID',
        CONTACT_EMAIL: 'Contact Email',
        STATUS: 'Status',
        REFRESH: 'Refresh',
        LOADING: 'Loading...',
        NO_CORPORATIONS: 'No companies found.',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
      },
      CORPORATIONS_LISTING: {
        SEARCH_PLACEHOLDER: 'Search company',
        COL_TRADE_NAME: 'Trade Name',
        COL_LEGAL_NAME: 'Legal Name',
        COL_TAX_ID: 'Tax ID',
        COL_CONTACT_EMAIL: 'Contact Email',
        COL_ACTIVE: 'Active',
        EXPORT_EMPTY_TEXT: 'There are no companies to export.',
        IMPORT_SUCCESS_TEXT: '{{count}} companies were imported successfully.',
      },
      CORPORATION_DETAIL: {
        ERR_NO_ID: 'No company ID was provided',
        ERR_PARAMS: 'Error reading the URL parameters',
        ERR_UPDATE: 'Error updating the company information',
        ERR_TIMEOUT: 'The request took too long (more than 10 seconds). Check your connection.',
        ERR_LOAD: 'Error loading the company: {{msg}}',
        ERR_UNKNOWN: 'Unknown error',
        ERR_OFFICES_TIMEOUT: 'Loading the offices took too long',
        ERR_OFFICES: 'Error loading the offices: {{msg}}',
        ERR_ADMINS_TIMEOUT: 'Loading the administrators took too long',
        ERR_ADMINS: 'Error loading administrators: {{msg}}',
        ID: 'ID',
        CLOSE: 'Close',
        EMAIL_PLACEHOLDER: 'user@example.com',
        TITLE: 'Company Detail',
        BACK_BUTTON: 'Back',
        LOADING: 'Loading company information...',
        ERROR: 'Error',
        TAB_OVERVIEW: 'Information',
        TAB_OFFICES: 'Offices',
        TAB_FUNNEL: 'Funnel',
        TAB_TRAVEL: 'Travel',
        TAB_PARKING: 'Parking',
        TAB_SUSTAINABILITY: 'Sustainability',
        TAB_CONVERSION: 'Conversion',
        TAB_USAGE: 'Usage',
        TAB_ADMINS: 'Administrators',
        TAB_KPIS: 'Mobility KPIs',
        GENERAL_INFORMATION: 'General information',
        ADDITIONAL_INFORMATION: 'Additional information',
        FISCAL_INFO: 'Fiscal Information',
        LEGAL_NAME: 'Legal Name:',
        TRADE_NAME: 'Trade Name:',
        TAX_ID: 'Tax ID:',
        CONTACT_INFO: 'Contact Information',
        CONTACT_NAME: 'Contact Name:',
        CONTACT_PHONE: 'Contact Phone:',
        CONTACT_EMAIL: 'Contact Email:',
        FISCAL_ADDRESS_SECTION: 'Fiscal address',
        FISCAL_ADDRESS: 'Fiscal Address:',
        FISCAL_CITY: 'Fiscal City:',
        FISCAL_POSTAL_CODE: 'Fiscal Postal Code:',
        COMMERCIAL_ADDRESS_SECTION: 'Commercial address',
        COMMERCIAL_ADDRESS: 'Commercial Address:',
        COMMERCIAL_CITY: 'Commercial City:',
        COMMERCIAL_POSTAL_CODE: 'Commercial Postal Code:',
        STATUS_LABEL: 'Status',
        CREATED_AT: 'Created',
        UPDATED_AT: 'Updated',
        OFFICES: 'Offices',
        NO_OFFICES: 'No offices found',
        OFFICES_LOADING: 'Loading offices...',
        ADMINS_LOADING: 'Loading administrators...',
        ADMINS_TITLE: 'Administrators',
        NO_ADMINS: 'No administrators assigned',
        ADMINS: 'Administrators',
        ADMIN_NAME: 'Name',
        ADMIN_EMAIL: 'Email',
        ADMIN_ROLE: 'Role',
        ADD_ADMIN: 'Add administrator',
        ASSIGN_ADMIN: 'Assign Administrator',
        ASSIGN_ADMIN_TITLE: 'Assign Company Administrator',
        ASSIGN_ROLE: 'Assign role',
        EMAIL_LABEL: 'Email',
        EMAIL_REQUIRED: 'Email is required',
        EMAIL_INVALID: 'Invalid email',
        SELECT_USER: 'Select User',
        SELECT_ROLE: 'Select Role',
        ASSIGN: 'Assign',
        CANCEL: 'Cancel',
        ASSIGNING: 'Assigning...',
        ADMIN_ASSIGNED_SUCCESS: 'Administrator assigned successfully',
        ADMIN_ASSIGN_ERROR: 'Error assigning administrator',
        ASSIGN_SUCCESS: 'Administrator assigned successfully',
        ASSIGN_ERROR: 'Error assigning administrator',
        USER_REQUIRED: 'User must be selected',
        ROLE_REQUIRED: 'Role must be selected',
        HEADING_OFFICES: 'Employees',
        HEADING_FUNNEL: 'Funnel',
        HEADING_TRAVEL: 'Travel',
        HEADING_PARKING: 'Reservations',
        HEADING_SUSTAINABILITY: 'Sustainability',
        HEADING_CONVERSION: 'Subsidy',
        HEADING_USAGE: 'Usage',
        HEADING_PRICING_CONFIGS: 'Policies',
        HEADING_SUBSIDY_CONSUMPTIONS: 'Incentives',
        HEADING_POOLING_RUNNERS: 'Fleet',
        HEADING_ADMINS: 'Settings',
        EDIT_BUTTON: 'Edit',
        EDIT_MODAL_TITLE: 'Edit general information',
        FIELD_REQUIRED: 'Required field',
        INVALID_TAX_ID: 'This tax ID is not valid. Check the letter, digits and control character.',
        ACTIVE_CHECKBOX: 'Company active',
        CANCEL_BUTTON: 'Cancel',
        SAVE_BUTTON: 'Save',
        SAVING: 'Saving...',
        SUCCESS_TITLE: 'Success!',
        UPDATE_SUCCESS_TEXT: 'The general information of the corporation has been updated successfully.',
        ERROR_TITLE: 'Error',
      },
      CORPORATION_SETTINGS: {
        COMPANY_INFO: {
          TITLE: 'Company details',
          SUBTITLE: 'Fiscal and contact information of the corporation',
          LOGO_LABEL: 'Company logo',
          LOGO_HINT: 'PNG, JPEG or WEBP. Max. 4 MB.',
          LOGO_UPLOAD: 'Upload logo',
          LOGO_CHANGE: 'Change logo',
          LOGO_REMOVE: 'Remove',
          LOGO_ERROR_TYPE: 'Unsupported format — use PNG, JPEG or WEBP.',
          LOGO_ERROR_SIZE: 'The logo cannot exceed 4 MB.',
          LEGAL_NAME: 'Legal name',
          LEGAL_NAME_PLACEHOLDER: 'Legal name of the company',
          TAX_ID: 'Tax ID',
          INVALID_TAX_ID: 'This tax ID is not valid. Check the letter, digits and control character.',
          FISCAL_ADDRESS: 'Fiscal address',
          FISCAL_ADDRESS_PLACEHOLDER: 'Street, number, floor',
          CITY: 'City',
          POSTAL_CODE: 'Postal code',
          CONTACT_NAME: 'Contact person',
          CONTACT_NAME_PLACEHOLDER: 'Full name',
          CONTACT_EMAIL: 'Contact email',
          CONTACT_PHONE: 'Contact phone',
          NUM_EMPLOYEES: 'No. of employees',
          NUM_OFFICES: 'No. of offices',
          PMST_ENABLED: 'Implement the PMST with WAIIS',
          PMST_ENABLED_HINT: 'If you turn this off, the PMST screen is locked for this company.',
          SAVE: 'Save changes',
          SAVING: 'Saving...',
          SAVE_SUCCESS_TITLE: 'Changes saved',
          SAVE_ERROR_TITLE: 'Could not save the changes',
          SAVE_ERROR_TEXT: 'Check the data and try again.',
        },
        CONTRACT_PREVIEW: {
          BUTTON: 'View contract',
          MODAL_TITLE: 'Service provision contract',
          LOADING: 'Generating contract...',
          CLOSE: 'Close',
          RETRY: 'Retry',
          ERROR_403: 'You do not have permission to view this company\'s contract.',
          ERROR_404: 'The company does not exist.',
          ERROR_GENERIC: 'The contract could not be loaded. Please try again.',
        },
        INVITE_CODE: {
          TITLE: 'Invitation code',
          SUBTITLE: 'Share it so employees can sign up on their own',
          COPY: 'Copy',
          COPIED: 'Copied!',
          EMPTY: 'This company has no invitation code',
        },
        OFFICES: {
          TITLE: 'Offices',
          SUBTITLE: 'Workplaces of the corporation',
          CREATE: 'Create office',
          NOTE: 'Each office can have its own admins and users.',
          EXTRA_OFFICE_NOTE: 'Each additional office adds €20/month to the Incentives Plan.',
          EMPTY: 'No offices registered',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          TABLE_NAME: 'Name',
          TABLE_CITY: 'City',
          TABLE_CONTACT: 'Contact',
          TABLE_ACTIVE: 'Status',
          MISSING_PRE: 'Missing',
          PENDING_SINGULAR: 'office to create',
          PENDING_PLURAL: 'offices to create',
          MISSING_POST: 'out of',
          MISSING_SUFFIX: 'declared. Create them here.',
          DELETE: 'Delete office',
          DELETE_CONFIRM_TITLE: 'Delete this office?',
          DELETE_CONFIRM_TEXT: '"{{name}}" will be permanently deleted. This action cannot be undone.',
          DELETE_SUCCESS_TITLE: 'Office deleted',
          DELETE_ERROR_TITLE: 'Could not delete the office',
        },
        OFFICE_MODAL: {
          NEW_TITLE: 'New office',
          NEW_SUBTITLE: 'Fill in the details of the new office',
          EDIT_SUBTITLE: 'Edit the details of this office',
          NAME_LABEL: 'Name *',
          NAME_PLACEHOLDER: 'Barcelona Office',
          CONTACT_NAME_LABEL: 'Contact person *',
          CONTACT_NAME_PLACEHOLDER: 'Full name',
          CONTACT_PHONE_LABEL: 'Phone *',
          CONTACT_EMAIL_LABEL: 'Contact email *',
          ADDRESS_LABEL: 'Address *',
          ADDRESS_PLACEHOLDER: 'Street, number, floor',
          CITY_LABEL: 'City *',
          POSTAL_CODE_LABEL: 'Postal code *',
          CANCEL: 'Cancel',
          SAVE: 'Create office',
          SAVE_CHANGES: 'Save changes',
          SAVING: 'Saving...',
          ERROR_SAVE: 'Could not save the office. Please try again.',
        },
        WALLET: {
          TITLE: 'My wallet',
          BALANCE_LABEL: 'Available balance',
          RECHARGE: 'Top up',
          WITHDRAW: 'Withdraw',
        },
        ADMINS: {
          TITLE: 'Admins',
          SUBTITLE: 'Users with administration permissions over this corporation',
          ADD: 'Add admin',
          EMAIL_LABEL: 'Email',
          EMAIL_PLACEHOLDER: 'Search user by email...',
          EMAIL_NOTICE: 'Only emails already registered in WAIIS can become administrators of a company or office.',
          ROLE_LABEL: 'Role',
          ROLE_CORPORATION_ADMIN: 'Company admin',
          ROLE_OFFICE_ADMIN: 'Office admin',
          OFFICE_LABEL: 'Office',
          SELECT_OFFICE_PLACEHOLDER: 'Select an office',
          ADDING: 'Adding...',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          ERROR_TITLE: 'An error occurred',
          ERROR_ADD: 'Could not add the admin. Please try again.',
          ERROR_EMAIL_NOT_FOUND: 'Only users already registered in WAIIS can be added as administrators.',
          ALL_OFFICES: 'All offices',
          TABLE_USER: 'User',
          TABLE_ROLE: 'Role',
          TABLE_EMAIL: 'Email',
          REMOVE_TITLE: 'Remove permission',
          EMPTY: 'No admins assigned',
          ROLE_ADMIN_DISPLAY: 'Admin',
          ROLE_OFFICE_ADMIN_DISPLAY: 'Office admin',
        },
        DELETE: {
          ZONE_TITLE: 'Delete company',
          ZONE_DESC: 'The company and all its data will be deleted. This action cannot be undone.',
          CONFIRM_TITLE: 'Delete company?',
          CONFIRM_HTML:
            'You are about to delete <strong>{{name}}</strong> and all its data. This action cannot be undone.<br><br>Type the name to confirm:',
          CONFIRM_BUTTON: 'Delete permanently',
          CANCEL_BUTTON: 'Cancel',
          NAME_MISMATCH: "The name doesn't match.",
          SUCCESS_TITLE: 'Company deleted',
          ERROR_TITLE: 'Could not delete',
          ERROR_TEXT: 'Please try again later.',
        },
      },
      PMST: {
        FORM: {
          TITLE: 'Company form · PMST',
          PROGRESS: '{{answered}} / {{total}} required answered',
          AUTOSAVE_HINT: 'It is saved automatically as you fill in each field — you can close it and continue later.',
          INHERITED: 'These are the values saved at company level. This office has no answer of its own yet: as soon as you save, it will stop following the company.',
          REQUIRED: 'Required',
          ADD_ROW: 'Add row',
          UPLOADING: 'Uploading…',
          SELECT_FILE: 'Select file',
          PREVIOUS: 'Previous',
          SAVE_AND_EXIT: 'Save and exit',
          NEXT: 'Next',
          FINISH: 'Finish',
          QUESTIONNAIRE: 'Questionnaire',
          VIEW_DOCUMENT: 'View document',
          QR: 'QR',
          SEND_ERROR: 'The answer could not be sent',
          SELECT_OFFICE: 'Select an office',
          SELECT_OFFICE_TEXT: 'Your account needs a specific office to fill in the PMST.',
          MISSING_TITLE: 'Required questions are missing',
          MISSING_TEXT_ONE: 'You have 1 required question left to answer.',
          MISSING_TEXT_OTHER: 'You have {{n}} required questions left to answer.',
          DONE_TITLE: 'Form completed',
          DONE_TEXT: 'You can now view the generated document.',
        },
        PMST_DISABLED: 'This company does not have the PMST with WAIIS enabled.',
        TOOLBAR: {
          MY_COMPANY: 'My company',
          ALL_CENTERS: 'All centers',
        },
        HERO: {
          STATUS_BADGE: 'Plan in progress',
          TITLE: 'Sustainable Commuting Plan',
          SUBTITLE: 'The PMST is a legal requirement for workplaces with more than 200 employees or more than 100 per shift (Law 9/2025). The deadline for its implementation ends on {{deadline}} (RDL 7/2026).',
          DAYS_LABEL: 'days until<br />{{deadline}}',
          PROGRESS_CAPTION: 'Current registration · {{registered}} / {{total}} of staff',
          LEGEND_YOU: 'You · {{percent}}%',
          LEGEND_MIN: 'PMST minimum · {{percent}}% of staff',
          LEGEND_GOAL: 'Company target {{percent}}%',
          ACTION_INVITE: 'Upload and invite employees',
          ACTION_COMPLETE_DATA: 'Complete data',
          ACTION_INCENTIVES: 'Manage incentives',
          ACTION_ADD_DOC: 'Add extra documentation',
        },
        REQUIREMENTS: {
          SECTION_LABEL: 'PMST REQUIREMENTS',
          COMPANY_DATA: 'Company data registered',
          OFFICES: 'Offices registered ({{count}} offices)',
          MOBILITY_MEASURES: 'Shared mobility measures active',
          STAFF_REGISTRATION: 'Staff registration',
          STAFF_REGISTRATION_SUBTITLE: 'of declared staff',
          PMST_PENDING_OFFICES: 'Pending at: {{offices}}',
          PMST_DOCUMENT: 'PMST document generated and validated',
        },
        STATUS: {
          COMPLETED: 'Completed',
          PROGRESS: 'In progress',
          PENDING: 'Pending',
        },
        EXTRA_DOCS: {
          SECTION_LABEL: 'EXTRA DOCUMENTATION',
          DOWNLOAD: 'Download',
          DELETE: 'Delete',
          EMPTY: 'You haven\'t added any extra documentation yet.',
          UPLOAD_ERROR_TITLE: 'Upload error',
          UPLOAD_ERROR_TEXT: 'Could not upload the file. Check the format and size.',
        },
        EXTRA_DOCS_MODAL: {
          TITLE: 'Add extra documentation',
          DESC: 'Upload any document and give it a name to add it to your PMST.',
          NAME_LABEL: 'Document name',
          NAME_PLACEHOLDER: 'E.g.: Transport agreement 2026',
          FILE_LABEL: 'File',
          FILE_PICKER: 'Select file from your device',
          FILE_HINT: 'E.g.: surveys, parking, agreements, etc.',
          SUBMIT: 'Add document',
        },
        VISITORS: {
          TITLE: 'Survey for visitors, clients and suppliers',
          DESC: 'Share the <strong>online form</strong> with regular visitors and suppliers; their answers, linked to your company, feed into the PMST report.',
          LINK_LABEL: 'Your company\'s form link',
          COPY: 'Copy',
          COPIED: 'Copied',
          QR_ALT: 'Form QR code',
          OPEN_FORM: 'Open form',
          SEND_EMAIL: 'Send by email',
          PDF_VERSION: 'PDF version',
        },
      },
      PMST_GOAL_CONFIG: {
        TITLE: 'PMST registration goals',
        SUBTITLE: 'Select a company (and optionally an office) to set the legally required minimum percentage and the company\'s own target for registered staff.',
        CORPORATION_LABEL: 'Company',
        CORPORATION_PLACEHOLDER: 'Select a company',
        OFFICE_LABEL: 'Office (optional)',
        OFFICE_PLACEHOLDER: 'Whole company',
        MIN_LABEL: 'PMST minimum (%)',
        MIN_HINT: 'Minimum percentage of registered staff required by law.',
        TARGET_LABEL: 'Company target (%)',
        TARGET_HINT: 'Percentage the company wants to reach as its own goal.',
        CURRENT_STATUS: 'Currently registered',
        SAVE: 'Save goals',
        SAVING: 'Saving…',
        SAVED: 'Goals saved successfully.',
        ERROR_LOAD: 'Could not load the goal configuration.',
        ERROR_SAVE: 'Could not save. Please try again.',
        ERROR_TITLE: 'Error',
        ACCEPT: 'Accept',
        SECTION_SCOPE: 'Company and office',
        SECTION_SCOPE_SUB: 'Who the goals apply to: the whole company or one of its offices.',
        SECTION_GOALS: 'Registered staff goals',
        SECTION_GOALS_SUB: 'Share of staff that must be registered in the PMST.',
        LOADING: 'Loading the configuration…',
      },
      PMST_QUESTIONNAIRE_RESPONSES: {
        TITLE: 'PMST questionnaire responses',
        SUBTITLE: 'Select a company (and optionally an office) to see the responses each employee has submitted.',
        CORPORATION_LABEL: 'Company',
        CORPORATION_PLACEHOLDER: 'Select a company',
        OFFICE_LABEL: 'Office (optional)',
        OFFICE_PLACEHOLDER: 'Whole company',
        NO_RESPONSES: 'No responses submitted yet.',
        SUBMITTED_AT: 'Submitted:',
        UNANSWERED: 'Unanswered',
        ERROR_TITLE: 'Error',
        ERROR_LOAD: 'Could not load the responses.',
        ERROR_FORBIDDEN: 'You do not have access to this company\'s responses.',
        ACCEPT: 'Accept',
        SECTION_SCOPE: 'Company and office',
        SECTION_SCOPE_SUB: 'Which company and, optionally, which office to see responses for.',
        LOADING: 'Loading responses…',
        ERROR_LOAD_TITLE: 'Could not load the responses',
      },
      CORPORATION_OFFICES_LIST: {
        TITLE: 'Corporate Offices',
        CORPORATION: 'Company',
        NAME: 'Name',
        CONTACT_NAME: 'Contact Name',
        CONTACT_EMAIL: 'Contact Email',
        CONTACT_PHONE: 'Contact Phone',
        CITY: 'City',
        STATUS: 'Status',
        REFRESH: 'Refresh',
        LOADING: 'Loading...',
        NO_OFFICES: 'No offices found.',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
      },
      CORPORATION_OFFICES_LISTING: {
        SEARCH_PLACEHOLDER: 'Search office',
        CREATE_OFFICE: 'Create office',
        COL_NAME: 'Name',
        COL_CONTACT: 'Contact',
        COL_PHONE: 'Phone',
        COL_EMAIL: 'Email',
        COL_CITY: 'City',
        COL_ACTIVE: 'Active',
        EXPORT_EMPTY_TEXT: 'There are no offices to export.',
        IMPORT_SUCCESS_TEXT: '{{count}} offices were imported successfully.',
      },
      CORPORATION_OFFICE_DETAIL: {
        TEXTS: {
          ERROR: 'Error',
          SUCCESS: 'Done',
          ACCEPT: 'OK',
          ERR_UPDATE_OFFICE: 'Error updating the office information',
          ERR_CREATE_OFFICE: 'Error creating the office',
          USERS_LINKED: 'Users linked successfully',
          ERR_LINK_USERS: 'Error linking users',
          OFFICE_NOT_FOUND: 'Office not found',
          OFFICE_TIMEOUT: 'Timed out while loading the office',
          OFFICE_LOAD_ERROR: 'Error loading the office',
          USERS_TIMEOUT: 'Timed out while loading the users',
          USERS_LOAD_ERROR: 'Error loading the users',
          INVALID_CSV: 'Please select a valid CSV file',
          IMPORT_OK: 'Users imported successfully',
          IMPORT_ERROR: 'Error importing users from the CSV',
          USER_UPDATED: 'User updated successfully',
          USER_UPDATE_ERROR: 'Error updating the user',
          USER_ADDED: 'User added successfully',
          USER_ADD_ERROR: 'Error creating the user',
          DT_SEARCH: 'Search:',
          DT_LENGTH: 'Show _MENU_ records',
          DT_ZERO: 'No records found',
          DT_INFO: 'Showing _START_ to _END_ of _TOTAL_ records',
          DT_INFO_EMPTY: 'Showing 0 records',
          DT_INFO_FILTERED: '(filtered from _MAX_ total records)',
          DT_FIRST: 'First',
          DT_LAST: 'Last',
          DT_NEXT: 'Next',
          DT_PREVIOUS: 'Previous',
          COL_SPACE: 'Space',
          COL_TYPE: 'Type',
          COL_USER: 'User',
          COL_RESERVED_DAYS: 'Reserved days',
          COL_SHIFT: 'Shift',
          COL_SHARING: 'Sharing',
          COL_ACTIVE_F: 'Active',
          COL_ACTIVE: 'Active',
          COL_LOCATION: 'Location',
          COL_OFFICE: 'Office',
          COL_ROLE: 'Role',
          COL_CREDIT: 'Credit',
          COL_EXPIRY: 'Expiry',
          COL_CODE: 'Code',
          COL_ENTRY: 'Entry',
          COL_EXIT: 'Exit',
          NOT_ASSIGNED: 'Not assigned',
          YES: 'Yes',
          NO: 'No',
          BUSY: 'Occupied',
          FREE: 'Free',
          CLOSE: 'Close',
          EMAIL_PLACEHOLDER: 'user@example.com',
        },
        TITLE: 'Office Detail',
        BACK_BUTTON: 'Back',
        TAB_OVERVIEW: 'General information',
        TAB_USERS: 'Assigned users',
        TAB_MANAGERS: 'Managers',
        TAB_KPIS: 'Mobility KPIs',
        GENERAL_INFORMATION: 'General information',
        ADDITIONAL_INFORMATION: 'Additional information',
        CONTACT_PERSON: 'Contact Person',
        CONTACT_PHONE: 'Contact Phone',
        CONTACT_EMAIL: 'Contact Email',
        STATUS: 'Status',
        COMMERCIAL_ADDRESS: 'Commercial Address',
        CITY: 'City',
        POSTAL_CODE: 'Postal Code',
        LOADING: 'Loading office information...',
        LOADING_USERS: 'Loading users...',
        ERROR: 'Error',
        USERS: 'Users',
        USER_NAME: 'Name',
        USER_EMAIL: 'Email',
        USER_PHONE: 'Phone',
        USER_CORPORATE_EMAIL: 'Corporate Email',
        USER_PERSONAL_EMAIL: 'Personal Email',
        USER_DNI: 'DNI',
        USER_DEPARTMENT: 'Department',
        USER_CORPORATE_PHONE: 'Corporate Phone',
        USER_CONFIRMED: 'Confirmed',
        USER_ROLE: 'Role',
        OFFICE_CODE: 'Office Code',
        CORPORATION: 'Corporation',
        CREATED_AT: 'Created:',
        UPDATED_AT: 'Updated:',
        NO_USERS: 'No users in this office',
        WAIIS_LINK: 'View in WAIIS',
        DELETE_USER: 'Delete',
        DELETE_CONFIRMATION: 'Are you sure you want to delete this user?',
        DELETE_CONFIRM_BUTTON: 'Yes, delete',
        DELETE_CANCEL_BUTTON: 'Cancel',
        ACTIONS: 'Actions',
        EDIT_USER: 'Edit user',
        ADD_USER: 'Add user',
        REQUIRED_FIELDS: 'Required fields',
        OPTIONAL_FIELDS: 'Optional fields (at least one is required)',
        NAME: 'Name',
        SURNAME: 'Surname',
        DEPARTMENT: 'Department',
        CORPORATE_EMAIL: 'Corporate email',
        PERSONAL_EMAIL: 'Personal email',
        DNI: 'DNI',
        CORPORATE_PHONE: 'Corporate phone',
        PERSONAL_PHONE: 'Personal phone',
        CONFIRMED: 'Confirmed',
        STATUS_PENDING: 'Pending',
        STATUS_REJECTED: 'Rejected',
        STATUS_ACCEPTED: 'Accepted',
        STATUS_ACTIVE: 'Active',
        STATUS_INACTIVE: 'Inactive',
        CANCEL: 'Cancel',
        SAVE_USER: 'Save user',
        UPDATE_USER: 'Update user',
        WAIT: 'Wait',
        UPLOAD_CSV: 'Upload CSV',
        UPLOADING: 'Uploading...',
        LINK_USERS: 'Link users',
        LINKING: 'Linking...',
        ERROR_REQUIRED_FIELD: 'Required field',
        ERROR_INVALID_EMAIL: 'Invalid email',
        ERROR_MIN_LENGTH: 'Must be at least 2 characters',
        ERROR_INVALID_FIELD: 'Invalid field',
        MANAGERS_LOADING: 'Loading managers...',
        MANAGERS_TITLE: 'Managers',
        NO_MANAGERS: 'No managers assigned',
        MANAGERS: 'Managers',
        MANAGER_NAME: 'Name',
        MANAGER_EMAIL: 'Email',
        MANAGER_ROLE: 'Role',
        ADD_MANAGER: 'Add manager',
        ASSIGN_MANAGER: 'Assign Manager',
        ASSIGN_MANAGER_TITLE: 'Assign Office Administrator',
        ASSIGN_ROLE: 'Assign role',
        EMAIL_LABEL: 'Email',
        EMAIL_REQUIRED: 'Email is required',
        EMAIL_INVALID: 'Invalid email',
        SELECT_USER: 'Select User',
        SELECT_ROLE: 'Select Role',
        ASSIGN: 'Assign',
        ASSIGNING: 'Assigning...',
        MANAGER_ASSIGNED_SUCCESS: 'Manager assigned successfully',
        MANAGER_ASSIGN_ERROR: 'Error assigning manager',
        ASSIGN_SUCCESS: 'Manager assigned successfully',
        ASSIGN_ERROR: 'Error assigning manager',
        USER_REQUIRED: 'User must be selected',
        ROLE_REQUIRED: 'Role must be selected',
        CREATE_OFFICE_TITLE: 'Create New Office',
        CORPORATION_LABEL: 'Company *',
        SELECT_CORPORATION: 'Select Company',
        CREATE_OFFICE_NAME_LABEL: 'Office Name *',
        CREATE_CONTACT_NAME_LABEL: 'Contact Name *',
        CREATE_CONTACT_PHONE_LABEL: 'Contact Phone *',
        CREATE_CONTACT_EMAIL_LABEL: 'Contact Email *',
        CREATE_COMMERCIAL_ADDRESS_LABEL: 'Commercial Address *',
        CREATE_CITY_LABEL: 'City *',
        CREATE_POSTAL_CODE_LABEL: 'Postal Code *',
        CREATE_ACTIVE_LABEL: 'Active',
        YES: 'Yes',
        NO: 'No',
        CREATE_OFFICE_BUTTON: 'Create Office',
        CREATING: 'Creating...',
        VALIDATION_CORPORATION: 'You must select a company.',
        VALIDATION_NAME: 'The name is required.',
        VALIDATION_CONTACT_NAME: 'The contact name is required.',
        VALIDATION_CONTACT_PHONE: 'The contact phone is required.',
        VALIDATION_CONTACT_EMAIL: 'The contact email is required and must be valid.',
        VALIDATION_COMMERCIAL_ADDRESS: 'The commercial address is required.',
        VALIDATION_CITY: 'The city is required.',
        VALIDATION_POSTAL_CODE: 'The postal code is required.',
        CHECKLIST_TITLE: 'Criteria checking order',
        CHECKLIST_DNI_LABEL: 'ID number',
        CHECKLIST_DNI_TEXT: ': the match is attempted if the user\'s document matches the corporate employee\'s ID number.',
        CHECKLIST_PERSONAL_EMAIL_LABEL: 'Personal email',
        CHECKLIST_PERSONAL_EMAIL_TEXT: ': it is checked whether the user\'s email matches the personal email of the corporate employee.',
        CHECKLIST_CORPORATE_EMAIL_LABEL: 'Corporate email',
        CHECKLIST_CORPORATE_EMAIL_TEXT: ': it is checked whether the user\'s email matches the employee\'s corporate email.',
        CHECKLIST_PERSONAL_PHONE_LABEL: 'Personal phone',
        CHECKLIST_PERSONAL_PHONE_TEXT: ': it is checked whether the user\'s phone matches the personal phone of the corporate employee.',
        CHECKLIST_CORPORATE_PHONE_LABEL: 'Corporate phone',
        CHECKLIST_CORPORATE_PHONE_TEXT: ': it is checked whether the user\'s phone matches the employee\'s corporate phone.',
        SEARCH_PARKING_SPACE: 'Search Parking Space',
        SEARCH_PARKING_RESERVATION: 'Search Parking Reservation',
        SEARCH_USER: 'Search user',
        SEARCH_SHIFT: 'Search Shift',
        FILTERS: 'Filters',
        APPLY_FILTERS: 'Apply filters',
        CLEAR: 'Clear',
        CLOSE: 'Close',
        CREATE_PARKING_SPACE: 'Create Parking Space',
        RESERVE_PARKING_SPACE: 'Reserve Parking Space',
        ASSIGN_PARKING_CREDIT: 'Assign parking credit coupon',
        CREATE_SHIFT: 'Create Shift',
        EDIT_BUTTON: 'Edit',
        EDIT_OFFICE_TITLE: 'Edit general office information',
        OFFICE_INFO_SECTION: 'Office information',
        CONTACT_INFO_SECTION: 'Contact information',
        COMMERCIAL_ADDRESS_SECTION: 'Commercial address',
        EDIT_OFFICE_NAME_LABEL: 'Office name',
        EDIT_CONTACT_NAME_LABEL: 'Contact name',
        EDIT_CONTACT_PHONE_LABEL: 'Contact phone',
        EDIT_CONTACT_EMAIL_LABEL: 'Contact email',
        EDIT_COMMERCIAL_ADDRESS_LABEL: 'Commercial address',
        EDIT_CITY_LABEL: 'City',
        EDIT_POSTAL_CODE_LABEL: 'Postal code',
        FIELD_REQUIRED: 'Required field',
        EMAIL_INVALID_MODAL: 'Invalid email',
        OFFICE_ACTIVE: 'Office active',
        CANCEL_BUTTON: 'Cancel',
        SAVE_BUTTON: 'Save',
        SAVING: 'Saving...',
        SUCCESS_TITLE: 'Success!',
        ERROR_TITLE: 'Error',
        UPDATE_OFFICE_SUCCESS: 'The office information has been updated successfully.',
        CREATE_OFFICE_SUCCESS: 'The office has been created successfully.',
        DELETE_TITLE: 'Confirm deletion',
        DELETE_USER_SUCCESS: 'User deleted successfully',
        DELETE_USER_ERROR: 'Error deleting the user',
      },
      CORPORATION_KPIS: {
        ERROR_TIMEOUT: 'Loading the KPIs took too long',
        ERROR_LOAD: 'Error loading the mobility KPIs',
        PERIOD_CURRENT_MONTH: 'Current month',
        PERIOD_LAST_30_DAYS: 'Last 30 days',
        AS_OF: 'Updated as of',
        LOADING: 'Loading KPIs...',
        COMING_SOON: 'Coming soon',
        NO_PREVIOUS_DATA: 'No data for previous month',
        REPARTO_MODAL_SOSTENIBLE: 'Sustainable modal share',
        CO2E_EVITADO: 'CO2e avoided',
        EMPLEADOS_COMPARTIENDO: 'Employees carpooling',
        CUESTIONARIO_MOVILIDAD: 'Mobility survey',
        VIAJES_COMPARTIDOS: 'Shared trips',
        KM_COMPARTIDOS: 'Shared km',
        USUARIOS_ACTIVOS: 'Active users',
        CONVERSION_CARPOOLING: 'Carpooling conversion',
        OCUPACION_MEDIA_VEHICULO: 'Average vehicle occupancy',
        AHORRO_ESTIMADO_EUR: 'Estimated savings',
        OCUPACION_PARKING: 'Parking occupancy',
      },
      ROUTES_TOGGLE: {
        COUNT_LABEL: 'Routines in the last 24 h',
        SHOW: 'Show routines',
        VISIBLE: 'Visible on the map',
        HIDDEN: 'Hidden on the map',
      },
      // Página Cartera: bolsa del mes, movimientos y cómo se paga la recarga mensual.
      CORPORATION_WALLET_PAGE: {
        RETRY: 'Retry',
        BAG: {
          LOADING: 'Loading the budget…',
          LOAD_ERROR: 'The budget could not be loaded.',
          MONTH_TITLE: '{{month}} budget',
          REMAINING: '€{{remaining}} left of €{{total}}',
          SPENT: 'Spent €{{amount}}',
          RENEWS: 'Renews on {{date}}',
          MONTHLY_TITLE: 'Monthly budget of €{{amount}}',
          NEXT_CHARGE: 'Tops up on {{date}}.',
          PENDING_PAYMENT: 'This month\'s top-up is pending: the budget is topped up when the payment arrives.',
          NOT_TOPPED_UP: 'This month\'s budget has not been topped up because the payment has not arrived.',
          NONE_TITLE: 'You don\'t have a budget yet',
          NONE_TEXT: 'Choose the amount and the payment method',
          PARTNER_TITLE: 'Your annual mobility budget',
          PARTNER_TEXT:
            'Your budget comes from {{partner}}\'s annual plan: each month it is topped up with its share and whatever is not spent carries over.',
          PARTNER_PENDING_TEXT: 'Your budget starts when {{partner}} activates your annual plan.',
        },
        MOVEMENTS: {
          TITLE: 'Movements',
          SUBTITLE: 'Every payment (−) and every top-up (+) of the wallet.',
          EMPTY: 'Every payment and every top-up will show up here.',
          LOAD_ERROR: 'The movements could not be loaded.',
          AMOUNT: '{{sign}}€{{amount}}',
          SHOW_ALL: 'Show all ({{count}})',
        },
        PAYMENT: {
          TITLE: 'How the budget is paid',
          SUBTITLE: 'It is charged on the 1st of every month for the budget amount.',
          AMOUNT_LABEL: 'Monthly amount',
          AMOUNT_HINT: 'In euros. Whatever is not spent carries over to the next month.',
          AMOUNT_ERROR: 'Enter an amount greater than 0.',
          AMOUNT_MAX_HINT: 'Up to €{{max}} a month.',
          AMOUNT_MAX_ERROR: 'The maximum is €{{max}} a month. For a higher amount, talk to WAIIS.',
          CONFIRM_TITLE: 'Are you sure you want a budget of €{{amount}} a month?',
          CONFIRM_TEXT: 'It will be charged on the 1st of every month.',
          CONFIRM_SAVE: 'Yes, save',
          METHOD_LABEL: 'Payment method',
          METHOD_HINT: 'The same one as the plan.',
          CHANGE: 'Change',
          CHOOSE_IN_PLAN: 'Choose the payment method in Plan',
          CARD: 'Card',
          CARD_LAST4: 'Card •••• {{last4}}',
          SEPA_DEBIT: 'SEPA direct debit',
          SEPA_DEBIT_LAST4: 'SEPA direct debit · •••• {{last4}}',
          BANK_TRANSFER: 'Bank transfer with invoice',
          DAY_ONE_NOTICE:
            'If the payment does not arrive before the 1st, the budget is not topped up until it does. We will email you 5 days before.',
          ACTIVE: 'Monthly top-up on',
          SAVE: 'Save',
          SAVING: 'Saving…',
          SAVED: 'Monthly budget saved',
          SAVE_ERROR: 'It could not be saved. Please try again.',
          DEACTIVATE: 'Turn off the monthly top-up',
          DEACTIVATE_TITLE: 'Turn off the monthly top-up?',
          DEACTIVATE_TEXT: 'Nothing will be charged on the next 1st. Your balance stays in the wallet.',
          DEACTIVATE_CONFIRM: 'Turn off',
          DEACTIVATING: 'Turning off…',
          DEACTIVATED: 'Monthly top-up turned off',
          PARTNER_MANAGED: 'The amount and the method are managed by {{partner}}.',
        },
      },
      CORPORATION_WALLET: {
        BACK: 'Back',
        TITLE: 'My wallet',
        UPGRADE_TO_INCENTIVES_BANNER: 'Switch to the Incentives plan to get the most out of it',
        AVAILABLE_BALANCE: 'AVAILABLE BALANCE',
        RETAINED_BALANCE: 'Retained balance',
        PAYMENT_SETTINGS: 'Payment and payout methods',
        PAYMENT_METHODS_SECTION: 'Payment method',
        PAYOUT_METHODS_SECTION: 'Payout method',
        TRANSACTIONS_HISTORY: 'Transaction history',
        CHANGE_PAYMENT_METHOD: 'Change payment method',
        RECHARGE: 'Top up',
        WITHDRAW: 'Withdraw',
        RECHARGE_MODAL_TITLE: 'Top up wallet',
        RECHARGE_AMOUNT: 'Amount to top up',
        PAY_WITH: 'Pay with',
        ADD_CARD: 'Add card',
        CANCEL: 'Cancel',
        PROCESSING: 'Processing...',
        CONTINUE: 'Continue',
        WITHDRAW_MODAL_TITLE: 'Withdraw balance',
        AVAILABLE_BALANCE_LABEL: 'Available balance',
        WITHDRAW_AMOUNT: 'Amount to withdraw',
        DESTINATION_ACCOUNT: 'Destination account',
        ADD_BANK_ACCOUNT: 'Add bank account',
        WITHDRAW_NOTE: 'The transfer usually takes 1-2 business days.',
        REQUEST_WITHDRAWAL: 'Request withdrawal',
        PAYMENT_METHOD: 'Payment method',
        CHOOSE_CARD_HINT: 'Choose the card to top up your wallet with.',
        EXPIRES: 'Expires',
        REMOVE_CARD: 'Remove card',
        NO_SAVED_CARDS: 'No saved cards',
        CLOSE: 'Close',
        NEW_CARD_HINT: 'Enter the new card details.',
        STRIPE_SECURE_NOTE: 'Secure payment powered by Stripe',
        SAVING: 'Saving...',
        SAVE_CARD: 'Save card',
        BANK_ACCOUNT: 'Bank account',
        CHOOSE_ACCOUNT_HINT: 'Choose the account to withdraw the balance to.',
        REMOVE_ACCOUNT: 'Remove account',
        NO_SAVED_ACCOUNTS: 'No saved bank accounts',
        ADD_BANK_ACCOUNT_SHORT: 'Add account',
        NEW_ACCOUNT_HINT: 'Enter the new bank account details.',
        IBAN: 'IBAN',
        ADDRESS: 'Address',
        ADDRESS_PLACEHOLDER: 'Street, number, floor',
        CITY: 'City',
        POSTAL_CODE: 'Postal code',
        SAVE_ACCOUNT: 'Save account',
        ACCOUNT_HOLDER: 'Account holder (optional)',
        ACCOUNT_HOLDER_PLACEHOLDER: "Company's legal name",
        ACCOUNT_HOLDER_HINT: "If left empty, the holder is the company's legal name.",
        KYB: {
          SECTION: 'Verification',
          TITLE: 'Company verification',
          STATUS_VERIFIED: 'Verified',
          STATUS_PENDING: 'Pending',
          STATUS_VERIFIED_TEXT: 'Company verified: you can now withdraw funds.',
          STATUS_PENDING_TEXT: 'Stripe has not verified the company yet: until then, funds cannot be withdrawn.',
          WITHDRAW_BLOCKED_TITLE: 'Company verification pending',
          WITHDRAW_BLOCKED_TEXT: 'To transfer to your account, Stripe needs to know who represents and owns the company.',
          COMPLETE: 'Complete verification',
          PERSONS_HINT: 'Declare the people who represent the company, manage it or own more than 25% of it. Once everyone is added, confirm the list.',
          NO_PERSONS: 'No one declared yet.',
          ADD_PERSON: 'Add person',
          REMOVE_PERSON: 'Remove person',
          UNKNOWN_PERSON: 'Person without details',
          ATTEST: 'Confirm list',
          ATTEST_HINT: 'Tell Stripe that everyone has been added.',
          ATTESTED: 'List confirmed. Stripe may take a few minutes to review the details.',
          NEW_PERSON_HINT: "The person's details exactly as on their ID document.",
          EDIT_PERSON_HINT: "Review the person's details.",
          FIRST_NAME: 'First name',
          LAST_NAME: 'Last name',
          DOB: 'Date of birth',
          HOME_ADDRESS: 'Home address',
          ROLES: 'Role in the company',
          ROLES_REQUIRED: 'Select at least one role.',
          ROLE_REPRESENTATIVE: 'Legal representative',
          ROLE_REPRESENTATIVE_HINT: 'Can act on behalf of the company.',
          ROLE_DIRECTOR: 'Director',
          ROLE_DIRECTOR_HINT: 'Member of the board of directors.',
          ROLE_EXECUTIVE: 'Executive',
          ROLE_EXECUTIVE_HINT: 'Holds a management position (CEO, general manager…).',
          ROLE_OWNER: 'Owner',
          ROLE_OWNER_HINT: 'Holds shares in the company.',
          OWNERSHIP: 'Ownership',
          OWNERSHIP_REQUIRED: "Enter the owner's ownership percentage.",
          FORM_INCOMPLETE: 'Fill in all the fields.',
          SAVE_PERSON: 'Save person',
          PERSON_UNVERIFIED: 'Unverified',
          PERSON_PENDING: 'Under review',
          PERSON_VERIFIED: 'Verified',
          ERROR_LOAD: 'The people could not be loaded.',
          ERROR_SAVE: 'The person could not be saved.',
          ERROR_DELETE: 'The person could not be removed.',
          ERROR_ATTEST: 'The list could not be confirmed.',
          ERROR_NO_STRIPE_ACCOUNT: "Add a bank account first: it is what creates the company's Stripe account.",
          ERROR_RECORDING_FAILED: 'The person was sent to Stripe but could not be saved. Do not try again; please contact support.',
          ERROR_NO_PERSONS: 'Declare at least one person before confirming the list.',
          ERROR_PERSON_NOT_FOUND: 'This person no longer exists.',
          ERROR_STRIPE_REJECTED: 'Stripe did not accept the details. Please review them and try again.',
          DOCUMENT_MISSING: 'Document missing',
          UPLOAD_DOCUMENT: 'Upload ID document',
          DOCUMENT_HINT: "{{name}}'s ID document: national ID card, foreigner ID (NIE) or passport, both sides if it has them.",
          DOCUMENT_FRONT: 'Front',
          DOCUMENT_BACK: 'Back (optional)',
          DOCUMENT_BACK_HINT: 'Required for ID cards and NIE. Passports do not need it.',
          DOCUMENT_PICK: 'Choose file',
          DOCUMENT_FORMATS: 'JPG, PNG or PDF · max. 10 MB',
          DOCUMENT_REMOVE: 'Remove file',
          DOCUMENT_PRIVACY: 'It is sent straight to Stripe: WAIIS does not keep the document.',
          DOCUMENT_SEND: 'Send document',
          DOCUMENT_SENDING: 'Sending…',
          DOCUMENT_SENT: 'Document sent. Stripe may take a few minutes to verify it.',
          DOCUMENT_INVALID_TYPE: 'Unsupported format: use JPG, PNG or PDF.',
          DOCUMENT_TOO_BIG: 'The file is larger than 10 MB.',
          ERROR_DOCUMENT: 'The document could not be sent.',
          ERROR_DOCUMENT_REJECTED: 'Stripe rejected the document. Check that it is legible and a valid ID card, NIE or passport.',
        },
        TRANSACTIONS_SUBTITLE: "Your company's WAIIS wallet movements.",
        NO_TRANSACTIONS: 'No transactions recorded',
        RECHARGE_ERROR: 'Error topping up the wallet',
        RECHARGE_PENDING: 'The top-up has been charged. The balance will update in a few minutes.',
        WITHDRAW_ERROR: 'Error requesting the withdrawal',
        WITHDRAW_INSUFFICIENT_BALANCE: 'Insufficient balance',
        WITHDRAW_SUBSCRIPTION_BALANCE: "You can't withdraw the balance obtained through the subscription",
        SELECT_CARD_ERROR: 'Error selecting the card',
        REMOVE_CARD_ERROR: 'Error removing the card',
        STRIPE_KEY_MISSING: 'The Stripe publishable key is not configured.',
        START_CARD_ERROR: 'Error starting the card setup',
        CONFIRM_CARD_ERROR: 'Error confirming the card',
        SAVE_CARD_ERROR: 'Error saving the card',
        REMOVE_ACCOUNT_ERROR: 'Error removing the account',
        SAVE_ACCOUNT_ERROR: 'Error saving the bank account',
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
      },
      ROUTES_MAP: {
        OFFICE: 'Office',
        OFFICE_LABEL: 'Office',
        ALL_OFFICES: 'All offices',
        NO_OFFICE_ACCESS: 'No office access',
        CO2_AVOIDED: 'CO₂ avoided',
        CO2_VALUE: '{{value}} kg CO₂e',
        PERIOD_30_DAYS: '30 days',
        LINKED_EMPLOYEES: 'Linked employees',
        PASSENGERS_PER_TRIP: 'Passengers per trip',
        TRIPS_LAST_MONTH: 'Trips · last month',
        HEADQUARTERS: {
          TITLE: 'Where is your headquarters?',
          TEXT: 'This is how we place your company on the map, and you will see your staff’s journeys.',
          PLACEHOLDER: 'Street, number, city',
          ADDRESS_LABEL: 'Headquarters address',
          SAVE: 'Save',
          SAVING: 'Saving…',
          ERROR: 'The headquarters could not be saved.',
        },
        NO_ROUTINES: {
          TITLE: 'No routines yet',
          TEXT: 'They will appear here when your staff create their journeys in the app.',
        },
      },
      COMPANY_OFFICE_DETAILS: {
        BACK: 'Back',
        TITLE: 'Company office details',
        BASIC_INFO: 'Basic information',
        OFFICE_NAME: 'Office name',
        CONTACT_PERSON: 'Contact person',
        CONTACT_PHONE: 'Contact phone',
        CONTACT_EMAIL: 'Contact email',
        ADDRESS: 'Address',
        CITY: 'City',
        POSTAL_CODE: 'Postal code',
        LOADING: 'Loading...',
      },
      OFFICES_LISTING: {
        SEARCH_PLACEHOLDER: 'Search Office',
        CREATE: 'Create office',
        EDIT_TITLE: 'Edit Office',
        CREATE_TITLE: 'Create Office',
        COL_OFFICE: 'Office',
        COL_LOCATION: 'Location',
        COL_EMPLOYEES: 'Employees',
        COL_LINKED: 'Linked',
        COL_ACTIVE: 'Active',
        IMPORT_UNAVAILABLE_TITLE: 'Import not available',
        IMPORT_UNAVAILABLE_TEXT: 'Bulk CSV import is not available yet. No data has been saved.',
        UPDATE_SUCCESS_TEXT: 'The office has been updated successfully',
        CREATE_SUCCESS_TEXT: 'The office has been created successfully',
      },
      PRICING_CONFIG_FORM: {
        CREATE_TITLE: 'Create Pricing Configuration',
        EDIT_TITLE: 'Edit Pricing Configuration',
        INTRO_TITLE: 'Type A pricing configuration',
        INTRO_TEXT:
          'This configuration defines how much the company subsidizes, whether WAIIS co-finances, who it applies to and its limits. Fixed amounts and amount limits are sent in cents.',
        GUIDE_SUMMARY: 'Field guide and examples',
        SUBSIDY_SECTION: 'Subsidy Settings',
        SUBSIDY_TYPE: 'Subsidy Type',
        SUBSIDY_TYPE_HINT:
          '<strong>fixed</strong>: fixed amount in cents. <strong>percentage</strong>: whole percentage over the price.',
        SUBSIDY_VALUE: 'Subsidy Value',
        SUBSIDY_VALUE_HINT:
          'Value contributed by the company. If the type is <strong>fixed</strong>, it is reported in cents. If it is <strong>percentage</strong>, it is reported as a whole percentage.',
        WAIIS_SECTION: 'WAIIS Co-financing',
        WAIIS_CONTRIBUTES: 'WAIIS Contributes',
        WAIIS_CONTRIBUTES_HINT:
          'Indicates whether WAIIS takes part in the subsidy together with the company.',
        CONTRIBUTION_TYPE: 'Contribution Type',
        CONTRIBUTION_TYPE_HINT:
          'Defines whether the WAIIS contribution is a fixed amount in cents or a whole percentage.',
        SELECT_TYPE: 'Select type',
        CONTRIBUTION_VALUE: 'Contribution Value',
        CONTRIBUTION_VALUE_HINT:
          'Value of the WAIIS co-financing according to the selected type.',
        PRICE_SECTION: 'Price Configuration',
        FINAL_PRICE_ZERO: 'Final Price Zero',
        FINAL_PRICE_ZERO_HINT:
          'If enabled, the final price for the user will be 0.',
        RESTRICTIONS_SECTION: 'Restrictions',
        EMPLOYEES_ONLY: 'Employees Only',
        EMPLOYEES_ONLY_HINT:
          'Restricts this configuration to employees of the company.',
        LIMIT_TYPE: 'Limit Type',
        LIMIT_TYPE_HINT:
          '<strong>none</strong>: no limit. <strong>date</strong>: until a specific date. <strong>amount</strong>: until a maximum amount in cents is consumed.',
        LIMIT_DATE: 'Limit Date',
        LIMIT_DATE_HINT:
          'Maximum date until which this configuration will keep applying.',
        LIMIT_AMOUNT: 'Limit Amount',
        LIMIT_AMOUNT_HINT:
          'Maximum total subsidizable amount for this configuration, expressed in cents.',
        OTHER_SECTION: 'Other Options',
        BASE_PRICE_RECIPIENT: 'Base Price Recipient',
        BASE_PRICE_RECIPIENT_HINT:
          'Indicates the base price the subsidy is calculated on. In this model the expected value is <strong>route_driver</strong>.',
        ACTIVE: 'Active',
        ACTIVE_HINT:
          'Allows enabling or disabling the configuration without deleting it.',
        REFUND_CREDITS: 'Refund Credits',
        REFUND_CREDITS_HINT:
          'Defines whether credits must be refunded when applicable according to the economic model logic.',
        CANCEL: 'Cancel',
        CREATE: 'Create',
        UPDATE: 'Update',
        FIELD_GUIDE:
          '# Field Guide - Corporate Pricing Configuration\n\n**Company subsidy program to reduce the trip price for its users.**\n\n---\n\n## Fields\n\n| Field | Description |\n|-------|-------------|\n| **Corporation** | The company that funds the subsidy. Identifies who this configuration belongs to. |\n| **Active** | ✅ Enabled / ❌ Inactive. Inactive ones do not apply to any trip. |\n| **Subsidy Type** | Discount type: `fixed` (fixed amount: 250 = 2.50€) or `percentage` (percentage: 50 = 50%). |\n| **Subsidy Value** | Discount amount. If `fixed`: cents. If `percentage`: 0-100. E.g.: 300 cents = 3€. |\n| **Waiis Contributes** | ✅ WAIIS adds extra money / ❌ No. Use it to force a 0€ price if needed. |\n| **Waiis Contribution Type** | Only if WAIIS contributes and the final price is not 0: `fixed` or `percentage`. E.g.: 400 cents = 4€ extra. |\n| **Waiis Contribution Value** | Amount contributed by WAIIS. Same format as Subsidy Value. |\n| **Final Price Zero** | ✅ Forces price = 0€ / ❌ No. If enabled and the subsidy does not cover 100%, WAIIS completes it automatically. |\n| **Applies to Employees Only** | ✅ Verified employees only / ❌ Any user. |\n| **Limit Type** | Limit type: `none` (no limit), `date` (until a date), `amount` (maximum spend in €). |\n| **Limit Date** | Valid if `Limit Type = date`. Date until which the subsidy applies (e.g.: 2026-12-31). |\n| **Limit Amount** | Valid if `Limit Type = amount`. Maximum spend in cents (e.g.: 500000 = 5,000€). |\n| **Consumed Amount** | Read only. Current accumulated spend. When it reaches `Limit Amount`, it is disabled. |\n| **Base Price Recipient** | Who receives the base price: usually `route_driver` (the trip driver). |\n| **Refund Credits** | ✅ Accumulate post-trip credits / ❌ Direct discount. E.g.: 10€ trip, 3€ discount -> pays 7€ + 3€ credits vs. only 7€. |\n| **Runners** | Runners (routes) where it applies. E.g.: Barcelona-Sabadell, Barcelona-Terrassa. If empty, it does not apply. |\n\n---\n\n## Quick examples\n\n### ✅ Simple subsidy (25% for Telefonica employees)\n- **Subsidy Type:** `percentage` | **Value:** `25`\n- **Applies to Employees Only:** ✅ Yes\n- **Limit Type:** `none`\n- **Runners:** Barcelona-Sabadell, Barcelona-Terrassa\n- **Result:** Employees pay 25% less, with no spend limit.\n\n### ✅ Free trips (company 6€ + WAIIS 4€)\n- **Subsidy Type:** `fixed` | **Value:** `600`\n- **Waiis Contributes:** ✅ Yes | **Type:** `fixed` | **Value:** `400`\n- **Final Price Zero:** ✅ Yes\n- **Applies to Employees Only:** ✅ Yes\n- **Limit Type:** `date` | **Date:** `2026-12-31`\n- **Result:** Google employees pay 0€ until the end of the year.\n\n### ✅ Logistics center (30% for anyone, max 5,000€)\n- **Subsidy Type:** `percentage` | **Value:** `30`\n- **Applies to Employees Only:** ❌ No\n- **Limit Type:** `amount` | **Amount:** `500000` (cents)\n- **Runners:** Barcelona-CentroATM, CentroATM-Barcelona\n- **Result:** Anyone gets a 30% discount, until 5,000€ is exhausted.\n\n### ✅ Loyalty with credits (10% for employees)\n- **Subsidy Type:** `percentage` | **Value:** `10`\n- **Refund Credits:** ✅ Yes\n- **Applies to Employees Only:** ✅ Yes\n- **Limit Type:** `none`\n- **Result:** Employees pay 10% less and receive that discount as gifted credits.',
      },
      PRICING_CONFIGS_LIST: {
        HOW_TO_READ_TITLE: 'How to read this listing',
        HOW_TO_READ_TEXT:
          'Fixed values and amount limits are shown in cents. Percentages are shown as whole numbers. Each row represents a subsidy rule applicable to a company and, optionally, to specific runners.',
        GUIDE_SUMMARY: 'Field guide and examples',
        CREATE_CONFIG: 'Create Config',
        LOADING: 'Loading...',
        EMPTY: 'No pricing configurations found. Create one to get started.',
        COL_SUBSIDY_TYPE: 'subsidy_type',
        COL_SUBSIDY_VALUE: 'subsidy_value',
        COL_WAIIS_CONTRIBUTES: 'waiis_contributes',
        COL_WAIIS_CONTRIBUTION_TYPE: 'waiis_contribution_type',
        COL_WAIIS_CONTRIBUTION_VALUE: 'waiis_contribution_value',
        COL_FINAL_PRICE_ZERO: 'final_price_zero',
        COL_APPLIES_TO_EMPLOYEES_ONLY: 'applies_to_employees_only',
        COL_LIMIT_TYPE: 'limit_type',
        COL_LIMIT_DATE: 'limit_date',
        COL_LIMIT_AMOUNT: 'limit_amount',
        COL_BASE_PRICE_RECIPIENT: 'base_price_recipient',
        COL_CONSUMED_AMOUNT: 'consumed_amount',
        COL_REFUND_CREDITS: 'refund_credits',
        COL_ACTIVE: 'active',
        COL_ACTIONS: 'Actions',
        YES: 'Yes',
        NO: 'No',
        EDIT_RUNNERS: 'Edit Runners',
        EDIT_CONFIG: 'Edit Config',
        DELETE_CONFIG: 'Delete Config',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'Failed to load pricing configs',
        CREATE_SUCCESS_TITLE: 'Success',
        CREATE_SUCCESS_TEXT: 'Pricing config created successfully',
        CREATE_ERROR_TEXT: 'Failed to create pricing config',
        UPDATE_SUCCESS_TITLE: 'Success',
        UPDATE_SUCCESS_TEXT: 'Pricing config updated successfully',
        UPDATE_ERROR_TEXT: 'Failed to update pricing config',
        DELETE_CONFIRM_TITLE: 'Delete Config?',
        DELETE_CONFIRM_TEXT: 'Are you sure you want to delete this pricing config?',
        DELETE_CONFIRM_BUTTON: 'Delete',
        DELETE_CANCEL_BUTTON: 'Cancel',
        DELETE_SUCCESS_TITLE: 'Deleted',
        DELETE_SUCCESS_TEXT: 'Pricing config deleted successfully',
        DELETE_ERROR_TEXT: 'Failed to delete pricing config',
      },
      PRICING_RUNNERS_MODAL: {
        TITLE: 'Manage Runners for Pricing Config',
        LOADING: 'Loading...',
        SEARCH_PLACEHOLDER: 'Search runners...',
        NO_RUNNERS: 'No runners found.',
        RUNNER_ID: 'ID: {{id}}',
        SELECTED_COUNT: 'Selected: {{selected}} of {{total}}',
        CLEAR_ALL: 'Clear All',
        CANCEL: 'Cancel',
        SAVE_RUNNERS: 'Save Runners',
        MISSING_ID_TITLE: 'Error',
        MISSING_ID_TEXT: 'Missing pricing config id',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT:
          'Failed to load runners. The request may have timed out or returned an unexpected response.',
        SAVE_SUCCESS_TITLE: 'Success',
        SAVE_SUCCESS_TEXT: 'Runners synchronized successfully',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'Failed to synchronize runners',
      },
      SUBSIDY_FORM: {
        CREATE_TITLE: 'Create Subsidy',
        EDIT_TITLE: 'Edit Subsidy',
        MODE: 'Mode',
        SELECT_MODE: 'Select mode',
        MODE_REQUIRED: 'Mode is required',
        AMOUNT: 'Amount',
        AMOUNT_REQUIRED: 'Amount is required',
        MAX_SUBSIDY: 'Max Subsidy',
        MAX_SUBSIDY_REQUIRED: 'Max subsidy is required',
        MAX_SUBSIDY_PER_USER: 'Max Subsidy Per User',
        MAX_SUBSIDY_PER_USER_REQUIRED: 'Max per user is required',
        CANCEL: 'Cancel',
        CREATE: 'Create',
        UPDATE: 'Update',
      },
      SUBSIDIES_LIST: {
        TITLE: 'Subsidies',
        CREATE_SUBSIDY: 'Create Subsidy',
        LOADING: 'Loading...',
        EMPTY: 'No subsidies found. Create one to get started.',
        COL_MODE: 'Mode',
        COL_AMOUNT: 'Amount',
        COL_MAX_SUBSIDY: 'Max Subsidy',
        COL_MAX_PER_USER: 'Max Per User',
        COL_ACTIONS: 'Actions',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'Failed to load subsidies',
        LIMIT_TITLE: 'Limit Reached',
        LIMIT_TEXT: 'Only one subsidy per corporation allowed',
        CREATE_SUCCESS_TITLE: 'Success',
        CREATE_SUCCESS_TEXT: 'Subsidy created successfully',
        CREATE_ERROR_TEXT: 'Failed to create subsidy',
        UPDATE_SUCCESS_TITLE: 'Success',
        UPDATE_SUCCESS_TEXT: 'Subsidy updated successfully',
        UPDATE_ERROR_TEXT: 'Failed to update subsidy',
        DELETE_CONFIRM_TITLE: 'Delete Subsidy?',
        DELETE_CONFIRM_TEXT: 'Are you sure you want to delete this subsidy?',
        DELETE_CONFIRM_BUTTON: 'Delete',
        DELETE_CANCEL_BUTTON: 'Cancel',
        DELETE_SUCCESS_TITLE: 'Deleted',
        DELETE_SUCCESS_TEXT: 'Subsidy deleted successfully',
        DELETE_ERROR_TEXT: 'Failed to delete subsidy',
      },
      SUBSIDY_CONSUMPTION_FORM: {
        CREATE_TITLE: 'Create Consumption',
        EDIT_TITLE: 'Edit Consumption',
        USER_ID: 'User ID',
        USER_ID_PLACEHOLDER: 'Enter user ID (UUID)',
        USER_ID_REQUIRED: 'User ID is required',
        ROUTE_ID: 'Pooling Route ID',
        ROUTE_ID_PLACEHOLDER: 'Enter route ID (UUID)',
        ROUTE_ID_REQUIRED: 'Route ID is required',
        AMOUNT: 'Amount',
        AMOUNT_REQUIRED: 'Amount is required',
        WAIIS_AMOUNT: 'WAIIS Amount',
        WAIIS_AMOUNT_REQUIRED: 'WAIIS amount is required',
        CANCEL: 'Cancel',
        CREATE: 'Create',
        UPDATE: 'Update',
      },
      SUBSIDY_CONSUMPTIONS_LIST: {
        TITLE: 'Subsidy Consumptions',
        CREATE_CONSUMPTION: 'Create Consumption',
        SELECT_CONFIG_LABEL: 'Select Pricing Configuration',
        SELECT_CONFIG_PLACEHOLDER: '-- Select a config --',
        LOADING: 'Loading...',
        EMPTY:
          'No consumptions found for this configuration. Create one to get started.',
        COL_USER_ID: 'User ID',
        COL_ROUTE_ID: 'Route ID',
        COL_AMOUNT: 'Amount',
        COL_WAIIS_AMOUNT: 'WAIIS Amount',
        COL_ACTIONS: 'Actions',
        EDIT: 'Edit',
        DELETE: 'Delete',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'Failed to load consumptions',
        CREATE_SUCCESS_TITLE: 'Success',
        CREATE_SUCCESS_TEXT: 'Consumption created successfully',
        CREATE_ERROR_TEXT: 'Failed to create consumption',
        UPDATE_SUCCESS_TITLE: 'Success',
        UPDATE_SUCCESS_TEXT: 'Consumption updated successfully',
        UPDATE_ERROR_TEXT: 'Failed to update consumption',
        DELETE_CONFIRM_TITLE: 'Delete Consumption?',
        DELETE_CONFIRM_TEXT:
          'Are you sure you want to delete this consumption record?',
        DELETE_CONFIRM_BUTTON: 'Delete',
        DELETE_CANCEL_BUTTON: 'Cancel',
        DELETE_SUCCESS_TITLE: 'Deleted',
        DELETE_SUCCESS_TEXT: 'Consumption deleted successfully',
        DELETE_ERROR_TEXT: 'Failed to delete consumption',
        PAGE_NAME: 'Subsidy',
        SUBTITLE:
          'Configure the economic contribution per shared trip for your employees.',
        BOX_LABEL: 'Subsidy the company contributes per trip',
        PER_TRIP: '€/trip',
        EDIT_PRICE: 'Edit price',
        STATUS_ACTIVE: 'Subsidy active',
        EXPLANATION:
          'This is the price applied as a subsidy to trips made by employees of {{scope}}.',
        ALL_OFFICES: 'All centers',
        WHOLE_COMPANY: 'the whole company',
        CANCEL: 'Cancel',
        SAVE_CONFIG: 'Save configuration',
        SAVE_SUCCESS_TITLE: 'Saved',
        SAVE_SUCCESS_TEXT: 'Subsidy saved successfully',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'Failed to save the subsidy',
        OFFICES_HEADER: 'Subsidy per office',
        NO_OFFICE_CONFIG: 'Not configured (company default applies)',
        BLOCKED_WARNING: 'Subsidy blocked due to unpaid balance. It will be unblocked automatically once the debt is settled.',
      },
      POOLING_RUNNERS: {
        PER_MONTH: '€{{amount}}/month',
        TITLE: 'Runners configuration',
        LOADING: 'Loading...',
        EMPTY: 'There are no runners associated with this company.',
        LOAD_ERROR_TEXT: 'Failed to load pooling runners',
        COL_NAME: 'name',
        COL_DESCRIPTION: 'description',
        COL_COLOR: 'color',
        COL_CREATED_AT: 'created_at',
        COL_UPDATED_AT: 'updated_at',
        MODAL_TITLE: 'Edit runner',
        NAME_LABEL: 'name',
        NAME_REQUIRED: 'Name is required.',
        DESCRIPTION_LABEL: 'description',
        COLOR_LABEL: 'color',
        COLOR_INVALID: 'Color must be in hexadecimal format, for example #009640.',
        CANCEL: 'Cancel',
        SAVE: 'Save changes',
        SAVE_SUCCESS_TITLE: 'Success',
        SAVE_SUCCESS_TEXT: 'Runner updated successfully',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'Failed to update pooling runner',
        FLEET_PAGE_NAME: 'Fleet',
        FLEET_MOCK_MODE: 'Sample data',
        FLEET_REAL_MODE: 'Real data',
        FLEET_ALL_OFFICES: 'All centers',
        FLEET_HEADER_TITLE: 'Fleet',
        FLEET_HEADER_DESC:
          'Economic control of the vehicles and return model of your company.',
        FLEET_KPI_REVENUE_GENERATED: 'Revenue generated (last month)',
        FLEET_KPI_TOTAL_REVENUE: 'Total accumulated revenue',
        FLEET_RETURN_MODEL_TITLE: 'Fleet return model',
        FLEET_RETURN_MODEL_TOOLTIP: 'CAE and return configuration',
        FLEET_RETURN_MODEL_DESC:
          'Choose the percentage of economic return the company will receive per trip. A 50% return means assigning the company 100% of the value generated by the Energy Savings Certificates (CAEs).',
        FLEET_SLIDER_LABEL:
          'Percentage the company keeps from each passenger',
        FLEET_INCOME_LABEL: 'Estimated income with this percentage',
        FLEET_SAVE_MODEL_BUTTON: 'Save model',
        FLEET_VEHICLES_TITLE: 'Fleet vehicles',
        FLEET_UPLOAD_CSV_BUTTON: 'Upload CSV',
        FLEET_ADD_VEHICLE_BUTTON: 'Add vehicle',
        FLEET_COL_VEHICLE: 'VEHICLE',
        FLEET_COL_OFFICE: 'ASSIGNED OFFICE',
        FLEET_COL_DRIVER: 'DRIVER',
        FLEET_COL_CAES: 'CAES GENERATED',
        FLEET_ASSIGN_DRIVER_LINK: 'Assign driver',
        FLEET_EDIT_TOOLTIP: 'Edit',
        FLEET_DELETE_TOOLTIP: 'Delete',
        FLEET_EMPTY_VEHICLES: 'There are no vehicles in this fleet.',
        FLEET_LOADING_VEHICLES: 'Loading vehicles...',
        FLEET_VEHICLE_MODAL_EDIT_TITLE: 'Edit vehicle',
        FLEET_VEHICLE_MODAL_ADD_TITLE: 'Add vehicle',
        FLEET_LICENSE_PLATE_LABEL: 'License plate',
        FLEET_LICENSE_PLATE_PLACEHOLDER: '0000 XYZ',
        FLEET_BRAND_LABEL: 'Brand',
        FLEET_BRAND_PLACEHOLDER: 'Toyota',
        FLEET_MODEL_LABEL: 'Model',
        FLEET_MODEL_PLACEHOLDER: 'Corolla',
        FLEET_COLOR_LABEL: 'Color',
        FLEET_SEATS_LABEL: 'Available seats',
        FLEET_FUEL_TYPE_LABEL: 'Fuel type',
        FLEET_FUEL_TYPE_GASOLINE: 'Gasoline',
        FLEET_FUEL_TYPE_DIESEL: 'Diesel',
        FLEET_FUEL_TYPE_ELECTRIC: 'Electric',
        FLEET_FUEL_TYPE_HYBRID: 'Hybrid',
        FLEET_OFFICE_LABEL: 'Assigned office',
        FLEET_SELECT_OFFICE_PLACEHOLDER: 'Select an office',
        FLEET_DRIVER_LABEL: 'Driver',
        FLEET_DRIVER_SEARCH_MIN_CHARS: 'Type at least 2 letters...',
        FLEET_DRIVER_SEARCH_PLACEHOLDER: 'Search employee...',
        FLEET_IMPORT_MODAL_TITLE: 'Import vehicles from CSV',
        FLEET_OFFICE_ONLY_LABEL: 'Office',
        FLEET_CSV_FILE_LABEL: 'CSV file',
        FLEET_DOWNLOAD_TEMPLATE: 'Download sample template',
        FLEET_DOWNLOADING_TEMPLATE: 'Downloading template...',
        FLEET_IMPORT_BUTTON: 'Import',
        FLEET_MISSING_DATA_TITLE: 'Missing data',
        FLEET_MISSING_DATA_TEXT: 'Fill in license plate, office and vehicle characteristics (brand, model, color, seats and fuel type)',
        FLEET_MISSING_OFFICE_TITLE: 'Missing office',
        FLEET_MISSING_OFFICE_TEXT: 'You must select an office',
        FLEET_MISSING_FILE_TITLE: 'Missing file',
        FLEET_MISSING_FILE_TEXT: 'You must select a CSV file',
        FLEET_MOCK_IMPORT_TITLE: 'Simulation',
        FLEET_MOCK_IMPORT_TEXT:
          'In sample data mode the import is not sent to the backend.',
        FLEET_SAVED_TITLE: 'Saved',
        MODEL_SAVED_TEXT: 'Return model saved successfully',
        MODEL_SAVE_ERROR_TEXT: 'Could not save the return model',
        FLEET_VEHICLE_SAVED_TEXT: 'Vehicle saved successfully',
        FLEET_VEHICLE_SAVE_ERROR_TEXT: 'Failed to save the vehicle',
        FLEET_DELETE_CONFIRM_TITLE: 'Delete vehicle?',
        FLEET_DELETE_CONFIRM_TEXT: 'The vehicle {{plate}} will be deleted.',
        FLEET_DELETE_CONFIRM_BUTTON: 'Delete',
        FLEET_DELETED_TITLE: 'Deleted',
        FLEET_VEHICLE_DELETED_TEXT: 'Vehicle deleted',
        FLEET_VEHICLE_DELETE_ERROR_TEXT: 'Failed to delete the vehicle',
        FLEET_IMPORTED_TITLE: 'Imported',
        FLEET_IMPORTED_TEXT: 'Vehicles imported successfully',
        FLEET_IMPORT_ERROR_TEXT: 'Failed to import the CSV file',
      },
      SHIFTS_LIST: {
        SELECT_OFFICE: 'Select an office:',
        SEARCH_PLACEHOLDER: 'Search Shift',
        FILTERS: 'Filters',
        FILTERS_TITLE: 'Filters',
        CLOSE: 'Close',
        DATE_PLACEHOLDER: 'Select date',
        APPLY_FILTERS: 'Apply filters',
        CLEAR: 'Clear',
        EXPORT_CSV: 'Export CSV',
        CREATE_SHIFT: 'Create Shift',
        COL_CODE: 'Code',
        COL_SHIFT: 'Shift',
        COL_START: 'Entry',
        COL_END: 'Exit',
        COL_ACTIVE: 'Active',
        EDIT_TITLE: 'Edit Shift',
        CREATE_TITLE: 'Create Shift',
      },
      SHIFT_DETAILS: {
        BACK: 'Back',
        TITLE: 'Shift Details',
        ID: 'Id',
        CODE: 'Code',
        NAME: 'Shift name',
        START_TIME: 'Entry time',
        END_TIME: 'Exit time',
        OFFICE: 'Office',
        LOADING: 'Loading...',
      },
      SHIFT_FORM: {
        CLOSE: 'Close',
        CANCEL: 'Cancel',
        ACCEPT: 'Accept',
        ACTIVE: 'Active',
        NAME_LABEL: 'Shift name',
        NAME_REQUIRED: 'Name is required',
        START_TIME_LABEL: 'Entry time',
        TIME_PLACEHOLDER: 'HH:MM',
        START_TIME_REQUIRED: 'Entry time is required',
        END_TIME_LABEL: 'Exit time',
        END_TIME_REQUIRED: 'Exit time is required',
        WAIT: 'Please wait...',
        LOADING: 'Loading...',
        SUCCESS_TITLE: 'Success!',
        UPDATE_SUCCESS_TEXT: 'Shift updated successfully',
        CREATE_SUCCESS_TEXT: 'Shift created successfully',
        ERROR_TITLE: 'Error',
      },
      GETTING_STARTED: {
        STEP_EMPLOYEES: {
          METHOD_AUTONOMOUS_NAME: 'Self-service registration',
          METHOD_AUTONOMOUS_DESC: "You don't need to upload any file. Share the link and the code; your team links itself to this dashboard when they sign up.",
          METHOD_TEMPLATE_NAME: 'Upload template',
          METHOD_TEMPLATE_DESC: 'If you prefer to pre-load your employee list before they sign up, to control who has access.',
          SHARE_CODE_LABEL: 'Company code',
          COPY_CODE_BUTTON: 'Copy code',
          SHARE_CODE_HELP: 'Each employee enters it when signing up from their profile to link to this dashboard.',
          SHARE_LINK_LABEL: 'Invitation link',
          COPY_LINK_BUTTON: 'Copy link',
          SHARE_LINK_HELP: 'Direct link that opens the WAIIS app with the company code already filled in.',
          INVITE_MESSAGE_LABEL_ALT: 'Invitation message',
          COPY_MESSAGE_BUTTON: 'Copy invitation message',
          COPY_MESSAGE_HELP: 'You can edit the text before copying it. It will be pasted into Slack, WhatsApp, Teams, or email with the link and code already included.',
          INVITE_UNAVAILABLE: 'The company code and invitation link are not available right now. Try again in a few minutes or contact support.',
          COPIED_SUFFIX: 'copied',
          INVITE_MESSAGE_BODY: "Hi!\n\n**{{company}}** has activated **WAIIS**, the app for carpooling with colleagues on your commute to work: you save money, travel more comfortably and cut emissions.\n\n**Joining takes less than 2 minutes:**\n\n**1.** Download the WAIIS app on your phone (available on the App Store and Google Play).\n\n**2.** From your phone, tap this link to be linked to the company automatically and unlock your WAIIS benefits:\n\n{{link}}\n\nLink won't open, or you already had the app? Open WAIIS, sign up and go to **Profile → My organisation** to enter this company code:\n\n{{code}}\n\nThat's it! You can now start sharing rides with people who live or work near you.\n\nAny questions? Message us through the support chat in the app.\n\nSee you on **WAIIS**!",
          INVITE_MESSAGE_COMPANY_FALLBACK: 'your company',
        },
        STEP_PAYMENT: {
          ADD_CARD_BUTTON: 'Add payment card',
          CARD_DATA_LABEL: 'Card details',
          SAVE_CARD: 'Save card',
          SAVING_CARD: 'Saving...',
          CANCEL_CARD: 'Cancel',
          LOADING_CARDS: 'Loading cards...',
          DEFAULT_BADGE: 'Default',
          SET_DEFAULT: 'Set as default',
          REMOVE: 'Remove',
          STRIPE_MISCONFIGURED: 'The payment gateway is not configured (missing Stripe publishable key). Please contact support.',
          SETUP_INTENT_ERROR: 'Could not start adding the card. Please try again.',
          CARD_INIT_ERROR: 'Could not load the card form.',
          CARD_DECLINED: 'The card could not be validated. Check the details and try again.',
          ATTACH_ERROR: 'The card was validated but could not be linked to the company. Please try again.',
        },
      },
      SUBSCRIPTION_FEATURES: {
        OVERVIEW: 'General overview',
        OFFICE_BREAKDOWN: 'Breakdown by office',
        CAE_CARPOOLING: 'Mobility CAE',
        CAE_FLEET: 'Fleet CAE',
        INCENTIVES: 'Incentives management',
        WALLET: 'Wallet / incentives fund',
        TRIP_BONIFICATION: 'Trip bonus',
        PSMT_DRAFT: 'PMST / PDE draft',
        ADVANCED_REPORTS: 'Advanced reports',
        USER_MANAGEMENT: 'User management',
        ADD_OFFICES: 'Add additional offices',
        BILLING: 'Billing and payment history',
        NEW_DASHBOARD_FEATURES: 'New dashboard features',
      },
      CORPORATION_PLAN: {
        TITLE: 'Plan',
        SUBTITLE: 'Your company\'s contracted plan and its conditions.',
        LOADING: 'Loading plan...',
        DEADLINE_LABEL: 'Deadline:',
        ACCESS_BLOCKED: 'Dashboard access is blocked: there is no active subscription. Choose a plan to reactivate it.',
        STATUS_LABEL: 'Status:',
        DAYS_REMAINING_LABEL: 'Days remaining:',
        ENDS_AT_LABEL: 'Ends on:',
        CURRENT_PLAN_BADGE: 'CURRENT PLAN',
        PREVIEW_CALCULATING: 'Calculating changes...',
        PREVIEW_DOWNGRADE: 'This change is a downgrade',
        PREVIEW_UPGRADE: 'This change is an upgrade',
        PREVIEW_GAIN: 'You gain',
        PREVIEW_LOSS: 'You lose',
        CARD_SECTION_TITLE: 'Add a credit card',
        CARD_SECTION_TEXT: 'The Incentives Plan requires a registered credit card.',
        CONFIRM_BUTTON: 'Confirm plan change',
        CANCEL_BUTTON: 'Cancel subscription',
        PLAN_NOT_AVAILABLE_TITLE: 'Plan not available',
        CARD_REQUIRED_TITLE: 'Credit card required',
        CARD_REQUIRED_TEXT: 'Add a credit card to continue with the Incentives Plan.',
        UPDATE_SUCCESS_TITLE: 'Plan updated',
        UPDATE_SUCCESS_TEXT: 'The plan change has been applied successfully.',
        UPDATE_ERROR_TITLE: 'The plan could not be changed',
        UPDATE_ERROR_GENERIC: 'The plan could not be changed. Please try again.',
        CANCEL_CONFIRM_TITLE: 'Cancel the subscription?',
        CANCEL_CONFIRM_TEXT: 'The company will no longer have an active plan. You can choose a new one whenever you want.',
        CANCEL_CONFIRM_BUTTON: 'Cancel subscription',
        CANCEL_CANCEL_BUTTON: 'Cancel',
        CANCEL_SUCCESS_TITLE: 'Subscription cancelled',
        CANCEL_ERROR_TITLE: 'Error',
        CANCEL_ERROR_GENERIC: 'The subscription could not be cancelled.',
        LOAD_ERROR: 'The plan could not be loaded.',
        RETRY: 'Retry',
        TRIAL_CARD: {
          PRE_LAUNCH_TITLE: '3-month free trial',
          PRE_LAUNCH_TAG: 'Starts when you add employees',
          NO_COMMITMENT: 'No commitment · no minimum term',
          TRIAL_TITLE: 'Free trial · {{days}} days left',
          TRIAL_TITLE_ONE: 'Free trial · 1 day left',
          TRIAL_TEXT: 'Ends on {{date}}. Nothing is charged until then.',
          TRIAL_TEXT_COMPLETE: 'Ends on {{date}}. Then the Incentives Plan starts.',
          TRIAL_DAY_TAG: 'Day {{day}} of {{total}}',
          LOCKED_TITLE: 'Your trial ended on {{date}}',
          LOCKED_TEXT: 'The dashboard is locked until you complete your account. Your staff app keeps working.',
          LOCKED_TAG: 'Locked',
          ACTIVE_TITLE: 'Incentives Plan · active',
          ACTIVE_TAG: 'Active',
          PARTNER_PRE_LAUNCH_TITLE: 'Free trial',
          PARTNER_TRIAL_TEXT: 'It ends on {{date}}. {{partner}} will contact you to activate your annual plan.',
          PARTNER_LOCKED_TEXT: '{{partner}} is preparing your contract and will contact you.',
          PARTNER_ACTIVE_TITLE: 'Annual plan',
          PARTNER_ACTIVE_TEXT: 'Your mobility budget comes from this plan: on the 1st of each month 1/12 goes into your wallet, and whatever is not spent carries over.',
          PARTNER_TAG: 'Managed by {{partner}}',
          PARTNER_MANAGED: 'Your plan, billing and contract are managed by {{partner}}.',
          ANNUAL_ACTIVE_SINCE: 'Active since {{date}}.',
          ANNUAL_RENEWS_ON: 'Renews on {{date}}.',
          ANNUAL_PENDING_PAYMENT: 'Payment pending: {{partner}} will send you how to pay it.',
          ANNUAL_DRAFT: '{{partner}} is preparing your annual plan.',
        },
        MANAGER: {
          TITLE: 'Your manager at {{partner}}',
          NAME: 'Name',
          EMAIL: 'Email',
          PHONE: 'Phone',
        },
        ACCOUNT: {
          TITLE: 'Complete your account',
          SUB_TRIAL: 'Whenever you like during the trial. Nothing is charged until it ends.',
          SUB_LOCKED: 'It is all that is left to start editing again.',
          COUNT: '{{done}} of {{total}}',
          BILLING_TITLE: 'Billing details',
          BILLING_TEXT: 'Company name, tax ID, address and billing email.',
          BILLING_ACTION: 'Complete',
          BILLING_DONE: '{{name}} · {{taxId}}',
          PAYMENT_TITLE: 'Payment method',
          PAYMENT_TEXT: 'SEPA direct debit, card or bank transfer with invoice.',
          PAYMENT_ACTION: 'Choose',
          CONTRACT_TITLE: 'Contract',
          CONTRACT_TEXT: 'Read it and accept it right here, with your name and position.',
          CONTRACT_ACTION: 'Read and accept',
          CONTRACT_DISABLED: 'Complete billing and payment first.',
          EDIT: 'Edit',
          COMPLETE_TITLE: 'Your account is complete',
          COMPLETE_SIGNED: 'Contract accepted by {{name}}, {{position}} · {{date}}',
          VIEW_CONTRACT: 'View contract',
          SUMMARY_PLAN: 'Plan',
          SUMMARY_TIER: 'Rate',
          SUMMARY_AMOUNT: 'Amount',
          SUMMARY_STARTS: 'Starts',
          SUMMARY_PAYMENT: 'Payment',
        },
        PAYMENT_LABEL: {
          CARD: 'Card',
          CARD_LAST4: 'Card •••• {{last4}}',
          SEPA_DEBIT: 'SEPA direct debit',
          BANK_TRANSFER: 'Bank transfer with invoice',
        },
        COACHING: {
          TITLE: 'Weekly support',
          TEXT: 'A 45-minute session a week with our team during the trial. Included and optional.',
          ACTION: 'Book a session',
        },
        PRICE: {
          EUR: '€{{amount}}',
          PER_MONTH: '€{{amount}}/month',
          MONTH_AMOUNT: '€{{amount}} a month',
          ADVISOR: 'Ask an advisor',
        },
        TIER: {
          BELOW: 'Fewer than {{max}}',
          RANGE: '{{min}} – {{max}}',
          ABOVE: 'More than {{min}}',
        },
        TARIFFS: {
          TITLE: 'Incentives Plan rates',
          SUB: 'Monthly per company, based on the size of the main office.',
          YOUR_TIER: 'Your tier',
          EXTRA_OFFICE: '+€{{amount}}/month for each additional office',
          EXTRA_OFFICE_OFFICES: '+€{{amount}}/month for each additional office · you have {{offices}} offices',
          REFERENCE: 'The office with the most employees is taken as the reference.',
        },
        BILLING_MODAL: {
          TITLE: 'Billing details',
          SUB: 'The ones that will go on the contract and the invoices.',
          LEGAL_NAME: 'Company name',
          TAX_ID: 'Tax ID (CIF)',
          ADDRESS: 'Registered address',
          ADDRESS_PLACEHOLDER: 'Street, number, floor',
          POSTAL_CODE: 'Postcode',
          CITY: 'City',
          EMAIL: 'Billing email',
          REQUIRED: 'This field is required.',
          POSTAL_CODE_INVALID: 'Enter a 5-digit postcode.',
          EMAIL_INVALID: 'Enter a valid email.',
          TAX_ID_INVALID: 'Invalid tax ID',
          ERROR: 'The billing details could not be saved.',
        },
        PAYMENT_MODAL: {
          TITLE: 'Payment method',
          SUB: 'Used from {{date}}. Nothing is charged until then.',
          SEPA: 'Direct debit',
          CARD: 'Card',
          TRANSFER: 'Bank transfer with invoice',
          IBAN: 'IBAN',
          SEPA_HINT: 'You sign the SEPA mandate when you save.',
          CARD_HINT: 'Stored securely with Stripe.',
          STRIPE_ERROR: 'The Stripe form could not be loaded. Please try again.',
          ERROR: 'The payment method could not be saved.',
        },
        CONTRACT_MODAL: {
          TITLE: 'Service agreement',
          SUB: 'Electronic acceptance from the dashboard. It is stored with the date, name and position.',
          CLIENT: 'Client',
          PLAN: 'Plan',
          TIER: 'Rate',
          AMOUNT: 'Amount',
          START: 'Start',
          DURATION: 'Term',
          PAYMENT: 'Payment',
          TODAY: 'Today',
          AT_TRIAL_END: 'When the trial ends',
          TIER_TEXT: 'Tier {{tier}} employees · €{{price}}/month',
          TIER_TEXT_EXTRA_ONE: 'Tier {{tier}} employees · €{{price}}/month + 1 additional office (€{{extra}})',
          TIER_TEXT_EXTRA: 'Tier {{tier}} employees · €{{price}}/month + {{count}} additional offices (€{{extra}})',
          TIER_TEXT_ADVISOR: 'Tier {{tier}} employees · ask an advisor',
          READ_PDF: 'Read the full contract (PDF)',
          NAME: 'Your name',
          POSITION: 'Position',
          CONFIRM: 'I have read the contract and I am authorised to accept it on behalf of {{company}}.',
          ACCEPT: 'I accept and sign',
          ACCEPTING: 'Signing…',
          ERROR: 'The contract could not be accepted.',
        },
        CONTRACT_PDF: {
          TITLE: 'Service agreement',
          LOADING: 'Loading the contract…',
          ERROR: 'The contract could not be loaded.',
          FRAME_TITLE: 'Contract PDF',
        },
        MODAL: {
          SAVE: 'Save',
          SAVING: 'Saving…',
          CANCEL: 'Cancel',
          CLOSE: 'Close',
        },
        COMPARISON: {
          CATEGORY_DASHBOARD: 'The app and dashboard',
          CATEGORY_CAE: 'CAE income',
          CATEGORY_INCENTIVES: 'Staff incentives',
          CATEGORY_COMPLIANCE: 'Compliance',
          CATEGORY_ACCOUNT: 'Account management',
          CATEGORY_LIMITS: 'Limits',
          LIMIT_DURATION: 'Duration',
          LIMIT_DURATION_TRIAL: '3 months',
          LIMIT_DURATION_UNLIMITED: 'Unlimited',
          LIMIT_TEAM_SIZE: 'Team size',
          LIMIT_UNLIMITED: 'No limit',
          LIMIT_ACTIVE_USERS: 'Active users',
          LIMIT_REQUIRES_CARD: 'Requires card',
          YES: 'Yes',
          NO: 'No',
          SELECT_PLAN: 'Select',
          NOT_ELIGIBLE_BADGE: 'Not eligible',
          TRIAL_COLUMN: '3-month trial',
          TRIAL_PRICE_NOTE: 'for 3 months',
          INCENTIVES_COLUMN: 'Incentives Plan',
          INCENTIVES_PRICE_NOTE: 'a month · tier {{tier}}',
          INCENTIVES_PRICE_NOTE_NO_TIER: 'a month',
          RECOMMENDED: 'Recommended',
          YOUR_PLAN: 'Your plan',
          INCLUDED: 'Included',
          NOT_INCLUDED: 'Not included',
        },
      },
      CORPORATION_RIDE_POLICY: {
        NOTE_COMMISSION: 'The platform fee applies just as on a regular ride.',
        NOTE_REASON: 'The employee always states the reason for the ride.',
        LOADING: 'Loading the policy…',
        LOAD_ERROR: 'The policy could not be loaded.',
        RETRY: 'Retry',
        CREATE_GROUP: 'Create group',
        CREATE_GROUP_LONG: 'Create a group with its own rules',
        OFF_TITLE: 'Company payment is off',
        OFF_TEXT: 'No group can charge rides to the company from the app. Turn it on in «Company payment».',
        GROUPS_TITLE: 'Groups',
        GROUPS_SUB: 'Each group has its own rules. Anyone who is not in another group follows «All employees».',
        GROUPS_ERROR: 'The groups could not be loaded.',
        DEFAULT_GROUP_NAME: 'All employees',
        DEFAULT_BADGE: 'Default',
        DEFAULT_WHO: 'anyone not in another group',
        MEMBERS_ONE: '{{count}} person',
        MEMBERS_MANY: '{{count}} people',
        EDIT_GROUP: 'Edit',
        SPEND_ONE: '{{amount}} on {{count}} ride · last 30 days',
        SPEND_MANY: '{{amount}} on {{count}} rides · last 30 days',
        SPEND_NONE: 'No rides in the last 30 days',
        SPEND_UNAVAILABLE: 'The spend for the last 30 days could not be read',
        RULES: {
          NO_COMPANY_PAY: 'No company payment',
          LIMIT: 'Up to {{amount}} / ride',
          ANY_TIME: 'Any day and time',
          CATEGORY: {
            economy: 'Economy',
            executive: 'Up to executive',
            any: 'Any category',
          },
          SERVICE: {
            any: 'Taxi or VTC',
            taxi: 'Taxi only',
            vtc: 'VTC only',
          },
        },
        CATEGORY: {
          economy: 'Economy',
          executive: 'Executive',
          any: 'Any',
        },
        SERVICE: {
          any: 'Taxi or VTC',
          taxi: 'Taxi',
          vtc: 'VTC',
        },
        DAYS: {
          MON: 'Mo',
          TUE: 'Tu',
          WED: 'We',
          THU: 'Th',
          FRI: 'Fr',
          SAT: 'Sa',
          SUN: 'Su',
          EVERY_DAY: 'Every day',
          WEEKDAYS: 'Mon–Fri',
        },
        GROUP_CREATED: 'Group «{{name}}» created with {{count}} people',
        GROUP_CREATED_ONE: 'Group «{{name}}» created with 1 person',
        GROUP_SAVED: 'Group «{{name}}» saved',
        GROUP_APPLIES_SOON: 'The rules apply in the app within a few minutes.',
        GROUP_MOVED: '{{moved}} people change group.',
        GROUP_MOVED_ONE: '1 person changes group.',
        PAYMENT_TITLE: 'Company payment',
        PAYMENT_SUB: 'Shared by all groups: whether rides can be charged to the company, the monthly budget and the wallet top-up.',
        NEVER_SUBSCRIBED_TITLE: 'Your company does not have a plan yet',
        NEVER_SUBSCRIBED_TEXT: 'You can save the policy, but the app will not offer company payment until you subscribe to a plan that includes it.',
        ACTIVE_LABEL: 'Company payment on',
        ACTIVE_HINT: 'When it is off, no group can charge rides to the company.',
        BUDGET_TITLE: 'Monthly budget',
        BUDGET_LABEL: 'Cap the company spend per month',
        BUDGET_HINT: 'Shared by all groups. Warning at 80 % and block at 100 %: once used up, nobody can pay with the company until next month.',
        BUDGET_AMOUNT_LABEL: 'Budget per month (€)',
        BUDGET_AMOUNT_HINT: 'Minimum €100.',
        USAGE_LABEL: 'Used this month',
        USAGE_TEXT: '{{consumed}} of {{budget}} · current month',
        USAGE_WARNING: '80 % of this month\'s budget has been used.',
        USAGE_EXHAUSTED: 'Budget used up: company payment is blocked until next month.',
        TOPUP_TITLE: 'Automatic top-up',
        TOPUP_LABEL: 'Top-up amount (€)',
        TOPUP_HINT: 'If there is no balance, the wallet is topped up with at least this amount from the company card. Minimum €10.',
        SAVE: 'Save changes',
        SAVING: 'Saving…',
        SAVE_DISABLED_HINT: 'Check the highlighted fields to be able to save',
        SAVED: 'Policy saved',
        SAVE_ERROR: 'The policy could not be saved',
        ACCEPT: 'OK',
        CANCEL: 'Cancel',
        DEACTIVATE_TITLE: 'Turn off company payment',
        DEACTIVATE_TEXT: 'No group will see «Company payment» in the app. Past rides do not change.',
        DEACTIVATE_CONFIRM: 'Turn off',
        DEACTIVATING: 'Turning off…',
        DEACTIVATED: 'Turned off',
        HOW_TITLE: 'How the rules apply',
        HOW_GROUPS_TITLE: 'Each person, in one group only',
        HOW_GROUPS_TEXT: 'If you add them to another group, they move to it. If you remove them, they go back to «All employees».',
        HOW_LIMIT_TITLE: 'If a ride goes over the limit',
        HOW_LIMIT_TEXT: 'The company pays up to the group\'s limit and the rest is charged to the employee\'s card. They see it before confirming.',
        HOW_TRIP_TITLE: 'On every ride',
        HOW_WAIIS_TITLE: 'What the company does not decide',
        HOW_WAIIS_TEXT: 'Providers (Uber, Cabify, Bolt) and prices are managed by WAIIS.',
        BILLING_TITLE: 'How it is charged',
        BILLING_SUB: 'Rides are paid from the company wallet. If the balance is short, it is topped up from the default card.',
        WALLET_BALANCE: 'Wallet balance',
        COMPANY_CARD: 'Company card',
        CARD_VALUE: '{{brand}} •••• {{last4}}',
        NO_CARD: 'No card',
        NO_CARD_WARNING: 'Without a card, company payment will fail when there is no balance.',
        GO_TO_SETTINGS: 'Top up or add a card in Settings',
        PREVIEW: {
          TITLE: 'What the employee sees',
          SUB: 'The app\'s «Choose how you move» sheet with the group\'s rules and what is saved in «Company payment».',
          VIEW_AS: 'View as',
          EDITOR_TITLE: 'How it will look in the app',
          PHONE_ARIA: 'App preview',
          SHEET_TITLE: 'Choose how you move',
          PERSONAL_CARD: 'Employee\'s card',
          COMPANY_NAME: 'Your company',
          COMPANY_ROW_SUBTITLE: 'Company payment · up to {{limit}}',
          SELECT: 'Select',
          CLOCK: 'With the current time in Madrid ({{time}})',
          PRODUCT: {
            go: 'Economy VTC',
            premium: 'Executive VTC',
            xl: 'VTC XL',
            taxi: 'Taxi',
          },
        },
        EDITOR: {
          NEW_TITLE: 'New group',
          NEW_SUB: 'It starts with the rules of «All employees». Adjust them and add the people.',
          DEFAULT_SUB: 'Shared rules for anyone not in another group',
          GROUP_SUB: '{{count}} people with these rules',
          GROUP_SUB_ONE: '1 person with these rules',
          CLOSE: 'Close',
          NAME_LABEL: 'Group name',
          NAME_PLACEHOLDER: 'E.g. Management, Sales, Night shift',
          TAB_RULES: 'Rules',
          TAB_MEMBERS: 'Members',
          COMPANY_PAYS: 'Can pay with the company',
          COMPANY_PAYS_HINT: 'If you turn it off, this group will not see «Company payment» in the app.',
          LIMIT_LABEL: 'Limit per ride (€)',
          LIMIT_HINT: 'The employee pays the rest. Minimum €5.',
          CATEGORY_LABEL: 'Highest category',
          SERVICE_LABEL: 'Service',
          SCHEDULE: 'Only within hours',
          SCHEDULE_HINT: 'Outside these hours, the app does not offer company payment.',
          FROM: 'From',
          TO: 'To',
          CROSSES_MIDNIGHT: 'Crosses midnight: it ends the next day.',
          DAYS_LABEL: 'Days',
          DEFAULT_MEMBERS_NOTE: 'This group is not edited by hand: it includes everyone who is not in another group. To give someone other rules, add them to a group.',
          SEARCH: 'Search employee…',
          MEMBERS_HINT: 'Each person is in one group only: if you pick someone from another group, they leave it.',
          IN_GROUP: 'in «{{name}}»',
          LEAVES_GROUP: 'leaves «{{name}}»',
          NO_RESULTS: 'No results.',
          NO_EMPLOYEES: 'The company has no linked employees yet.',
          EMPLOYEES_ERROR: 'The employees could not be loaded.',
          DELETE: 'Delete group',
          DELETE_TITLE: 'Delete the group «{{name}}»',
          DELETE_TEXT: 'Its {{count}} people go back to «All employees».',
          DELETE_TEXT_ONE: 'The person in the group goes back to «All employees».',
          DELETE_TEXT_NONE: 'The group has no people.',
          DELETE_CONFIRM: 'Delete group',
          DELETING: 'Deleting…',
          DELETED: 'Deleted',
          DELETE_ERROR: 'The group could not be deleted',
          CREATE: 'Create group',
          SAVE: 'Save',
          SAVE_ERROR: 'The group could not be saved',
          SAVE_DISABLED_HINT: 'Fill in the required fields (*) to be able to save',
        },
        VALIDATION: {
          REQUIRED: 'This field is required.',
          MIN: 'The minimum amount is €{{min}}.',
          MAX_LENGTH: 'At most {{max}} characters.',
          SAME_TIMES: 'The end time must be different from the start time.',
          DAYS_REQUIRED: 'Pick at least one day.',
        },
      },
      CORPORATION_RIDES: {
        TITLE: 'Taxi rides and spend',
        ALL_OFFICES: 'All offices',
        OFFICE_ARIA: 'Office',
        PERIOD: {
          ARIA: 'Period',
          LAST_30_DAYS: 'Last 30 days',
          LAST_90_DAYS: 'Last 90 days',
          THIS_YEAR: 'This year',
        },
        EXPORT_CSV: 'Export CSV',
        EXPORTING: 'Exporting…',
        EXPORT_ERROR: 'The CSV could not be exported.',
        EXPORT_EMPTY: 'There are no rides in the period.',
        EXPORT_DONE: 'CSV exported · {{count}} rides',
        LOAD_ERROR: 'The rides could not be loaded.',
        FORBIDDEN: 'You are not allowed to see this company\'s rides.',
        RETRY: 'Retry',
        ACCEPT: 'OK',
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
        NO_COST: 'No cost',
        PAGINATION: 'Showing {{shown}} of {{total}} rides',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        KPI: {
          SPEND: 'Company spend',
          VS_PREVIOUS: 'vs {{value}} in the previous period',
          NO_PREVIOUS: 'No comparable previous period',
          RIDES: 'Employee rides',
          RIDES_HINT: 'Completed in the period',
          AWAITING_RECEIPT: '{{count}} awaiting receipt',
          AVERAGE: 'Average amount per ride',
          AVERAGE_HINT: 'What the company pays',
          EMPLOYEES: 'Employees who used it',
          EMPLOYEES_HINT: 'With at least one completed ride',
          ELIGIBLE: 'of {{count}} with company payment',
        },
        WEEKS: {
          TITLE: 'Spend per week',
          Q: 'What the company has paid in the last 8 weeks',
          TOTAL: '{{value}} in 8 weeks',
          CURRENT: 'Current week',
          TIP: 'Company spend',
          EMPTY: 'No spend in the last 8 weeks.',
          TABLE: 'See the data',
          WEEK: 'Week',
          TOTAL_ROW: 'Total',
        },
        RECLAIM: {
          LINE: 'Claimed back from the employee after the rejection',
          STATUS: {
            WAITING: 'Waiting for the charge to close',
            REQUESTED: 'Claiming',
            PENDING_DEBT: 'Owed by the employee',
            RECLAIMED: 'Claimed back',
            NOT_NEEDED: 'Nothing to claim',
            FAILED: 'Failed: manual handling',
          },
        },
        TABLE: {
          TITLE: 'Ride details',
          SUB: 'Rides in the selected period and office, newest first.',
          SEARCH: 'Employee, pickup or drop-off…',
          STATE: 'Status',
          REVIEW: 'Review',
          EMPLOYEE: 'Employee',
          DATE: 'Date',
          ROUTE: 'Route',
          COMPANY_AMOUNT: 'Company amount',
          OPEN: 'Open',
          PLUS_EMPLOYEE: '+ {{value}} employee',
        },
        REVIEW_FILTER: {
          ALL: 'All reviews',
          PENDING: 'Awaiting review',
        },
        STATE_FILTER: {
          ALL: 'All statuses',
          IN_PROGRESS: 'In progress',
          COMPLETED: 'Completed',
          CANCELLED: 'Cancelled',
          REJECTED: 'Rejected',
        },
        STATE_GROUP: {
          IN_PROGRESS: 'In progress',
          COMPLETED: 'Completed',
          CANCELLED: 'Cancelled',
        },
        AMOUNT_STATUS: {
          AWAITING_RECEIPT: 'Awaiting receipt',
          WALLET_SYNC_PENDING: 'Wallet charge pending',
        },
        EMPTY: {
          TITLE: 'No rides',
          FILTERED: 'Nothing matches the filter.',
          NONE: 'When an authorised employee pays a ride with the company, it will show up here.',
        },
        REASON: {
          COMMUTE: 'Commute',
          CLIENT_VISIT: 'Client visit',
          BETWEEN_OFFICES: 'Travel between offices',
          LATE_EXIT: 'Late finish',
          CORPORATE_EVENT: 'Corporate event',
          OTHER: 'Other',
        },
        DETAIL: {
          CLOSE: 'Close',
          LOAD_ERROR: 'The ride could not be loaded',
          NOT_FOUND: 'The ride no longer exists or is not paid by the company',
          TRIP: 'Ride',
          REASON: 'Stated reason',
          JUSTIFICATION: 'Justification',
          NO_JUSTIFICATION: 'Not provided',
          REVIEW: 'Review',
          STATE: 'Status',
          DEPARTMENT: 'Department',
          REQUESTED_AT: 'Requested',
          SCHEDULED_AT: 'Scheduled for',
          ACCEPTED_AT: 'Accepted',
          ENDED_AT: 'Finished',
          RECEIPT: 'Provider receipt',
          RECEIPT_YES: 'Received',
          RECEIPT_NO: 'Not yet',
          SPLIT: 'Payment split',
          COMPANY: 'Company',
          COMPANY_UP_TO: 'Company · up to {{limit}} per ride',
          EMPLOYEE_OVER_LIMIT: 'Employee card · amount over the limit',
          AWAITING_RECEIPT_NOTE: 'The provider has not sent the receipt yet: the amount is charged to the wallet when it arrives.',
          WALLET_SYNC_NOTE: 'This amount could not be charged to the company wallet. It will be charged when there is balance.',
          CANCELLATION: 'Cancellation',
          PENALTY: 'Penalty',
          PENALTY_COMPANY: 'Paid by the company',
          PENALTY_EMPLOYEE: 'Paid by the employee',
          PRICE: 'Price breakdown',
          CONCEPT: 'Item',
          ESTIMATED: 'Estimated',
          FINAL: 'Final',
          PROVIDER_PRICE: '{{provider}} price',
          COMMISSION: 'WAIIS commission',
          COMMISSION_PCT: 'WAIIS commission ({{pct}} %)',
          TOTAL: 'Total',
        },
        CSV: {
          DATE: 'Date',
          TIME: 'Time',
          EMPLOYEE: 'Employee',
          DEPARTMENT: 'Department',
          OFFICE: 'Office',
          PICKUP: 'Pickup',
          DROPOFF: 'Drop-off',
          PROVIDER: 'Provider',
          PRODUCT: 'Category',
          TOTAL: 'Total amount',
          COMPANY: 'Company amount',
          EMPLOYEE_AMOUNT: 'Employee amount',
          REASON: 'Reason',
          STATE: 'Status',
          REVIEW: 'Review',
        },
      },
      EMPLOYEES_GATE: {
        TITLE: 'Activate your account to manage employees',
        TEXT: 'Enter your credit card securely to activate your account, add your employees and start seeing your real data. No charge will be made at this time (€0 verification).',
        ZERO_CHARGE_BADGE: 'Secure payment · €0 verification · No charge now',
      },
      PMST_QUESTIONNAIRE_CONFIG: {
        PREVIEW: 'Preview',
        RESTORE: 'Restore example',
        SUMMARY: '{{steps}} steps · {{questions}} questions · {{required}} required',
        LOADING_BACKEND: 'Loading the current version from the backend…',
        STEP_TITLE: 'Step {{n}}',
        STEP_TITLE_LABEL: 'Step title',
        QUESTIONS_COUNT: '{{count}} questions',
        SAVE_TITLE: 'Save title',
        CANCEL: 'Cancel',
        MOVE_UP: 'Move up',
        MOVE_DOWN: 'Move down',
        RENAME: 'Rename',
        DELETE_STEP: 'Delete step',
        NO_STATEMENT: '(no statement)',
        NO_TEXT: '(no text)',
        REQUIRED: 'Required',
        OPTIONAL: 'Optional',
        CONDITIONAL: 'Conditional',
        EDIT: 'Edit',
        DELETE: 'Delete',
        EMPTY_STEP: 'This step has no questions yet.',
        ADD_QUESTION: 'Add question',
        ADD_STEP: 'Add step',
        SYNCING: 'Syncing with the backend…',
        SYNCED: 'Synced with the backend',
        SYNC_ERROR: 'Could not sync with the backend — the local save was completed',
        SAVING: 'Saving…',
        SAVE_CHANGES: 'Save changes',
        SAVED: 'Saved',
        NEW_QUESTION: 'New question',
        EDIT_QUESTION: 'Edit question',
        SECTION_QUESTION: 'Question',
        STATEMENT: 'Statement',
        STATEMENT_PLACEHOLDER: 'Question text',
        ANSWER_TYPE: 'Answer type',
        REQUIREDNESS: 'Required?',
        UNIT: 'Unit (optional)',
        UNIT_PLACEHOLDER: 'e.g. €/year, seats, km/year',
        SECTION_OPTIONS: 'Options',
        OPTION_N: 'Option {{n}}',
        REMOVE: 'Remove',
        ADD_OPTION: 'Add option',
        SECTION_COLUMNS: 'Table columns',
        COLUMN_N: 'Column {{n}}',
        ADD_COLUMN: 'Add column',
        SECTION_CONDITION: 'Condition',
        IS_CONDITIONAL: 'This is a conditional question (“only if applicable”)',
        DEPENDS_ON: 'Depends on',
        DEPENDS_ON_NOTE: '(optional — leave blank if the source question doesn\'t exist yet)',
        UNLINKED: '— Not linked —',
        TRIGGER_VALUE: 'Value that triggers the question',
        TRIGGER_VALUE_PLACEHOLDER: 'Exact answer value',
        NOTE: 'Explanatory note',
        NOTE_HINT: '(always shown next to the question)',
        NOTE_PLACEHOLDER: 'e.g. Only if the company has its own fleet',
        SAVE_QUESTION: 'Save question',
        DELETE_STEP_TITLE: 'Delete this step?',
        DELETE_STEP_TEXT: '“{{title}}” and its {{count}} questions will be deleted.',
        DELETE_QUESTION_TITLE: 'Delete this question?',
        MISSING_STATEMENT_TITLE: 'The statement is missing',
        MISSING_STATEMENT_TEXT: 'Write the question text before saving.',
        PREVIEW_WINDOW_TITLE: 'Preview · PMST form',
        RESTORE_TITLE: 'Restore the example questionnaire?',
        RESTORE_TEXT: 'The current steps and questions will be replaced by the 81 example ones (11 steps).',
        RESTORE_CONFIRM: 'Restore',
        TYPE: {
          short_text: 'Short answer',
          long_text: 'Open answer (free text)',
          single_choice: 'Single choice',
          multiple_choice: 'Multiple choice',
          table: 'Table',
          integer: 'Whole number',
          number: 'Number',
          percentage: 'Percentage (%)',
          currency: 'Amount in €',
          file: 'Attach file',
          date: 'Date',
        },
      },
    },
    MOCK_MODE: {
      DEMO_BADGE: 'Demo environment · simulated data',
    },
    EMPLOYEES_BANNER: {
      TITLE: "Haven't added any employees yet?",
      TEXT: 'Meanwhile, you can explore how the Usage, Funnel and Trips sections work: for now they show sample fictitious data as a demo, so you can see what information you will be able to check. Once you add your staff, that data will switch to reflect your employees\' real activity. To see real data,',
      MOCK_NOTICE: "The data you're seeing now is simulated until you add employees.",
      CTA: 'load your employees',
    },
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
    },
    AUTH: {
      PARTNER_INVITATION: {
        BRAND_EYEBROW: 'Invitation',
        BRAND_TITLE: 'Join {{partner}}\'s team',
        BRAND_SUB: 'Manage, with your team, the companies {{partner}} brings to WAIIS.',
        EYEBROW: 'Team invitation',
        TITLE: '{{partner}} invites you to its team',
        AS_ROLE: 'You\'ll join as {{role}}.',
        ROLE_TUTOR: 'Partner admin',
        ROLE_SUBTUTOR: 'Partner user (read only)',
        REGISTER_HINT: 'Create your account with this email to accept the invitation.',
        REGISTER: 'Create my account',
        LOGIN_HINT: 'You already have an account with this email: log in and the invitation is accepted automatically.',
        LOGIN: 'Log in',
        ACCEPTING: 'Accepting the invitation…',
        OTHER_ACCOUNT: 'You\'re logged in as {{session}}, but the invitation is for {{email}}.',
        SWITCH_ACCOUNT: 'Log out and continue',
        ACCEPT_ERROR: 'Couldn\'t accept the invitation.',
        RETRY: 'Retry',
        INVALID: 'This invitation isn\'t valid or has expired.',
        INVALID_HINT: 'Ask the person who invited you to send a new one.',
        REGISTER_NOTE_TITLE: 'You\'re joining {{partner}}\'s team',
        REGISTER_NOTE_TEXT: 'The account is created with {{email}}, the invitation email.',
      },
      PARTNER: {
        LINKED_TO: 'Your company will be linked to {{partner}}.',
      },
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot your password?',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Sign in',
        SUBTITLE: "We'll send a one-time code to your email or phone — no password needed.",
        TOGGLE_PASSWORD: 'Show or hide the password',
        GOOGLE: 'Continue with Google',
        OR_FORM: 'or with your email or phone',
        GOOGLE_POPUP_BLOCKED: 'Your browser blocked the Google window. Allow pop-ups for this site and try again.',
        GOOGLE_ERROR: 'Could not sign in with Google. Please try again.',
        EMAIL: 'Email',
        SUBMIT: 'Sign in',
        LOADING: 'Please wait...',
        NO_ACCOUNT: "Don't have an account yet?",
        REGISTER_LINK: 'Sign up',
      },
      FORGOT: {
        TITLE: 'Forgot your password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Password reset sent. Please check your email.',
        ERROR: 'Sorry, some errors were detected. Please try again.',
        EMAIL: 'Email',
        EMAIL_HINT:
          'An email with a button to reset your password will be sent. Check your inbox and, if it does not appear, check the spam folder. If you still cannot find it, write to soporte@waiss.com.',
        SUBMIT: 'Send',
        LOADING: 'Please wait...',
        CANCEL: 'Cancel',
        VALIDATION: {
          EMAIL_REQUIRED: 'Email is required',
          EMAIL_INVALID: 'Email is invalid',
          EMAIL_MIN: 'Email must have at least 3 characters',
          EMAIL_MAX: 'Email must have a maximum of 30 characters',
        },
      },
      RESET: {
        TITLE: 'Reset password',
        DESC: 'Enter the token received by email and your new password',
        ERROR: 'Sorry, some errors were detected. Please try again.',
        SUCCESS: 'Password reset successfully. Redirecting to login…',
        TOKEN: 'Token',
        TOKEN_PLACEHOLDER: 'Reset token',
        EMAIL: 'Email',
        NEW_PASSWORD: 'New password',
        CONFIRM_PASSWORD: 'Confirm password',
        SUBMIT: 'Reset password',
        LOADING: 'Please wait...',
        CANCEL: 'Cancel',
        VALIDATION: {
          TOKEN_REQUIRED: 'The token is required',
          EMAIL_REQUIRED: 'Email is required',
          EMAIL_INVALID: 'Email is invalid',
          PASSWORD_REQUIRED: 'The password is required',
          PASSWORD_MIN: 'The password must be at least 8 characters long',
          PASSWORD_CONFIRM_REQUIRED: 'Password confirmation is required',
          PASSWORD_MISMATCH: 'Passwords do not match',
        },
      },
      TWO_FACTOR: {
        TITLE: 'Two-step authentication',
        DESC: 'To continue, choose a two-step authentication method:',
        METHOD_MOBILE: 'Send a code to your phone *****{{phone}}',
        METHOD_EMAIL: 'Send a code to your email {{email}}',
        DEFAULT: 'Default',
        SUBMIT: 'Continue',
        LOADING: 'Please wait...',
      },
      VERIFY: {
        SMS_TITLE: 'We have sent an SMS code',
        SMS_DESC:
          'To phone number ******{{contact}}. Codes are valid for 10 minutes. Did not receive the code? Request a resend in 28 seconds.',
        EMAIL_TITLE: 'We have sent an email',
        EMAIL_DESC:
          'To continue, enter the 6-digit verification code sent to your email: {{contact}}. Codes are valid for 10 minutes. Did not receive the code? Request a resend in 28 seconds.',
        NO_CODE: 'Didn\'t receive the code?',
        RESEND: 'Resend',
        ERROR: 'The code is incorrect',
        LOADING: 'Please wait...',
        SUBMIT: 'Sign In',
      },
      OTP_VERIFY: {
        TITLE: 'Verify your code',
        SUBTITLE_SMS: 'Code sent by SMS to {{contact}}',
        SUBTITLE_EMAIL: 'Code sent by email to {{contact}}',
        CODE_ERROR: 'The code you entered is incorrect',
        SUBMIT: 'Verify and sign in',
        LOADING: 'Verifying...',
        RESEND: 'Resend code',
        RESEND_COUNTDOWN: 'Resend code in {{time}}',
        RESENDING: 'Resending code...',
      },
      LOGIN_OTP: {
        TAB_PHONE: 'Phone',
        TAB_EMAIL: 'Email',
        PHONE_LABEL: 'Phone number',
        PHONE_PLACEHOLDER: '600 000 000',
        PHONE_INVALID: 'Enter a valid phone number',
        PHONE_NOT_REGISTERED: 'This phone number is not registered',
        EMAIL_PLACEHOLDER: 'you@company.com',
        EMAIL_INVALID: 'Enter a valid email address',
        EMAIL_NOT_REGISTERED: 'This email address is not registered',
        SUBMIT: 'Continue',
        LOADING: 'Sending code...',
      },
      WELCOME: {
        EYEBROW: 'Get started now',
        TITLE: 'Create your dashboard',
        SUBTITLE: 'Explore it with sample data or create it now for your company.',
        REGISTER_OPTION: 'Create my space',
        EXPLORE_OPTION: 'Explore the dashboard',
        GOOGLE_OPTION: 'Continue with Google',
        GOOGLE_ERROR: 'Could not sign in with Google. Please try again.',
        HAS_ACCOUNT: 'Already have an account?',
        LOGIN_LINK: 'Sign in',
        VIDEO_TITLE: 'Meet WAIIS',
        VIDEO_SUBTITLE: 'Mobility, made easier',
        VIDEO_DURATION: '{{duration}} min',
        VIDEO_CLOSE: 'Close the video',
      },
      BRAND: {
        TITLE: 'Sustainable mobility, measured with',
        TITLE_END: 'real data.',
        SUBTITLE: 'Your workforce carpools with the app. You see it all in the dashboard.',
        FEATURE_1: 'Your workforce\'s participation, in real time',
        FEATURE_2: 'Trips and CO₂e avoided, measured and verified',
        FEATURE_3: 'PMST report and compliance tracking',
        COPYRIGHT: '© {{year}} WAIIS Solutions Iberia, SL',
      },
      SIGNUP_BRAND: {
        TITLE: 'Your space,',
        TITLE_END: 'in two steps.',
        SUB: 'This is what happens next:',
        STEP_1: 'You create your space',
        STEP_1_SUB: 'Now',
        STEP_2: 'You invite your workforce',
        STEP_2_SUB: 'By email or with a CSV',
        STEP_3: 'Your trial starts',
        STEP_3_SUB: '3 free months from your first employee',
        STEP_4: 'We support you',
        STEP_4_SUB: 'Weekly sessions with our team',
      },
      REGISTER: {
        EYEBROW: 'Step 1 of 2',
        TITLE: 'Create your account',
        TOGGLE_PASSWORD: 'Show or hide the password',
        GOOGLE: 'Continue with Google',
        GOOGLE_POPUP_BLOCKED: 'Your browser blocked the Google window. Allow pop-ups for this site and try again.',
        GOOGLE_SKIP: '— skip this step',
        OR_FORM: 'or with your email',
        FULLNAME: 'Full name',
        FULLNAME_PLACEHOLDER: 'Marta Vidal',
        EMAIL_PLACEHOLDER: 'marta@yourcompany.com',
        BACK: 'Back',
        LEGAL_PREFIX: 'By continuing you accept the',
        LEGAL_TERMS: 'Terms',
        LEGAL_AND: 'and the',
        LEGAL_PRIVACY: 'Privacy Policy',
        LEGAL_SUFFIX: '.',
        EMAIL: 'Work email',
        DNI: 'National ID (DNI)',
        DNI_PLACEHOLDER: '12345678A',
        BIRTH_DATE: 'Date of birth',
        PHONE: 'Phone',
        PHONE_PLACEHOLDER: '+34 600 000 000',
        PASSWORD: 'Password',
        PASSWORD_HINT: 'At least 8 characters, one uppercase letter and one special character.',
        PASSWORD_CONFIRM: 'Confirm password',
        SUBMIT: 'Continue',
        LOADING: 'Please wait...',
        ERROR: 'An error occurred during registration. Please try again.',
        VALIDATION: {
          FULLNAME_REQUIRED: 'Enter your first and last name.',
          EMAIL_REQUIRED: 'Email is required',
          EMAIL_INVALID: 'Enter a valid email.',
          DNI_REQUIRED: 'National ID is required',
          DNI_INVALID: 'Invalid DNI format (8 digits + letter)',
          BIRTH_DATE_REQUIRED: 'Date of birth is required',
          PHONE_REQUIRED: 'Phone number is required',
          PHONE_INVALID: 'Enter a valid Spanish phone number',
          PASSWORD_REQUIRED: 'Password is required',
          PASSWORD_MIN: 'Password must be at least 8 characters',
          PASSWORD_UPPERCASE: 'Password must contain at least one uppercase letter',
          PASSWORD_SPECIAL: 'Password must contain at least one special character',
          PASSWORD_CONFIRM_REQUIRED: 'Please confirm your password',
          PASSWORD_MATCH: 'Passwords do not match',
        },
        PASSWORD_PLACEHOLDER: '••••••••',
        PASSWORD_CONFIRM_PLACEHOLDER: 'Repeat the password',
        PERSONAL_EMAIL: 'This looks like a personal email; better use your work one',
      },
      COMPANY: {
        EYEBROW: 'Step 2 of 2',
        STEP: 'Step 2 of 2 · {{email}}',
        BACK: 'Back',
        TITLE: 'About your company',
        GOOGLE: 'Google',
        PHONE: 'Phone',
        PHONE_PREFIX: 'Country code',
        PHONE_PLACEHOLDER: '600 000 000',
        NAME: 'Company',
        NAME_PLACEHOLDER: 'Logística Norte',
        TAX_ID: 'Tax ID (CIF)',
        TAX_ID_PLACEHOLDER: 'B12345674',
        EMPLOYEES: 'No. of employees',
        EMPLOYEES_PLACEHOLDER: 'Approximate number',
        SUBMIT: 'Create my space',
        SUBMIT_LARGE: 'Continue',
        LEGAL_PREFIX: 'By continuing you accept the',
        LEGAL_TERMS: 'Terms',
        LEGAL_SEP: ', the',
        LEGAL_PRIVACY: 'Privacy policy',
        LEGAL_AND: 'and the',
        LEGAL_DPA: 'DPA',
        LEGAL_TERMS_TITLE: 'Terms and conditions',
        LEGAL_DPA_TITLE: 'Data processing agreement (DPA)',
        LEGAL_CLOSE: 'Close',
        LEGAL_MISSING: 'The current terms and DPA could not be loaded. Reload the page to continue.',
        ERROR: 'Your space could not be created. Please try again.',
        VALIDATION: {
          PHONE_REQUIRED: 'Enter your phone number.',
          PHONE_INVALID: 'Enter a valid phone number.',
          NAME_REQUIRED: 'Enter your company name.',
          TAX_ID_REQUIRED: 'Enter your company tax ID.',
          TAX_ID_INVALID: 'Invalid tax ID',
          EMPLOYEES_REQUIRED: 'Choose your company size.',
          EMPLOYEES_INVALID: 'Enter a whole number greater than 0.',
        },
      },
      LARGE_ACCOUNT: {
        EYEBROW: 'Large accounts',
        TITLE: 'Your account is managed by the {{partner}} team',
        SUBTITLE: 'Companies your size have a dedicated team that sets up the space with you. We have already passed on your details.',
        SENT_TITLE: 'Details sent to {{partner}}',
        SENT_BADGE: '✓ Sent',
        COMPANY: 'Company',
        TAX_ID: 'Tax ID',
        EMPLOYEES: 'Employees',
        CONTACT: 'Contact',
        EMAIL: 'Email',
        PHONE: 'Phone',
        CONTACT_PARTNER: 'Contact {{partner}} ↗',
        WAIT: 'I\'d rather be contacted',
        DEMO_MEANWHILE: 'Meanwhile, explore the sample dashboard →',
        DONE_TITLE: 'Request sent',
        DONE_TEXT: '{{partner}} will write to you at {{email}} within 24–48 h to set up the space for {{company}}.',
        NEXT_TITLE: 'What happens next',
        NEXT_1: '{{partner}} reviews your request and contacts you.',
        NEXT_2: 'You agree on plan and pricing.',
        NEXT_3: '{{partner}} creates your space and you get an email to sign in.',
        DEMO: 'Explore the sample dashboard →',
        TITLE_NO_PARTNER: 'Your account is managed by a dedicated team',
        SENT_TITLE_NO_PARTNER: 'Details sent',
        DONE_TEXT_NO_PARTNER: 'The WAIIS team will write to you at {{email}} within 24–48 h to set up the space for {{company}}.',
        NEXT_1_NO_PARTNER: 'The WAIIS team reviews your request and contacts you.',
        NEXT_3_NO_PARTNER: 'The WAIIS team creates your space and you get an email to sign in.',
        BRAND_TITLE: 'Large accounts,',
        BRAND_TITLE_END: 'with {{partner}}.',
        BRAND_TITLE_END_NO_PARTNER: 'with a dedicated team.',
        BRAND_SUB: 'This is what happens now:',
        STEP_1: 'We receive your details',
        STEP_1_SUB: 'Now',
        STEP_2: '{{partner}} contacts you',
        STEP_2_NO_PARTNER: 'We contact you',
        STEP_2_SUB: 'Their large accounts team',
        STEP_2_SUB_NO_PARTNER: 'Our large accounts team',
        STEP_3: 'You set up your space together',
        STEP_3_SUB: '{{partner}} creates it for you',
        STEP_3_SUB_NO_PARTNER: 'We create it for you',
        STEP_4: 'You launch WAIIS',
        STEP_4_SUB: 'To your whole workforce',
        FOOT_NOTE: 'WAIIS × {{partner}} · Mobility for large workforces',
        EYEBROW_THRESHOLD: 'Large accounts · More than {{threshold}} employees',
        BACK: 'Back',
      },
      SPACE_READY: {
        BRAND_TITLE: 'Your space',
        BRAND_TITLE_END: 'is ready.',
        BRAND_SUB: '{{partner}} has created your space. You can sign in now.',
        LOGIN_TITLE: 'Sign in to your space',
        LOGIN_SUBTITLE: 'With the account you created when you signed up.',
        GOOGLE: 'Continue with Google',
        OR_EMAIL: 'or with your email',
        EMAIL: 'Work email',
        SUBMIT: 'Send code',
        ERROR: 'We couldn\'t sign you in. Please try again.',
        STEP_1: 'Request sent',
        STEP_1_SUB: 'From sign-up',
        STEP_2: '{{partner}} created your space',
        STEP_2_NO_PARTNER: 'We created your space',
        STEP_2_SUB: 'Plan and pricing agreed',
        STEP_3: 'You sign in to your space',
        STEP_3_SUB: 'Now',
        STEP_4: 'You invite your workforce',
        STEP_4_SUB: 'By email or with a CSV',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Full name',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'You must accept the terms and conditions',
        NOT_FOUND: '{{name}} not found',
        INVALID_LOGIN: 'The login details are incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    COMMON: {
      SUCCESS: 'Done',
      OK: 'OK',
      ACCEPT: 'Accept',
      CANCEL: 'Cancel',
      SUBMIT: 'Submit',
      PLEASE_WAIT: 'Please wait...',
      TYPE_TO_SEARCH: 'Type at least 2 characters',
      NO_RESULTS: 'No results found',
      SELECT: 'Select',
      REQUIRED_FIELD: 'This field is required',
      CONFIRM_DELETE_TITLE: 'Confirm deletion',
      FILTERS: 'Filters',
      CLOSE: 'Close',
      LOADING: 'Loading...',
      ACTIVE: 'Active',
      SELECT_DATE_PLACEHOLDER: 'Select a date',
      APPLY_FILTERS: 'Apply filters',
      CLEAR_FILTERS: 'Clear filters',
      REFRESH: 'Refresh',
      EXPORT_CSV: 'Export CSV',
      IMPORT_CSV: 'Import CSV',
      NO_DATA_TITLE: 'No data',
      ERROR: 'Error',
      EXPORT_CSV_ERROR_PREFIX: 'Error exporting CSV: ',
      EMPTY_FILE_TITLE: 'Empty file',
      IMPORT_EMPTY_TEXT: 'The file does not contain any valid records to import.',
      IMPORT_SUCCESS_TITLE: 'Import completed',
      IMPORT_ERROR_TITLE: 'Import error',
      UNKNOWN_ERROR: 'An unknown error occurred',
      PROCESS_ERROR_TITLE: 'Error processing the file',
      CSV_ERRORS: {
        EXPORT_FAILED: 'Could not export the CSV:',
        NO_FILE: 'No file selected',
        INVALID_FILE: 'Please select a valid CSV file',
        EMPTY_FILE: 'The CSV file is empty',
        READ_FAILED: 'Error reading the CSV file:',
        MAP_FAILED: 'Error processing the CSV rows:',
        UNKNOWN: 'Unknown error',
      },
      BREADCRUMB_ARIA: 'Breadcrumb',
    },
    HTTP_ERRORS: {
      FORBIDDEN: {
        TITLE: 'Access denied',
        MESSAGE: 'You do not have access to this resource.',
        CONFIRM: 'Understood',
      },
      FEATURE_LOCKED: {
        TITLE: 'Feature not included in the plan',
        MESSAGE: "This company's plan does not include this feature.",
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    // Cabecera común de las páginas del menú (app-bo-page-header): qué se hace
    // en cada página, en una frase.
    PAGE_HEADER: {
      PARTNER_REQUESTS: 'Large account requests from every partner: reassign them to another partner or create their company.',
      PARTNERS: 'Resellers who bring their own companies. For each one you decide what the partner manages and what the company sees.',
      CORP_LAUNCH_GUIDE: 'The three steps to get WAIIS up and running in your company. Each one is ticked off on its own once you do it.',
      CORP_PLAN: 'Your trial, what is left to keep using WAIIS and the price of the Incentives Plan.',
      CORP_PLAN_PARTNER: 'Your free trial and your annual plan.',
      CORP_WALLET:
        'This month\'s budget, its movements and how it is topped up; your balance, manual top-ups and withdrawals.',
      CORP_TAXI_RIDES:
        'Only the rides the company pays for: how much is spent, who takes them and the detail of each one. Personal rides never appear.',
      CORP_TAXI_POLICY:
        'Company payment for taxi and VTC by group: each group\'s rules, the monthly budget and how it is charged.',
      CORP_TAXI_BOOKINGS:
        'Bookings of several vehicles for an event, a visit or a group. They are booked automatically as Uber, Cabify or Bolt rides and the company pays.',
      CORP_TAXI_REVIEW: 'WAIIS compares every company-paid ride with the employee’s usual pattern and only shows you the ones that need your attention.',
      RIDE_BOOKING_DESK: 'Companies’ group bookings: you see and cancel them; the vehicles are booked automatically.',
      RIDE_BOOKING_DESK_DETAIL: 'A group booking: the company, route, amount, vehicles and history, with the actions for its status.',
      RIDES_CONFIG_BOOKINGS: 'Rules for companies’ group bookings: notice, cancellation, seats per vehicle and notices to WAIIS.',
      RIDES_CONFIG_REVIEW: 'Points, levels, cost, distances and places used to review the rides that companies pay for.',
      RIDES: 'VTC rides booked with Uber, Bolt and Cabify: status, amounts and billing incidents.',
      RIDE_DETAIL: 'A VTC ride: who booked it, route, amounts, billing and the data sent by the provider.',
      ADMIN_HOME:
        'Map of the routines driven in the last 24 hours, and how many there are.',
      TRAVEL_LIST:
        'Shared trips on the platform and their verification. Filter by date, status, distance or company.',
      WAIIS_USERS:
        'Everyone registered in the app. Search by name, email, phone or ID and click a row to see their profile, trips and wallet movements.',
      FRAUD:
        'Fraud scores and signals sent by the data team, and the decision on each account.',
      PAYOUT_REVIEWS:
        'Withdrawals waiting for review: risk, signals and the decision to pay them or not.',
      SUPPORT_CHAT:
        'Live conversations with users. Open several at once in tabs and reply from here.',
      AGENT_CONVERSATIONS:
        'History of agent conversations via app, WhatsApp and phone calls, with their outcome.',
      RECLAMATIONS:
        'User complaints by category and status. Open one to review it and mark it as processed.',
      RECLAMATION_TAXONOMY:
        'Categories and subcategories used to classify complaints. Create or edit the ones you need.',
      CORPORATIONS:
        'Client companies with their offices, employees, trips and plan. Open one to see its profile or enter its dashboard.',
      EMAILS: 'The emails WAIIS sends and their header and footer, with their status in each language. Pick one to edit it.',
      PUSH_NOTIFICATIONS: 'Send a hand-written push notification to one or more app users.',
      EMAIL_EDITOR: 'Edit the subject and content of an email in one language, see how it looks and publish it.',
      EMAIL_LAYOUT_EDITOR: 'Edit the header or footer of every email in one language, see how it looks and publish it.',
      MARKETING_USERS:
        'Registered users: verification, CAE and pooling activity. Filter them and choose which columns to show.',
      REFERRALS:
        'Who has created invitation links, how their funnel is doing and how much each link pays out.',
      PVP_PROMOS:
        'Users with the full price bonus activated: their trip progress and whether it has been paid out. Search and filter by status.',
      PROMOS:
        'Backoffice promotions: the full price bonus (with fraud consequences) and the trip promo. Each tab with its progress and whether it has been paid out.',
      ZONE_AD_IMBALANCE:
        'H3 cells where drivers and riders are out of balance. Filter, check the map and create an ad draft for a cell.',
      ZONE_AD_DRAFTS:
        'Meta ad drafts by zone. Filter by status or audience and open them to review.',
      ZONE_AD_DRAFT:
        'Review a draft: edit it while it is a draft, approve, reject or publish it to Meta.',
      ZONE_AD_TEMPLATES:
        'Image and texts of zone ads. Create, edit, activate or delete templates.',
      ZONE_AD_SETTINGS:
        'How Meta ad drafts are generated for zones with unmatched routines: when, with which values and with which publishing details.',
      ROLES:
        'Backoffice access roles. Create or edit roles and review their actions, permissions and pages.',
      ROLE_ACTIONS:
        'Actions this role can perform. Add, edit or remove actions.',
      ROLE_PERMISSIONS:
        'API operations this role is allowed to use. Add, change or remove permissions.',
      ROLE_PAGES:
        'Backoffice screens this role can see. Add, change or remove pages.',
      USER_ROLE_CORPORATIONS:
        'Which role each user has and in which company or office. Add or remove assignments.',
      CORPORATION_USERS:
        'All company users in one list. Search by name or email, or create a new one.',
      POOLING_RUNNERS:
        'Pooling corridors with their name, description and colour. Open one to view and edit its stops.',
      CREDIT_PROVIDERS:
        'Companies that offer gift cards, their contact details and how many cards they have available.',
      GIFT_CARDS:
        'Gift cards by provider: their value in credits and euros, expiry date and whether they are active.',
      CODES:
        'Codes for each gift card, which user they were assigned to and when they expire. You can import them from CSV.',
      PROMOTIONAL_CODES:
        'Discount codes for rides: type and value, free rides, validity dates and status.',
      PARKING_SPACES:
        'Company parking spaces: type, location, office and availability by shift.',
      PARKING_RESERVATIONS:
        'Parking space bookings: who books, which days and shift, at which office and whether it is shared.',
      PARKING_CREDITS:
        'Each user\'s parking credits: days and shift booked, available balance and expiry date.',
      FOOTPRINT_USERS:
        'Users with their latest recorded footprint and segment. Filter by date and open their trip review.',
      FOOTPRINT_RAW:
        'A user\'s raw footprint on the map. Choose the user and a date range to load their points.',
      TRAVEL_REVIEW:
        'A user\'s trips day by day, on a calendar and a map. Review and classify them one by one.',
      CORRIDORS_REVIEW:
        'Shared-route corridors on the map. Add routines or polylines to see where they overlap.',
      TAGS:
        'Tags used to classify trips during review, with their category and colour. Create, edit and enable them.',
      VALORATION_LABELS:
        'Positive and negative label pairs that drivers and riders use to rate their trips.',
      LABELS:
        'Labels to mark users and pooling routes, such as "VIP". Choose where each one can be assigned.',
      MATCH_REVIEW:
        'Compare driver and rider routines on the map to see whether their routes fit together.',
      MATCHES_LISTING:
        'Matches made between drivers and riders. Filter by status, driver or dates.',
      MATCH_CONFIG_VARIABLES:
        'Settings that control how drivers and riders are matched. Edit each value in the table.',
      POIS:
        'Pick-up and drop-off points by category. Review them on the map or upload a new list.',
      CREDIT_TYPES:
        'Available credit types with their description and value. You can edit them or add new ones.',
      COMMISSIONS:
        'Commissions Waiis charges, with their description and amount. You can edit them or add new ones.',
      FRAUD_RULES:
        'Limits that flag a ride as suspicious, and the notice drivers see under enhanced verification.',
      CONFIG_VARIABLES:
        'Variables that adjust how the platform behaves. Create, edit, import or export them as CSV and turn on logs.',
      APP_ANNOUNCEMENT:
        "Announcement people see when they open the app until they tap the button. Turn it on, write the texts in each language and publish it.",
      TERMS_CONDITIONS:
        'Terms and conditions people accept on the dashboard and in the app. Edit and publish a new version.',
      CONTRACT_TEMPLATES:
        'Template for the contract generated for companies. Edit it and save it as a new version.',
      DATA_PROCESSING_AGREEMENT:
        'Data processing agreement (DPA) companies accept when they sign up. Saving publishes it.',
      PMST_GOAL:
        'Legal minimum and company target for the share of staff registered in the PMST, per company or office.',
      PMST_QUESTIONNAIRE:
        'Steps and questions in the PMST form companies fill in. Reorder, edit and preview them.',
      PMST_QUESTIONNAIRE_RESPONSES:
        'PMST questionnaire answers sent by each company. Filter by company and, optionally, by office.',
      FACE_VERIFICATION:
        'When users are required to pass face verification and which Rekognition thresholds make it count as passed.',
      RIDES_SETTINGS:
        'General ride settings: enable VTC, commission, cancellation penalty and adjustments for actual fare or receipt.',
      RIDES_GUEST_PHONES:
        'Phone numbers registered as guests for rides. Add, edit or deactivate them.',
      RIDES_PROVIDER_ROUTING:
        'Which provider a user sees in estimates according to their tag. Tags are assigned by the data team.',
      RIDES_PROVIDERS:
        'Ride products riders see and how each provider\'s products map to them, in display order.',
      SUPPORT_SNIPPETS:
        'Texts the support team inserts from the chat. Drag the rows to change the order in which they appear.',
    },
    WAIIS: {
      // Marketing › Correos: listado de plantillas, cabecera y pie.
      EMAILS: {
        LAYOUTS_TITLE: 'Header and footer',
        LAYOUTS_SUB: 'The pieces shared by every email.',
        HEADER: 'Header',
        FOOTER: 'Footer',
        TEMPLATES_TITLE: 'Templates',
        TEMPLATES_SUB: 'Each email with the status of its languages. Click a language to open its editor.',
        COL_PIECE: 'Piece',
        COL_EMAIL: 'Email',
        COL_LOCALES: 'Languages',
        SEARCH: 'Search by name or code…',
        SEARCH_ARIA: 'Search emails',
        STATE_PUBLISHED: 'Published',
        STATE_DRAFT: 'Draft',
        STATE_EMPTY: 'No content',
        STATE_ARCHIVED: 'Archived',
        PUBLISHED_VERSION: 'Published version: v{{version}}',
        OPEN_LOCALE: 'Open {{name}} in {{locale}}',
        NO_MATCH: 'No email matches the search',
        EMPTY: 'There are no editable emails.',
        LOAD_ERROR_TEMPLATES: 'The emails could not be loaded.',
        LOAD_ERROR_LAYOUTS: 'The header and footer could not be loaded.',
        RETRY: 'Retry',
        HEALTH_COUNT: 'Problems: {{count}}',
        HEALTH_LOCALES: 'Problems in the published version of: {{locales}}',
        EDITOR: {
          TITLE: 'Email editor',
          ALIAS: 'Alias',
          ALIAS_ADD: 'Add alias',
          ALIAS_EDIT: 'Change alias',
          ALIAS_SAVE: 'Save alias',
          ALIAS_CANCEL: 'Cancel',
          ALIAS_HINT: 'The name shown in Emails. Leave it empty to use the internal name.',
          ALIAS_SAVED: 'Alias saved',
          ALIAS_ERROR: 'The alias could not be saved',
          HEALTH_TITLE: 'Published version v{{version}} has problems',
          HEALTH_SUB: 'Fix what is listed below, save and publish. This warning does not prevent saving or publishing.',
          LOCALE: 'Language',
          UNSAVED: 'Unsaved changes',
          CONTENT_TITLE: 'Content',
          CONTENT_SUB: 'The subject, preheader and body of the email in this language.',
          SUBJECT: 'Subject',
          PREHEADER: 'Preheader',
          PREHEADER_HINT: 'The text the inbox shows next to the subject. Optional.',
          BODY_HTML: 'Content (HTML)',
          BODY_BLOCKS: 'Content (blocks in JSON)',
          JSON_INVALID: 'Invalid JSON',
          SAVE: 'Save draft',
          SAVING: 'Saving…',
          SAVED: 'Draft saved',
          SAVE_ERROR: 'The draft could not be saved',
          DISCARD: 'Discard draft',
          DISCARD_TITLE: 'Discard the draft',
          DISCARD_TEXT: 'The draft is deleted and the editor goes back to the published version.',
          DISCARD_CONFIRM: 'Discard',
          DISCARD_SAVING: 'Discarding…',
          DISCARD_DONE: 'Discarded',
          DISCARD_ERROR: 'The draft could not be discarded',
          PUBLISH: 'Publish',
          PUBLISH_TITLE: 'Publish the draft',
          PUBLISH_TEXT: 'Emails sent from now on in this language will use this version.',
          PUBLISH_CONFIRM: 'Publish',
          PUBLISH_SAVING: 'Publishing…',
          PUBLISH_DONE: 'Published',
          PUBLISH_ERROR: 'It could not be published',
          PUBLISH_NEEDS_SAVE: 'Save the draft before publishing',
          TEST_SEND: 'Send test',
          TEST_SENDING: 'Sending…',
          TEST_SENT: 'Sent to {{email}}',
          TEST_ERROR: 'The test could not be sent',
          TEST_NEEDS_SAVE: 'Save the draft to send yourself a test',
          PREVIEW: 'Preview',
          PREVIEW_TITLE: 'Preview',
          PREVIEW_SUB: 'How the content in the editor looks.',
          PREVIEW_VERSION: 'Version {{version}}, as it was saved.',
          PREVIEW_EMPTY: 'Press «Preview» to see the email.',
          PREVIEW_ERROR: 'The preview could not be generated.',
          DEVICE: 'Device',
          DESKTOP: 'Desktop',
          MOBILE: 'Mobile',
          SCHEME: 'Theme',
          LIGHT: 'Light',
          DARK: 'Dark',
          VERSIONS_TITLE: 'Versions',
          VERSIONS_SUB: 'Pick one to see how it was; you can go back to it.',
          VERSIONS_ERROR: 'The versions could not be loaded.',
          VERSIONS_EMPTY: 'There are no saved versions yet.',
          EDITING: 'What you are editing',
          ACTIVE: 'Active',
          ROLLBACK: 'Revert to this version',
          ROLLBACK_TITLE: 'Revert to version {{version}}',
          ROLLBACK_TEXT: 'A new draft is created with the content of that version. Anything you have not saved is lost.',
          ROLLBACK_CONFIRM: 'Revert',
          ROLLBACK_SAVING: 'Reverting…',
          ROLLBACK_DONE: 'Draft created',
          ROLLBACK_ERROR: 'It could not be reverted to that version',
          VARIABLES_TITLE: 'Variables',
          VARIABLES_SUB: 'What you can use in the subject, preheader and content.',
          VARIABLES_EMPTY: 'This email has no variables.',
          MUST_APPEAR: 'Must appear',
          UNSAVED_TITLE: 'You have unsaved changes',
          UNSAVED_TEXT: 'If you continue, they will be lost.',
          UNSAVED_LEAVE: 'Continue without saving',
          CANCEL: 'Cancel',
          ACCEPT: 'OK',
          LOAD_ERROR: 'The email could not be loaded.',
          BACK: 'Back to the list',
        },
        // Editor de la cabecera y el pie.
        LAYOUT_EDITOR: {
          TITLE: '{{piece}} · {{locale}}',
          NOT_FOUND_TITLE: 'Piece not found',
          NOT_FOUND: 'That piece or that language does not exist.',
          LOAD_ERROR: 'The piece could not be loaded.',
          CONTENT_SUB: 'What every email carries in this language.',
          ALLOWED_BLOCKS: 'Blocks it accepts: {{types}}.',
        },
      },
      AGENT_CONVERSATIONS: {
        CHANNELS: {
          IN_APP: 'In-app',
          WHATSAPP: 'WhatsApp',
          CALL: 'Calls',
        },
        CHANNEL_SUBTITLES: {
          IN_APP: 'User chats with the AI agents inside the app. Choose one to see the full thread.',
          WHATSAPP: 'AI agent conversations on WhatsApp. Choose one to see the full thread.',
          CALL: 'Calls handled by the AI agents, with their transcript. Choose one to see it in full.',
        },
        OUTCOMES: {
          RESOLVED: 'Resolved',
          ESCALATED: 'Escalated',
          UNRESOLVED: 'Unresolved',
          UNKNOWN: 'Unclassified',
        },
        NOTES: {
          RESOLVED_HUMAN: 'Conversation resolved with human intervention',
          RESOLVED_AUTO: 'Conversation resolved automatically',
          ESCALATED: 'Conversation escalated to the support team',
          UNRESOLVED: 'Unresolved conversation',
          UNKNOWN: 'Unclassified outcome',
        },
        USER_FALLBACK: 'User',
        FIRST_NAME_FALLBACK: 'the user',
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
        CHANNEL_ARIA: 'Channel',
        SEARCH_PLACEHOLDER: 'Search conversation, user or agent...',
        SEARCH_ARIA: 'Search conversations',
        PERIOD_ARIA: 'Period',
        AGENT_ARIA: 'Agent',
        OUTCOME_ARIA: 'Outcome',
        CLEAR_FILTERS: 'Clear filters',
        LIST_ARIA: 'Conversations',
        LOADING: 'Loading conversations',
        RETRY: 'Retry',
        EMPTY: 'No {{channel}} conversations match the filters.',
        LOADING_MORE: 'Loading more conversations...',
        LOAD_MORE: 'Load more',
        THREAD_ARIA: 'Conversation',
        PERIOD: {
          D7: 'Period: 7 days',
          D30: 'Period: 30 days',
          D90: 'Period: 90 days',
          ALL: 'Period: all',
        },
        OUTCOME_ALL: 'Outcome: all',
        OUTCOME_OPTION: 'Outcome: {{label}}',
        AGENT_ALL: 'Agent: all',
        AGENT_OPTION: 'Agent: {{name}}',
        LOAD_ERROR: 'Could not load the conversation history.',
        DETAIL_ERROR: 'Could not load the conversation.',
        PANEL_CALLS: 'Calls with agents',
        PANEL_CHANNEL: '{{channel}} conversations',
        COUNT_ONE: '1 conversation',
        COUNT_OTHER: '{{count}} conversations',
        SHOWING: 'Showing {{shown}} of {{total}} conversations',
        THREAD: {
          SELECT_TITLE: 'Select a conversation',
          SELECT_TEXT: 'Choose a conversation from the list to see how the agent handled it.',
          REF_COPIED: 'Reference copied',
          COPY_REF: 'Copy reference',
          OPENS_NEW_TAB: 'Opens in a new tab',
          VIEW_PROFILE_OF: "View {{name}}'s profile",
          CHANNEL: 'Channel',
          MESSAGES: 'Messages',
          DURATION: 'Duration',
          INTERVENTION: 'Intervention',
          RECORDING_UNAVAILABLE: 'Call recording not available in the back office.',
          NO_TRANSCRIPT: 'There is no transcript of this call yet.',
          NO_MESSAGES: 'This conversation has no messages.',
          OUTCOME_PENDING_TEXT: 'The system has not yet indicated whether this conversation was resolved, escalated or left unresolved.',
          CALL_SUMMARY: 'Call summary',
          DETECTED_REASON: 'Detected reason',
          MESSAGES_ONE: '1 message',
          MESSAGES_OTHER: '{{count}} messages',
          WITH_HUMAN: 'With human intervention',
          WITHOUT_HUMAN: 'No human intervention',
          TRANSCRIPT: 'Transcript',
        },
      },
      COMPLAINTS: {
        SEARCH_CODE: 'Search code',
        FILTERS: 'Filters',
        CLOSE: 'Close',
        SELECT_DATE: 'Select a date',
        APPLY_FILTERS: 'Apply filters',
        CLEAR: 'Clear',
        EXPORT_CSV: 'Export CSV',
        ADD: 'Add incident',
        CREATE_TITLE: 'Create incident',
        EDIT_TITLE: 'Edit incident',
        FIELDS: {
          CONTEXT: 'Context',
          TYPE: 'Type',
          REASON: 'Reason',
          REPORTER: 'Reporter',
          REPORTED: 'Reported user',
          ASSIGN_TO: 'Assign to',
          DESCRIPTION: 'Description',
          DATE: 'Date',
          STATUS: 'Status',
          ASSIGNED_TO: 'Assigned to',
          LAST_UPDATE: 'Last update',
          COMMENT: 'Comment',
        },
        REQUIRED: {
          CONTEXT: 'Context is required',
          TYPE: 'Type is required',
          REASON: 'Reason is required',
          REPORTER: 'Reporter is required',
          REPORTED: 'Reported user is required',
          DESCRIPTION: 'Description is required',
          COMMENT: 'Comment is required',
        },
        CANCEL: 'Cancel',
        ACCEPT: 'OK',
        WAIT: 'Please wait...',
        SUCCESS_TITLE: 'Done',
        ERROR_TITLE: 'Error',
        CREATED: 'The incident was created successfully',
        UPDATED: 'The incident was updated successfully',
        ASSIGNED: 'The incident was assigned successfully',
        STATUS: {
          PENDING: 'Pending',
          ASSIGNED: 'Assigned',
          IN_PROGRESS: 'In progress',
          RESOLVED: 'Resolved',
        },
        CONTEXT: {
          TRAVEL: 'End trip',
          UNMATCH: 'Unmatch',
          TRAVEL_LINK: 'Link in the trip',
          PROFILE_LINK: 'Profile link',
        },
        TYPE: {
          UNMATCH: 'Unmatch',
          TRAVEL: 'Trip',
        },
        REASON: {
          CLEANLINESS: 'Cleanliness',
          DELAY: 'Delay',
          SAFETY: 'Safety',
          BEHAVIOUR: 'Behaviour',
        },
        DETAIL: {
          BACK: 'Back',
          PROBLEM_INFO: 'Problem information',
          ASSIGN: 'Assign incident',
          MANAGE: 'Manage incident',
          TYPE: 'Type:',
          REASON: 'Reason:',
          STATUS: 'Status:',
          EXPLANATION: 'Explanation:',
          ASSIGNED_TO: 'Assigned to:',
          COMMENT: 'Comment:',
          TRIP_INFO: 'Trip information',
          TRIP_ID: 'Trip ID:',
          DATE: 'Date:',
          ORIGIN: 'Origin:',
          DESTINATION: 'Destination:',
          DRIVER: 'Driver:',
          PASSENGER: 'Passenger:',
          REPORTED_INFO: 'Reported user information',
          REPORTER_INFO: 'Reporting user information',
          NAME: 'Name:',
          SURNAME: 'Surname:',
          PHONE: 'Phone:',
          EMAIL: 'Email:',
          ROLE: 'Role:',
          USER_ID: 'User ID:',
        },
      },
      RIDES: {
        SEARCH_PLACEHOLDER: 'Search by name, email or phone',
        FROM: 'From',
        TO: 'To',
        ALL_PROVIDERS: 'All providers',
        ALL_STATES: 'All states',
        INCIDENT_FILTER: 'Billing incidents only',
        COL_DATE: 'Date',
        COL_USER: 'User',
        COL_PROVIDER: 'Provider',
        COL_ROUTE: 'Route',
        COL_AMOUNT: 'Amount',
        COL_STATE: 'Status',
        COL_ACTIONS: 'Actions',
        SCHEDULED_FOR: 'Scheduled: {{date}}',
        EMPTY: 'No rides match these filters',
        ERROR: 'Rides could not be loaded',
        NOT_FOUND: 'The ride does not exist',
        RETRY: 'Retry',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        PAGINATION: 'Showing {{shown}} of {{total}} rides',
        BACK: 'Back to rides',
        DETAIL_TITLE: 'Ride detail',
        BACK_TO_LIST: 'Back to list',
        LOADING: 'Loading the ride…',
        COPY_ID: 'Copy ID',
        ID_COPIED: 'ID copied',
        NO_FIELDS: 'No data',
        RAW_TITLE: 'Full data',
        RAW_SUB: 'As sent by the provider (JSON).',
        RAW_SHOW: 'Show full data',
        RAW_HIDE: 'Hide',
        SECTION_SUB: {
          SUMMARY: 'Provider, product, dates and trip identifiers.',
          ROUTE: 'Pickup, dropoff, driver, vehicle and rating.',
          AMOUNTS: 'Provider fare, commission, coupon and final amount.',
          BILLING: 'User payment, settlement and billing incidents.',
          CANCELLATION: 'Cancellation data sent by the provider.',
          RECEIPT: 'Receipt data sent by the provider.',
        },
        NO_PAYMENT: 'No payment recorded',
        STATE: {
          SCHEDULED: 'Scheduled',
          REQUESTED: 'Requested',
          ACCEPTED: 'Accepted',
          ARRIVING: 'Arriving',
          ARRIVED: 'Driver arrived',
          IN_PROGRESS: 'In progress',
          COMPLETED: 'Completed',
          NO_DRIVERS: 'No drivers',
          CANCELLED_BY_RIDER: 'Cancelled by rider',
          CANCELLED_BY_DRIVER: 'Cancelled by driver',
          FAILED: 'Failed',
        },
        INCIDENT: {
          DEFERRED_CHARGE_DEBT: 'Debt: failed charge',
          RECEIPT_MANUAL_REVIEW: 'Receipt in manual review',
        },
        SECTION: {
          SUMMARY: 'Summary',
          ROUTE: 'Route and driver',
          AMOUNTS: 'Amounts',
          BILLING: 'Billing',
          CANCELLATION: 'Cancellation',
          RECEIPT: 'Provider receipt',
        },
        FIELD: {
          USER: 'User',
          PRODUCT: 'Product',
          CREATED_AT: 'Created',
          SCHEDULED_AT: 'Scheduled for',
          ACCEPTED_AT: 'Accepted',
          UPDATED_AT: 'Last update',
          PROVIDER_TRIP_ID: 'Provider trip ID',
          PROVIDER_PRODUCT_ID: 'Provider product ID',
          PICKUP: 'Pickup',
          DROPOFF: 'Dropoff',
          DRIVER: 'Driver',
          VEHICLE: 'Vehicle',
          RATING: 'Rating',
          PROVIDER_FARE: 'Provider fare',
          COMMISSION: 'Commission',
          FARE: 'Estimated fare',
          PROVIDER_FINAL: 'Provider final amount',
          FINAL_COMMISSION: 'Final commission',
          FINAL: 'Final amount',
          COUPON: 'Coupon',
          PAYMENT: 'Payment',
          REFUNDED: 'Refunded',
          SETTLEMENT_REFUNDED: 'Refunded at settlement',
          SETTLEMENT_APPLIED_AT: 'Settlement applied',
          DEFERRED_CHARGE: 'Failed deferred charge',
          ATTEMPTS: 'Attempts',
          RECEIPT_FALLBACK: 'Receipt pending since',
          ALERTED_AT: 'Manual review alert',
          RIDE_ID: 'Ride ID',
        },
      },
      TRAVEL_LIST: {
        RANGE_7: 'Range: 7 days',
        RANGE_30: 'Range: 30 days',
        RANGE_90: 'Range: 90 days',
        RANGE_365: 'Range: 1 year',
        RANGE_ALL: 'Range: all',
        KM_ANY: 'Km: any',
        KM_LT: 'Km: under {{km}}',
        KM_GT: 'Km: over {{km}}',
        TYPE_RECURRING: 'Routine',
        TYPE_PUNCTUAL: 'One-off',
        TYPE_FLEET: 'Taxi/VTC',
        TAB_ALL: 'All',
        TAB_RECURRING: 'Routine',
        TAB_PUNCTUAL: 'One-off',
        TAB_FLEET: 'Taxi/VTC',
        STATUS_PENDING: 'Pending',
        STATUS_ONGOING: 'In progress',
        STATUS_IN_REVIEW: 'In review',
        APP_SHOWS_VERIFYING: "In the app: «Verificando»",
        APP_VERIFYING_HINT: "Verified, but the driver has not been paid yet (cash delay). Until then the app shows «Verificando» to the driver and the passengers.",
        STATUS_REINFORCED_REVIEW: 'In enhanced review',
        STATUS_VERIFIED: 'Verified',
        STATUS_UNREALIZED: 'Not verified',
        STATUS_CANCELLED: 'Cancelled',
        VERIF_SHARED: 'Shared',
        VERIF_SHARED_H3: 'Shared (H3)',
        VERIF_BLUETOOTH: 'Bluetooth',
        VERIF_TEMPORAL: 'Time-based',
        VERIF_NONE: 'Unverified',
        FILTER_TYPE_ALL: 'Type: all',
        FILTER_STATUS_ALL: 'Status: all',
        FILTER_VERIFICATION_ALL: 'Verification: all',
        FILTER_COMPANY_ALL: 'Company: all',
        FILTER_RUNNER_ALL: 'Runner: all',
        SEARCH_PLACEHOLDER: 'Search by ID, user, match...',
        SEARCH_ARIA: 'Search trips',
        ARIA_DATE_RANGE: 'Date range',
        ARIA_TRIP_TYPE: 'Trip type',
        ARIA_STATUS: 'Trip status',
        ARIA_VERIFICATION: 'Verification method',
        ARIA_DISTANCE: 'Distance',
        ARIA_COMPANY: 'Company',
        ARIA_RUNNER: 'Runner',
        ARIA_IDENTITY: 'Identity',
        UNVERIFIED_IDENTITY_FILTER: 'Unverified identity',
        LOADING_ARIA: 'Loading trips',
        COL_ID: 'ID',
        COL_DATE: 'Date',
        COL_ROUTE: 'Route',
        COL_KM: 'Km',
        COL_TYPE: 'Type',
        COL_DRIVER: 'Driver',
        COL_PASSENGERS: 'Passengers',
        COL_VERIFICATION: 'Verification',
        COL_PRICE: 'Price',
        COL_PRICE_RECEIVED: 'Price received',
        COL_STATUS: 'Status',
        COL_ACTIONS: 'Actions',
        LOAD_ERROR: 'The trip list could not be loaded.',
        EXPORT_ERROR: 'The list could not be exported.',
        CSV_FILE_PREFIX: 'trips',
        RETRY: 'Retry',
        EMPTY: 'No trips match the filters.',
        UNVERIFIED_TOOLTIP: 'A participant took this trip without a verified identity',
        UNVERIFIED_BADGE: 'No identity',
        CASH_DELAY_TITLE: 'Cash delay: the driver won\'t have this amount in their balance until {{date}} at {{time}}. The app doesn\'t show this.',
        CASH_DELAY_LABEL: 'Cash payout: {{date}} {{time}}',
        CASH_DELAY_DAYS_LABEL: 'Cash · day {{day}}/{{total}} · {{date}}',
        CASH_DELAY_DUE_LABEL: 'Cash · day {{day}}/{{total}} · credited in a few minutes',
        REINFORCED_HOLD_TITLE: 'Enhanced verification: the driver gets this trip in their balance on {{date}} at {{time}}. If they leave enhanced verification earlier, it is credited on the next run (every 10 min).',
        REINFORCED_HOLD_LABEL: 'Credited on {{date}}',
        REINFORCED_HOLD_DAYS_LABEL: 'Day {{day}}/{{total}} · credited on {{date}}',
        REINFORCED_HOLD_DUE_LABEL: 'Day {{day}}/{{total}} · credited in a few minutes',
        PAGINATION: 'Showing {{shown}} of {{total}} trips',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        PANEL_ALL_TITLE: 'All trips',
        PANEL_ALL_SUB: 'Routine, one-off and taxi/VTC. Click a trip to see who was in the car; the › arrow opens its details.',
        PANEL_RECURRING_TITLE: 'Routine trips',
        PANEL_RECURRING_SUB: 'Journeys that are part of users\' routines. Click one to see who was in the car; the › arrow opens its details.',
        PANEL_PUNCTUAL_TITLE: 'One-off trips',
        PANEL_PUNCTUAL_SUB: 'Single-day journeys outside the routine. Click one to see who was in the car; the › arrow opens its details.',
        PANEL_FLEET_TITLE: 'Taxi/VTC trips',
        PANEL_FLEET_SUB: 'Taxi or VTC trips booked from the app. Click one to see its details.',
        OPEN_TRIP: 'Open trip',
        DRAWER: {
          EYEBROW: 'Trip details',
          LOADING: 'Loading trip…',
          NOT_FOUND: 'The requested trip was not found.',
          TIMEOUT: 'The server did not respond in time. Please try again.',
          LOAD_ERROR: 'The trip details could not be loaded.',
          MARKER_PICKUP: 'Pickup · {{name}}',
          MARKER_DROPOFF: 'Drop-off · {{name}}',
          LEGEND_REFERENCE: 'Planned footprint (driver\'s route)',
          LEGEND_TRACE: 'Actual footprint (driver)',
          ORIGIN_DESTINATION: 'Origin / Destination',
          DRIVER: 'Driver',
          FOOTPRINT: 'Footprint',
          NO_DRIVER: 'No driver data.',
          PASSENGERS: 'Passengers',
          COL_PASSENGER: 'Passenger',
          COL_VERIFICATION: 'Verification',
          COL_STATUS: 'Status',
          COL_PICKUP_DISTANCE: 'Pickup dist.',
          COL_DESTINATION_DISTANCE: 'Destination dist.',
          NO_PASSENGERS: 'No passengers.',
          TRIP_DATA: 'Journey data',
          DATE_TIME: 'Date and time',
          DISTANCE_LISTING: 'Distance (list)',
          DRIVER_DETOUR: 'Driver detour',
          DURATION: 'Duration',
          PASSENGER_FOOTPRINTS: 'Passenger footprints',
          N_VERIFIED: '{{count}} verified',
          N_PENDING: '{{count}} pending',
          N_REJECTED: '{{count}} rejected',
          WAYPOINTS: 'Waypoints',
          NO_WAYPOINTS: 'No waypoints recorded.',
          IDENTIFIER: 'Identifier',
          FOOTPRINT_PENDING: 'Pending',
          FOOTPRINT_VERIFIED: 'Verified',
          FOOTPRINT_REJECTED: 'Rejected',
          FOOTPRINT_IN_REVIEW: 'In review',
          APP_SHOWS_VERIFYING: "In the app: «Verificando»",
          APP_VERIFYING_HINT: "Verified, but the driver has not been paid yet. Until then the app shows «Verificando» to the driver and the passengers.",
          FOOTPRINT_CANCELLED: 'Cancelled',
          STATUS: {
            PENDING: 'Pending',
            IN_PROGRESS: 'In progress',
            ONGOING: 'In progress',
            ACCEPTED: 'Accepted',
            CONFIRMED: 'Confirmed',
            COMPLETED: 'Completed',
            VERIFIED: 'Verified',
            IN_REVIEW: 'In review',
            REJECTED: 'Rejected',
            CANCELLED: 'Cancelled',
          },
          ACTION: {
            PICKUP: 'Pickup',
            DROPOFF: 'Drop-off',
          },
        },
      },
      CORRIDORS_REVIEW: {
        LOAD_CORRIDORS: 'Load corridors',
        LOADING: 'Loading…',
        ADD_ROUTINE: 'Add routine',
        LOAD_POLYLINE: 'Load polyline',
        PROCESSING: 'Processing…',
        MAP_TITLE: 'Corridor map',
        MAP_SUBTITLE: 'Pooling corridors, added routines and polylines loaded from file.',
        H3_SEARCH_PLACEHOLDER: 'Search H3…',
        H3_SEARCH_ARIA: 'H3 identifier',
        SEARCH: 'Search',
        SEARCHING: 'Searching…',
        SHOW_ALL: 'Show all',
        HIDE_ALL: 'Hide all',
        FIT_ALL: 'Fit all',
        FIT_ALL_TOOLTIP: 'Fit the map to show all corridors',
        EMPTY_HINT: 'Click "Load corridors" to see the data on the map',
        LEGEND_LABEL: 'Corridors',
        SHOW_ON_MAP: 'Show on the map',
        HIDE_ON_MAP: 'Hide on the map',
        ADD_ROUTINE_SUB: 'Origin and destination coordinates as "latitude, longitude"',
        ORIGIN: 'Origin',
        DESTINATION: 'Destination',
        CREATING: 'Creating…',
        CREATE_ROUTE: 'Create route',
        ROUTE_NAME: 'Route {{n}}',
        POLYLINE_NAME: 'Polyline {{id}}',
        INVALID_COORDINATES: 'Invalid format. Use: 41.67520306862359, -0.8767050772489519',
        NOT_ENOUGH_POINTS: 'The route doesn\'t return enough points to draw.',
        ROUTE_ERROR: 'The route could not be generated. Check the coordinates and endpoint.',
        POLYLINE_NO_COORDINATES: 'No valid coordinates could be extracted from the file. Use: JSON with a LineString, JSON with an encoded polyline, or just the encoded polyline.',
        POLYLINE_UNKNOWN_ERROR: 'Unknown error while loading the file.',
        POLYLINE_READ_ERROR: 'Error reading the file.',
        H3_REQUIRED: 'Please enter an H3 identifier',
        H3_INVALID: 'The H3 identifier is not valid',
        MAP_UNAVAILABLE: 'The map is not available. Please try again.',
        H3_PROCESS_ERROR: 'Error processing the H3 hexagon: {{detail}}',
        UNKNOWN_ERROR: 'Unknown error',
      },
      POOLING_RUNNERS_ADMIN: {
        ITEMS: 'runners',
        COL_NAME: 'Name',
        COL_DESCRIPTION: 'Description',
        COL_COLOR: 'Color',
        COL_CREATED: 'Created',
        COL_UPDATED: 'Updated',
        DETAIL_TITLE: 'Details',
        DETAIL_SUBTITLE: 'Runner data and its stops. Click a stop to change its order or enable it.',
        BACK: 'Back',
        BACK_TO_LIST: 'Back to list',
        RETRY: 'Retry',
        EDIT: 'Edit',
        DETAILS_TITLE: 'Runner details',
        STOPS_TITLE: 'Stops',
        STOPS_COUNT: '{{count}} stop(s)',
        COL_ORDER: 'Order',
        COL_LOCALITY: 'Locality',
        COL_ADDRESS: 'Address',
        COL_TYPE: 'Type',
        COL_COORDINATES: 'Coordinates',
        NO_STOPS: 'This runner has no associated stops',
        EDIT_RUNNER_TITLE: 'Edit runner',
        EDIT_STOP_TITLE: 'Edit stop',
        NAME_PLACEHOLDER: 'Runner name',
        NAME_REQUIRED: 'Name is required',
        NAME_MAXLENGTH: 'Name cannot exceed {{max}} characters',
        DESCRIPTION_PLACEHOLDER: 'Runner description',
        DESCRIPTION_MAXLENGTH: 'Description cannot exceed {{max}} characters',
        PICK_COLOR: 'Pick color',
        COLOR_REQUIRED: 'Color is required',
        COLOR_INVALID: 'Color must be a valid hex value (#RRGGBB)',
        ORDER_PLACEHOLDER: 'Stop order',
        ORDER_REQUIRED: 'Order is required',
        ORDER_MIN: 'Order must be 0 or greater',
        ENABLED: 'Enabled',
        SAVE: 'Save',
        SAVING: 'Saving...',
        LOAD_ERROR: 'Error loading the runner data',
        LOAD_ERROR_SWAL: 'The runner data could not be loaded',
        STOPS_LOAD_ERROR: 'The stops could not be loaded.',
        SAVE_SUCCESS: 'Runner updated successfully',
        SAVE_ERROR: 'The runner could not be updated',
        STOP_SAVE_SUCCESS: 'Stop updated successfully',
        STOP_SAVE_ERROR: 'The stop could not be updated',
      },
      FOOTPRINT_STATISTICS: {
        TITLE: 'Location capture',
        SUBTITLE: 'Moving averages of points per day and GPS accuracy for each period (up to yesterday).',
        HELP_LINK: 'What are these metrics?',
        EXPAND: 'Expand',
        COLLAPSE: 'Collapse',
        POINTS_PER_DAY: 'Points/day',
        POINTS_PER_DAY_UNIT: 'points/day',
        ACCURACY_3_DAYS: 'Accuracy (last 3 days)',
        AVG_ERROR_METERS: 'metres of average error',
        CHANGE_VS_WEEK: 'Change vs last week',
        POINTS_VARIATION: 'Change in points/day',
        CHART_TITLE: 'Data and accuracy trend',
        CHART_QUESTION: 'How many points are captured per day, and how accurately, in each period? From the longest (left) to the most recent (right).',
        SERIES_ACCURACY_POSITION: 'Accuracy (position)',
        SERIES_ACCURACY_SPEED: 'Accuracy (speed)',
        BY_PERIOD_ARIA: '{{series}} by period',
        VIEW_DATA: 'View the data',
        PERIOD: 'Period',
        NO_DATA: 'No data for any period.',
        SUMMARY_BY_PERIOD: 'Summary by period',
        ACCURACY_POS_SHORT: 'Accuracy (pos)',
        ACCURACY_SPEED_SHORT: 'Accuracy (speed)',
        VS_PREVIOUS_PERIOD: 'Compared with the previous period in the list',
        STATUS_GOOD: 'Good',
        STATUS_WARNING: 'Warning',
        STATUS_CRITICAL: 'Critical',
        INSIGHT: '{{period}}: {{points}} points per day, with {{accuracy}} m average position error',
        INSIGHT_SAME: '; the same as last week.',
        INSIGHT_MORE: '; {{pct}}% more than last week.',
        INSIGHT_LESS: '; {{pct}}% fewer than last week.',
        PERIODS: {
          LAST_3_DAYS: 'Last 3 days',
          LAST_WEEK: 'Last week',
          LAST_15_DAYS: 'Last 15 days',
          LAST_MONTH: 'Last month',
          LAST_2_MONTHS: 'Last 2 months',
          LAST_QUARTER: 'Last quarter',
          LAST_4_MONTHS: 'Last 4 months',
          LAST_5_MONTHS: 'Last 5 months',
          LAST_6_MONTHS: 'Last 6 months',
        },
        PERIODS_SHORT: {
          LAST_3_DAYS: '3 days',
          LAST_WEEK: 'week',
          LAST_15_DAYS: '15 days',
          LAST_MONTH: 'month',
          LAST_2_MONTHS: '2 months',
          LAST_QUARTER: 'quarter',
          LAST_4_MONTHS: '4 months',
          LAST_5_MONTHS: '5 months',
          LAST_6_MONTHS: '6 months',
        },
      },
      FOOTPRINT: {
        ITEMS: 'users',
        RAW_FOOTPRINT: 'Raw footprint',
        RAW_FOOTPRINT_TOOLTIP: "View users' raw footprint",
        SEARCH_PLACEHOLDER: 'Search name or email',
        REMOVE_FILTER: 'Remove {{label}}',
        OPEN_CALENDAR: 'Open calendar',
        CLEAR: 'Clear',
        COL_NAME: 'Name',
        COL_SURNAME: 'Surname',
        COL_EMAIL: 'Email',
        COL_LAST_FOOTPRINT: 'Latest footprint',
        COL_LAST_SEGMENT: 'Latest segment',
        BACK: 'Back',
        USER: 'User',
        SEARCH_USER: 'Search user...',
        NO_RESULTS: 'No results',
        FROM_LOCAL: 'From (local date and time)',
        TO_LOCAL: 'To (local date and time)',
        SHOWN: 'Shown: {{date}}',
        LOADING: 'Loading…',
        LOAD_DATA: 'Load data',
        EMPTY_MAP: "Load a user's data to see their raw footprint on the map",
        ERROR_LOADING_USERS: 'Error loading users',
        SELECT_USER: 'Select a user',
        SELECT_BOTH_DATES: 'Select both dates and times',
        CHECK_RANGE: 'Check the interval',
        RANGE_INVALID: 'The start date/time cannot be later than the end date/time',
        NO_DATA_TEXT: 'No data available for the selected period',
        LOADED_POINTS: '{{count}} raw footprint points loaded',
        ERROR_LOADING_DATA: 'Error loading data',
        DETAILS_TITLE: 'User footprint',
        DETAILS_EXPORT_CSV: 'Export full user CSV',
        DETAILS_SELECT_DATE: 'Select date:',
        DETAILS_PHONE_STATUS: 'Phone status',
        DETAILS_DATA: 'Data',
        DETAILS_CREATED: 'Created',
        DETAILS_UPDATED: 'Updated',
        DETAILS_PREVIOUS: '← Previous',
        DETAILS_NEXT: 'Next →',
        DETAILS_ITEM_OF: 'Item {{n}} of {{total}} in total',
        DETAILS_NO_DATA_FOR_DATE: 'No data available for the selected date.',
      },
      MATCH_CONFIG_VARIABLES: {
        TITLE: 'Match configurations',
        SUB: 'Each row is a matching configuration. Click the pencil to edit a value: Enter saves and Esc cancels.',
        LOADING: 'Loading…',
        LOAD_ERROR: 'The match variables could not be loaded.',
        LOAD_ERROR_TITLE: 'The variables could not be loaded',
        RETRY: 'Retry',
        EMPTY: 'There are no match configurations.',
        RELOAD: 'Reload',
        UPDATED: 'Updated',
        EDIT_FIELD: 'Edit {{field}}',
        SAVE: 'Save',
        SAVING: 'Saving…',
        SAVED: 'Saved',
        FOOTER_ONE: 'Showing {{count}} of {{total}} configuration',
        FOOTER_OTHER: 'Showing {{count}} of {{total}} configurations',
        CONFIRM_TITLE: 'Change {{field}}',
        CONFIRM_TEXT: 'Configuration {{id}}: from {{from}} to {{to}}.',
        CONFIRM_BUTTON: 'Yes, save',
        SAVE_ERROR_TITLE: 'The change could not be saved',
        INVALID_TITLE: 'Invalid value',
        INVALID_SELECT: 'Select a valid value.',
        INVALID_EMPTY: 'The value cannot be empty.',
        INVALID_NUMBER: 'Enter a valid number before saving.',
        INVALID_INTEGER: 'This field only accepts whole numbers.',
        GENERIC_ERROR: 'The operation could not be completed.',
        LEGEND: 'Legend',
        LEGEND_SUB: 'Functional description of the variables shown in the table.',
        SHOW_GUIDE: 'Show guide',
        HIDE_GUIDE: 'Hide guide',
        LEGEND_ITEMS: {
          ALGORITHM: 'Indicates which matching algorithm this configuration row applies: <code class="bo-code">\'v1\'</code> (legacy) or <code class="bo-code">\'v2\'</code> (new).<br /><br />Details:<br />- The active algorithm is global: as soon as any row has <code class="bo-code">algorithm = \'v2\'</code>, the whole system switches to v2<br />- v1 uses all of its configuration rows (sorted by <code class="bo-code">order</code>); v2 only uses the first row with <code class="bo-code">algorithm = \'v2\'</code>',
          H3_RESOLUTION_START: 'The H3 resolution level used to compare the start points (origin) of the driver\'s and the passenger\'s routes during matching.<br /><br />Details:<br />- <code class="bo-code">h3_resolution_start = 8</code> -> Hexagons of ~500 metres<br />- <code class="bo-code">h3_resolution_start = 6</code> -> Hexagons of ~10 km<br />- <code class="bo-code">h3_resolution_start = 4</code> -> Hexagons of ~150 km',
          H3_KRING_START: 'The number of rings (k-ring) around the start H3 hexagon that are also accepted as matching when comparing origin points. Increasing this value widens the geographic tolerance beyond the exact hexagon.',
          H3_RESOLUTION_END: 'The H3 resolution level used to compare the end points (destination) of the driver\'s and the passenger\'s routes during matching.',
          H3_KRING_END: 'The number of rings (k-ring) around the destination H3 hexagon that are also accepted as matching when comparing end points. Increasing this value widens the geographic tolerance beyond the exact hexagon.',
          H3_RESOLUTION_POLYLINE: 'The H3 resolution level used to extract H3 hexagons along the whole path (polyline) of both routes in order to calculate the overlap between them.',
          H3_KRING_ROUTE: 'The number of rings (k-ring) around each H3 hexagon of the path that are included when calculating the overlap between the driver\'s and the passenger\'s polylines. Increasing this value makes the overlap calculation more permissive.',
          DURATION_DELTA: 'The maximum extra time allowed, in seconds, that can be added to the driver\'s trip duration when picking up a passenger. If the extra time is below this threshold, the match is accepted.',
          DISTANCE_DELTA: 'A percentage multiplier that defines the maximum relative increase allowed in the trip duration. If the new time is less than <code class="bo-code">distance_delta</code> times the original time, the match is accepted.<br /><br />Details (important: the name is misleading):<br />- Despite being called "<code class="bo-code">distance_delta</code>", it does NOT refer to a distance in metres but to a percentage threshold<br />- It is validated with the logic: <code class="bo-code">newDuration / baseDuration &lt; distance_delta</code><br />- It is a multiplying factor, typically between 1.0 and 1.5',
          DELAY_THRESHOLD: 'The maximum delay allowed, in seconds, between the actual time the driver picks up/drops off the passenger and the time the passenger expects. If the difference is below this threshold, the match is accepted.<br /><br />Details:<br />- It compares two times:<br />- Actual pickup/dropoff time: calculated from the driver\'s travel time (OSRM duration) + delays<br />- Time expected by the passenger: their desired departure/arrival time<br />- If the difference is &lt;= <code class="bo-code">delay_threshold</code> seconds in BOTH cases (pickup and dropoff), the match is accepted',
          EXTENDED_DELAY_THRESHOLD: 'The loose delay margin (in seconds) used on the flexible side of the time window, complementing <code class="bo-code">delay_threshold</code> (the tight margin on the side the user committed to).<br /><br />Details:<br />- If left empty (null), <code class="bo-code">delay_threshold</code> is used on both sides, keeping the previous symmetric behaviour<br />- When departing: tight margin backwards, loose margin forwards (e.g. leaving later)<br />- When arriving: loose margin backwards, tight margin forwards (e.g. arriving earlier)',
          DEPARTURE_MARGIN_SECONDS: 'The time margin allowed before the driver\'s departure for a passenger to be considered compatible. It defines an early time window in which passengers are accepted.<br /><br />Details:<br />- Sets how many seconds BEFORE the driver leaves passengers can be accepted<br />- It is validated with the logic: <code class="bo-code">riderDepartureTime &gt;= driverDepartureTime - departure_margin_seconds</code><br />- It creates a flexible time-compatibility window',
          ARRIVAL_MARGIN_SECONDS: 'The time margin allowed after the driver\'s arrival for a passenger to be considered compatible. It defines a late time window in which passengers are accepted.<br /><br />Details:<br />- Sets how many seconds AFTER the driver arrives passengers can be accepted<br />- It is validated with the logic: <code class="bo-code">riderArrivalTime &lt;= driverArrivalTime + arrival_margin_seconds</code><br />- It creates a flexible time-compatibility window (in the opposite direction to <code class="bo-code">departure_margin_seconds</code>)',
          RADIUS_METERS: 'Defines the geographic search radius (in metres) used when matching riders and drivers.<br /><br />Details:<br />- When looking for compatible driver routes for a rider, only those whose origin/destination points are within that radius of the rider\'s coordinates are considered<br />- It is a geographic restriction that limits matches to nearby drivers',
        },
      },
      PAYOUT_REVIEWS: {
        TIME: {
          NOW: 'now',
          AGO: '{{value}} ago',
          IN: 'in {{value}}',
        },
        LEVEL: {
          HIGH: 'Likely fraud',
          MEDIUM: 'Review',
          LOW: 'Low',
        },
        HOLD: {
          REINFORCED: 'Enhanced verification',
          CASH_DELAY: 'Cash delay',
        },
        DELAY: {
          INSTANT: 'instant',
          HOURS: '{{value}} h',
          DAY: '{{value}} day',
          DAYS: '{{value}} days',
        },
        DEADLINE: {
          PAID_AUTO: 'Approved automatically',
          PAID_RECOVERY: 'Paid (payment recovered)',
          VERIFIED_BY: 'Verified by {{name}}',
          REJECTED_BY: 'Rejected by {{name}}',
          PREAPPROVED_PAYS: 'Pre-approved by {{name}} · paid {{when}}',
          PREAPPROVED_NEXT_CRON: 'Pre-approved by {{name}} · will be paid in the next cron run',
          SCHEDULED: 'Scheduled · payable {{when}}',
          OVERDUE_OVER_LIMIT: 'Overdue · needs a decision (over the limit)',
          NEEDS_DECISION: 'Needs a decision · due {{when}}',
          OVERDUE_NEXT_CRON: 'Overdue · will be paid in the next cron run',
          AUTO_PAY: 'Auto-pay {{when}}',
        },
        STRIPE_ERRORS: {
          NO_TRANSFERS: "The driver's Stripe account cannot receive transfers: the transfers capability is not enabled in Stripe.",
          INSUFFICIENT_FUNDS: 'There is not enough balance in Stripe to make the transfer.',
          NO_ACCOUNT: "The driver's Stripe account does not exist or is no longer connected.",
          RESTRICTED: "The driver's Stripe account is restricted and cannot receive payments.",
          BANK_INVALID: "The driver's bank account in Stripe is invalid or closed.",
          RATE_LIMIT: 'Stripe received too many requests in a row. Try again in a few minutes.',
          GENERIC: 'Stripe rejected the operation.',
        },
        // Pestaña «Retiradas» de la ficha de usuario (la misma tabla, filtrada).
        USER: {
          TAB: 'Withdrawals',
          EMPTY_TITLE: 'This user has no withdrawals under review',
        },
        LIST: {
          HEADER_NOTE: 'With no decision in {{hours}} h, those up to {{amount}} are paid automatically; larger ones wait here.',
          KPIS_ARIA: 'Withdrawal indicators',
          KPI_PENDING: 'Pending',
          KPI_PENDING_HINT: 'Awaiting review or automatic payment',
          KPI_IN_TABLE: 'In the table',
          KPI_SEE_IN_TABLE: 'See in the table',
          KPI_OVERDUE: 'Overdue',
          KPI_OVERDUE_HINT: '{{hours}} h passed with no decision',
          KPI_OVERDUE_HINT_NO_META: 'The grace hours passed with no decision',
          KPI_OVERDUE_ACTION: 'Review as soon as possible',
          NONE: 'None',
          KPI_OVER_LIMIT: 'Over the limit',
          KPI_OVER_LIMIT_HINT: 'More than {{amount}}: not paid automatically',
          KPI_OVER_LIMIT_HINT_NO_META: 'Over the limit: not paid automatically',
          KPI_OVER_LIMIT_ACTION: 'Need a decision',
          KPI_DECIDED: 'Decided today',
          KPI_DECIDED_HINT: 'Approved or rejected today',
          STATUS_ARIA: 'Status',
          TABS: {
            PENDING: 'Pending',
            DECIDED: 'Resolved',
            ALL: 'All',
          },
          PANEL: {
            PENDING_TITLE: 'Pending withdrawals',
            PENDING_SUBTITLE: 'Awaiting a decision. Click one to see its risk analysis.',
            DECIDED_TITLE: 'Decided withdrawals',
            DECIDED_SUBTITLE: 'Already paid or rejected. Click one to see its details.',
            ALL_TITLE: 'All withdrawals',
            ALL_SUBTITLE: 'Pending and decided. Click one to see its details.',
          },
          SEARCH_PLACEHOLDER: 'Search by name, email, ID number or phone',
          SEARCH_ARIA: 'Search withdrawals',
          SORT_ARIA: 'Sort',
          SORT: {
            RELEASE: 'Sort: nearest deadline',
            RISK: 'Sort: highest risk',
            AMOUNT: 'Sort: highest amount',
            CREATED: 'Sort: most recent',
          },
          REFRESH: 'Refresh',
          LOADING: 'Loading withdrawals',
          COLS: {
            USER: 'User',
            AMOUNT: 'Amount',
            REQUESTED: 'Requested',
            DEADLINE: 'Deadline',
            STATUS: 'Status',
            RISK: 'Risk',
            SIGNALS: 'Signals',
            DECISION: 'Decision',
            OPEN: 'Open',
          },
          ERROR: 'Error',
          RETRY: 'Retry',
          EMPTY_TITLE: 'Nothing pending',
          EMPTY_TEXT: 'There are no withdrawals in this filter.',
          OVER_LIMIT: 'over the limit',
          STRIPE_ORIGINAL: 'Original Stripe message: {{message}}',
          ANALYZING: 'Analysing…',
          ANALYSIS_FAILED: 'Analysis failed',
          TRIPS_KM_ONE: '{{count}} trip · {{km}} km',
          TRIPS_KM_OTHER: '{{count}} trips · {{km}} km',
          FIXED_IP: 'Fixed IP {{pct}}',
          SHARED_IP: 'Passengers same IP {{pct}}',
          APPROVE_SCHEDULED_TIP: 'Leaves it approved: it is paid automatically on its date',
          PAY_NOW_TIP: 'Pays the withdrawal in Stripe now',
          APPROVE: 'Approve',
          VERIFY: 'Verify',
          REJECT_TIP: 'Returns the amount to their wallet',
          REJECT: 'Reject',
          PAID: 'Paid',
          REJECTED: 'Rejected',
          APPROVED: 'Approved',
          PAYOUT_PAID: 'Paid into the bank',
          PAYOUT_FAILED: 'Returned by the bank',
          PAYOUT_CANCELED: 'Canceled in Stripe',
          PAYOUT_SENT: 'Sent to the bank',
          PAGINATION: 'Showing {{shown}} of {{total}} withdrawals',
          PREV: 'Previous',
          NEXT: 'Next',
          LOAD_ERROR: 'Could not load the withdrawals.',
          TOAST_PREAPPROVED: 'Withdrawal of {{amount}} pre-approved: it is paid automatically on {{date}}.',
          TOAST_PAID: 'Withdrawal of {{amount}} paid to {{name}}.',
          REJECT_TITLE: 'Reject {{amount}} from {{name}}',
          REJECT_TEXT: 'The amount goes back to their wallet. Nothing is paid in Stripe. The reason is optional and only the team sees it.',
          REJECT_PLACEHOLDER: 'Reason (optional): e.g. fixed IP on every trip, GPS jumps…',
          REJECT_ARIA: 'Optional reason',
          REJECT_CONFIRM: 'Reject withdrawal',
          CANCEL: 'Cancel',
          REJECTING: 'Rejecting…',
          ALREADY_DECIDED: 'Already decided',
          DECIDED_BY_OTHER: 'Someone else decided first.',
          DECIDED_BY_NAME: '{{message}} Decided by {{name}}.',
          STRIPE_REJECTED_TITLE: 'Stripe did not accept the payment',
          STILL_PENDING: 'The withdrawal is still pending.',
          STRIPE_ERROR_STILL_PENDING: '{{error}} The withdrawal is still pending.',
          DECISION_ERROR: 'Could not apply the decision',
          NO_JUMPS: 'No jumps',
          JUMPS_ONE: '{{count}} jump · {{detail}}',
          JUMPS_OTHER: '{{count}} jumps · {{detail}}',
          JUMP_KM_KMH: '{{km}} km at {{kmh}} km/h',
        },
        DETAIL: {
          BREADCRUMB_ARIA: 'Breadcrumb',
          DETAIL: 'Details',
          LOADING: 'Loading withdrawal',
          BACK: 'Back',
          VIEW_PROFILE: 'View profile',
          DNI: 'ID {{value}}',
          SIGNUP: 'Signed up {{date}}',
          APPROVE_SCHEDULED_TIP: 'It cannot be paid yet: it stays approved and is paid automatically on its date',
          PREAPPROVE: 'Pre-approve',
          VERIFY_AND_PAY: 'Verify and pay',
          DECIDED_AUTO: 'automatically',
          DECIDED_BY: 'by {{name}}',
          REQUESTED_AT: 'requested {{when}} · {{date}}',
          SCHEDULED_FOR: 'Scheduled due to {{reason}} · payable from {{date}}',
          CASH_DELAY: 'Cash delay {{delay}}',
          CASH_DELAY_FIRST: '(one of their first)',
          CASH_PREVIOUS_ONE: '{{count}} previous withdrawal for {{amount}}',
          CASH_PREVIOUS_OTHER: '{{count}} previous withdrawals for {{amount}}',
          CASH_LAST: 'the previous one {{delay}}',
          CASH_LAST_LATE: 'the previous one {{delay}}, arrived late',
          PREAPPROVED_BY: 'Pre-approved by {{name}} · {{date}}',
          NO_FLAGS: 'No fraud signals in the period.',
          ANALYZING: 'Analysing trips, IPs and GPS track…',
          NOTE: 'Note:',
          STRIPE: 'Stripe:',
          STRIPE_ERROR: 'Stripe error:',
          KPIS_ARIA: 'Withdrawal indicators',
          K_TRIPS: 'Trips as driver',
          K_TRIPS_HINT: 'In the analysed period',
          K_TRIPS_DELTA: '{{km}} km · {{hours}} h · {{days}} days',
          K_PER_DAY: 'Trips per active day',
          K_PER_DAY_HINT: 'Average of the days with trips',
          K_PER_DAY_DELTA: 'max. {{count}} in one day',
          K_MAX_DAY: 'Most driving in one day',
          K_MAX_DAY_HINT: 'Hours driving on the day with most trips',
          K_OVER_4H: 'More than 4 h',
          K_NORMAL: 'Normal',
          K_FIXED_IP: 'Trips with fixed IP',
          K_FIXED_IP_HINT: 'Home or office IP, not mobile',
          K_FIXED_IP_DELTA: '{{fixed}} of {{total}} with IP data',
          K_SHARED: 'Passengers on their IP',
          K_SHARED_HINT: "All passengers on the driver's IP",
          K_SHARED_DELTA: '{{shared}} of {{total}} with data · any: {{any}}',
          K_JUMPS: 'Impossible GPS jumps',
          K_JUMPS_HINT: 'More than 10 km and 130 km/h between points',
          K_JUMPS_DELTA: 'max. {{km}} km · {{kmh}} km/h',
          K_NONE: 'None',
          MONEY_TITLE: 'Money',
          MONEY_NOTE: 'does not affect the score',
          MONEY_REQUESTED: 'Requests to withdraw',
          MONEY_EARNED_PERIOD: 'Earned in the period',
          MONEY_WALLET: 'In the wallet now',
          MONEY_WITHDRAWN: 'Withdrawn to bank (all time)',
          MONEY_WITHDRAWN_COUNT: '· {{count}} withdrawals',
          MONEY_EARNED_TOTAL: 'Total earned',
          MONEY_REVIEWS: 'Previous reviews',
          MONEY_REVIEWS_VALUE: '{{approved}} paid · {{rejected}} rejected',
          RIDERS_TITLE: 'Passengers they have driven',
          RIDERS_COUNT: '{{count}} different',
          RIDER_TRIPS_ONE: '{{count}} trip · {{amount}}',
          RIDER_TRIPS_OTHER: '{{count}} trips · {{amount}}',
          RIDER_SAME_IP: 'same IP {{same}}/{{total}}',
          RIDER_NEVER_DRIVES: 'never drives',
          RIDER_SAME_WEEK: 'signed up same week',
          NO_RIDERS: 'No confirmed passengers in the period.',
          MAP_TITLE: 'GPS track for the period',
          MAP_POINTS: 'Points',
          MAP_LINE: 'Route',
          MAP_JUMPS: 'Jumps',
          MAP_COLOR_TRIPS: 'Colour trips',
          MAP_FIT: 'Show all',
          MAP_LOADING: 'Loading GPS track…',
          MAP_FOOTER: '{{kept}} points drawn of {{total}} read ({{from}} → {{to}}) · route {{km}} km',
          MAP_TRUNCATED: 'track trimmed to the last 60 days of the period',
          JUMPS_TITLE: 'Impossible GPS jumps',
          JUMPS_NOTE: '> 10 km between two consecutive points at > 130 km/h · the more km and km/h, the clearer',
          J_FROM: 'From',
          J_TO: 'To',
          J_KM: 'Km',
          J_KMH: 'Km/h',
          J_SECONDS: 'Seconds',
          J_SHOW: 'Show on map',
          TRIPS_TITLE: 'Trips as driver',
          TRIPS_NOTE: '{{reason}} · {{from}} → {{to}} · click a trip to see it on the map',
          T_START: 'Start',
          T_ROUTINE: 'Routine',
          T_DURATION: 'Duration',
          T_RIDERS: 'Passengers',
          T_DRIVER_IP: "Driver's IP",
          T_SHARED: 'Passengers on their IP',
          T_EARNS: 'Earns',
          OVERLAP: 'overlap {{pct}} %',
          RIDER_SAME: 'same IP',
          RIDER_OTHER: 'different IP',
          RIDER_NO_IP: 'no IP data',
          NO_RIDERS_TRIP: 'No passengers',
          DETAIL_LINK: 'Details',
          NO_TRIPS: 'No completed trips as driver in the period.',
          IPS_TITLE: 'IPs seen during trips',
          IPS_RESOLVING: 'resolving rDNS from the browser…',
          IPS_NOTE: 'fixed = home/office ISP rDNS or same IP ≥ 3 days · mobile (CGNAT) changes between days',
          I_IP: 'IP',
          I_TYPE: 'Type',
          I_DETAIL: 'Details',
          I_TRIPS: 'Trips',
          I_DAYS: 'Days',
          I_USERS: 'Users',
          I_DRIVER: 'driver',
          I_RDNS_PENDING: 'rDNS pending',
          COMPUTED: 'Report computed {{when}} ({{date}}).',
          RECOMPUTE: 'Recompute',
          ANALYSIS_FAILED_TEXT: 'The analysis failed: {{error}}',
          RETRY_ANALYSIS: 'Retry analysis',
          NOT_FOUND: 'This withdrawal does not exist.',
          LOAD_ERROR: 'Could not load the withdrawal.',
          TRACK_NOT_READY: 'The GPS track is not ready yet.',
          TRACK_ERROR: 'Could not load the GPS track.',
          TOAST_PREAPPROVED: 'Pre-approved: {{amount}} will be paid automatically on {{date}}.',
          TOAST_PAID: '{{amount}} paid to {{name}}.',
          REJECT_TITLE: 'Reject {{amount}}',
          REJECT_TEXT: "The amount goes back to the user's wallet. Nothing is paid in Stripe. The reason is optional and only the team sees it.",
          REJECT_PLACEHOLDER: 'Reason (optional)',
          RECOMPUTE_ERROR: 'Could not recompute',
          PERIOD: {
            LAST_PAYOUT: 'since their last payout',
            FIRST_TRIP: 'since their first trip (never paid out before)',
            SIGNUP: 'since signing up',
          },
          IP_KIND: {
            HOSTING: 'Hosting / VPN',
            FIXED: 'Fixed',
            FIXED_PROBABLE: 'Fixed (probable)',
            MOBILE: 'Mobile',
            UNKNOWN: 'Unknown',
          },
          TRIP_IP: {
            NO_DATA: 'No data',
            FIXED_ALL: 'Fixed IP the whole route',
            FIXED_MANY: 'Fixed IPs',
            MOBILE: 'Mobile',
            ONE_UNKNOWN: 'One IP (unknown)',
            MANY: '{{count}} IPs',
          },
          DURATION_RATIO: '{{pct}} % of plan',
        },
        MAP: {
          DURING_TRIP: 'During a trip',
          OUT_OF_TRIP: 'Outside a trip',
          SELECTED: 'Selected',
          IMPOSSIBLE_JUMP: 'Impossible jump',
          JUMP_TOOLTIP: '{{km}} km in {{seconds}} s',
          JUMP_TOOLTIP_KMH: '{{km}} km in {{seconds}} s · {{kmh}} km/h',
        },
      },
      PARTNER_PANEL: {
        COMMON: {
          CLOSE: 'Close',
          CANCEL: 'Cancel',
          SAVE: 'Save',
          SAVING: 'Saving…',
          RETRY: 'Retry',
          OK: 'OK',
          PREVIOUS: 'Previous',
          NEXT: 'Next',
          ACTION_ERROR: 'The action could not be completed. Please try again.',
        },
        SPLIT: {
          LABEL: 'Share for the company wallet',
          VALUE: '{{n}} % to the company wallet',
          ALL_PARTNER: 'All for {{partner}}',
          ALL_WALLET: 'All to the wallet',
        },
        BILLING_MODE: {
          LABEL: 'Who bills',
          WAIIS: 'WAIIS bills the company',
          PARTNER: '{{partner}} bills the company',
          PARTNER_HINT: 'WAIIS bills {{partner}} for the wallet',
          LOCKED: 'Who bills only changes at renewal. WAIIS changes it.',
          SCHEDULED: 'From renewal: {{option}}',
          NO_AMOUNT_NOTE: 'Without an amount no plan is saved: choose who bills later in «Contract and price».',
          LIST_WAIIS: 'Billed by WAIIS',
          LIST_PARTNER: 'Billed by {{partner}}',
        },
        STATUS: {
          INVITED: 'Invitation sent',
          NONE: '—',
        },
        COMPANIES: {
          TITLE: '{{name}} companies',
          SUBTITLE: 'Your companies: adoption, annual plan and what they are missing. Click a row to open its record.',
          NEW_COMPANY: 'New company',
          EXPORT: 'Export CSV',
          EXPORT_ERROR: 'The export failed.',
          KPIS_LABEL: 'Indicators of your companies',
          KPI_COMPANIES: 'Companies',
          KPI_COMPANIES_HINT: '{{active}} active · {{trial}} on trial',
          KPI_REGISTERED: 'Registered employees',
          KPI_REGISTERED_HINT: '{{percent}} % of {{declared}} on staff',
          KPI_REGISTERED_HINT_NONE: 'of {{declared}} on staff',
          KPI_TRIPS: 'Shared trips · {{month}}',
          KPI_CO2: 'CO₂e avoided · {{month}}',
          KPI_CO2_VALUE: '{{value}} t',
          KPI_CONTRACTED: 'Contracted per year',
          KPI_CONTRACTED_SUB: 'Active companies',
          KPI_CONTRACTED_HINT: '{{wallet}} to wallets',
          KPIS_ERROR: 'The indicators could not be loaded.',
          ENDING_ONE: 'One company’s trial ends soon',
          ENDING_OTHER: '{{n}} companies’ trials end soon',
          ENDING_ITEM: '{{name}} · ends on {{date}} ({{days}} days)',
          ENDING_ITEM_ONE_DAY: '{{name}} · ends on {{date}} (1 day)',
          PREPARE_CONTRACT: 'Prepare contract',
          SEARCH_PLACEHOLDER: 'Search by name or tax ID…',
          SEARCH_LABEL: 'Search companies',
          FILTER_ALL: 'All',
          FILTER_ACTIVE: 'Active',
          FILTER_TRIAL: 'On trial',
          FILTER_LOCKED: 'Locked',
          FILTER_PENDING: 'Pending',
          FILTER_NONE: 'No status',
          FILTER_STATUS_LABEL: 'Status',
          FILTER_MANAGER: 'Manager',
          FILTER_MANAGER_ALL: 'Manager: all',
          CLEAR_FILTERS: 'Clear filters',
          TABLE_TITLE: 'Your companies',
          COL_COMPANY: 'Company',
          COL_MANAGER: 'Manager',
          COL_HEADCOUNT: 'Headcount',
          COL_REGISTERED: 'Sign-ups',
          COL_TRIPS: 'Trips ({{month}})',
          COL_PLAN: 'Annual plan',
          COL_STATUS: 'Status',
          COL_ACTIONS: 'Actions',
          PLAN_YEAR: '{{amount}} / year',
          PLAN_WALLET: '{{wallet}} to wallet · {{monthly}}/month',
          PLAN_NONE: 'No annual plan',
          PLAN_DRAFT: 'Not activated',
          PLAN_PENDING_PAYMENT: 'Payment pending',
          PLAN_PENDING_INVOICE: 'Invoice pending',
          NO_MANAGER: 'No manager',
          EMPTY: 'No companies match these filters',
          LOAD_ERROR: 'The companies could not be loaded.',
          ACTION_DASHBOARD: 'View their dashboard',
          ACTION_CONTRACT: 'Contract and price',
          ACTION_DETAIL: 'Open record',
          FOOT: 'Showing {{shown}} of {{total}} companies',
          CREATED_PRICE_ERROR: 'The company was created, but its price could not be saved. Set it in «Contract and price».',
        },
        CREATE: {
          TITLE: 'New company',
          SUBTITLE: 'We invite them right away: the admin gets an email to sign in.',
          SUBTITLE_REQUEST: 'With the data from the request of {{company}}.',
          SECTION_COMPANY: 'Company',
          SECTION_ADMIN: 'Company admin',
          SECTION_PRICE: 'Price and trial',
          LEGAL_NAME: 'Company (legal name)',
          TAX_ID: 'Tax ID',
          CITY: 'City',
          EMPLOYEES: 'No. of employees',
          MANAGER: 'Manager',
          MANAGER_HINT: 'A Partner admin from your team.',
          ADMIN_NAME: 'Full name',
          ADMIN_EMAIL: 'Email',
          ADMIN_EMAIL_HINT: 'They will get the invitation to sign in.',
          ADMIN_PHONE: 'Phone',
          PRICE_SUMMARY: 'Company wallet {{wallet}} per year · {{monthly}} each month',
          ERROR_REQUIRED: 'Required field',
          ERROR_EMAIL: 'Enter a valid email',
          ERROR_EMPLOYEES: 'Enter a number greater than 0.',
          ERROR_AMOUNT: 'Enter an amount greater than 0.',
          ERROR_SAVE: 'The company could not be created. Please try again.',
          SUBMIT: 'Create and send invitation',
          CREATING: 'Creating…',
          DONE_INVITED: 'Company created. Invitation sent to {{email}}',
          DONE_LINKED: 'Company created. {{email}} can now sign in as admin',
        },
        CONTRACT: {
          CLOSE_PERIOD: {
            BUTTON: 'Close the period today',
            TITLE: 'Close the period today',
            TEXT: 'The current plan period ends today instead of {{date}} and the renewal opens with what is scheduled (who bills, amount and split). The wallet stops receiving the remaining months. Refunding or offsetting what has not been allocated is done manually.',
            CONFIRM: 'Close the period',
            CANCEL: 'Cancel',
            DONE: 'Period closed. The renewal is open.',
            ERROR: 'The period could not be closed. Try again.',
          },
          AMOUNT: 'Annual amount',
          AMOUNT_HINT: '€ per year · VAT not included',
          TRIAL_MONTHS: 'Trial months',
          TRIAL_UNCHANGED: 'Unchanged',
          TRIAL_HINT: 'Free trial months from sign-up.',
          TRIAL_ENDS: 'The trial now ends on {{date}}.',
          TRIAL_LOCKED: 'With the plan active, the trial can no longer change.',
          SPLIT: 'Split',
          PRICE_TITLE: 'Annual price',
          PRICE_SUB: 'What the company pays per year and how much goes to its wallet.',
          ACTIVE_NOTE: 'The plan is active: the split changes from next month and the amount, at renewal.',
          SCHEDULED_SPLIT: 'Scheduled: {{n}} % to the wallet from {{date}}.',
          SCHEDULED_AMOUNT: 'At renewal: {{amount}}.',
          SUMMARY_TITLE: 'Summary',
          SUMMARY_EMPTY: 'Enter the annual amount to see the split between {{partner}} and the wallet.',
          SUMMARY_PLAN: 'Annual plan',
          SUMMARY_PARTNER: 'For {{partner}}',
          SUMMARY_WALLET: 'Company wallet',
          SUMMARY_MONTHLY: 'Wallet each month · carries over',
          SAVED: 'Price saved',
          SAVED_ACTIVE: 'The split changes from next month; the amount, at renewal.',
          SAVE_ERROR: 'The price could not be saved.',
          ERROR_NO_AMOUNT: 'Enter the annual amount.',
          LOAD_ERROR: 'The annual plan could not be loaded.',
          CHECK_TITLE: 'To activate the plan',
          CHECK_NOTE: 'You fill it in with the client. They only see the result in their dashboard.',
          STEP_BILLING: 'Billing details',
          STEP_BILLING_TEXT: 'The company gives them when paying in Stripe; the panel does not get their status.',
          STEP_PAYMENT: 'Payment',
          STEP_PAYMENT_TEXT: 'With the Stripe payment link: card, SEPA or bank transfer.',
          STEP_CONTRACT: 'Contract',
          STEP_CONTRACT_TEXT: 'The company closes it when paying the plan; the panel does not get its status.',
          GENERATE_LINK: 'Generate payment link',
          LINK_NEEDS_PRICE: 'Save the price first.',
          COPY_LINK: 'Copy payment link',
          LINK_COPIED: 'Link copied',
          LINK_EXPIRES: 'Valid until {{date}}.',
          LINK_ERROR: 'The payment link could not be generated.',
          PAYMENT_IN_PROGRESS: 'The payment is in progress.',
          STATE_DONE: 'Done',
          STATE_PENDING: 'Pending',
          STATE_ON_PAYMENT: 'On payment',
          INVOICE_TITLE: 'WAIIS invoice to {{partner}}',
          INVOICE_NOTE: 'WAIIS invoices {{partner}} for the company’s wallet. The company pays nothing and does not see it on its dashboard.',
          STEP_PARTNER_PAYMENT: '{{partner}} payment',
          STEP_PARTNER_PAYMENT_TEXT: '{{partner}} pays by bank transfer with the details on the Stripe invoice.',
          GENERATE_INVOICE: 'Generate invoice',
          VIEW_INVOICE: 'View invoice',
          INVOICE_DUE: 'Due on {{date}}.',
          INVOICE_WALLET: 'The {{company}} wallet starts when {{partner}} pays this invoice.',
          INVOICE_ERROR: 'The invoice could not be generated.',
        },
        SUMMARY: {
          FUNNEL_TITLE: 'Staff adoption',
          FUNNEL_SUB: '{{percent}} % of {{total}} on staff',
          FUNNEL_REGISTERED: 'Registered',
          FUNNEL_ROUTINE: 'With a routine',
          FUNNEL_SHARED: 'Shared trip',
          FUNNEL_PERCENT_TIP: 'Out of the registered ones',
          TRIPS_TITLE: 'Shared trips per month',
          NO_TRIPS: 'No trips yet',
          CONTACT_TITLE: 'Contact',
          ADMIN: 'Admin',
          EMAIL: 'Email',
          PHONE: 'Phone',
          MANAGER: 'Partner manager',
        },
        EMPLOYEES: {
          ADD: 'Add employees',
          EXPORT: 'Export CSV',
          EXPORT_ERROR: 'The staff could not be exported.',
          ADD_TITLE: 'Add employees',
          NOTE: 'You do the sign-ups. The company only sees the list.',
          OFFICE: 'Office',
          NO_OFFICES: 'Create an office first in the «Offices» tab.',
          BY_EMAIL: 'By email',
          EMAILS: 'Employee emails',
          EMAILS_PLACEHOLDER: 'ana@company.com, pere@company.com',
          EMAILS_HINT: 'Separated by commas or lines. The invitation goes out right away.',
          SEND: 'Send invitations',
          BY_CSV: 'Or upload a CSV',
          CSV_FILE: 'CSV file',
          TEMPLATE: 'Download the sample template',
          UPLOAD: 'Upload CSV',
          SENT_ONE: '1 invitation sent to the staff of {{company}}',
          SENT_OTHER: '{{n}} invitations sent to the staff of {{company}}',
          SKIPPED: 'Already on staff: {{emails}}.',
          CSV_DONE: 'CSV uploaded to the staff of {{company}}',
          ERROR_NO_EMAILS: 'Enter at least one email.',
          ERROR_EMAILS: 'Check these emails: {{emails}}',
          ERROR_SAVE: 'They could not be added. Please try again.',
        },
        OFFICES: {
          CREATE: 'Create office',
          CREATE_TITLE: 'Create office',
          CREATE_SUB: 'Pick the address from the suggestions: it cannot be created without one.',
          NAME: 'Office name',
          ADDRESS: 'Address',
          ADDRESS_PLACEHOLDER: 'Start typing the address…',
          ADDRESS_HINT: 'Pick an address from the list.',
          ADDRESS_OK: 'Address selected · {{city}}',
          CONTACT: 'Office contact',
          CONTACT_NAME: 'Name',
          CONTACT_EMAIL: 'Email',
          CONTACT_PHONE: 'Phone',
          CREATED: '«{{name}}» created',
          ERROR_SAVE: 'The office could not be created. Please try again.',
        },
        DATA: {
          TITLE: 'Company details',
          SUBTITLE: 'What the company sees in its space. The admin’s sign-in email is not changed here.',
          TRADE_NAME: 'Trade name',
          LEGAL_NAME: 'Legal name',
          TAX_ID: 'Tax ID',
          CITY: 'City',
          EMPLOYEES: 'No. of employees',
          MANAGER: 'Manager',
          MANAGER_HINT: 'Only a Partner admin from your team.',
          ADMIN_TITLE: 'Admin',
          ADMIN_NAME: 'Name',
          ADMIN_EMAIL: 'Sign-in email',
          ADMIN_EMAIL_HINT: 'It cannot be changed: for another admin, invite them.',
          CHANGE_ADMIN: 'Change admin',
          CHANGE_ADMIN_NOTE: 'We invite the new admin. The previous one keeps their access.',
          NEW_ADMIN_EMAIL: 'New admin’s email',
          INVITE_ADMIN: 'Invite the new admin',
          ADMIN_INVITED: 'Invitation sent to {{email}}',
          ADMIN_LINKED: '{{email}} can now sign in as admin',
          ADMIN_ERROR: 'The admin could not be changed.',
          SAVE: 'Save changes',
          SAVED: 'Details saved',
          NO_CHANGES: 'There are no changes to save.',
          FIX_FIELDS: 'Check the required fields.',
          SAVE_ERROR: 'The details could not be saved.',
        },
        FOLLOWUP: {
          CONTACT_TITLE: 'Contact',
          COPY_EMAIL: 'Copy email',
          EMAIL_COPIED: 'Email copied',
          NOTES_TITLE: 'Follow-up notes',
          NOTES_SUB: 'What you discuss with the company. WAIIS can see them too.',
          NEW_NOTE: 'Write a note…',
          ADD: 'Add',
          EMPTY: 'No notes yet',
          LOAD_ERROR: 'The notes could not be loaded.',
          SAVE_ERROR: 'The note could not be saved.',
          SYSTEM: 'System',
          UNKNOWN_AUTHOR: 'User',
        },
        WALLET: {
          BAG_TITLE: '{{month}} wallet · 1/12 of the annual plan',
          BAG_SUB: 'What is not spent carries over to the next month.',
          MONTHLY: '{{amount}} each month of the annual plan',
          AVAILABLE: 'Available balance in the wallet: {{amount}}',
          INACTIVE_TITLE: 'It starts with the contract',
          INACTIVE_TEXT: 'There is no wallet during the trial: it starts with the contract.',
          MOVES_TITLE: 'This month’s transactions',
          MOVES_EMPTY: 'No transactions this month.',
          MOVES_ERROR: 'The transactions could not be loaded.',
          LOAD_ERROR: 'The wallet could not be loaded.',
        },
      },
      PARTNER_REQUESTS: {
        TABS_LABEL: 'Request status',
        TAB_NEW: 'New',
        TAB_CONTACTED: 'Contacted',
        TAB_CREATED: 'Company created',
        TAB_DISCARDED: 'Discarded',
        TITLE_TAB_NEW: 'New requests',
        TITLE_TAB_CONTACTED: 'Contacted requests',
        TITLE_TAB_CREATED: 'Requests with a company created',
        TITLE_TAB_DISCARDED: 'Discarded requests',
        INTRO: 'Companies that reached a partner’s threshold when signing up. The partner handles them; here you see all of them, from everyone.',
        COL_RECEIVED: 'Received',
        COL_COMPANY: 'Company',
        COL_PARTNER: 'Partner',
        COL_EMPLOYEES: 'Employees',
        COL_CONTACT: 'Contact',
        COL_ORIGIN: 'Source',
        COL_ACTIONS: 'Actions',
        ORIGIN_SIGNUP: 'Sign-up',
        EMPTY: 'There are no requests in this status.',
        LOAD_ERROR: 'The requests could not be loaded.',
        RETRY: 'Retry',
        FOOT: 'Showing {{shown}} of {{total}} requests',
        REASSIGN: 'Reassign',
        REASSIGN_TITLE: 'Reassign the request',
        REASSIGN_CURRENT: 'It now belongs to {{partner}}.',
        REASSIGN_TO: 'New partner',
        REASSIGN_HINT: 'The request moves to the new partner’s panel and no longer shows in the current one.',
        REASSIGN_CONFIRM: 'Reassign',
        REASSIGNING: 'Reassigning…',
        REASSIGN_ERROR: 'The request could not be reassigned.',
        CREATE_COMPANY: 'Create company',
        PARTNER_SUBTITLE: 'Large companies that asked for WAIIS with you when signing up: contact them and create their company.',
        PARTNER_INTRO: 'Pick a request to see its details and what you can do with it.',
        EMPTY_NEW_PARTNER: 'You are up to date. New requests will appear here.',
        DETAIL_TITLE: 'Sign-up details of {{company}}',
        DETAIL_TAX_ID: 'Tax ID',
        DETAIL_EMAIL: 'Email',
        DETAIL_PHONE: 'Phone',
        DETAIL_REASON: 'Reason for discarding',
        CREATE_FROM_REQUEST: 'Create company with these details',
        MARK_CONTACTED: 'Mark as contacted',
        DISCARD: 'Discard',
        RESTORE: 'Restore request',
        DISCARD_TITLE: 'Why are you discarding it?',
        DISCARD_TEXT: 'We let them know by email that you are not going ahead.',
        DISCARD_CONFIRM: 'Discard request',
        DISCARD_REASON_SIZE: 'Not the right size',
        DISCARD_REASON_OTHER_PROVIDER: 'Already works with another provider',
        DISCARD_REASON_NO_RESPONSE: 'No response',
        DISCARD_REASON_DUPLICATE: 'Duplicate',
        CONTACTED: '{{company}} moves to contacted',
        DISCARDED: '{{company}} discarded',
        RESTORED: '{{company}} back to new',
      },
      PARTNERS: {
        USERS: {
          TITLE: 'Partner users',
          SUBTITLE: 'Who signs in to the {{partner}} panel: Partner admin (manages) and Partner user (view only).',
          NOTE: '{{partner}} manages them from its panel.',
        },
        PAYOUT: {
          TITLE: 'CAE bonus payout term',
          NOTE: '{{partner}} sets it from its panel.',
        },
        BILLING: {
          TITLE: 'Billing',
          SUBTITLE: 'Stripe customer WAIIS invoices {{partner}} to, and the annual plan settlement.',
          CUSTOMER_TITLE: 'Stripe customer',
          CUSTOMER_TEXT: 'Customer WAIIS invoices for the budget of the companies {{partner}} bills.',
          CUSTOMER_ID: 'Stripe customer ID',
          SAVE: 'Save',
          NAME: 'Name in Stripe',
          EMAIL: 'Email in Stripe',
          NO_CUSTOMER: 'No Stripe customer: it cannot be invoiced.',
          SAVED: 'Stripe customer of {{partner}} saved',
          STRIPE_UNAVAILABLE: 'Stripe could not be reached. Please try again.',
          SAVE_ERROR: 'The Stripe customer could not be saved.',
          LOAD_ERROR: 'The Stripe customer could not be loaded.',
          SETTLEMENT_TITLE: 'Annual plan settlement',
          SETTLEMENT_TEXT: 'By company and period: what was collected, what went to the budget and what belongs to {{partner}}.',
          FROM: 'From',
          TO: 'To',
          DOWNLOAD: 'Download CSV',
          DATES_HINT: 'Payment date, both days included.',
          SETTLEMENT_HELP: 'In rows collected through Connect, pay the «Adjustment», not the «Partner share». The «Unallocated budget» is to be refunded or offset.',
          DOWNLOAD_ERROR: 'The settlement could not be downloaded.',
        },
        TABS: {
          DATA: 'Details and access',
          LARGE: 'Large accounts',
          DEFAULTS: 'Prices and trial months',
          SECTIONS: 'What the company sees',
          USERS: 'Partner users',
          PAYOUT: 'Driver payouts',
          BILLING: 'Billing',
        },
        SETTINGS_ERROR: 'The partner settings could not be loaded.',
        LARGE: {
          TITLE: 'Large accounts',
          SUBTITLE: 'Whether {{partner}} receives the large companies that sign up to WAIIS, and who is notified.',
          FLAG: 'Large accounts partner',
          THRESHOLD: 'Employee threshold',
          THRESHOLD_HINT: 'Companies with more employees than this send a request to the partner instead of creating their space.',
          FROM_NOW: 'It applies to sign-ups from now on.',
          THRESHOLD_INVALID: 'Enter a whole number greater than 0.',
          EMAILS: 'Notification emails',
          EMAILS_HINT: 'They receive every new request. With none, only WAIIS gets it.',
          ADD_EMAIL: 'Add',
          REMOVE_EMAIL: 'Remove {{email}}',
          EMAIL_INVALID: 'Enter a valid email.',
          SAVE: 'Save',
          SAVED: '{{partner}} large accounts saved',
          OK: 'OK',
          SAVE_ERROR: 'The large accounts could not be saved.',
        },
        DEFAULTS: {
          TITLE: 'Prices and trial months',
          SUBTITLE: 'What new {{partner}} companies get by default.',
          NOTE: '{{partner}} sets them from its panel.',
          WALLET: 'Default split · {{percent}} % to the wallet',
          TRIAL_MONTHS: 'Default free trial months · {{months}}',
        },
        ADMINS: {
          TITLE: 'Partner admin',
          SUBTITLE: 'Who runs {{partner}}: they see and manage its companies and invite its team. Assigned by invitation: they get an email, valid for 7 days, and become Partner admin when they accept it.',
          COL_PERSON: 'Person',
          COL_STATUS: 'Status',
          COL_DATE: 'Date',
          COL_ACTIONS: 'Actions',
          STATUS_ACTIVE: 'Active',
          STATUS_PENDING: 'Invitation pending',
          STATUS_EXPIRED: 'Invitation expired',
          SINCE: 'Since {{date}}',
          EXPIRES_ON: 'Expires {{date}}',
          EXPIRED_ON: 'Expired {{date}}',
          EMPTY: 'No Partner admin yet. Invite someone below.',
          LOAD_ERROR: 'Couldn\'t load the Partner admins.',
          EMAIL: 'Assign Partner admin',
          EMAIL_PLACEHOLDER: 'name@company.com',
          EMAIL_INVALID: 'Enter a valid email.',
          EMAIL_HINT: 'We\'ll send the invitation to this email.',
          INVITE: 'Send invitation',
          INVITING: 'Sending…',
          INVITED: 'Invitation sent to {{email}}.',
          INVITE_ERROR: 'Couldn\'t send the invitation.',
          RESEND: 'Resend invitation',
          RESENT: 'Invitation resent to {{email}}.',
          ACTION_ERROR: 'Couldn\'t complete the action.',
          REMOVE: 'Remove Partner admin',
          REMOVE_TITLE: 'Remove Partner admin',
          REMOVE_TEXT: '{{name}} will no longer run {{partner}}.',
          REMOVING: 'Removing…',
          REMOVED: 'Removed',
          CANCEL: 'Cancel invitation',
          CANCEL_TITLE: 'Cancel invitation',
          CANCEL_TEXT: 'The link sent to {{email}} will stop working.',
          CANCELLING: 'Cancelling…',
          CANCELLED: 'Cancelled',
          KEEP: 'Go back',
        },
        TUTORS_COUNT: 'Tutors: {{count}}',
        CREATE: {
          TUTOR_EMAIL: 'First tutor (Partner admin)',
          TUTOR_EMAIL_HINT: 'They\'ll get an email invitation, valid for 7 days, to join the partner. No account is created until they accept it.',
          SECTIONS_NOTE: 'Its companies see the sections you set in «What the company sees»; until then, all hidden.',
          SUBTITLE: 'Its first Partner admin is invited when you create it. Everything else is set in its tabs.',
          SLUG: 'Identifier',
          SLUG_HINT: 'Lowercase letters, numbers and hyphens. Used in its email branding and cannot be changed later.',
        },
        DATA: {
          SAVE: 'Save details',
          SAVING: 'Saving…',
          SAVED: 'Partner details saved.',
          TITLE: '{{partner}} details',
          SUBTITLE: 'Name and logo for the shared branding, and who manages it.',
          NAME: 'Name',
          LOGO: 'Logo',
          NO_LOGO: 'No logo',
          UPLOADING: 'Uploading…',
          CHANGE_LOGO: 'Change',
        },
        SECTIONS: {
          TITLE: 'What each company sees in its dashboard',
          SUBTITLE: 'Applied the same to all of {{partner}}\'s companies. It limits their admins and those of their offices; {{partner}} always sees everything.',
          COL_SECTION: 'Section',
          COL_ACCESS: 'What the company sees',
          MODE_NORMAL: 'Normal',
          MODE_READONLY: 'Read only',
          MODE_HIDDEN: 'Hidden',
          MANAGED_BY: 'managed by {{partner}}',
          RETRY: 'Retry',
          DISCARD_TITLE: 'Discard {{partner}}\'s section changes',
          DISCARD_TEXT: 'The changes you haven\'t applied will be lost.',
          DISCARD_CONFIRM: 'Discard',
          DISCARD_CANCEL: 'Keep editing',
          ERROR_APPLY_ALL: 'Couldn\'t apply the sections. No company was changed.',
          ERROR_FORBIDDEN_ALL: 'Only a WAIIS admin can apply sections to all of a partner\'s companies.',
          ERROR_PARTNER_NOT_FOUND: 'This partner no longer exists.',
          WALLET: 'Wallet',
          SAVE: 'Save',
          SAVED: 'It applies right away to every {{partner}} company.',
        },
      },
      PARTNER_PAYMENTS: {
        SUBTITLE: 'Payout terms for drivers on trips of the companies linked to {{name}}.',
        SCOPE: 'All {{name}} companies',
        TERMS_TITLE: 'CAE bonus payout term',
        TERMS_SUB: "Calendar days from the trip date until the payout to the driver's wallet.",
        DAYS: '{{days}} days',
        EXAMPLE_TRIP: 'Trip on {{date}}, paid on',
        TERMS_ERROR: 'The term could not be loaded.',
        LAST_CHANGE: 'Last change: {{date}}',
        DISCARD: 'Discard',
        SAVE: 'Save changes',
        SAVING: 'Saving…',
        SAVED: 'Saved',
        SAVE_ERROR: 'The term could not be saved.',
        CALENDAR_TITLE: 'Payout calendar',
        CALENDAR_SUB: 'CAE bonuses pending payout.',
        PENDING_AMOUNT: 'Pending amount',
        NEXT_PAYOUT: 'Next payout',
        COL_PAYOUT_DATE: 'Payout date',
        COL_AMOUNT: 'Amount',
        TODAY: 'Today',
        EMPTY: 'There are no pending payouts.',
        CALENDAR_ERROR: 'The payout calendar could not be loaded.',
        TAB_DEFAULTS: 'Annual price and wallet',
        TAB_PAYOUT: 'Driver payouts',
        DEFAULTS_TITLE: 'Annual price and wallet',
        DEFAULTS_SUB: 'What each new company is offered. Each company can then have its own price.',
        DEFAULTS_ERROR: 'The default values could not be loaded.',
        DEFAULT_SPLIT: 'Default split',
        DEFAULT_TRIAL: 'Free trial months for new companies',
        DEFAULT_TRIAL_HINT: 'Trials already running do not change.',
        SIMULATOR: 'Agreed annual amount',
        SIMULATOR_PLACEHOLDER: 'E.g.: 12000',
        DEFAULTS_SAVED: 'Default values saved',
        DEFAULTS_SAVE_ERROR: 'The default values could not be saved.',
        PAYOUTS: 'Payouts',
        SCHEDULED: 'The {{days}}-day term applies from {{date}}.',
        RETRY: 'Retry',
      },
      PARTNER_USERS: {
        TITLE: "{{name}}'s users",
        TITLE_GENERIC: 'Users',
        SUBTITLE: 'The people at {{name}} with access to the dashboard. Only the Partner admin can invite or remove people.',
        INVITE: 'Invite user',
        COL_USER: 'User',
        COL_ROLE: 'Role',
        COL_STATUS: 'Status',
        ACTIONS: 'Actions',
        YOU: '(you)',
        ROLE_ADMIN: 'Partner admin',
        ROLE_USER: 'Partner user',
        STATUS_ACTIVE: 'Active',
        STATUS_INVITED: 'Invitation pending',
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
        LOAD_ERROR: 'The users could not be loaded.',
        RETRY: 'Retry',
        EMPTY: 'No one has access yet.',
        RESEND: 'Resend invitation',
        REMOVE: 'Remove access',
        REMOVE_TEXT: "{{name}} will no longer be able to access {{partner}}'s dashboard.",
        RESENT: 'Invitation resent to {{email}}.',
        INVITED: 'Invitation sent to {{email}}.',
        ACTION_ERROR: 'The action could not be completed.',
        INVITE_TITLE: 'Invite user',
        INVITE_SUB: 'They will get an email with a link, valid for 7 days, to join {{name}}\'s team.',
        EMAIL: 'Email',
        EMAIL_PLACEHOLDER: 'name@company.com',
        EMAIL_INVALID: 'Enter a valid email.',
        ROLE: 'Role',
        INVITE_ERROR: 'The invitation could not be sent.',
        CANCEL: 'Cancel',
        SEND: 'Send invitation',
        SENDING: 'Sending…',
        CANCEL_INVITE: 'Cancel invitation',
        CANCEL_INVITE_TITLE: 'Cancel invitation',
        CANCEL_INVITE_TEXT: 'The link sent to {{email}} will stop working.',
        CANCELLING_INVITE: 'Cancelling…',
        CANCELLED_INVITE: 'Invitation cancelled',
        COL_COMPANIES: 'Companies managed',
        COL_LAST_ACCESS: 'Last access',
        NAME: 'Name',
        NAME_REQUIRED: 'Enter their name.',
        ROLE_ADMIN_HINT: 'Creates companies, sets prices and invites users',
        ROLE_USER_HINT: 'Only views companies and data',
        MAKE_ADMIN: 'Change role to Partner admin',
        MAKE_USER: 'Change role to Partner user',
        REMOVE_ASK: 'Remove access for {{name}}?',
        REMOVE_CONFIRM: 'Yes, remove access',
        REMOVED_NAME: '{{name}} no longer has access.',
        ROLE_ASK: 'Make {{name}} a {{role}}?',
        ROLE_TEXT: '{{name}} will become a {{role}} of {{partner}}.',
        ROLE_CONFIRM: 'Change role',
        ROLE_CHANGED: '{{name}} is now a {{role}}.',
        REASSIGN_TO: 'Which Partner admin takes over their {{n}} companies?',
        REASSIGN_LABEL: 'New manager',
        REASSIGN_NONE: 'There is no other Partner admin: invite one first.',
      },
      COMPANIES: {
        CREATE: {
          TITLE: 'New company',
          SUBTITLE: 'Its space is created and its administrator is invited by email.',
          SUBTITLE_REQUEST: 'With the request details: choose who handles it at the partner.',
          CLOSE: 'Close',
          SECTION_COMPANY: 'Company',
          SECTION_ADMIN: 'Administrator',
          SECTION_PARTNER: 'Partner',
          LEGAL_NAME: 'Legal name',
          TAX_ID: 'Tax ID',
          CITY: 'City',
          EMPLOYEES: 'No. of employees',
          ADMIN_NAME: 'Full name',
          ADMIN_EMAIL: 'Administrator email',
          ADMIN_EMAIL_PLACEHOLDER: 'name@company.com',
          ADMIN_EMAIL_HINT: 'They will receive an invitation to sign in to the company dashboard.',
          PARTNER: 'Partner',
          PARTNER_WAIIS: 'WAIIS (default)',
          PARTNER_NOTE: 'If you choose a partner, the company shows up in its panel and inherits its prices, free trial months and permissions.',
          MANAGER: 'Partner manager',
          MANAGER_HINT: 'The Partner admin who will handle the company.',
          ERROR_REQUIRED: 'This field is required.',
          ERROR_EMAIL: 'Enter a valid email.',
          ERROR_EMPLOYEES: 'Enter at least 1 employee.',
          ERROR_MANAGER: 'Choose the company manager.',
          ERROR_SAVE: 'The company could not be created.',
          CANCEL: 'Cancel',
          SUBMIT: 'Create company',
          CREATING: 'Creating…',
          DONE_INVITED: 'Company created. Invitation sent to {{email}}',
          DONE_LINKED: 'Company created. {{email}} can now sign in as administrator',
          DONE_OK: 'OK',
        },
        ONBOARDING: {
          GRAN_DAY: 'Day',
          GRAN_WEEK: 'Week',
          GRAN_MONTH: 'Month',
          HINT_DAY: 'Last 30 days',
          HINT_WEEK: 'Last 12 weeks',
          HINT_MONTH: 'Last 12 months',
          IN_PERIOD_DAY: 'the last 30 days',
          IN_PERIOD_WEEK: 'the last 12 weeks',
          IN_PERIOD_MONTH: 'the last 12 months',
          INSIGHT_ALL_DONE: 'all have completed onboarding',
          INSIGHT_ONE_PENDING: '1 is still pending activation',
          INSIGHT_N_PENDING: '{{n}} are still pending activation',
          INSIGHT_ONE: '{{n}} sign-up in {{period}}; {{pending}}.',
          INSIGHT_OTHER: '{{n}} sign-ups in {{period}}; {{pending}}.',
          TILE_UNSEEN: 'New, not reviewed',
          TILE_UNSEEN_SUB: 'last 90 days',
          TILE_UNSEEN_HINT: 'You have not opened their details yet',
          TILE_ALL_REVIEWED: 'All reviewed',
          TILE_TODAY: 'Sign-ups today',
          TILE_TODAY_HINT: '{{n}} in the last 30 days',
          TILE_WEEK: 'Sign-ups this week',
          TILE_WEEK_HINT: 'Since Monday',
          TILE_MONTH: 'Sign-ups this month',
          TILE_MONTH_HINT: '{{n}} pending activation (90 days)',
          TITLE: 'Onboarding sign-ups',
          SUBTITLE: 'Companies that have started signing up to WAIIS. New ones not yet reviewed are highlighted in blue in the list.',
          GRANULARITY: 'Granularity',
          LOADING: 'Loading sign-ups…',
          KPIS_LABEL: 'Sign-up indicators',
          VIEW_IN_TABLE: 'View in the table',
          BY_DAY: 'Sign-ups per day',
          BY_WEEK: 'Sign-ups per week',
          BY_MONTH: 'Sign-ups per month',
          CHART_Q: '{{period}} · {{n}} sign-ups',
          LEGEND_DONE: 'Onboarding completed',
          LEGEND_PENDING: 'Pending activation',
          EMPTY: 'There are no sign-ups in this period.',
          TIP_DONE: 'Completed:',
          TIP_PENDING: 'Pending:',
          TIP_TOTAL: 'Total:',
          VIEW_DATA: 'View the data',
          COL_PERIOD: 'Period',
          COL_DONE: 'Completed',
          COL_PENDING: 'Pending',
        },
        INCENTIVES_TAB: {
          READ_ONLY: 'Read-only view. Campaigns are set up and sent from the company\'s dashboard.',
          MANAGE: 'Manage incentives',
          LOADING: 'Loading incentives…',
          LOCKED: 'The incentives module is not included in this company\'s current plan.',
          VIEW_PLAN: 'View the company\'s plan',
          SEGMENTS_LABEL: 'Employees per segment to incentivise',
          CAMPAIGNS_TITLE: 'Incentive campaigns',
          NO_CAMPAIGNS: 'No campaign has been sent yet.',
          LAST_CAMPAIGNS: 'Last {{shown}} of {{total}} campaigns.',
          COL_RECIPIENTS: 'Recipients',
          COL_COMMITTED: 'Committed',
          COL_THRESHOLD: 'Inactivity threshold',
          COL_DETAIL: 'Detail',
          DAYS: '{{n}} days',
          ONE_OFFICE: 'One office only',
          ERROR_LOAD: 'The incentives information could not be loaded.',
          SEG_NOT_REGISTERED: 'Not registered',
          SEG_NOT_REGISTERED_HINT: 'Employees on staff who have not signed up in the app yet',
          SEG_DNI: 'ID pending',
          SEG_DNI_HINT: 'Registered without identity verification',
          SEG_NO_TRIPS: 'No trips',
          SEG_NO_TRIPS_HINT: 'Registered users who have not shared any trip yet',
          SEG_INACTIVE: 'Inactive',
          SEG_INACTIVE_HINT: 'No trips in the last {{n}} days',
          ST_IN_PROGRESS: 'In progress',
          ST_COMPLETED: 'Completed',
          ST_CANCELLED: 'Cancelled',
          ST_SCHEDULED: 'Scheduled',
          ST_SENT: 'Sent',
          ST_FAILED: 'Failed',
        },
        TRAVELS_TAB: {
          LAST_DAYS: 'Last {{n}} days',
          OFFICE_ALL: 'Office: all',
          SEARCH_PLACEHOLDER: 'Search by driver, passenger or address…',
          SEARCH_LABEL: 'Search trip',
          RANGE: 'Range',
          REPORT: 'Trips report',
          COL_ROUTE: 'Route',
          COL_DRIVER: 'Driver',
          COL_PASSENGERS: 'Passengers',
          COL_AMOUNT: 'Amount',
          LOADING: 'Loading trips…',
          EMPTY: 'There are no trips by this company\'s employees in the selected range.',
          ERROR_LOAD: 'The trips could not be loaded.',
          FOOT: 'Showing <b>{{shown}}</b> of <b>{{total}}</b> trips',
        },
        PMST_TAB: {
          TITLE: 'Sustainable Workplace Mobility Plan',
          SUBTITLE: 'Mandatory for companies with more than 200 employees. The questionnaire is filled in per company and per office.',
          OPEN: 'Open PMST in the dashboard',
          ENABLED: 'PMST enabled by the company',
          DISABLED: 'PMST disabled by the company',
          OFFICES_DONE: '{{done}} of {{total}} with the questionnaire completed',
          NO_OFFICES: 'No offices signed up.',
          INACTIVE: '· inactive',
          DOCS_TITLE: 'Documents and reports',
          DOCS_SUB: 'PMST files uploaded by the company or by WAIIS.',
          LOADING_DOCS: 'Loading documents…',
          COL_DOCUMENT: 'Document',
          COL_UPLOADED: 'Uploaded',
          EMPTY: 'There are no PMST documents for this company.',
          DOWNLOAD: 'Download',
          DOWNLOAD_DOC: 'Download document',
          ERROR_LOAD: 'The PMST documents could not be loaded.',
          ERROR_DOWNLOAD: 'The document could not be downloaded.',
          QUESTIONNAIRE_DONE: 'Questionnaire completed',
          QUESTIONNAIRE_PENDING: 'Questionnaire pending',
        },
        OFFICES_TAB: {
          COUNT_ONE: 'office signed up',
          COUNT_OTHER: 'offices signed up',
          DECLARED: '· {{n}} declared at sign-up',
          MANAGE: 'Manage offices in the dashboard',
          EMPTY: 'This company has no offices signed up.',
          NOT_APPLICABLE: 'Not applicable',
          VIEW_EMPLOYEES: 'View office employees',
          VIEW_OFFICE: 'View office',
        },
        EMPLOYEES_TAB: {
          SEARCH_PLACEHOLDER: 'Search employee, email, ID number or department…',
          SEARCH_LABEL: 'Search employee',
          OFFICE_ALL: 'Office: all',
          STATUS_ALL: 'Status: all',
          FILTER_REGISTERED: 'Registered',
          FILTER_PENDING: 'Pending registration',
          FILTER_INACTIVE: 'Inactive',
          MANAGE: 'Manage in the dashboard',
          COL_DEPARTMENT: 'Department',
          COL_APP: 'App',
          LOADING: 'Loading employees…',
          ERROR_LOAD: 'The employees could not be loaded.',
          EMPTY_FILTERED: 'No employee matches the filters.',
          EMPTY: 'This company has no employees signed up yet.',
          VIEW_EMPLOYEE: 'View employee',
          FOOT: 'Showing <b>{{shown}}</b> of <b>{{total}}</b> employees',
          ST_INACTIVE: 'Inactive',
          ST_REGISTERED: 'Registered',
          ST_PENDING: 'Pending',
          ST_PENDING_HINT: 'Has not registered in the app yet',
          LINKED: 'Linked',
          LINKED_HINT: 'App account linked',
          NOT_LINKED: 'Not linked',
          STATUS_CODE: {
            activo: 'Active',
            con_rutina: 'With routine',
            vinculado: 'Linked',
            inactivo: 'Inactive',
            pendiente: 'Pending',
            rechazado: 'Rejected',
          },
        },
        DATA_TAB: {
          TITLE: 'Company details',
          SUBTITLE: 'Tax identity, contact person and address. Changes are saved immediately.',
          SEC_IDENTITY: 'Identity',
          TRADE_NAME: 'Trade name',
          LEGAL_NAME: 'Legal name',
          TAX_ID: 'Tax ID (CIF / NIF)',
          SECTOR: 'Sector',
          OPTIONAL: 'Optional',
          SEC_CONTACT: 'Contact person',
          NAME: 'Name',
          SEC_FISCAL: 'Registered address',
          CITY: 'City',
          POSTAL_CODE: 'Postcode',
          SEC_STATUS: 'Status',
          ACTIVE: 'Active company',
          PMST_ENABLED: 'PMST enabled',
          STATUS_HELP: 'An inactive company no longer appears in the app for its employees. Disabling the PMST hides the Mobility Plan section in its dashboard.',
          DISCARD: 'Discard',
          SAVING: 'Saving…',
          SAVE: 'Save changes',
          INVITE_TITLE: 'Invitation code',
          INVITE_SUB: 'Employees use it to link their app account to the company.',
          CODE_COPIED: 'Code copied',
          COPY_CODE: 'Copy code',
          NO_CODE: 'No code generated.',
          INVITE_LINK: 'Linking link',
          PLAN: 'Plan',
          PLAN_BILLING: 'Plan and billing',
          PLAN_MANAGED_BY_WAIIS: 'WAIIS manages the plan. To change it, write to us.',
          PARTNER: 'Partner',
          PARTNER_READ_ONLY: 'Only WAIIS can change it',
          SETTINGS_LINK: 'Logo, administrators and contract',
          FIX_FIELDS: 'Check the highlighted fields before saving.',
          NO_CHANGES: 'There are no changes to save.',
          SAVED: 'Details saved.',
          SAVE_ERROR: 'The details could not be saved.',
          NO_PLAN_ASSIGNED: 'No plan assigned',
          PLAN_ACTIVE: 'active',
          PLAN_EXPIRED: 'expired',
          PLAN_CANCELLED: 'cancelled',
          PLAN_UNTIL: ' · until {{date}}',
          ERR_REQUIRED: 'Required',
          ERR_EMAIL: 'Invalid email',
          ERR_PATTERN: 'Invalid format',
          ERR_TOO_LONG: 'Too long',
          ERR_CIF: 'Invalid tax ID (CIF/NIF)',
          ERR_INVALID: 'Invalid value',
        },
        DETAIL: {
          TAB_EMPLOYEES: 'Employees',
          TAB_OFFICES: 'Offices',
          TAB_TRIPS: 'Trips',
          TAB_INCENTIVES: 'Incentives',
          TAB_PMST: 'PMST / reports',
          TAB_DATA: 'Details',
          ERROR_NOT_FOUND: 'The company was not found.',
          ERROR_FORBIDDEN: 'You do not have permission to view this company.',
          ERROR_LOAD: 'The company could not be loaded.',
          KPI_REGISTERED: 'Registered employees',
          KPI_REGISTERED_HINT: '{{total}} on staff · {{active}} active',
          KPI_CARPOOLING: 'Carpooling (month)',
          KPI_SHARED_TRIPS: 'Shared trips (month)',
          KPI_CO2: 'CO₂e avoided (month)',
          META_TAX_ID: 'Tax ID {{value}}',
          TRIAL_ENDS: 'Trial · ends on {{date}}',
          TRIAL_END_CHANGE: 'Change trial end date',
          TAB_SUMMARY: 'Summary',
          TAB_CONTRACT: 'Contract and price',
          TAB_WALLET: 'Wallet',
          TAB_FOLLOWUP: 'Follow-up',
          PARTNER_KPI_REGISTERED_HINT: '{{percent}} % of {{total}} on staff',
          PARTNER_KPI_TRIPS_CHANGE: '{{percent}} % vs. previous month',
          PARTNER_KPI_CO2_TOTAL: 'CO₂e avoided since sign-up',
          PARTNER_TRIAL_NOTE: 'The trial ends on {{date}} · {{days}} days left.',
          PARTNER_TRIAL_NOTE_MISSING: 'The trial ends on {{date}} · {{days}} days left. Missing: {{items}}.',
          PARTNER_RESENT: 'Invitation resent to {{email}}',
          PARTNER_CALL: 'Call',
          PARTNER_WRITE: 'Email',
          PARTNER_RESEND: 'Resend invitation',
          PARTNER_DASHBOARD: 'View their dashboard',
          PARTNER_GO_CONTRACT: 'Go to the contract',
          PARTNER_KPI_TONS: '{{value}} t',
          TRIAL_END_LABEL: 'Last day of the trial',
          TRIAL_END_HINT: 'It must be later than today. If the company was locked, it goes back to the trial.',
          TRIAL_END_SAVE: 'Save',
          TRIAL_END_SAVING: 'Saving…',
          TRIAL_END_ERROR: 'The trial end date could not be changed.',
          TOPUP_LIMIT: 'Monthly budget limit',
          TOPUP_LIMIT_GENERAL: 'General: €{{max}}',
          TOPUP_LIMIT_CUSTOM: 'Specific to this company: €{{max}}',
          TOPUP_LIMIT_LABEL: 'New limit, in euros a month',
          TOPUP_LIMIT_HINT: 'It can be higher or lower than the general one. The amount the company has already saved does not change.',
          TOPUP_LIMIT_SAVE: 'Save',
          TOPUP_LIMIT_SAVING: 'Saving…',
          TOPUP_LIMIT_RESET: 'Back to the general one',
          TOPUP_LIMIT_LOADING: 'Loading the limit…',
          TOPUP_LIMIT_LOAD_ERROR: 'The budget limit could not be loaded.',
          TOPUP_LIMIT_ERROR: 'The budget limit could not be saved.',
          META_PLAN: 'Plan {{value}}',
          BACK: 'Back to companies',
          BREADCRUMB: 'Breadcrumb',
          COMPANIES: 'Companies',
          LOADING: 'Loading the company…',
          BACK_TO_LIST: 'Back to the list',
          EDIT: 'Edit',
          ENTER_DASHBOARD: 'Open the dashboard',
          ENTER_DASHBOARD_TOOLTIP: 'See the dashboard as the company sees it',
          CONTACT_PERSON: 'Contact person',
          KPIS_LABEL: 'This month\'s indicators',
          TABS_LABEL: 'Company section',
        },
        COMMON: {
          RETRY: 'Retry',
          PREVIOUS: 'Previous',
          NEXT: 'Next',
          PREV_PAGE: 'Previous page',
          NEXT_PAGE: 'Next page',
          CLEAR_FILTERS: 'Clear filters',
          LOADING: 'Loading…',
          ACTIONS: 'Actions',
          STATUS: 'Status',
          PER_PAGE: '{{n}} per page',
          SHOWING: 'Showing {{shown}} of {{total}}',
          VS_PREV_MONTH: '{{trend}} vs previous month',
          EMPLOYEE: 'Employee',
          OFFICE: 'Office',
          OFFICES: 'Offices',
          EMPLOYEES: 'Employees',
          PLAN: 'Plan',
          DATE: 'Date',
          EMAIL: 'Email',
          PHONE: 'Phone',
          ADDRESS: 'Address',
          CONTACT: 'Contact',
          TOTAL: 'Total',
        },
        FORMAT: {
          STATUS_PRE_LAUNCH: 'Not started',
          STATUS_TRIAL: 'On trial',
          STATUS_TRIAL_DAYS: 'On trial · {{n}} days',
          STATUS_LOCKED: 'Locked',
          STATUS_ACTIVE: 'Active',
          MISSING: 'missing {{items}}',
          MISSING_NONE: 'ready',
          MISSING_BILLING: 'billing details',
          MISSING_PAYMENT_METHOD: 'payment method',
          MISSING_CONTRACT: 'contract',
          MISSING_ANNUAL_PLAN: 'annual plan',
          MISSING_PAYMENT: 'payment',
          MISSING_INVOICE: 'invoice payment',
          PLAN_FREEMIUM: 'Freemium',
          PLAN_INCENTIVES: 'Incentives',
          NO_PLAN: 'No plan',
          NOT_AVAILABLE: 'Data not available',
          SUB_ACTIVE: 'Active subscription',
          PLAN_EXPIRED: '{{plan}} · expired',
          SUB_EXPIRED: 'Subscription expired',
          PLAN_CANCELLED: '{{plan}} · cancelled',
          SUB_CANCELLED: 'Subscription cancelled',
          PMST_NOT_REQUESTED: 'Not requested',
          PMST_NOT_REQUESTED_HINT: 'The company has not enabled the PMST',
          COMPLETED: 'Completed',
          PMST_COMPLETED_HINT: 'PMST questionnaire completed for the company and its offices',
          PENDING: 'Pending',
          PMST_PENDING_HINT: 'PMST questionnaire not completed',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
        },
        LIST: {
          NEW_COMPANY: 'New company',
          ENDING_TITLE: '{{n}} trials end soon with pending details',
          ENDING_TITLE_ONE: 'One trial ends soon with pending details',
          ENDING_DAYS_LEFT: '{{n}} days left',
          ENDING_DAYS_LEFT_ONE: '1 day left',
          SHOULD_BE_PARTNER: 'Should it be {{partner}}? +{{threshold}} employees',
          SHOULD_BE_PARTNER_SHORT: 'Should it be {{partner}}?',
          DEGRADED_NOTE: 'The backend in this environment does not expose the aggregated listing yet ({{endpoint}}): offices, employees, trips and plan are empty and the plan filter is disabled.',
          VIEW: 'View',
          TAB_COMPANIES: 'Companies',
          TAB_DATA: 'Data',
          SEARCH_PLACEHOLDER: 'Search company, tax ID, contact or city…',
          SEARCH_LABEL: 'Search company',
          NEW_UNSEEN: 'New, not reviewed',
          NEW_UNSEEN_TOOLTIP: 'Companies signed up in the last 90 days that you have not opened yet',
          COL_SIGNUP: 'Signed up',
          COL_COMPANY: 'Company',
          COL_TRIPS_MONTH: 'Trips (month)',
          LOADING_COMPANIES: 'Loading companies',
          EMPTY_NEW: 'No new companies to review. All caught up!',
          EMPTY_FILTERED: 'No company matches the filters.',
          EMPTY: 'There are no registered companies yet.',
          NEW_PILL: 'New',
          NEW_PILL_TOOLTIP: 'Recent sign-up you have not opened yet',
          ENTER_DASHBOARD: 'Open the company\'s dashboard',
          EDIT_DATA: 'Edit details',
          VIEW_DETAIL: 'View details',
          PER_PAGE_LABEL: 'Companies per page',
          FOOT: 'Showing {{shown}} of {{total}} companies',
          FILTER_STATUS_ALL: 'Status: all',
          FILTER_PMST_ALL: 'PMST: all',
          FILTER_PLAN_ALL: 'Plan: all',
          COL_PARTNER: 'Partner',
          FILTER_PARTNER_ALL: 'Partner: all',
          CHANGE_PARTNER: 'Change partner',
          CHANGE_PARTNER_CONSEQUENCES: 'Permissions and what the company sees change right away. The plan, the wallet, the contract and the trial are closed manually: the company is left pending to complete its account with {{partner}}.',
          PARTNER_TITLE: "{{name}}'s companies",
          PARTNER_SUBTITLE: 'The companies you have signed up with WAIIS. Click a row to see its details, or use the eye to open its dashboard as the company sees it.',
          PARTNER_VIEW_NOTE: 'You are only seeing the companies of <strong>{{name}}</strong>.',
          ERROR_FORBIDDEN: 'You do not have permission to view the company list.',
          ERROR_LOAD: 'The company list could not be loaded.',
          TITLE_NEW: 'New companies not reviewed',
          TITLE_ACTIVE: 'Active companies',
          TITLE_PRE_LAUNCH: 'Companies not started',
          TITLE_TRIAL: 'Companies on trial',
          TITLE_LOCKED: 'Locked companies',
          TITLE_ALL: 'All companies',
          SUB_NEW: 'Sign-ups from the last 90 days that you have not opened yet.',
          SUB_PMST: 'PMST {{value}}',
          SUB_NO_PLAN: 'no plan',
          SUB_PLAN: 'plan {{value}}',
          SUB_SEARCH: 'search “{{value}}”',
          SUB_FILTERED: 'Filtered by {{filters}}.',
          SUB_DEFAULT: 'Client companies with their offices, employees, trips this month and plan.',
          AGO_TODAY: 'today',
          AGO_YESTERDAY: 'yesterday',
          AGO_DAYS: '{{n}} days ago',
          AGO_WEEKS: '{{n}} weeks ago',
          AGO_MONTHS: '{{n}} months ago',
          AGO_ONE_YEAR: '1 year ago',
          AGO_YEARS: '{{n}} years ago',
        },
      },
      MATCH_LIST: {
        ALL: 'All',
        ITEMS: 'matches',
        COL_DRIVER: 'Driver',
        COL_ROUTINE: 'Routine',
        COL_ROUTE_DATE: 'Route date',
        COL_PASSENGERS: 'Passengers',
        COL_CREATED: 'Created',
        FILTER_STATUS: 'Status',
        FILTER_DRIVER: 'Driver',
        FILTER_DATE_FROM: 'Date from',
        FILTER_DATE_TO: 'Date to',
        REMOVE_FILTER: 'Remove {{label}}',
        OPEN_CALENDAR: 'Open calendar',
        CLEAR: 'Clear',
        STATUS: {
          INITIAL: 'Initial',
          CONFIRMED: 'Confirmed',
          ONGOING: 'Ongoing',
          PENDING: 'Pending',
          ACCEPTED: 'Accepted',
          REJECTED: 'Rejected',
          CANCELLED: 'Cancelled',
          EXPIRED: 'Expired',
        },
      },
      MATCH: {
        TITLE: 'Match details',
        SUBTITLE: 'Driver, passengers and route of the match, with their maps.',
        BACK: 'Back',
        LOADING: 'Loading match...',
        LOAD_ERROR: 'The match could not be loaded.',
        BACK_TO_LIST: 'Back to the list',
        RETRY: 'Retry',
        DRIVER: 'Driver',
        PASSENGERS_ONE: '{{count}} passenger',
        PASSENGERS_OTHER: '{{count}} passengers',
        CREATED: 'Created',
        UPDATED: 'Updated',
        DRIVER_ROUTE: 'Driver\'s route',
        ROUTINE: 'Routine',
        SCHEDULES: 'Times',
        COL_TYPE: 'Type',
        COL_ORIGINAL_ROUTE: 'Original route',
        COL_MATCH: 'Match',
        DEPARTURE: 'Departure',
        ARRIVAL: 'Arrival',
        POINTS: 'Points',
        ORIGIN: 'Origin',
        DESTINATION: 'Destination',
        PICKUP: 'Pickup',
        DROPOFF: 'Dropoff',
        DROPOFF_X: 'Dropoff (X)',
        COPY_COORDINATES: 'Copy coordinates',
        COORDINATES_COPIED: 'Coordinates copied',
        COPY_ORIGIN_ARIA: 'Copy origin coordinates',
        COPY_DESTINATION_ARIA: 'Copy destination coordinates',
        VIEW_ORIGIN: 'View origin on the map',
        VIEW_DESTINATION: 'View destination on the map',
        VIEW_DRIVER_ORIGIN_ARIA: 'View the driver\'s origin on the map',
        VIEW_DRIVER_DESTINATION_ARIA: 'View the driver\'s destination on the map',
        DRIVER_MAP_CAPTION: 'Map of the driver\'s original route with origin and destination.',
        PASSENGERS_TITLE: 'Linked passengers',
        PASSENGERS_LINKED_ONE: '{{count}} passenger linked to the match.',
        PASSENGERS_LINKED_OTHER: '{{count}} passengers linked to the match.',
        NO_PASSENGERS: 'This match has no linked passengers.',
        REFRAME_PASSENGER: 'Reframe origin and destination',
        REFRAME_PASSENGER_ARIA: 'Reframe the passenger\'s origin and destination on the map',
        ORDER: 'Order {{order}}',
        COPY_PAX_ORIGIN_ARIA: 'Copy the passenger\'s origin coordinates',
        FOCUS_PAX_ORIGIN_ARIA: 'Focus the passenger\'s origin on the map',
        COPY_PAX_DESTINATION_ARIA: 'Copy the passenger\'s destination coordinates',
        FOCUS_PAX_DESTINATION_ARIA: 'Focus the passenger\'s destination on the map',
        COPY_PAX_PICKUP_ARIA: 'Copy the passenger\'s pickup coordinates',
        VIEW_PICKUP: 'View pickup on the map',
        FOCUS_PAX_PICKUP_ARIA: 'Focus the passenger\'s pickup on the map',
        EDIT_PICKUP: 'Edit pickup on the map',
        EDIT_PICKUP_ARIA: 'Edit the passenger\'s pickup',
        COPY_PAX_DROPOFF_ARIA: 'Copy the passenger\'s dropoff coordinates',
        VIEW_DROPOFF: 'View dropoff on the map',
        FOCUS_PAX_DROPOFF_ARIA: 'Focus the passenger\'s dropoff on the map',
        EDIT_DROPOFF: 'Edit dropoff on the map',
        EDIT_DROPOFF_ARIA: 'Edit the passenger\'s dropoff',
        PASSENGER_MAP_CAPTION: 'Map of the passenger\'s route with origin, destination, pickup and dropoff when available.',
        CLICK_MAP_PICKUP: 'Click on the map to select the pickup point.',
        CLICK_MAP_DROPOFF: 'Click on the map to select the dropoff point.',
        WAYPOINTS: 'Waypoints',
        WAYPOINTS_COUNT_ONE: '{{count}} point on the route.',
        WAYPOINTS_COUNT_OTHER: '{{count}} points on the route.',
        REFRAME_ALL: 'Reframe all points',
        REFRAME_ALL_ARIA: 'Reframe all waypoints on the map',
        REFRAME: 'Reframe',
        COL_TIME: 'Time',
        COL_POINT: 'Point',
        COL_ACTIONS: 'Actions',
        FOCUS_WAYPOINT_ARIA: 'Focus waypoint {{n}} on the map',
        VIEW_THIS_POINT: 'View this point on the map',
        NO_ADDRESS: 'No address',
        COORDINATES: 'Coordinates',
        DISTANCE_FROM_PREVIOUS: 'Distance from the previous point',
        COPY_WAYPOINT_ARIA: 'Copy waypoint coordinates',
        VIEW_POINT: 'View point on the map',
        VIEW_WAYPOINT_ARIA: 'View waypoint on the map',
        WAYPOINTS_MAP_CAPTION: 'Interactive route map with zoom and panning.',
        MAP_LOAD_ERROR: 'The map could not be loaded.',
        MAP_LOADING: 'Loading map…',
        DRIVER_ORIGIN: 'Driver\'s origin',
        DRIVER_DESTINATION: 'Driver\'s destination',
        MARKER_WAYPOINT: 'Waypoint {{n}}',
        SAVE_POINT_TITLE: 'Save {{point}}',
        SAVE_POINT_QUESTION: 'Do you want to save this {{point}} point for this route?',
        POINT_PICKUP: 'pickup',
        POINT_DROPOFF: 'dropoff',
        SAVE: 'Save',
        SAVING: 'Saving…',
        SAVED: 'Saved',
        SAVE_ERROR_TITLE: 'The point could not be saved',
        SAVE_ERROR_TEXT: 'The backend did not accept the update.',
        STATUS: {
          PENDING_DRIVER: 'Pending driver',
          CONFIRMED_DRIVER: 'Confirmed by driver',
          PENDING_PASSENGER: 'Pending passenger',
          PASSENGER_CONFIRMED: 'Confirmed by passenger',
          INITIAL: 'Initial',
          CONFIRMED: 'Confirmed',
          ONGOING: 'Ongoing',
          CANCELLED: 'Cancelled',
          REJECTED: 'Rejected',
        },
        WAYPOINT_ACTIONS: {
          START: 'Start',
          END: 'End',
          PICKUP: 'Pickup',
          DROPOFF: 'Drop-off',
        },
      },
      FACE_VERIFICATION: {
        SETTINGS: {
          TITLE: 'Face verification',
          PAGE: {
            NOTE_TITLE: 'When face verification is required',
            NOTE_TEXT: 'Only the mid-trip fraud check asks for the face verification, when the trip ends. With the general switch off, nobody is asked. The Rekognition thresholds set when it passes and the reference sets which photo it is compared against. Everything is saved with the button at the end.',
            GENERAL_SUB: 'Turns face verification on or off for all users',
            THRESHOLDS_SUB: 'Minimum liveness and similarity confidence for the verification to count as passed',
            REFERENCE_SUB: 'Which photo the user\'s face is compared against in each verification',
            LOADING: 'Loading settings',
          },
          GENERAL_TITLE: 'General switch',
          KILL_SWITCH_WARNING: 'Emergency kill switch: when turned off, nobody is required to pass face verification.',
          ENABLED_LABEL: 'Face verification enabled',
          THRESHOLDS_TITLE: 'Rekognition thresholds',
          LIVENESS_THRESHOLD_LABEL: 'Liveness confidence threshold',
          LIVENESS_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          SIMILARITY_THRESHOLD_LABEL: 'Similarity threshold',
          SIMILARITY_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          REFERENCE_TITLE: 'Comparison reference',
          REFERENCE_TECALIS_LABEL: 'Tecalis selfie',
          REFERENCE_TECALIS_HINT: 'Always against the selfie Tecalis verified against the ID document',
          REFERENCE_ENROLLMENT_LABEL: 'Capture after near misses',
          REFERENCE_ENROLLMENT_HINT: 'First against the Tecalis selfie; after several near misses the liveness image is stored and later checks compare against it',
          ENROLLMENT_MIN_SIMILARITY_LABEL: 'Minimum similarity of a near miss',
          ENROLLMENT_MIN_SIMILARITY_HINT: 'Number between 0 and 100 (decimals allowed). A Tecalis selfie with no detectable face also counts',
          ENROLLMENT_ATTEMPTS_LABEL: 'Near misses to store the capture',
          ENROLLMENT_ATTEMPTS_HINT: 'Whole number between 1 and 10, counting all the user\'s trips',
          UPDATED_AT_LABEL: 'Last modified',
          DISABLE_CONFIRM_TITLE: 'Turn off face verification?',
          DISABLE_CONFIRM_TEXT: 'Nobody will be required to pass face verification until it is turned back on.',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          SAVE: 'Save',
          SAVING: 'Saving…',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Settings could not be loaded',
          ERROR_SAVE: 'Changes could not be saved',
          ERROR_FORBIDDEN: 'You do not have permission to perform this action',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            INTEGER: 'The value must be an integer',
            RANGE: 'The value must be between 0 and 100',
            ATTEMPTS_RANGE: 'The value must be between 1 and 10',
          },
        },
      },
      RIDES_CONFIG: {
        SETTINGS: {
          PAGE: {
            NOTE_TITLE: 'VTC is saved when you confirm it; the rest, with «Save»',
            NOTE_TEXT: 'The VTC switch asks for confirmation and applies as soon as you confirm. Product catalog, commission, penalty and adjustments are saved together with the button at the end.',
            VTC_TITLE: 'VTC availability',
            VTC_SUB: 'Shows or hides the request ride button in the app for all users',
            ESTIMATES_TITLE: 'Options display',
            ESTIMATES_SUB: 'How the app presents VTC and taxi options when estimating a ride',
            PRODUCTS_TITLE: 'Product catalog',
            PRODUCTS_SUB: 'Which products the rider sees when estimating a ride',
            FEES_TITLE: 'Commission and cancellation',
            FEES_SUB: 'Commission charged on each ride and penalty if it is cancelled',
            ADJUSTMENTS_TITLE: 'Adjustments with the real amount',
            ADJUSTMENTS_SUB: 'Correct the penalty or the charge with what the provider bills',
            LOADING: 'Loading settings',
          },
          TITLE: 'Ride settings',
          VTC_LABEL: 'VTC enabled',
          VTC_HINT: 'Controls global availability of VTC rides in the app',
          VTC_CONFIRM_TITLE: 'Are you sure?',
          VTC_DISABLE_TEXT: 'Disabling VTC will hide the request-ride button in the app for all users',
          VTC_ENABLE_TEXT: 'Enabling VTC will show the request-ride button in the app again',
          VTC_SAVED: 'VTC updated',
          ESTIMATES_LABEL: 'Display mode',
          ESTIMATES_HINT: 'All shows every available option. Best options only shows the cheapest and the fastest.',
          ESTIMATES_ALL: 'All options',
          ESTIMATES_BEST_OPTIONS: 'Only the cheapest and the fastest',
          ESTIMATES_SAVED: 'Display updated',
          ERROR_FORBIDDEN: 'You do not have permission to change the options display',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          RIDE_PRODUCTS_ENABLED_LABEL: 'WAIIS products in estimates',
          RIDE_PRODUCTS_ENABLED_HINT: 'On: the WAIIS products are shown and, for each one, the cheapest provider. Off: the real product list of each visible provider is shown (e.g. for certifications).',
          COMMISSION_ENABLED_LABEL: 'Charge commission',
          COMMISSION_PERCENT_LABEL: 'Commission %',
          COMMISSION_PERCENT_HINT: 'Percentage between 0 and 100 (two decimals)',
          CANCELLATION_PENALTY_LABEL: 'Cancellation penalty %',
          CANCELLATION_PENALTY_HINT: 'Percentage between 0 and 100',
          REAL_FEE_ADJUSTMENT_LABEL: 'Real fee adjustment',
          REAL_FEE_ADJUSTMENT_HINT: 'Recalculate the penalty using the provider\'s real fee',
          REAL_FEE_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          RECEIPT_ADJUSTMENT_LABEL: 'Receipt adjustment on completed rides',
          RECEIPT_ADJUSTMENT_HINT: 'Reconcile the difference against the amount charged when the provider receipt arrives',
          RECEIPT_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          ADJUSTMENT_NEVER_ENABLED: 'Never enabled',
          SAVE: 'Save',
          SAVING: 'Saving…',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Could not load settings',
          ERROR_SAVE: 'Could not save changes',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            RANGE: 'Value must be between 0 and 100',
          },
        },
        GUEST_PHONES: {
          PAGE: {
            SUBTITLE: 'Numbers in the guest pool. You can activate, edit or delete them.',
            FOOTER: 'Showing {{shown}} of {{total}} phones',
            LOADING: 'Loading phones',
            ACTIVE_ON: 'Active',
            ACTIVE_OFF: 'Inactive',
            SAVING: 'Saving…',
            RETRY: 'Retry',
            MODAL_SECTION: 'Guest number',
            DELETING: 'Deleting…',
            DELETED: 'Deleted',
            ERROR_LOAD: 'The phones could not be loaded',
            ERROR_TOGGLE: 'The phone status could not be changed',
            ERROR_DELETE: 'The phone could not be deleted',
          },
          TITLE: 'Guest phones',
          EMPTY: 'No phones configured',
          TABLE: {
            PHONE_NUMBER: 'Phone number',
            ACTIVE: 'Active',
            ACTIONS: 'Actions',
          },
          ACTIONS: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
            CANCEL: 'Cancel',
            SAVE: 'Save',
            ACCEPT: 'Accept',
          },
          MODAL: {
            CREATE_TITLE: 'New guest phone',
            EDIT_TITLE: 'Edit guest phone',
          },
          FORM: {
            PHONE_NUMBER: 'Phone number',
            PHONE_PLACEHOLDER: '+34600000000',
            PHONE_HINT: 'E.164 format: international prefix with + (e.g. +34600000000)',
          },
          VALIDATION: {
            PHONE_REQUIRED: 'Phone number is required',
            PHONE_FORMAT: 'Invalid format: use E.164 (+ and 7–15 digits)',
          },
          DELETE: {
            TITLE: 'Delete phone?',
            TEXT: '{{phone}} will be removed from the guest pool',
            CONFIRM: 'Yes, delete',
          },
          ERROR: {
            TITLE: 'Error',
          },
        },
        PROVIDER_ROUTING: {
          TITLE: 'Routing by tag',
          PAGE: {
            SUBTITLE: 'Each rule sets the provider a user with that tag sees.',
            FOOTER: 'Showing {{shown}} of {{total}} rules',
            LOADING: 'Loading rules',
            RETRY: 'Retry',
            SAVING: 'Saving…',
            DELETING: 'Deleting…',
            DELETED: 'Deleted',
            ERROR_LOAD: 'Could not load the rules',
            ERROR_SWITCH: 'Could not change the switch',
            ERROR_DELETE: 'Could not delete the rule',
            MODAL_SECTION: 'Rule',
          },
          SWITCH: {
            TITLE: 'Routing enabled',
            LABEL: 'Route by tag',
            HINT: 'When on, a tagged user only sees the provider of their rule in estimates.',
            SAVED_ON: 'Routing enabled',
            SAVED_OFF: 'Routing disabled',
          },
          EMPTY: 'No rules configured',
          TABLE: {
            TAG: 'Tag',
            PROVIDER: 'Provider',
            USERS: 'Users',
            ACTIONS: 'Actions',
          },
          ACTIONS: {
            ADD: 'Add rule',
            EDIT: 'Edit',
            DELETE: 'Delete',
            CANCEL: 'Cancel',
            SAVE: 'Save',
            ACCEPT: 'OK',
            CLOSE: 'Close',
          },
          USERS: {
            TITLE: 'Rule users',
            OPEN: 'See the users with the tag {{tag}}',
            SEARCH_PLACEHOLDER: 'Search by name or email',
            LOADING: 'Loading users',
            NAME: 'Name',
            EMAIL: 'Email',
            ERROR_LOAD: 'Could not load the users',
            EMPTY: 'No user has this tag',
            EMPTY_SEARCH: 'No user matches the search',
            FOOTER: 'Showing {{shown}} of {{total}} users',
            PREVIOUS: 'Previous',
            NEXT: 'Next',
          },
          MODAL: {
            CREATE_TITLE: 'New rule',
            EDIT_TITLE: 'Edit rule',
          },
          FORM: {
            TAG: 'Tag',
            TAG_PLACEHOLDER: 'uber',
            TAG_HINT: 'Letters, numbers, dot, hyphen and underscore. It cannot be changed later.',
            PROVIDER: 'Provider',
          },
          VALIDATION: {
            TAG_REQUIRED: 'The tag is required',
            TAG_FORMAT: 'Only letters, numbers, ".", "_" and "-"',
            PROVIDER_REQUIRED: 'Choose a provider',
          },
          DELETE: {
            TITLE: 'Delete rule?',
            TEXT: 'The rule for tag {{tag}} will be removed',
            CONFIRM: 'Yes, delete',
          },
        },
        PROVIDERS: {
          TITLE: 'Providers and product mapping',
          RIDE_PRODUCTS: {
            TITLE: 'WAIIS products',
            HELP: 'These are the products the rider sees. Each provider maps one of its real products to every WAIIS product; the estimate shows the cheapest mapped provider.',
            ADD: 'Add WAIIS product',
            MOVE_UP: 'Move up',
            MOVE_DOWN: 'Move down',
            TABLE: {
              ORDER: 'Order',
              PRODUCT: 'Product',
              VISIBLE: 'Visible',
              ACTIONS: 'Actions',
            },
            MODAL: {
              NEW_TITLE: 'New WAIIS product',
              EDIT_TITLE: 'Edit WAIIS product',
              SECTION_DATA: 'Product details',
              KEY: 'Key',
              KEY_HELP: 'Internal identifier in lowercase, digits and hyphens (e.g. go, premium-xl). It cannot be changed later.',
              DISPLAY_NAME: 'Name',
              IMAGE: 'Image',
              IMAGE_HELP: 'URL of the icon the rider sees',
              DESCRIPTION: 'Description',
              DESCRIPTION_HELP: 'Optional, per language. Only languages with text are stored.',
              VISIBLE: 'Visible',
            },
            VALIDATION: {
              KEY_REQUIRED: 'The key is required',
              KEY_FORMAT: 'Only lowercase letters, digits and hyphens (50 characters max)',
              DISPLAY_NAME_REQUIRED: 'The name is required',
            },
            CONFIRM: {
              DELETE_TITLE: 'Delete WAIIS product?',
              DELETE_TEXT: '"{{product}}" will be permanently deleted',
            },
            ERROR: {
              IN_USE: 'It cannot be deleted: there are still mappings pointing to it in {{providers}}',
            },
          },
          ROUTE: {
            TITLE: 'Sample route for product discovery',
            HELP: 'Providers only reveal their products when estimating a trip, and the catalog changes by city. Pick an origin and destination in the city you want to query: the route is saved for the whole team.',
            PICKUP: 'Origin',
            DROPOFF: 'Destination',
          },
          DISCOVER: {
            BUTTON: 'Discover provider products',
            ADD_TAG: 'Use this key: ',
            PLACEHOLDER: 'Type the key or discover the provider products',
            EMPTY: 'No products discovered yet',
            CAPACITY: '{{capacity}} seats',
            MAPPED_TO: 'Already mapped to {{product}}',
            MAPPED_HIDDEN: 'Mapped and hidden',
            REFRESH: 'Query the provider again',
            ROUTE_USED: 'Sample route: {{pickup}} → {{dropoff}}',
            NO_ROUTE: 'Set the sample route on the providers page to discover products',
            ERROR: {
              DISABLED: 'The provider is disabled on the server',
              UNAVAILABLE: 'The provider is not available right now',
              GENERIC: 'Provider products could not be discovered',
            },
          },
          ACTIONS: {
            ADD_PRODUCT: 'Add product',
            SAVE: 'Save',
            CANCEL: 'Cancel',
            ACCEPT: 'Accept',
            EDIT: 'Edit',
            DELETE: 'Delete',
            SAVING: 'Saving…',
            DELETING: 'Deleting…',
            DELETED: 'Deleted',
            RETRY: 'Retry',
          },
          FORM: {
            DISPLAY_NAME: 'Custom name',
            VISIBLE: 'Visible',
          },
          EMPTY: {
            PRODUCTS: 'This provider has no mapped products yet',
            RIDE_PRODUCTS: 'There are no WAIIS products configured',
          },
          FOOT: {
            RIDE_PRODUCTS: 'Showing {{count}} of {{total}} WAIIS products',
            PRODUCTS: 'Showing {{count}} of {{total}} products',
          },
          TABLE: {
            PRODUCT_KEY: 'Provider product',
            RIDE_PRODUCT: 'WAIIS product',
            VISIBLE: 'Visible',
            ACTIONS: 'Actions',
          },
          MODAL: {
            NEW_PRODUCT: 'New product',
            EDIT_PRODUCT: 'Edit product',
            PRODUCT_KEY: 'Provider product',
            PRODUCT_KEY_HELP: 'Exact product name at the provider (e.g. UberX, Standard)',
            RIDE_PRODUCT: 'WAIIS product',
            RIDE_PRODUCT_PLACEHOLDER: 'Select a WAIIS product',
            VISIBLE: 'Visible',
          },
          VALIDATION: {
            PRODUCT_KEY_REQUIRED: 'Provider product is required',
            RIDE_PRODUCT_REQUIRED: 'WAIIS product is required',
          },
          CONFIRM: {
            DELETE_PRODUCT_TITLE: 'Delete product?',
            DELETE_PRODUCT_TEXT: '"{{product}}" will be permanently deleted',
          },
          ERROR: {
            TITLE: 'Error',
            LOAD: 'Providers could not be loaded',
            REORDER: 'The order could not be changed',
            VISIBILITY: 'Visibility could not be changed',
            DELETE: 'Could not delete',
            SAVE_PROVIDER: 'The provider could not be saved',
            LOAD_ROUTE: 'The sample route could not be loaded',
            SAVE_ROUTE: 'The sample route could not be saved',
          },
          SUCCESS: {
            PROVIDER_SAVED: 'Provider saved',
          },
        },
      },
      POIS: {
        TITLE: 'POIs',
        SUBTITLE: 'Pickup / dropoff points',
        REVIEW_TAB: 'Review',
        UPLOAD_TAB: 'Upload',
        TOTAL: 'Total POIs',
        BY_CATEGORY: 'By category',
        BUS_STOP: 'Bus stops',
        TRAIN_STATION: 'Train stations',
        METRO_STATION: 'Metro stations',
        ZEBRA_CROSSING: 'Zebra crossings',
        STREET_CORNER: 'Street corners',
        LOCAL_BUSINESS: 'Local businesses',
        LOAD_IN_VIEW: 'Load POIs in this view',
        LOADING: 'Loading…',
        SHOWING: 'Showing {{count}} POIs',
        TRUNCATED:
          'Showing the first {{limit}} POIs — zoom in to see all of them.',
        NO_POIS: 'No POIs in this view.',
        FILTERS: 'Categories',
        UPLOAD_TITLE: 'Upload POIs',
        UPLOAD_HELP:
          'JSON array of {osm_id, category, name, lat, lng}. The upload replaces the whole dataset by diff.',
        SELECT_FILE: 'Select JSON file',
        UPLOAD_BTN: 'Upload',
        UPLOADING: 'Uploading…',
        IMPORT_RUNNING: 'An import is already running.',
        IMPORT_QUEUED: 'Import queued.',
        UPLOAD_ERROR: 'Upload failed.',
        PROGRESS_TITLE: 'Import progress',
        STATUS: 'Status',
        PROCESSED: 'Processed',
        STAGED: 'Upserted',
        DELETED: 'Deleted',
        FAILED: 'Failed',
        STATUS_IDLE: 'Idle',
        STATUS_QUEUED: 'Queued',
        STATUS_PARSING: 'Parsing file',
        STATUS_RESYNCING: 'Recomputing relations',
        STATUS_COMPLETED: 'Completed',
        STATUS_FAILED: 'Failed',
      },
      TRIP_MAP: {
        SHOW_HEXAGONS: 'Show Hexagons',
        H3_RESOLUTION: 'H3 Resolution:',
        POINT_DETAILS: 'Point Details',
        SELECT_TRIP: 'Select a trip to see the map',
        LOADING: 'Loading map',
        POINT: 'Point',
        MOBILITY: 'Mobility',
        NOT_CLASSIFIED: 'Not classified',
        CLASSIFIED_AS: 'Classified as:',
        CLASSIFY_GROUP: 'Classify group of points',
        RESET: 'Reset',
        START: 'Start',
        END: 'End',
        ACTIVITY: 'Activity',
        MISCELLANEOUS: 'Miscellaneous',
        CONFIRM: 'Confirm',
        TAGS: {
          VEHICLE: 'Vehicle',
          BICYCLE: 'Bicycle',
          WALKING: 'Walking',
          BUS: 'Bus',
          SUBWAY: 'Subway',
          MOTORCYCLE: 'Motorcycle',
          OTHER: 'Other',
        },
        MISC: {
          HOME: 'Home',
          WORK: 'Work',
          JAM: 'Jam',
          STOPOVER: 'Stopover',
          OTHER: 'Other',
        },
        SAVING: 'Saving',
        SAVED: 'Changes saved successfully',
        ERROR_ASSIGNING_TAG: 'Error assigning tag. Please try again.',
        ERROR_LOADING_DATA: 'Error loading trip data. Please try again.',
        REVISION_STATUS: 'Review status',
        PENDING: 'Pending',
        MULTISELECT_INSTRUCTION: 'Hold Shift + Click to select multiple points',
        SELECT_ALL: 'Select all',
        ALL_POINTS: 'All points',
        DATE: 'Date',
        MOVING: 'Moving',
        MOVING_YES: 'Yes',
        MOVING_NO: 'No',
        SPEED: 'Speed',
        ODOMETER: 'Odometer',
        START_TIME: 'Start Time',
        END_TIME: 'End Time',
        SELECTION_OPTIONS: 'Selection Options',
        SELECT_BY_RANGE: 'Select by Time Range',
        ENTER_START_TIME: 'Start time (HH:mm)',
        ENTER_END_TIME: 'End time (HH:mm)',
        SELECT: 'Select',
        CANCEL: 'Cancel',
        NO_POINTS_IN_RANGE: 'No points found in the selected range.',
        FILTER_POINTS: 'Filter points',
        ALL: 'All',
        NONE: 'None',
        SHOW_VISIBLE_MAP_H3: 'Show H3 for the visible map',
        AVAILABLE_RANGE: 'Available range: {{start}} - {{end}}',
        START_BEFORE_END: 'The start time must be earlier than the end time',
        RANGE_BETWEEN: 'The range must be between {{start}} and {{end}}',
        HEX_POINTS: '{{count}} points',
        LONG_ADDRESS: 'Full address',
        COORDINATES: 'Coordinates',
        RAW_POINT_DATA: 'Raw point data',
        TIME: 'Time',
        EVENT: 'Event',
        CONFIDENCE: 'Confidence',
        ACCURACY: 'Accuracy',
        ALTITUDE: 'Altitude',
        HEADING: 'Heading',
        ORDER: 'Order',
        NOT_AVAILABLE: 'N/A',
      },
      TRIP_REVIEW: {
        SELECTED_DATE: 'Selected date',
        NO_TRIPS_FOR_DAY: 'No trips for this day',
        NO_DATA_FOR_USER: 'No data for this user',
        VERIFY_USER_EXISTS:
          'Verify that the user exists or select another one.',
        LOADING: 'Loading',
        STATUS_REVIEWED: 'Reviewed',
        STATUS_NOT_REVIEWED: 'Not reviewed',
        ROUTINE_TRIP: 'Routine trip',
        REVIEW_STATUS_PENDING: 'Pending',
        REVIEW_STATUS_REVIEWED: 'Reviewed',
        REVIEW_STATUS_FRAUDULENT: 'Fraudulent',
        REVIEW_STATUS_ERRONEOUS: 'Erroneous',
        CLASSIFICATION_SAVE_SUCCESS: 'Classification saved successfully',
        CLASSIFICATION_SAVE_ERROR:
          'Error saving classification. Please try again.',
        BACK: 'Back',
        SEARCH_USER_PLACEHOLDER: 'Search user…',
        SEARCH_USER_ARIA: 'Search user by name or email',
        SEARCH_SHOWING: 'Showing {{shown}} of {{total}} matches. Refine your search to see the rest.',
        SEARCHING: 'Searching…',
        NO_RESULTS: 'No results',
        SEARCH_ERROR: "Couldn't search. Please try again.",
        LOAD_USER_ERROR: "Couldn't load this user's profile. Please try again later.",
        LOAD_CALENDAR_ERROR: "Couldn't load this user's calendar. Please try again later.",
        COPY_ID: 'Copy ID',
        ID_COPIED: 'ID copied',
        COPY_ID_ERROR: "Couldn't copy the ID",
        SHOW_MORE_TRIPS: 'Show more trips',
        UNKNOWN: 'Unknown',
        NOT_LINKED: 'Not linked',
        EDIT_LINKED_SEGMENTS: 'Edit linked segments',
        EDIT_SEGMENTS: 'Edit segments',
        PREVIOUS_SEGMENT: 'Previous segment',
        NEXT_SEGMENT: 'Next segment',
        UNSAVED_CHANGES: 'There are unsaved changes.',
        SAVING: 'Saving…',
        SAVE: 'Save',
        SAVE_SEGMENTS_ERROR: "Couldn't save the linked segments.",
      },
      MATCH_REVIEW: {
        DRIVER: 'Driver',
        RIDERS: 'Passengers',
        PASSENGER: 'Passenger',
        VERIFY: 'Verify',
        SELECT_DRIVER: 'Select a driver',
        SELECT_PASSENGER: 'Select a passenger',
        DRIVER_DATA: 'Driver Data',
        PASSENGER_DATA: 'Passenger Data',
        ROUTE_MAP: 'Route Map',
        NO_DATA: 'No data available',
        ENTER_ROUTINE_IDS:
          'Enter routine IDs for driver and passenger to view the routes on the map',
        LOADED: 'Loaded',
        USER: 'User',
        DISTANCE: 'Distance',
        DURATION: 'Duration',
        PRICE: 'Price',
        LOADING: 'Loading',
        SHOW_HEXAGONS: 'Show Routes Hexagons',
        SHOW_MAP_HEXAGONS: 'Show all map Hexagons',
        SHOW_POLYLINE: 'Show Polyline',
        ADD_DRIVER: 'Add driver',
        ADD_RIDER: 'Add passenger',
        SELECT_ROUTINE: 'Click here to add a routine',
        ROUTE_SELECTOR: 'Route Selector',
        NAME: 'Name',
        LOCATIONS: 'Locations',
        ERROR_LOADING_ROUTE: 'Error loading route',
        SELECT_ROUTE_DETAILS: 'Select a route to see the details',
        COPY_PHP_PAYLOAD: 'Copy PHP payload',
        COPY_PHP_PAYLOAD_HINT: 'Copies the routine data as a PHP array',
        COPIED: 'Copied',
        CENTER: 'Center',
        H3_RESOLUTION: 'H3 Resolution',
        HEXAGON_POINTS: 'Hexagon Points',
        SIGNIFICANT_POINTS: 'Significant Points',
        ALL_POINTS: 'All Points',
        ERROR: 'Error',
        MAPS_LOAD_ERROR: 'Failed to load Google Maps',
        ENTER_DRIVER_ID: 'Please enter a driver routine ID',
        ENTER_PASSENGER_ID: 'Please enter a passenger routine ID',
        ERROR_VERIFYING: 'Error verifying {{type}} routine',
        PICKUP: 'Pickup {{type}}',
        ORIGIN: 'Origin {{type}}',
        DROPOFF: 'Dropoff {{type}}',
        DESTINATION: 'Destination {{type}}',
        DRIVER_TEXT: 'driver',
        PASSENGER_TEXT: 'passenger',
        COORDINATES: '{{lat}}, {{lng}}',
        H3_INDEX: 'H3 Index (Res {{res}})',
        LOADING_ROUTINE: 'Loading routine...',
        UNKNOWN_ERROR: 'Unknown error',
        INFO: 'Information',
        SEARCH_RADIUS: 'Search Radius',
        RADIUS_PLACEHOLDER: 'Radius in meters',
        FOUND: 'Found',
        INTEREST_POINTS: 'interest points',
        NO_POINTS_FOUND: 'No interest points found in the specified radius',
        ERROR_FETCHING_POINTS: 'Error fetching interest points',
        SEARCH_INTEREST_POINTS: 'Search interest points',
        CANCEL_SEARCH: 'Cancel search',
        CLEAN_INTEREST_POINTS: 'Clear interest points',
        LOAD_FROM_FILE: 'Load from file',
        PROCESS_COMPLETE: 'Process completed',
        CONFIRM: 'Confirm',
        MAP_SUB: 'Polylines, points and H3 hexagons of the routines chosen in the tables below.',
        H3_ROUTINE: 'Routine H3',
        H3_ALL: 'All H3',
        POI_CLICK_HINT: 'Click on the map to search around that point.',
        LEGEND: 'Legend',
        SHARED_H3: 'Yellow hexagon with green border: H3 shared between routines',
        POI_LEGEND: 'Yellow label: bus or train station (visible at zoom 13 or more)',
        DRIVERS: 'Drivers',
        DRIVERS_SUB: 'Driver routines drawn on the map. Click a row to see its details.',
        RIDERS_SUB: 'Passenger routines drawn on the map, with their pickup and drop-off. Click a row to see its details.',
        LOAD_FROM_FILE_HINT: 'Load routines from file',
        ROUTINE: 'Routine',
        POLYLINE: 'Polyline',
        ORIGIN_DESTINATION: 'Origin / Destination',
        PICKUP_DROPOFF: 'Pickup / Dropoff',
        TOGGLE_POLYLINE: 'Show or hide the polyline on the map',
        TOGGLE_PINS: 'Show or hide origin and destination on the map',
        TOGGLE_SPECIAL: 'Show or hide pickup and drop-off on the map',
        CENTER_ON_ROUTE: 'Center map on this route',
        REMOVE_DRIVER: 'Remove driver',
        REMOVE_RIDER: 'Remove passenger',
        EXPAND: 'Show or hide details',
        DAY: 'Day',
        DEPARTURE: 'Departure',
        ARRIVAL: 'Arrival',
        SCHEDULE: 'Schedule',
        COPY_ADDRESS: 'Copy address',
        COPY_COORDS: 'Copy coordinates',
        ROUTINE_LOAD_FAILED: 'The routine could not be loaded',
        FILE_NOT_TXT: 'Select a .txt file',
        FILE_NO_IDS: 'The file does not contain valid routineIds',
        FILE_PROCESS_ERROR: 'The file could not be processed',
        FILE_READ_ERROR: 'The file could not be read',
        LOAD_DRIVERS_TITLE: 'Load {{count}} drivers',
        LOAD_RIDERS_TITLE: 'Load {{count}} passengers',
        LOAD_ROUTINES_TEXT: 'Each routine will be verified and added to the table and the map.',
        PROCESSED_OK: '{{count}} routines were processed successfully.',
        ERRORS_FOUND: 'Errors found ({{count}}):',
        DAY_N: 'Day {{n}}',
        OUTBOUND: 'Outbound',
        RETURN: 'Return',
        UNKNOWN_DAY: 'Unknown',
        ROUTE_POINT: 'Route point',
        FILE_EMPTY: 'The file is empty',
        POI_TYPE_BUS_STATION: 'Bus station',
        POI_TYPE_TRAIN_STATION: 'Train station',
      },
      SUPPORT_CHAT: {
        TRIP_CHAT_FALLBACK: 'Trip chat',
        NAMES_AND: '{{names}} and {{last}}',
        TITLE: 'Support Chat',
        LIST_TITLE: 'Support Chats',
        NO_CHATS: 'No active chats.',
        SEND: 'Send',
        SELECT_CHAT: 'Select a chat',
        SELECT_CHAT_DESC: 'Pick a conversation from the list to see messages',
        LOADING_MORE: 'Loading previous messages...',
        YOU_SUPPORT: 'You (Support)',
        NO_MESSAGES: 'No messages',
        IMAGE_MSG: '[Image]',
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
        SEARCH_PLACEHOLDER: 'Search by name, ID or message...',
        CLEAR_SEARCH: 'Clear search',
        NO_RESULTS: 'No conversation matches your search.',
        LOAD_ERROR: 'Could not load the data.',
        RETRY: 'Retry',
        LOADING_MORE_CHATS: 'Loading more conversations...',
        LOAD_MORE: 'Load more',
        ALL_LOADED: 'No more conversations',
        CONVERSATION_START: 'Start of the conversation',
        CLOSE_TAB: 'Close tab',
        CLOSE_ALL: 'Close all',
        VIEW_PROFILE: 'View user',
        MARK_AS_UNREAD: 'Mark as unread',
        MARK_AS_READ: 'Mark as read',
        PENDING_REPLY_HINT: 'Pending reply',
        PENDING_REPLY_ERROR: 'Could not update the pending reply reminder',
        SEND_HINT: 'Enter to send · Shift+Enter for a new line',
        TABS_HINT: 'Every chat opens in its own tab, so you can jump back to any earlier conversation.',
        IMAGE_UNAVAILABLE: 'Image unavailable',
        SEARCH_INDEXING: 'Indexing all conversations...',
        SEARCH_SCOPE_ALL: 'Searching across all conversations',
        ATTACH_IMAGE: 'Attach image',
        DROP_IMAGE: 'Drop the image to send it',
        IMAGE_SENDING: 'Sending image...',
        IMAGE_TOO_LARGE: 'The image is too large. The maximum is 4 MB.',
        IMAGE_INVALID_TYPE: 'That file is not an image.',
        IMAGE_UPLOAD_ERROR: 'Could not send the image. Please try again.',
        CLOSE_IMAGE: 'Close image',
        LOCATION_SHARED: 'Shared location',
        EDIT: 'Edit',
        DELETE: 'Delete',
        SAVE: 'Save',
        CANCEL: 'Cancel',
        EDITED: '(edited)',
        EDIT_HINT: 'Enter to save · Esc to cancel',
        DELETE_CONFIRM: 'Delete this message? This cannot be undone.',
        EDIT_ERROR: 'Could not edit the message. Please try again.',
        DELETE_ERROR: 'Could not delete the message. Please try again.',
        TRIP_CARD_MSG: 'Unverified trip',
        CAPTURE_ATTEMPT_MSG: 'Capture attempt',
        CAPTURE_ATTEMPT_ROW_SCREENSHOT: 'Tried to take a screenshot',
        CAPTURE_ATTEMPT_ROW_RECORDING: 'Tried to record the screen',
        CAPTURE_ATTEMPT_SCREENSHOT: '{{name}} tried to take a screenshot in the “{{chat}}” chat',
        CAPTURE_ATTEMPT_RECORDING: '{{name}} tried to record the screen in the “{{chat}}” chat',
        CAPTURE_ATTEMPT_UNKNOWN_CHAT: 'unknown',
        TRIP_CHAT_LABEL: 'Trip group chat',
        COMPANY_TAG: 'Company - {{name}}',
        TRIP_CHAT_TITLE_PREFIX: 'Group chat',
        VIEW_PARTICIPANTS: 'View participants',
        GO_TO_TRIP: 'Go to trip detail',
        TRIP_DATE: 'Date',
        TRIP_TYPE: 'Trip type',
        TRIP_TYPE_routine: 'Routine',
        TRIP_TYPE_punctual: 'One-off',
        TRIP_DRIVER: 'Driver',
        CLOSE_INCIDENT: 'Close incident',
        CLOSE_INCIDENT_CONFIRM: 'The chat will disappear from the app for participants. You can still see it here and reopen it whenever needed.',
        CLOSE_INCIDENT_ERROR: 'Could not close the incident. Please try again.',
        CLOSE_INCIDENT_DONE: 'Incident closed and archived',
        INCIDENT_CLOSED: 'Incident closed',
        INCIDENT_CLOSED_HINT: 'This incident is closed. Messages can no longer be sent.',
        REOPEN_INCIDENT: 'Reopen incident',
        REOPEN_INCIDENT_CONFIRM: 'The chat will be available again in the app and messages can be sent again.',
        REOPEN_INCIDENT_ERROR: 'Could not reopen the incident. Please try again.',
        NEW_MESSAGES_BELOW: '{{count}} new messages',
        BACK_TO_LIST: 'Back to the list',
        MORE_ACTIONS: 'More actions',
        INBOX: {
          TAB_UNREAD: 'Unread',
          TAB_ALL: 'All',
          TAB_GROUPS: 'Groups',
          FILTER: 'Sort',
          ORDER: 'Order',
          COMPANY: 'Company',
          COMPANY_ALL: 'All',
          COMPANY_CLEAR: 'Clear company filter',
          COMPANY_FILTER: 'Filter by company',
          COMPANY_FILTER_EMPTY: 'No company conversations in this tab',
          COMPANY_SEARCH: 'Search company…',
          COMPANY_NONE: 'No company matches',
          ORDER_OLDEST: 'Oldest first',
          ORDER_NEWEST: 'Newest first',
          WAITING_FOR: 'Waiting for a reply for {{time}}',
          YOU_PREFIX: 'You:',
          CHIP_CLOSED: 'Closed',
          CHIP_RESOLVED: 'Finished',
          DONE_SECTION: 'Finished',
          EMPTY_unread: 'Nothing unread.',
          EMPTY_all: 'No conversations.',
          EMPTY_groups: 'No trip chats.',
          EMPTY_TAG: 'No conversations with this topic.',
        },
        PEEK: {
          SHOW: 'Read without opening',
          HIDE: 'Hide and mark as read',
          HINT: 'Hiding it marks it as read',
          MARK_READ: 'Mark as read',
          REPLY: 'Reply',
          EMPTY: 'No messages from the user to show.',
          ERROR: 'The preview could not be loaded.',
          READ_ERROR: 'Could not mark as read. Please try again.',
        },
        TAGS: {
          trip: 'Trip',
          payments: 'Payments',
          payouts: 'Payouts',
          cae: 'CAE',
          price: 'Price',
          referrals: 'Referrals',
          app: 'App',
          account: 'Account',
        },
        TAG_FILTER: 'Filter by topic',
        TAG_FILTER_ALL: 'All topics',
        TAG_FILTER_SHOW: 'Show topics',
        TAG_FILTER_HIDE: 'Hide topics',
        TAG_FILTER_CLEAR: 'Clear topic filter',
        TAG_FILTER_EMPTY: 'No conversation in this tab has a topic',
        TAG_SCROLL_PREV: 'Previous topics',
        TAG_SCROLL_NEXT: 'More topics',
        TAG_ADD: 'Topic',
        TAG_MENU_TITLE: 'Conversation topic',
        TAG_ACCEPT: 'Confirm',
        TAG_REMOVE: 'Remove topic',
        TAG_SUGGESTED_HINT: 'Topic suggested from the last message. Confirm it to save it.',
        TAG_AUTO_HINT: 'Automatic: this is a trip chat',
        TAGS_ERROR: 'The topic could not be saved. Please try again.',
        RESOLVE: {
          FINISH: 'Finish',
          REOPEN: 'Reopen',
          UNDO: 'Undo',
          DONE_ONE: 'Conversation finished',
          DONE_MANY: '{{count}} conversations finished',
          REOPENED: 'Conversation reopened',
          ERROR: 'Could not finish it. Check the connection or permissions and try again.',
          REOPEN_ERROR: 'Could not reopen it. Check the connection or permissions and try again.',
          STALE_BANNER: '{{count}} conversations idle for 30+ days.',
          STALE_BANNER_ONE: '1 conversation idle for 30+ days.',
          STALE_DISMISS: 'Hide notice',
          STALE_ACTION: 'Finish them',
          BULK_TITLE: 'Finish {{count}} conversations?',
          BULK_CONFIRM: 'They will move to “Finished”. If the user writes again they go back to “Unread” on their own. Nothing changes in the app for the user.',
          BULK_ACTION: 'Finish',
        },
        COMPOSER: {
          PLACEHOLDER: 'Type a message…',
          HINT: 'Enter to send · Shift+Enter for a new line · “/” on an empty message for quick replies',
          QUICK_REPLIES: 'Quick replies',
          DISMISS: 'Dismiss',
        },
        QUICK_REPLIES: {
          TITLE: 'Quick replies',
          SEARCH: 'Search by title, category or text...',
          LANGUAGE: 'Reply language',
          LOCAL_FALLBACK: 'Could not load the replies: showing the built-in ones.',
          NO_CA: 'No Catalan version: the Spanish one will be inserted',
          EMPTY: 'No reply matches your search.',
          KEYS_HINT: '↑↓ move · Enter insert · Esc close',
          MANAGE: 'Manage replies',
        },
        CONTEXT: {
          TITLE: 'User',
          TOGGLE: 'Show or hide the user details',
          CLOSE: 'Close panel',
          OPEN_PROFILE: 'Open profile',
          GROUP_HINT: 'Click a participant to see their payment details.',
          NO_PARTICIPANTS: 'No participants.',
          UPDATED_AT: 'Updated at {{time}}',
          LOADING: 'Loading...',
          REFRESH: 'Refresh',
          USER_ERROR: 'Could not load the payment details.',
          USER_NOT_FOUND: 'This user does not exist in this environment.',
          PAYMENTS: 'Payments',
          PAYMENT_STATUS: {
            OK: 'Up to date',
            WARNING: 'Warning',
            BLOCKED: 'Blocked',
            CANCELLED: 'Cancelled',
            UNKNOWN: 'No data',
          },
          REASON: 'Reason',
          CARD_EXPIRED: 'Expired',
          CARD_EXPIRES_SOON: 'Expires soon',
          OTHER_CARDS: '+{{n}} cards',
          NO_CARDS: 'No saved cards',
          NO_CUSTOMER: 'Has never added a card',
          STRIPE_UNAVAILABLE: 'Stripe is not responding: incomplete data.',
          PAYOUTS: 'Payouts',
          BANK_ACCOUNT: 'Bank account',
          PAYOUT_LOCAL_ONLY: 'Stripe is not responding: showing stored data.',
          BALANCE: 'Balance',
          WALLET: 'Wallet',
          CREDITS: 'Credits',
        },
      },
      SUPPORT_TOOLS: {
        PAYMENTS: {
          TAB: 'Payments',
          TITLE: 'Payments',
          SUBTITLE: 'Cards used to pay as a passenger and the account that receives payouts as a driver. Stripe is queried live.',
          REFRESH: 'Refresh',
          RETRY: 'Retry',
          LOAD_ERROR: 'Payment information could not be loaded.',
          CARDS_TITLE: 'As passenger · cards',
          PAYOUT_TITLE: 'As driver · payouts',
          PAYMENT_STATUS: 'Payment status',
          STATUS: {
            ok: 'Up to date',
            warning: 'Warning',
            blocked: 'Blocked',
            cancelled: 'Cancelled',
            unknown: 'No data',
          },
          REASONS: {
            card_expiring: 'Card about to expire',
            card_expired: 'Card expired',
            method_removed: 'Payment method removed',
            charge_failed: 'Charge failed',
            hold_failed: 'Hold declined',
            debt_paid: 'Debt paid',
            method_added: 'Payment method added',
            wallet_topup: 'Wallet top-up',
            retry_succeeded: 'Charge retry succeeded',
            grace_period_exceeded: 'Grace period exceeded',
            manual_override: 'Manual change',
          },
          FUNDING: {
            credit: 'Credit',
            debit: 'Debit',
            prepaid: 'Prepaid',
            unknown: 'Unknown type',
          },
          EXPIRES: 'Expires {{date}}',
          DEFAULT: 'Default',
          EXPIRES_SOON: 'Expires soon',
          EXPIRED: 'Expired',
          GRACE_PERIOD: 'In grace period',
          GRACE_PERIOD_UNTIL: 'In grace period until {{date}}',
          NO_CARDS: 'No cards',
          NO_CUSTOMER: 'No Stripe customer',
          STRIPE_UNAVAILABLE_CARDS: 'Stripe did not respond: cards cannot be shown right now. Try refreshing in a moment.',
          LOCAL_SOURCE_NOTE: 'Stripe did not respond: this data comes from our database and may be out of date.',
          UNKNOWN: 'Unknown',
          BANK_ACCOUNTS: 'Bank accounts',
          NO_BANK_ACCOUNTS: 'No bank accounts',
          BANK_UNKNOWN: 'Unknown bank',
          REASON_OTHER: 'Other reason',
          PAYOUT_OK: 'Can receive payouts',
          PAYOUT_BLOCKED: 'Cannot receive payouts',
          PAYOUT_NOT_STARTED: 'Has not set up payouts yet',
          PAYOUT_UNVERIFIED: 'Not checked with Stripe',
          PAYOUT_RECEIVES_IN: 'Receives withdrawals at {{bank}} •••• {{last4}}.',
          PAYOUT_NO_BANK: 'No bank account registered yet.',
          PAYOUT_NOT_STARTED_TEXT: 'Has not started the payout setup in the app, so they cannot withdraw what they earn as a driver yet.',
          PAYOUT_COMPLETE_ONBOARDING: 'Needs to complete the payout setup in the app.',
          PAYOUT_WAIT_VERIFICATION: 'Stripe is reviewing their details: nothing to do for now.',
          PAYOUT_STRIPE_ASKS: 'Stripe is asking for:',
          PAYOUT_STRIPE_WILL_ASK: 'Stripe will soon ask for:',
          REQ_GROUPS: {
            personal: 'Personal details (name, date of birth, address, phone…)',
            document: 'Identity document',
            bank: 'Bank account',
            tos: 'Accept Stripe\'s terms',
            business: 'Business details',
            other: 'Other details',
          },
          DISABLED_REASONS: {
            past_due: 'Stripe requested details and the deadline has passed',
            pending_verification: 'Stripe is verifying the details',
            rejected: 'Stripe has rejected the account',
            under_review: 'Under review by Stripe',
            other: 'Blocked by Stripe',
          },
          BANK_STATUS: {
            new: 'New',
            validated: 'Validated',
            verified: 'Verified',
            verification_failed: 'Verification failed',
            errored: 'Errored',
          },
        },
        SOLUTIONS: {
          TITLE: 'How to fix it',
          COPY: 'Copy message for the user',
          INSERT: 'Insert into the chat',
          COPIED: 'Copied',
          COPY_ERROR: 'Could not copy: the text is selected so you can copy it manually.',
          ACCOUNT_ID: 'Account id',
          COPY_ID: 'Copy id',
          OPEN_CHAT: 'Open chat with the message',
          NO_CHAT_HINT: 'This user has no support chat yet: copy the message and send it another way.',
          CHECKING_CHAT: 'Checking whether they have a support chat…',
          OPEN_CHAT_ERROR: 'Could not open the support chat. Please try again.',
          STEPS: {
            ASK_ADD_BANK: 'Ask them to add their bank account in the app: «Mi cartera» → «Métodos de pago y cobro» → «Cobro» → «Añadir método de cobro».',
            SEND_MESSAGE: 'You can send them the message below.',
            LEGACY_REPLACEABLE: 'Their payout account belongs to the old system and is incomplete. Adding a bank account in the app replaces it automatically.',
            LEGACY_HAS_BALANCE: 'Their old account has a Stripe balance and cannot be replaced automatically.',
            NOTIFY_DEV_WITH_ID: 'Let the development team know, with the account id.',
            REVIEW_PERSONAL: 'Ask them to check their personal details in «Perfil» and to add their bank account again.',
            IF_PERSISTS_DEV: 'If nothing changes, let the development team know.',
            NOTHING_TO_DO: 'Nothing to do: Stripe is reviewing their details.',
            RE_ADD_BANK: 'Ask them to add their bank account again in the app.',
            ASK_NEW_CARD: 'Ask them to add a new card: «Mi cartera» → «Métodos de pago y cobro» → «Pago» → «Añadir método de pago».',
            WARN_EXPIRING: 'Let them know their card expires soon and that they can add a new one beforehand.',
            DEBT: 'They have a pending charge and a blocked account: ask them to tap «Actualizar método de pago» on the app notice and add a valid card. The debt is charged automatically.',
          },
        },
        SNIPPETS_CONFIG: {
          MENU: 'Support replies',
          BREADCRUMB: 'Configuration',
          BREADCRUMB_ARIA: 'Breadcrumb',
          TITLE: 'Support replies and reminders',
          DESCRIPTION: 'Texts the support team inserts from the chat. Drag the rows to change the order in which they appear.',
          NEW: 'New text',
          TAB_REPLIES: 'Quick replies',
          TAB_REMINDERS: 'Reminders',
          SEARCH_PLACEHOLDER: 'Search by title, text or category...',
          REORDER_DISABLED: 'Clear the search to reorder',
          LOADING: 'Loading...',
          LOAD_ERROR: 'The texts could not be loaded.',
          RETRY: 'Retry',
          EMPTY_REPLIES: 'There are no quick replies yet.',
          EMPTY_REMINDERS: 'There are no reminders yet.',
          NO_RESULTS: 'No text matches the search.',
          COL_ORDER: 'Order',
          COL_LABEL: 'Title',
          COL_BODY: 'Text',
          COL_CATEGORY: 'Category',
          COL_USES: 'Uses',
          COL_ACTIVE: 'Active',
          COL_ACTIONS: 'Actions',
          DRAG: 'Drag to reorder',
          EDIT: 'Edit',
          DELETE: 'Delete',
          NEW_TITLE: 'New text',
          EDIT_TITLE: 'Edit text',
          KIND_REPLY: 'Quick reply',
          KIND_REMINDER: 'Reminder',
          FIELD_LABEL: 'Title',
          FIELD_CATEGORY: 'Category',
          CATEGORY_PLACEHOLDER: 'E.g. Payments, CAE...',
          CATEGORY_NONE: 'No category',
          CATEGORY_NEW: '+ New category…',
          CATEGORY_NEW_PLACEHOLDER: 'Name of the new category',
          CATEGORY_BACK: 'Choose from the list',
          FIELD_BODY: 'Text',
          FIELD_BODY_ES: 'Spanish text',
          FIELD_BODY_CA: 'Catalan text (optional)',
          FIELD_ACTIVE: 'Active',
          PLACEHOLDER_HINT: 'When the reply is inserted, <code>{nombre}</code> (Spanish) and <code>{nom}</code> (Catalan) are replaced with the user\'s first name.',
          REQUIRED: 'Required field',
          PREVIEW: 'Preview',
          PREVIEW_EMPTY: 'Type the text to see how it will look.',
          SAVE: 'Save',
          CANCEL: 'Cancel',
          CREATED: 'Text created',
          SAVED: 'Changes saved',
          DELETED: 'Text deleted',
          DELETE_TITLE: 'Delete text',
          DELETE_TEXT: '"{{label}}" will no longer appear in the support chat.',
          DELETE_CONFIRM: 'Yes, delete',
          ERROR_SAVE: 'The changes could not be saved and have been undone.',
          ERROR_DELETE: 'It could not be deleted. The text has been restored.',
          ERROR_REORDER: 'The order could not be saved. The previous one has been restored.',
          SAVING: 'Saving…',
          ACCEPT: 'OK',
          SECTION_CONTENT: 'Content',
        },
      },
      ECONOMIC_DASHBOARD: {
        DETAIL_ROUTE: 'route {{id}}',
        HOLD: {
          REASON: {
            reinforced_verification: 'Enhanced',
            cash_delay: 'Cash',
          },
          DAYS: 'day {{day}}/{{total}}',
          UNTIL: 'until {{date}}',
          DUE_TRANSFER: 'day {{day}}/{{total}} · credited in a few minutes',
          DUE_PAYOUT: 'day {{day}}/{{total}} · awaiting review',
          TITLE: 'Held until {{date}}',
        },
        TITLE: 'Economic dashboard',
        SUBTITLE: 'Driver payouts, Stripe balance and what is still to be paid. All amounts in euros.',
        EXPORT_CSV: 'Export movements (CSV)',
        EXPORTING: 'Exporting…',
        EXPORT_ERROR: 'The CSV could not be exported',
        FORBIDDEN: 'You don\'t have permission for this: missing operation {{operation}}',
        HELP: {
          trip_charge: 'What the passenger is charged for a trip.',
          user_charge: 'Charge to the user: a wallet top-up or another charge (they can\'t be told apart today).',
          negative_balance_charge: 'Charge to bring a user\'s negative balance back to zero.',
          trip_transfer: 'Trip payment to the driver, from the passenger\'s wallet.',
          trip_commission: 'What WAIIS keeps from each trip.',
          driver_payout: 'The driver moves money from their wallet to their bank account.',
          instant_payout: 'Instant payout: the driver gets the money within minutes, for a fee.',
          instant_payout_fee: 'Fee WAIIS charges for an instant payout.',
          instant_payout_refund: 'Refund to the wallet of an instant payout that failed (amount and fee).',
          cae_discount: 'Energy Saving Certificates (CAE) bonus for a completed trip.',
          manual_adjustment: 'Correction made by hand by an administrator (credit or withdrawal).',
          referral_bonus: 'Bonus for inviting someone who takes their first trip.',
          corporate_ride_reclaim: 'Charge to the employee for a rejected company ride: from their wallet to the company’s.',
          corporate_ride_reclaim_topup: 'Top-up with the employee’s card to cover a rejected company ride.',
          PAYOUT_PAID: 'Stripe confirmed the payment in the driver\'s bank.',
          PAYOUT_PENDING: 'Sent to Stripe without confirmation, or under manual review.',
          PAYOUT_FAILED: 'Stripe couldn\'t pay it, or it was rejected in review.',
          PAYOUT_REFUNDED: 'It failed and the money went back to the driver\'s wallet.',
          CHARGE_COMPLETED: 'The passenger was charged successfully.',
          CHARGE_PENDING: 'The charge isn\'t confirmed yet.',
          CHARGE_FAILED: 'Charging the passenger failed: money that didn\'t come in.',
          CHARGE_REFUNDED: 'It was charged and then returned to the passenger.',
        },
        STATS: {
          FOLD_HIDE: 'Hide details',
          FOLD_SHOW: 'Show details',
          INSIGHT_FLOWS_NEG: 'In {{range}}, passengers paid {{in}} by card and drivers withdrew {{out}} to their bank: {{net}} more went out than came in.',
          INSIGHT_FLOWS_POS: 'In {{range}}, passengers paid {{in}} by card and drivers withdrew {{out}} to their bank: {{net}} more came in than went out.',
          FLOWS_TIP_OUT: 'Withdrawn by drivers',
          FLOWS_TIP_IN: 'Paid by passengers',
          FLOWS_TOTAL: 'Total',
          FLOWS: 'Money coming into and going out of WAIIS',
          FLOWS_Q_hour: 'In: what passengers pay by card (trips and wallet top-ups), landing in WAIIS\'s Stripe account. Out: what drivers withdraw from their wallet to their bank. Per hour, excluding failed and refunded.',
          FLOWS_Q_day: 'In: what passengers pay by card (trips and wallet top-ups), landing in WAIIS\'s Stripe account. Out: what drivers withdraw from their wallet to their bank. Per day, excluding failed and refunded.',
          FLOWS_Q_week: 'In: what passengers pay by card (trips and wallet top-ups), landing in WAIIS\'s Stripe account. Out: what drivers withdraw from their wallet to their bank. Per week, excluding failed and refunded.',
          FLOWS_IN: 'In · passenger payments',
          FLOWS_OUT: 'Out · driver payouts',
          FLOWS_NET: 'Difference',
          FLOWS_PERIOD: 'Period',
          FLOWS_TABLE: 'Show the data',
          FLOWS_WEEK_OF: 'week of {{date}}',
          FLOWS_TRUNCATED: 'Partial data: there are more than 1,000 movements in this range and only the most recent are added up. Choose a shorter range.',
          INSIGHT_PAYOUTS: '{{paid}} of {{total}} payouts were paid ({{pct}}).',
          INSIGHT_PAYOUTS_FAILED: '{{n}} failed or were rejected: check the table filtering by {{concept}}.',
          INSIGHT_CHARGES_FAILED: '1 in {{n}} trip charges wasn\'t collected ({{pct}}): money that didn\'t come in.',
          INSIGHT_CHARGES_OK: 'All trip charges were collected or are still in progress.',
          INSIGHT_CONCEPT: 'The most frequent is {{label}}: {{pct}} of movements.',
          INSIGHT_MANUAL: '{{n}} manual adjustments ({{pct}}): many corrections made by hand.',
          INSIGHT_NO_REFERRALS: 'No referral bonuses in this period.',
          SHOW_IN_TABLE: 'Show in table',
          HELP: 'What it means',
          SHOW: 'Show statistics',
          HIDE: 'Hide statistics',
          TITLE: 'Movement statistics',
          SUBTITLE: 'Data for the table range: {{range}}',
          PAYOUTS: 'Payouts by status',
          PAYOUTS_Q: 'Are drivers being paid?',
          PAYOUTS_TOTAL: '{{count}} payouts · {{valid}} excluding failed or rejected',
          PAYOUT_PAID: 'Paid',
          PAYOUT_PENDING: 'Pending',
          PAYOUT_FAILED: 'Failed or rejected',
          PAYOUT_REFUNDED: 'Returned to the wallet',
          INSTANT_PAYOUTS: 'Instant payouts by status',
          INSTANT_PAYOUTS_Q: 'Are instant payouts reaching drivers?',
          INSTANT_PAYOUTS_TOTAL: '{{count}} instant payouts · {{valid}} excluding failed or rejected',
          CHARGES: 'Trip charges by status',
          CHARGES_Q: 'Are passengers being charged for trips?',
          CHARGES_TOTAL: '{{count}} charges',
          CHARGE_COMPLETED: 'Charged',
          CHARGE_PENDING: 'Pending',
          CHARGE_FAILED: 'Unpaid',
          CHARGE_REFUNDED: 'Refunded',
          BY_CONCEPT: 'What movements there are',
          BY_CONCEPT_Q: 'How many movements of each concept, from most to least',
          TOTAL: '{{count}} movements',
          EMPTY: 'No movements in this range',
          LOADING: 'Calculating statistics…',
          ERROR: 'Statistics could not be loaded',
        },
        KPI: {
          PAYOUTS_24H: 'Payouts · last 24 h',
          PAYOUTS_24H_HINT: 'Driver payouts',
          PAYOUTS_24H_DETAIL: '{{count}} payouts',
          PAYOUTS_24H_UNCONFIRMED: '{{count}} unconfirmed',
          PAYOUTS_MONTH: 'Payouts · last month',
          PAYOUTS_MONTH_HINT: 'Last 30 days',
          PAYOUTS_MONTH_DETAIL: '{{count}} payouts',
          VS_PREVIOUS: '{{pct}} vs previous month',
          STRIPE: 'Available in Stripe',
          STRIPE_HINT: 'Pending: {{pending}}',
          UPDATED_JUST_NOW: 'Updated now',
          UPDATED_MINUTES: 'Updated {{n}} min ago',
          UPDATED_HOURS: 'Updated {{n}} h ago',
          UPDATED_ON: 'Updated {{date}}, {{time}}',
          NO_STRIPE_MOVEMENTS: 'No movements',
          PENDING: 'Pending to pay',
          PENDING_HINT: 'Withdrawable wallet balance + created payouts',
          COVERED: 'Covered: Stripe = {{ratio}}× pending',
          NOT_COVERED: 'Not covered: {{missing}} short',
          STRIPE_UNAVAILABLE: 'Not available',
          ERROR: 'Indicators could not be loaded',
        },
        MOVEMENTS: {
          SEARCH: 'Search concept, user or reference…',
          NO_MATCH: 'No movement on this page matches «{{q}}»',
          CLEAR_SEARCH: 'Clear search',
          SEARCH_SERVER: 'Searching all movements by {{filters}}',
          TITLE: 'Recent movements',
          SUBTITLE: 'Each trip generates two internal movements: the passenger\'s payment to the driver and the WAIIS commission. Stripe charges and payouts are real money coming in and going out.',
          CLEAR: 'Clear filters',
          SHOWING: 'Showing {{count}} of {{total}} movements',
          PREV: 'Previous',
          NEXT: 'Next',
          LOADING: 'Loading movements…',
          EMPTY: 'No movements match these filters',
          ERROR: 'Movements could not be loaded',
          RETRY: 'Retry',
          DELETED_USER: 'Deleted user',
        },
        COLUMNS: {
          DATE: 'Date',
          MOVEMENT: 'Movement',
          USER: 'User',
          COUNTERPARTY: 'Counterparty',
          TYPE: 'Type',
          MEDIUM: 'Medium',
          AMOUNT: 'Amount',
          STATUS: 'Status',
        },
        FILTERS: {
          TYPE_ALL: 'Type: all',
          CONCEPT_ALL: 'Concept: all',
          MEDIUM_ALL: 'Medium: all',
          STATUS_ALL: 'Status: all',
          RANGE: 'Range: {{range}}',
        },
        TYPE: {
          inbound: 'In',
          outbound: 'Out',
          internal: 'Internal',
        },
        MEDIUM: {
          stripe: 'Stripe',
          balance: 'Balance',
          manual: 'Manual',
        },
        STATUS: {
          completed: 'Completed',
          paid: 'Paid',
          pending: 'Pending',
          failed: 'Unpaid',
          refunded: 'Refunded',
          held: 'Held',
        },
        RANGE: {
          '24h': '24 hours',
          '7d': '7 days',
          '30d': '30 days',
          '90d': '90 days',
        },
        CONCEPT: {
          trip_charge: 'Trip charge',
          user_charge: 'User charge',
          negative_balance_charge: 'Negative balance charge',
          trip_transfer: 'Payment to driver',
          trip_commission: 'WAIIS commission',
          driver_payout: 'Driver payout',
          instant_payout: 'Instant payout',
          instant_payout_fee: 'Instant payout fee',
          instant_payout_refund: 'Instant payout refund',
          cae_discount: 'CAE bonus',
          manual_adjustment: 'Manual adjustment',
          referral_bonus: 'Referral bonus',
          corporate_ride_reclaim: 'Rejected company ride',
          corporate_ride_reclaim_topup: 'Top-up for rejected company ride',
        },
      },
      RECLAMATIONS: {
        PANEL: {
          ALL_TITLE: 'All complaints',
          ALL_SUBTITLE: 'Pending and processed. Click one to see its details.',
          PENDING_TITLE: 'Pending complaints',
          PENDING_SUBTITLE: 'Not processed yet. Click one to review it.',
          PROCESSED_TITLE: 'Processed complaints',
          PROCESSED_SUBTITLE: 'Already reviewed by the team. Click one to see its details.',
        },
        SHOWING: 'Showing {{shown}} of {{total}} complaints',
        DETAIL: {
          BREADCRUMB_ARIA: 'Breadcrumb',
          DETAIL: 'Details',
          BACK: 'Back to complaints',
          LOADING: 'Loading complaint…',
          RETRY: 'Retry',
          PROCESSED: 'Processed',
          PENDING: 'Pending',
          REOPEN: 'Reopen',
          MARK_PROCESSED: 'Mark as processed',
          RECEIVED: 'Received',
          UPDATED: 'updated {{date}}',
          PERSON: 'Person',
          VIEW_PROFILE: 'View profile',
          NO_PERSON: 'No data about the person.',
          MANAGER: 'Assigned manager',
          UNASSIGNED: 'Unassigned',
          MANAGER_HINT: 'Managers are assigned or removed from the complaints list.',
          CONTENT_TITLE: 'What the person says',
          ENRICHED_TITLE: 'Agent enriched context',
          NEEDS_REVIEW: 'Needs review · {{value}}',
          DIAGNOSIS: 'Diagnosis',
          PROBABLE_CAUSE: 'Probable cause',
          PROPOSED_RESOLUTION: 'Proposed resolution',
          CONVERSATION_SUMMARY: 'Conversation summary',
          SENTIMENT: 'Reported sentiment',
          NO_ENRICHED_TITLE: 'No enriched context',
          NO_ENRICHED_TEXT: 'This ticket has no enriched context: either it was not created by the support agent, or the backend does not expose these fields to the back office yet (see <code>specs/reclamation-detail-backend-brief.md</code>).',
          RELATED: 'Related items',
          TRIP: 'Trip',
          OPEN: 'Open',
          ASSIGNMENT: 'Assignment',
          PAYMENT: 'Payment',
          LOAD_ERROR: 'Could not load the complaint.',
          UPDATE_ERROR: 'Could not update the status.',
          DOMAIN: {
            VALIDATION: 'Validation',
            CAE: 'CAE',
            CANCELLATION: 'Cancellation',
            PAYMENT: 'Payment',
            CREDITS: 'Credits',
            ACCOUNT: 'Account',
          },
          OUTCOME: {
            RESOLVED: 'Resolved by the agent',
            RESOLVED_WITH_REPORT: 'Resolved with report · needs confirmation',
            ESCALATED_WRITE_REQUIRED: 'Escalated · needs a manual action',
            ESCALATED_DATA_MISMATCH: "Escalated · data doesn't match",
            ESCALATED_PRIORITY: 'Escalated · high priority',
            ESCALATED_RECURRENCE: 'Escalated · recurring issue',
            ESCALATED_NO_DATA: 'Escalated · not enough data',
          },
          PRIORITY: {
            P0: 'P0 · critical',
            P1: 'P1 · high',
            P2: 'P2 · medium',
            P3: 'P3 · low',
          },
        },
        TITLE: 'Reclamations',
        SEARCH_PLACEHOLDER: 'Search reclamations...',
        TABS: {
          ALL: 'All',
          PENDING: 'Pending',
          PROCESSED: 'Processed',
        },
        STATE: {
          LOADING: 'Loading claims',
          LOADING_HINT: 'Requesting the list with the selected filters.',
          ERROR: 'The claims list could not be loaded.',
          EMPTY: 'No results',
          EMPTY_HINT: 'No claims match the filters.',
        },
        PAGINATION: {
          PREVIOUS: 'Previous',
          NEXT: 'Next',
          OF: 'of',
        },
        COLUMNS: {
          TITLE: 'Title',
          CATEGORY: 'Category',
          SUBCATEGORY: 'Subcategory',
          STATUS: 'Status',
          USER: 'User',
          DATE: 'Date',
        },
        STATUS: {
          PENDING: 'Pending',
          PROCESSED: 'Processed',
        },
        FILTERS: {
          CATEGORY_ALL: 'Category: all',
          SUBCATEGORY_ALL: 'Subcategory: all',
          CLEAR_ALL: 'Clear filters',
          TITLE: 'Filters',
          APPLY: 'Apply filters',
          CLEAR: 'Clear',
          ALL: 'All',
          USER_ID: 'User ID',
        },
        MODAL: {
          CLASSIFICATION: 'Classification',
          TITLE: 'Reclamation details',
          CONTENT: 'Content',
          USER_SECTION: 'User',
          USER_NAME: 'Name',
          USER_EMAIL: 'Email',
          USER_PHONE: 'Phone',
          USER_ROLE: 'Role',
          VIEW_USER: 'View user profile',
          NO_USER: 'User data not available',
          METADATA: 'Metadata',
          CREATED_AT: 'Created',
          UPDATED_AT: 'Updated',
        },
        ACTIONS: {
          RETRY: 'Retry',
          OPEN: 'Open',
          SAVE: 'Save',
          SAVING: 'Saving...',
          CANCEL: 'Cancel',
          ACCEPT: 'OK',
          MARK_PROCESSED: 'Mark as processed',
          REOPEN: 'Reopen',
          VIEW_DETAIL: 'View full detail',
        },
        SUCCESS: {
          TITLE: 'Success',
          UPDATED: 'Reclamation updated successfully',
        },
        ERROR: {
          TITLE: 'Error',
        },
        VALIDATION: {
          TITLE_REQUIRED: 'Title is required',
          CONTENT_REQUIRED: 'Content is required',
          SUBCATEGORY_REQUIRES_CATEGORY:
            'Subcategory requires a selected category',
        },
        INACTIVE_CODE: 'Inactive',
      },
      RECLAMATION_TAXONOMY: {
        BREADCRUMB_ARIA: 'Breadcrumb',
        LOADING_SUBCATEGORIES: 'Loading subcategories',
        TITLE: 'Reclamation taxonomy',
        FORM: {
          UNCHANGED: 'Change the code to be able to save',
          CODE: 'Code (identifier)',
          CODE_PLACEHOLDER: 'e.g. no_show',
          CODE_HINT:
            'Lowercase letters, numbers and underscores only (snake_case).',
          PREVIEW: 'Preview',
        },
        DETAIL: {
          EDIT_CATEGORY: 'Edit category',
          SUBCATEGORIES: 'Subcategories',
        },
        MODAL: {
          NEW_CATEGORY: 'New category',
          NEW_SUBCATEGORY: 'New subcategory',
        },
        ACTIONS: {
          RETRY: 'Retry',
          BACK: 'Back to list',
          NEW_CATEGORY: 'New category',
          NEW_SUBCATEGORY: 'Add subcategory',
          SAVE: 'Save',
          SAVING: 'Saving...',
          CANCEL: 'Cancel',
          ACCEPT: 'OK',
          DELETE: 'Delete',
          DELETING: 'Deleting...',
          DELETED: 'Deleted',
          DELETE_CATEGORY: 'Delete category',
        },
        EMPTY: {
          CATEGORIES: 'No categories configured.',
          CREATE_FIRST: 'Create first category',
          SUBCATEGORIES: 'This category has no subcategories.',
        },
        SUCCESS: {
          CATEGORY_CREATED: 'Category created successfully',
          CATEGORY_UPDATED: 'Category updated successfully',
          CATEGORY_DELETED: 'Category deleted successfully',
          SUBCATEGORY_CREATED: 'Subcategory created successfully',
          SUBCATEGORY_DELETED: 'Subcategory deleted successfully',
        },
        ERROR: {
          LOAD_CATEGORIES: 'Categories could not be loaded.',
          LOAD_SUBCATEGORIES: 'Subcategories could not be loaded.',
          LOAD_CATEGORY: 'The category could not be loaded.',
          TITLE: 'Error',
          NOT_FOUND: 'Category not found',
        },
        VALIDATION: {
          CODE_REQUIRED: 'Code is required',
          CODE_FORMAT: 'Invalid format. Use snake_case (e.g. no_show)',
          CODE_MAX_LENGTH: 'Code cannot exceed 255 characters',
        },
        CONFIRM: {
          DELETE_SUBCATEGORY_TITLE: 'Delete subcategory?',
          DELETE_SUBCATEGORY_TEXT:
            '«{{label}}» (<code>{{code}}</code>) will be deleted. Existing reclamations keep their classification, but it cannot be used for new ones.',
          DELETE_CATEGORY_TITLE: 'Delete category?',
          DELETE_CATEGORY_TEXT:
            '«{{label}}» (<code>{{code}}</code>) and <strong>all its subcategories</strong> will be deleted. This cannot be undone from the dashboard; existing reclamations keep their classification.',
        },
      },
      TAGS: {
        SAVE: 'Save',
        SAVING: 'Saving…',
        DISABLED: 'Disabled',
        PICK_COLOR: 'Pick colour',
        CLEAR_COLOR: 'Remove colour',
        SAVE_ERROR: 'The tag could not be saved',
        DELETE_ERROR: 'The tag could not be deleted',
        TITLE: 'Tags',
        ADD: 'Add Tag',
        EDIT: 'Edit Tag',
        NAME: 'Name',
        TSOFT_NAME: 'TSoft Name',
        CATEGORY: 'Category',
        COLOR: 'Color',
        SUCCESS_CREATE: 'Tag created successfully',
        SUCCESS_UPDATE: 'Tag updated successfully',
        SUCCESS_DELETE: 'Tag deleted successfully',
        CONFIRM_DELETE: 'Are you sure you want to delete this tag?',
        SEARCH: 'Search tag',
        ACTIONS: 'Actions',
        WAIT: 'Wait..',
        ENABLED: 'Enabled',
        ENABLE_TAG: 'Enable tag',
        CATEGORIES: {
          ACTIVITY: 'Activity',
          GENERAL: 'General',
          MISC: 'Misc',
        },
        SUCCESS: 'Success!',
        ERROR: 'Error',
        CONFIRM: 'Confirm',
        CANCEL: 'Cancel',
        ITEMS: 'tags',
      },
      ROLES: {
        TITLE: 'Roles',
        ADD: 'Add Role',
        EDIT: 'Edit Role',
        NAME: 'Name',
        CREATED_AT: 'Creation Date',
        UPDATED_AT: 'Update Date',
        SUCCESS_CREATE: 'Role created successfully',
        SUCCESS_UPDATE: 'Role updated successfully',
        SUCCESS_DELETE: 'Role deleted successfully',
        CONFIRM_DELETE: 'Are you sure you want to delete this role?',
        SEARCH: 'Search role',
        ACTIONS: 'Actions',
        WAIT: 'Wait..',
        SUCCESS: 'Success!',
        ERROR: 'Error',
        CONFIRM: 'Confirm',
        CANCEL: 'Cancel',
        ITEMS: 'roles',
      },
      AUTHORIZATION: {
        TITLE: 'Authorization',
        BACK_TO_ROLES: 'Back to Roles',
        ROLES: {
          TITLE: 'Roles',
          ADD: 'Add Role',
          EDIT: 'Edit Role',
          NAME: 'Name',
          CREATED_AT: 'Creation Date',
          UPDATED_AT: 'Update Date',
          SUCCESS_CREATE: 'Role created successfully',
          SUCCESS_UPDATE: 'Role updated successfully',
          SUCCESS_DELETE: 'Role deleted successfully',
          CONFIRM_DELETE: 'Are you sure you want to delete this role?',
          SEARCH: 'Search role',
          PANEL_SUB:
            'Roles that backoffice users can have. Edit them or open their actions, permissions and pages.',
          MODAL_SUB: 'The name shown for the role when assigning it.',
          ACTIONS: 'Actions',
          VIEW_ACTIONS: 'View Actions',
          VIEW_PERMISSIONS: 'View Permissions',
          VIEW_PAGES: 'View Pages',
          WAIT: 'Wait..',
          SUCCESS: 'Success!',
          ERROR: 'Error',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
        },
        ACTIONS: {
          ITEMS: 'actions',
          TITLE: 'Actions',
          ADD: 'Add Action',
          EDIT: 'Edit Action',
          ACTION: 'Action',
          CREATED_AT: 'Creation Date',
          UPDATED_AT: 'Update Date',
          SUCCESS_CREATE: 'Action created successfully',
          SUCCESS_UPDATE: 'Action updated successfully',
          SUCCESS_DELETE: 'Action deleted successfully',
          CONFIRM_DELETE: 'Are you sure you want to delete this action?',
          SEARCH: 'Search action',
          WAIT: 'Wait..',
          SUCCESS: 'Success!',
          ERROR: 'Error',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
        },
        ROLES_PERMISSIONS: {
          ITEMS: 'permissions',
          TITLE: 'Permissions',
          ADD: 'Add Permission',
          EDIT: 'Edit Permission',
          OPERATION_ID: 'Operation',
          DESCRIPTION: 'Description',
          SELECT_OPERATION: 'Select an operation...',
          CREATE_MODAL_TITLE: 'Create Permission',
          EDIT_MODAL_TITLE: 'Edit Permission',
          CREATED_AT: 'Creation Date',
          UPDATED_AT: 'Update Date',
          SUCCESS_CREATE: 'Permission created successfully',
          SUCCESS_UPDATE: 'Permission updated successfully',
          SUCCESS_DELETE: 'Permission deleted successfully',
          CONFIRM_DELETE: 'Are you sure you want to delete this permission?',
          SEARCH: 'Search permission',
          WAIT: 'Wait..',
          SUCCESS: 'Success!',
          ERROR: 'Error',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
        },
        ROLES_PAGES: {
          ITEMS: 'pages',
          TITLE: 'Pages',
          ADD: 'Add Page',
          EDIT: 'Edit Page',
          PAGE_TAG: 'Page',
          CREATED_AT: 'Creation Date',
          UPDATED_AT: 'Update Date',
          SUCCESS_CREATE: 'Page created successfully',
          SUCCESS_UPDATE: 'Page updated successfully',
          SUCCESS_DELETE: 'Page deleted successfully',
          CONFIRM_DELETE: 'Are you sure you want to delete this page?',
          SEARCH: 'Search page',
          WAIT: 'Wait..',
          SUCCESS: 'Success!',
          ERROR: 'Error',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
        },
        USER_ROLE_CORPORATIONS: {
          TITLE: 'User Role Assignments',
          ADD: 'New',
          SEARCH: 'Search assignment',
          USER: 'User',
          ROLE: 'Role',
          TYPE: 'Assignment Type',
          CORPORATION: 'Corporation',
          OFFICE: 'Office',
          OFFICE_LABEL: 'Corporation Office',
          TYPE_AUTO_HINT:
            'Assignment Type is automatically set based on the selected role.',
          PANEL_SUB:
            'Each row is a user with a role, and the company or office where they have it.',
          MODAL_SUB:
            'Choose the user and their role; the company or office, if the role needs one.',
          LOADING: 'Loading...',
          COL_USER: 'User',
          COL_EMAIL: 'Email',
          COL_ROLE: 'Role',
          COL_TYPE: 'Type',
          COL_CORP_OFFICE: 'Corporation/Office',
          DELETE_CONFIRM_BTN: 'Delete',
          DELETE_CANCEL_BTN: 'Cancel',
          CREATED_AT: 'Creation Date',
          UPDATED_AT: 'Update Date',
          REQUIRED_TEXT: 'Choose the user and the role.',
          DUPLICATE_TITLE: 'Duplicate assignment',
          DUPLICATE_TEXT: 'This user already has this assignment.',
          CREATE_ERROR: 'The assignment could not be created.',
          DELETE_ERROR: 'The assignment could not be deleted.',
          LOAD_ERROR: 'The data could not be loaded.',
          SUCCESS_CREATE: 'Assignment created successfully',
          SUCCESS_DELETE: 'Assignment deleted successfully',
          DELETE_CONFIRM: 'Are you sure you want to delete this assignment?',
          WAIT: 'Wait..',
          SUCCESS: 'Success!',
          ERROR: 'Error',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          ITEMS: 'role assignments',
        },
      },
      CRUD: {
        PROCESSING: 'Loading...',
        EMPTY_TABLE: 'No data available in table',
        INFO: 'Showing _START_ to _END_ of _TOTAL_ entries',
        INFO_EMPTY: 'Showing 0 to 0 of 0 entries',
        INFO_FILTERED: '(filtered from _MAX_ total entries)',
        LENGTH_MENU: 'Show _MENU_ entries',
        LOADING_RECORDS: 'Loading...',
        ZERO_RECORDS: 'No matching records found',
        SEARCH: 'Search:',
        ACTIONS: 'Actions',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        SHOWING: 'Showing {{count}} of {{total}} {{items}}',
        ITEMS: 'records',
        DELETE: 'Delete',
        DELETING: 'Deleting…',
        DELETED: 'Deleted',
        DELETE_ERROR: 'Could not delete it',
        CONFIRM_DELETE_TITLE: 'Are you sure?',
        CONFIRM_DELETE_TEXT:
          'This action will deactivate the selected resource',
        ROW_VIEW: 'View',
        ROW_EDIT: 'Edit',
        ROW_DELETE: 'Delete',
        ROW_LINK: 'Link',
      },
      TERMS_CONDITIONS: {
        TITLE: 'Terms and Conditions of Use',
        TAB_DASHBOARD: 'Dashboard',
        TAB_APP: 'App',
        CURRENT_VERSION: 'Current version updated on',
        NO_VERSION: 'No current version — create the first one',
        SAVING: 'Saving…',
        SAVE: 'Save changes',
        LOADING: 'Loading content…',
        PLACEHOLDER: 'Write the terms and conditions here...',
        SUCCESS_SAVE: 'Changes saved successfully',
        ERROR_ACTIVATE: 'Error activating the version',
        ERROR_SAVE: 'Error saving changes',
        NOTE_TITLE: 'Saving publishes',
        NOTE_TEXT: 'Each save creates a new version and makes it the current one. The dashboard and the app have their own text: pick the tab before editing.',
        EMPTY_HINT: 'Write the text to be able to save',
      },
      CONTRACT_TEMPLATES: {
        TITLE: 'Contract template',
        CURRENT_VERSION: 'Current version updated on',
        HASH: 'Hash:',
        NO_VERSION: 'No current version — create the first one',
        SAVING: 'Saving…',
        SAVE: 'Save changes',
        LOADING: 'Loading content…',
        PLACEHOLDER: 'Write the contract template here...',
        SUCCESS_SAVE: 'Changes saved successfully',
        ERROR_ACTIVATE: 'Error activating the version',
        ERROR_SAVE: 'Error saving changes',
        NOTE_TITLE: 'Saving publishes',
        NOTE_TEXT: 'Each save creates a new version and makes it the current one: it is used to generate each company\'s contract. Text in brackets, such as [Razón social del Cliente], is filled in by the system with the company\'s data: do not change it.',
        EDITOR_TITLE: 'Template text',
        EMPTY_HINT: 'Write the text to be able to save',
      },
      DATA_PROCESSING_AGREEMENT: {
        TITLE: 'Data processing agreement (DPA)',
        CURRENT_VERSION: 'Current version updated on',
        NO_VERSION: 'No current version — create the first one',
        PUBLISH_HINT: 'Saving creates a new version and publishes it: it replaces the current one for every company created from then on.',
        SOFT_BREAK_HINT: 'Inside a cell, Enter creates another cell: use Shift+Enter for a line break. Tab on the last cell adds a row.',
        SAVING: 'Saving…',
        SAVE: 'Save and publish',
        LOADING: 'Loading content…',
        PLACEHOLDER: 'Write the data processing agreement here...',
        SUCCESS_SAVE: 'Data processing agreement saved and published',
        ERROR_LOAD: 'Could not load the data processing agreement',
        ERROR_ACTIVATE: 'The version was created but could not be published',
        ERROR_SAVE: 'Error saving the changes',
        NOTE_TITLE: 'Saving publishes',
        EDITOR_TITLE: 'Agreement text',
        EMPTY_HINT: 'Write the text to be able to save',
        INSERT_TABLE: 'Insert table',
        TABLE_COLUMNS: '{{count}} columns',
        CELL_BACKGROUND: 'Cell background',
        CELL_BG_PEACH: 'Peach (labels)',
        CELL_BG_LIGHT_BLUE: 'Light blue',
        CELL_BG_NAVY: 'Navy blue (header)',
        CELL_BG_GREY: 'Grey',
        CELL_BG_NONE: 'No background',
        TABLE_COLUMN: '{{count}} column',
      },
      LABELS: {
        SAVE: 'Save',
        SEARCH: 'Search label',
        ADD: 'Add label',
        EDIT: 'Edit label',
        NAME: 'Name',
        NAME_PLACEHOLDER: 'E.g. VIP',
        NAME_MAX_LENGTH: 'Name cannot be longer than 255 characters',
        CODE: 'Code',
        CODE_PLACEHOLDER: 'E.g. vip',
        CODE_HINT:
          'Stable identifier of the label: lowercase letters, digits and underscores. It is suggested from the name and you can change it.',
        CODE_INVALID:
          'Only lowercase letters without accents, digits and underscores, starting with a letter',
        CODE_MAX_LENGTH: 'Code cannot be longer than 100 characters',
        APPLIES_TO: 'Applies to',
        APPLIES_TO_OPTIONS: {
          ALL: 'Users and routes',
          USER: 'Users',
          POOLING_ROUTE: 'Pooling routes',
        },
        APPLIES_TO_HINT:
          'Sets where the label can be assigned. "Users and routes" makes it available on both.',
        CANCEL: 'Cancel',
        CONFIRM: 'Accept',
        WAIT: 'Saving…',
        SUCCESS: 'Success',
        SUCCESS_CREATE: 'Label created successfully',
        SUCCESS_UPDATE: 'Label updated successfully',
        SUCCESS_DELETE: 'Label deleted successfully',
        ERROR: 'Error',
        SAVE_ERROR: 'The label could not be saved',
        DELETE_ERROR: 'The label could not be deleted',
        NOT_FOUND: 'The label no longer exists. Refresh the list.',
        LOAD_ERROR: 'Could not load the labels',
        UNKNOWN_ERROR: 'Could not complete the operation. Please try again.',
        ITEMS: 'labels',
      },
      VALORATION_LABELS: {
        SEARCH: 'Search label',
        ADD: 'Add label',
        EDIT: 'Edit label',
        NAME: 'Name',
        NAME_MAX_LENGTH: 'Name cannot be longer than 255 characters',
        ROLE: 'Role',
        ROLES: {
          BOTH: 'Both',
          DRIVER: 'Driver',
          RIDER: 'Passenger',
        },
        POSITIVE_NAME: 'Positive label',
        POSITIVE_NAME_PLACEHOLDER: 'E.g. Clean car',
        NEGATIVE_NAME: 'Negative label',
        NEGATIVE_NAME_PLACEHOLDER: 'E.g. Dirty car',
        PAIR_HINT:
          'Labels always come in pairs: votes against the positive one are the times its negative is received. Both are created at once and the pair cannot be changed afterwards.',
        CANCEL: 'Cancel',
        CONFIRM: 'Accept',
        WAIT: 'Saving…',
        SUCCESS: 'Success',
        SUCCESS_CREATE: 'Valoration label created successfully',
        SUCCESS_UPDATE: 'Valoration label updated successfully',
        SUCCESS_DELETE: 'Valoration label deleted successfully',
        ERROR: 'Error',
        ITEMS: 'valoration labels',
        SAVE: 'Save',
        SAVE_ERROR: 'Could not save the label',
        DELETE_ERROR: 'Could not delete the label',
        NOT_FOUND: 'The label no longer exists. Refresh the list.',
        LOAD_ERROR: 'Could not load the label data',
        UNKNOWN_ERROR: 'Could not complete the operation. Please try again.',
      },
      FRAUD_RULES: {
        NOTE_TITLE: 'These alerts help prioritise; they don\'t make the final decision',
        NOTE_TEXT: 'The system gathers signals and explains what it has detected. A person must review the context before blocking an account or holding a payment.',
        LOADING: 'Loading the rules',
        LOAD_ERROR: 'The model rules could not be loaded.',
        SAVE_ERROR: 'The rules could not be saved.',
        RETRY: 'Retry',
        RULES_TITLE: 'How alerts are generated',
        RULES_SUB: 'Behaviours that make a trip need review',
        RULES_UNUSED: "Not used right now: the data team's model does not read them and they do not change any alert. Kept for reference only.",
        MAX_SPEED: 'Maximum plausible speed (km/h)',
        MAX_GPS_JUMP: 'Maximum GPS jump between points (m)',
        MAX_TRIPS_DEVICE: 'Max. trips/day per device',
        NO_SHOWS: 'No-shows to flag risk',
        NON_ELIGIBLE: 'Non-eligible transport threshold',
        COLLISION: 'Collusion / low independence threshold',
        SPOOFING: 'Location spoofing threshold',
        MANUAL_REVIEW: 'Manual review threshold',
        MIN_ZERO: 'Must be 0 or more.',
        RANGE_ERROR: 'Must be between 0 and 1.',
        RANGE_HINT: 'Between 0 and 1.',
        NOTICE_TITLE: 'Reinforced verification notice',
        NOTICE_SUB_1: 'Text the driver sees in the trip detail while their account is under reinforced verification.',
        NOTICE_SUB_2: 'is replaced by the configured number of days.',
        REQUIRED: 'The text is required.',
        REINFORCED_TITLE: "Reinforced verification",
        REINFORCED_SUB: "When an account enters reinforced verification and what happens while it is there.",
        AUTO_ENABLED: "Put under reinforced verification automatically by score",
        AUTO_HINT: "Applied every time the data team loads a new score. The whitelist never enters.",
        AUTO_MIN_SCORE: "Minimum score",
        SCORE_RANGE: "Between 0 and 100.",
        TRIP_DELAY: "Days until the trip is credited to the driver",
        WITHDRAWAL_DELAY: "Days a withdrawal waits",
        DAYS_RANGE: "Between 0 and 90 days.",
        MIN_PAYOUT: "Minimum withdrawal (€)",
        FREE_INVITE: "Under reinforced verification they can still invite at no cost",
        FREE_INVITE_HINT: "Unchecked, nobody under reinforced verification can give or redeem free trips. «Reinforced + no free trips» always blocks it.",
        SWITCH_ON: "On",
        SWITCH_OFF: "Off",
        SWITCH_TURN_ON: "Turn on",
        SWITCH_TURN_OFF: "Turn off",
        CANCEL: "Cancel",
        CONFIRM_WORD: "CONFIRM",
        CONFIRM_TYPE: "To continue, type {{word}}.",
        AUTO_OFF_CONFIRM_TITLE: "Turn off automatic reinforced verification?",
        AUTO_OFF_CONFIRM_TEXT: "New scores will stop putting anyone under reinforced verification. Accounts already there stay as they are. Saved right away.",
        AUTO_ON_CONFIRM_TITLE: "Turn on automatic reinforced verification?",
        AUTO_ON_CONFIRM_TEXT: "Every new score of {{score}} or more will put that account under reinforced verification (except the whitelist). Saved right away.",
        FREE_INVITE_OFF_CONFIRM_TITLE: "Block free trips under reinforced verification?",
        FREE_INVITE_OFF_CONFIRM_TEXT: "Nobody under reinforced verification will be able to give or redeem free trips, starting now. The app reads the same value. Saved right away.",
        FREE_INVITE_ON_CONFIRM_TITLE: "Allow free trips under reinforced verification?",
        FREE_INVITE_ON_CONFIRM_TEXT: "Accounts under reinforced verification will be able to invite at no cost again (except «Reinforced + no free trips»). Saved right away.",
        BACK: "Back to Fraud",
        LAST_CHANGE: "Last change: {{by}} · {{when}}",
        SOMEONE: "Automatic",
        SAVE_CARD: "Save",
        NEVER_CHANGED: "Last change: never changed from the backoffice yet (default values).",
        REVIEW_DAYS: "Remind to review the score every (days)",
        REVIEW_DAYS_HINT: "After these days without saving the score, Fraud shows a red warning.",
        SAVED: 'Saved',
        FIX_FIELDS: 'Check the highlighted fields to be able to save',
        SAVING: 'Saving…',
        SAVE: 'Save rules',
      },
      APP_ANNOUNCEMENT: {
        GO_VARIABLES: "View variables",
        NOTE_TITLE: "Each person sees the announcement once",
        NOTE_TEXT: "The app shows the announcement until the button is tapped and remembers its identifier. <b>Save changes</b> keeps the identifier (to fix typos): people who already accepted it will not see it again. <b>Publish as a new announcement</b> creates another identifier and everyone sees it again.",
        LOADING: "Loading the announcement…",
        LOAD_ERROR: "The announcement could not be loaded.",
        RETRY: "Retry",
        VISIBILITY_TITLE: "Visibility",
        VISIBILITY_SUB: "Switch for the APP_ANNOUNCEMENT_ENABLED variable. It is saved immediately.",
        SHOW: "Show announcement",
        CURRENT_ID: "Published announcement:",
        NO_ID: "No announcement has been published yet.",
        STATE_ON: "Visible in the app",
        STATE_OFF: "Hidden",
        ENABLE: "Turn on",
        DISABLE: "Turn off",
        CONTENT_TITLE: "Texts",
        CONTENT_SUB: "Spanish is required. In Catalan and English, if there is no title, the app shows the Spanish version.",
        NO_ANNOUNCEMENT: "There is no saved announcement yet.",
        INVALID_STORED: "The saved APP_ANNOUNCEMENT value is not a valid announcement. Saving will replace it with these texts.",
        LANGUAGE: "Language",
        LANG_ES: "Spanish",
        LANG_CA: "Catalan",
        LANG_EN: "English",
        LANG_HAS_ERRORS: "There are fields to fix in this language",
        FALLBACK_HINT: "No text in this language: the app will show the Spanish version.",
        FIELD_TITLE: "Title",
        TITLE_REQUIRED: "Write a title or a text in Spanish.",
        FIELD_BODY: "Text",
        BODY_PLACEHOLDER: "Write the announcement text…",
        BODY_HELP: "Headings, bold, italic, underline, lists and <b>accent colour</b> (bold in purple). Images, links and pasted styles are removed.",
        BODY_HELP_HTML: "Body HTML. Only <code>p</code>, <code>br</code>, <code>strong</code>, <code>em</code>, <code>u</code>, <code>h2</code>, <code>h3</code>, <code>ul</code>, <code>ol</code>, <code>li</code> and <code>&lt;span class=\"ql-color-accent\"&gt;</code> are kept; any other tags and attributes are removed on save.",
        VIEW_HTML: "View HTML",
        VIEW_EDITOR: "View editor",
        ACCENT_COLOR: "Accent colour",
        FIELD_CTA: "Button text",
        PREVIEW_TITLE: "Preview",
        PREVIEW_SUB: "How it will look in the app.",
        PREVIEW_THEME: "Preview theme",
        PREVIEW_LIGHT: "Light",
        PREVIEW_DARK: "Dark",
        COPY_HINT: "What you write in Spanish is copied to Catalan and English automatically. For a version of its own in another language, open its tab and change it.",
        LINKED_HINT: "Copied from Spanish: it updates on its own. If you change it here, it becomes this language's own version.",
        OWN_HINT: "This language's own version: no longer copied from Spanish.",
        RELINK: "Copy from Spanish again",
        UNSAVED: "There are unsaved changes",
        NOT_PUBLISHED: "Announcement not published",
        FIX_FIELDS: "Check the highlighted fields to be able to save",
        PUBLISH_NEW: "Publish as a new announcement",
        SAVE_HINT: "Keeps the current announcement: people who already accepted it will not see it again.",
        SAVE: "Save changes",
        SAVING: "Saving…",
        SAVED: "Announcement saved",
        ERROR_SAVE: "The announcement could not be saved",
        ERROR_TOGGLE: "The announcement visibility could not be changed",
        PUBLISH_NEW_TITLE: "Publish as a new announcement",
        PUBLISH_NEW_TEXT_ON: "A new announcement is created and every user will see it again when they open the app, including those who accepted the previous one.",
        PUBLISH_NEW_TEXT_OFF: "A new announcement is created. When you turn it on, every user will see it, including those who accepted the previous one.",
        PUBLISH_NEW_CONFIRM: "Publish",
        PUBLISHED_DONE: "Published",
        CANCEL: "Cancel",
        ACCEPT: "OK",
        ENABLE_NEEDS_SAVE: "Save the announcement before turning it on",
        ENABLE_TITLE: "Show the announcement",
        ENABLE_TEXT: "Users who have not accepted it yet will see it when they open the app.",
        ENABLE_TEXT_DIRTY: "Users who have not accepted it yet will see it when they open the app, with the saved texts: unsaved changes are not shown.",
        DISABLE_TITLE: "Hide the announcement",
        DISABLE_TEXT: "Nobody will see it when opening the app until you turn it on again.",
        ENABLED_DONE: "Turned on",
        DISABLED_DONE: "Turned off",
      },
      CONFIG_VARIABLES: {
        MODAL_CREATE: 'Add configuration variable',
        MODAL_EDIT: 'Edit configuration variable',
        SECTION_VARIABLE: 'Variable',
        FIELD_NAME: 'Variable name',
        NAME_PLACEHOLDER: 'e.g. app_version',
        NAME_REQUIRED: 'The name is required (at least 3 characters; only letters, numbers, hyphens and underscores)',
        FIELD_VALUE: 'Value',
        VALUE_PLACEHOLDER: 'e.g. 1.0.0',
        VALUE_REQUIRED: 'The value is required',
        FIELD_DESCRIPTION: 'Description',
        DESCRIPTION_PLACEHOLDER: 'Variable description',
        FREE_TRIPS: {
          TITLE: 'Companies with zero cost',
          HINT: 'Employees linked to the company ride as passengers at zero cost on any trip on those days (dates included).',
          SELECT_COMPANY: 'Select a company',
          COMPANY: 'Company',
          FROM: 'From',
          TO: 'To',
          ADD: 'Add company',
          REMOVE: 'Remove',
          EMPTY: 'No company with zero cost.',
          INCOMPLETE: 'Pick the company and both dates (the end cannot be before the start), otherwise it does not apply.',
          INVALID: 'The saved value cannot be read; saving will replace it with this one.',
        },
        SECTION_CLASSIFICATION: 'Classification',
        FIELD_CATEGORY: 'Category',
        SELECT_CATEGORY: 'Select category',
        CATEGORY_REQUIRED: 'The category is required',
        FIELD_STATUS: 'Status',
        ACTIVE: 'Active',
        CREATE: 'Create',
        SAVE: 'Save',
        SAVING: 'Saving…',
        ACTIVATE_LOGS: 'Enable logs',
        ADD_TOOLTIP: 'Add new variable',
        ADD: 'Add variable',
        PANEL_TITLE: 'Configuration variables',
        PANEL_SUB: 'Each row is a variable with its value, its category and whether it is active. Click the pencil to edit it.',
        LOADING: 'Loading…',
        COL_NAME: 'Name',
        COL_VALUE: 'Value',
        COL_DESCRIPTION: 'Description',
        COL_CATEGORY: 'Category',
        COL_ACTIVE: 'Active',
        COL_ACTIONS: 'Actions',
        LOAD_ERROR: 'The configuration variables could not be loaded.',
        RELOAD_ERROR: 'The configuration variables could not be reloaded.',
        RETRY: 'Retry',
        YES: 'Yes',
        NO: 'No',
        EDIT: 'Edit',
        DELETE: 'Delete',
        SHOW: 'Show',
        PER_PAGE: 'Records per page',
        RECORDS: 'records',
        TTL_LABEL: 'Time to live (seconds)',
        TTL_PLACEHOLDER: 'e.g. 3600',
        TTL_HINT: 'Enter how many seconds the logs will stay active',
        ACTIVATE: 'Enable',
        ACTIVATING: 'Enabling…',
        DT_SEARCH: 'Search:',
        DT_LENGTH_MENU: 'Show _MENU_ records',
        DT_ZERO_RECORDS: 'No records found',
        DT_INFO_EMPTY: 'Showing 0 of 0 variables',
        DT_INFO_FILTERED: '(filtered from _MAX_ total variables)',
        DT_FIRST: 'First',
        DT_LAST: 'Last',
        DT_NEXT: 'Next',
        DT_PREVIOUS: 'Previous',
        DT_INFO: 'Showing {{shown}} of {{total}} variables',
        DELETE_TITLE: 'Delete configuration variable',
        DELETE_TEXT: 'The variable “{{name}}” will be deleted.',
        DELETE_CONFIRM: 'Yes, delete',
        DELETING: 'Deleting…',
        DELETED: 'Deleted',
        DELETE_ERROR: 'The variable could not be deleted',
        CREATED: 'Configuration variable created successfully',
        CREATE_ERROR: 'The variable could not be created',
        UPDATED: 'Configuration variable updated successfully',
        UPDATE_ERROR: 'The variable could not be updated',
        GENERIC_ERROR: 'An error occurred. Please try again.',
        TTL_INVALID_TITLE: 'Invalid value',
        TTL_INVALID_TEXT: 'Enter a value greater than 0',
        LOGS_ACTIVATED: 'Logs enabled for {{seconds}} seconds',
        LOGS_ERROR: 'The logs could not be enabled',
      },
      COUPONS: {
        SHARED: {
          CLEAR: 'Clear',
          REMOVE_FILTER: 'Remove {{label}}',
          SAVING: 'Saving…',
        },
        GIFT_CARDS: {
          ADD: 'Add coupon',
          SEARCH_PLACEHOLDER: 'Search coupon',
          SEARCH_LABEL: 'Search coupon',
          ITEMS: 'coupons',
          PROVIDER: 'Provider',
          PROVIDER_REQUIRED: 'The provider is required',
          NAME: 'Coupon name',
          NAME_REQUIRED: 'The name is required',
          IMAGE: 'Coupon image',
          IMAGE_REQUIRED: 'The image is required when creating a coupon',
          PREVIEW: 'Preview',
          DESCRIPTION: 'Description',
          DESCRIPTION_REQUIRED: 'The description is required',
          EXPIRATION: 'Expiry',
          EXPIRATION_REQUIRED: 'The expiry date is required',
          CREDIT_VALUE: 'Value in credits',
          CREDIT_VALUE_REQUIRED: 'The value in credits is required',
          EURO_VALUE: 'Value in €',
          EURO_VALUE_REQUIRED: 'The value in euros is required',
          STATUS: 'Status',
          STATUS_REQUIRED: 'The status is required',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          COL_COUPON: 'Coupon',
          COL_PROVIDER: 'Provider',
          COL_EXPIRATION: 'Expiry',
          COL_CREDIT_VALUE: 'Value in credits',
          COL_EURO_VALUE: 'Value in €',
          COL_STATUS: 'Status',
          COL_INSTRUCTIONS: 'Instructions link',
          OPEN: 'Open',
          EDIT_TITLE: 'Edit coupon',
          CREATE_TITLE: 'Create coupon',
          UPDATED: 'Gift card updated successfully',
          CREATED: 'Gift card created successfully',
          SAVE_ERROR: 'The gift card could not be saved',
        },
        CODES: {
          ADD: 'Add code',
          SEARCH_PLACEHOLDER: 'Search code',
          SEARCH_LABEL: 'Search code',
          ITEMS: 'codes',
          COUPON: 'Coupon',
          COUPON_REQUIRED: 'The coupon is required',
          CODE: 'Code',
          CODE_REQUIRED: 'The code is required',
          INSTRUCTIONS: 'Instructions',
          URL_INVALID: 'Enter a valid URL',
          ASSIGN_TO: 'Assign to',
          IMPORT_TITLE: 'Import CSV by coupon',
          IMPORT_SELECT_COUPON: 'Select a coupon',
          IMPORT_SELECT_FILE: 'Select a file',
          IMPORT_FILE_REQUIRED: 'The file is required',
          IMPORT: 'Import',
          STATUS_ALL: 'All',
          STATUS_AVAILABLE: 'Available',
          STATUS_EXPIRED: 'Expired',
          STATUS_USED: 'Used',
          COL_CODE: 'Code',
          COL_INSTRUCTIONS: 'Instructions',
          COL_PROVIDER: 'Provider',
          COL_COUPON: 'Coupon',
          COL_EXPIRATION: 'Expiry',
          COL_ASSIGNMENT: 'Assignment date',
          COL_USER: 'User',
          EDIT_TITLE: 'Edit code',
          VIEW_TITLE: 'Code details',
          CREATE_TITLE: 'Create code',
          UPDATED: 'Code updated successfully',
          CREATED: 'Code created successfully',
          SAVE_ERROR: 'The code could not be saved',
          IMPORTED: 'Codes imported successfully',
          IMPORT_ERROR: 'The codes could not be imported',
          IMPORT_ERROR_TEXT: 'An error occurred while importing the codes',
        },
        PROVIDERS: {
          ADD: 'Add provider',
          SEARCH_PLACEHOLDER: 'Search',
          SEARCH_LABEL: 'Search provider',
          ITEMS: 'providers',
          LOGO: 'Logo',
          NAME: 'Provider',
          NAME_REQUIRED: 'The name is required',
          NAME_MIN: 'The name must have at least 4 letters',
          CONTACT: 'Contact',
          EMAIL_REQUIRED: 'The email is required',
          EMAIL_INVALID: 'The email is not valid',
          LOADING: 'Loading...',
          COL_PROVIDER: 'Provider',
          COL_TOTAL_COUPONS: 'Total coupons',
          COL_CONTACT: 'Contact',
          EDIT_TITLE: 'Edit provider',
          CREATE_TITLE: 'Create provider',
          UPDATED: 'Provider updated successfully',
          CREATED: 'Provider created successfully',
          SAVE_ERROR: 'The provider could not be saved',
        },
        PROMO_CODES: {
          ITEMS: 'promo codes',
          KIND_APP: 'In-app promotion',
          KIND_CAMPAIGN: 'Campaign code',
          LOADING_DETAIL: 'Loading the promo code…',
          LOAD_DETAIL_ERROR: 'The promo code could not be loaded. Close the form and try again; nothing has been saved.',
          GUIDE_TITLE: 'What kind of promotion are you setting up?',
          GUIDE_SUB: 'Guide: in-app promotion or campaign code, with an example of each.',
          GUIDE_SHOW: 'Show guide',
          GUIDE_HIDE: 'Hide guide',
          GUIDE_APP_TEXT: 'The user sees it in “Promotions” and activates it with the “Apply” button, without typing any code.',
          GUIDE_APP_EXAMPLE: 'Example: €5 off the first Taxi/VTC trip',
          GUIDE_APP_1: 'Type <b>Fixed amount</b>, value <b>5</b>',
          GUIDE_APP_2: 'Applies to <b>Taxi / VTC only</b> (no Carpooling)',
          GUIDE_APP_3: 'No. of trips <b>1</b>: one discounted trip',
          GUIDE_APP_4: 'Max. completed trips <b>0</b>: only users who haven\'t taken any Taxi/VTC trip yet',
          GUIDE_APP_5: 'Trips that count: <b>Only the types it applies to</b> (carpooling trips don\'t count)',
          GUIDE_APP_6: '<b>Visible in the app</b> enabled · zone if needed',
          GUIDE_APP_7: 'Texts in es/en/ca (the Spanish title is required)',
          GUIDE_APP_HINT: 'When you choose <b>Visible in the app</b>, empty fields are filled in with this setup. You can change them.',
          GUIDE_CAMPAIGN_TEXT: 'It only works if the user types the code in “I have a promo code”. It doesn\'t appear on the “Apply” card.',
          GUIDE_CAMPAIGN_EXAMPLE: 'Example: VERANO10, 10% off 3 trips',
          GUIDE_CAMPAIGN_1: 'Choose <b>Code only</b>',
          GUIDE_CAMPAIGN_2: 'Code: the one you hand out (<b>VERANO10</b>)',
          GUIDE_CAMPAIGN_3: 'Campaign dates',
          GUIDE_CAMPAIGN_4: 'Type and value (<b>Percentage 10</b>) and max. discount/use',
          GUIDE_CAMPAIGN_5: 'No. of trips (<b>3</b>): required for percentage',
          GUIDE_CAMPAIGN_6: 'Applies to <b>Carpooling</b> (campaign codes can\'t be for Taxi/VTC)',
          GUIDE_CAMPAIGN_HINT: 'The other conditions and the texts are for promotions visible in the app. In the app it is shown with the code as its title.',
          GUIDE_NOTE: 'The difference is in <b>“How does the user get it?”</b>: visible in the app = activated with a button; code only = it has to be typed.',
          HOW_TITLE: 'How does the user get it?',
          SECTIONS: 'Promo code sections',
          TAB_DISCOUNT: 'Discount',
          CODE: 'Code',
          CODE_HINT_APP: 'The app doesn\'t show it, but it still works if someone types it in “I have a promo code” (with the same rules). The visible title goes in “In the app”.',
          CODE_HINT_CAMPAIGN: 'It\'s what the user types to redeem it.',
          START_DATE: 'Start date',
          START_DATE_REQUIRED: 'The start date is required',
          END_DATE: 'End date',
          END_DATE_HINT: 'Empty = never expires',
          DATES_HINT: 'It starts at 00:00 on the start date and expires at 00:00 on the end date: the last day with a discount is the day before the end date.',
          TYPE: 'Type',
          TYPE_REQUIRED: 'The type is required',
          VALUE: 'Value',
          VALUE_REQUIRED: 'The value is required',
          VALUE_MIN: 'The minimum allowed value is 0',
          VALUE_MAX: 'The maximum allowed value is {{max}}',
          FREE_TRIPS: 'No. of free trips',
          FREE_TRIPS_REQUIRED: 'The number of trips is required',
          MAX_PER_USE: 'Max. discount/use',
          MAX_PER_USE_REQUIRED: 'The max. discount/use is required',
          MAX_PER_USE_MIN: 'It can\'t be negative',
          MAX_PER_USE_MAX: 'It can\'t exceed the coupon value ({{limit}} €)',
          MAX_PER_USE_HINT: 'Maximum discounted on each trip. 0 = no limit.',
          NUM_ROUTES: 'No. of trips',
          NUM_ROUTES_TIP: 'How many discounted trips each user gets. Required for percentage: without it the coupon is redeemed but never discounts anything.',
          NUM_ROUTES_PLACEHOLDER: 'e.g. 3',
          NO_LIMIT: 'No limit',
          NUM_ROUTES_REQUIRED: 'For percentage you must say on how many trips it applies',
          NUM_ROUTES_MIN: 'Minimum 1 trip',
          NUM_ROUTES_MAX_ONE: 'With “Max. completed trips” = {{completed}} it can only be used on {{count}} trip',
          NUM_ROUTES_MAX: 'With “Max. completed trips” = {{completed}} it can only be used on {{count}} trips',
          NUM_ROUTES_HINT: 'It\'s the number the user sees in “You have N discounted trips left”.',
          NUM_ROUTES_FIRST_TRIP: 'First trip: a single discounted trip (the rule is checked on every trip).',
          APPLIES_TO: 'Applies to',
          CAMPAIGN_ONLY_CARPOOLING: 'Campaign codes can only be for Carpooling.',
          REMOVED_VTC: 'This code had Taxi / VTC, which is no longer allowed in campaign codes. Check “Applies to” before saving.',
          APPLIES_TO_REQUIRED: 'Select at least one trip type',
          APP_PROMO_NEEDS_VTC: 'A promotion visible in the app must include Taxi / VTC: the app only shows them on on-demand trips.',
          TAB_CONDITIONS: 'Conditions',
          FIRST_TRIP_RULES_ONLY_VTC: '“Max. completed trips” and “Trips that count” (first-trip rules) are only available when “Applies to” is Taxi / VTC only.',
          MAX_COMPLETED: 'Max. completed trips',
          MAX_COMPLETED_TIP: 'Only users with at most this number of trips taken can use it. 0 = first trip. Empty = anyone.',
          NO_RESTRICTION: 'No restriction',
          MAX_COMPLETED_HINT: 'Requirement to use it: the maximum number of trips the user may have taken. E.g. 0 = only those who haven\'t taken any trip yet. This number doesn\'t appear in the app.',
          TRIPS_COUNTED: 'Trips that count',
          TRIPS_COUNTED_TIP: 'Which trips count towards “Max. completed trips”. With “Only the types it applies to”, carpooling doesn\'t count for a Taxi/VTC promo.',
          TRIPS_COUNTED_ALL: 'All trips',
          TRIPS_COUNTED_APPLICABLE: 'Only the types it applies to',
          ZONE: 'Zone',
          ZONE_TIP: 'It only discounts if the trip origin is inside. In the app it is shown as “Valid in”.',
          ANYWHERE: 'Anywhere',
          LEGACY_ZONE: 'This zone is no longer a promotion zone. It is kept if you don\'t change it; if you choose another one, you won\'t be able to go back to it.',
          ZONE_NO_PERMISSION: 'You don\'t have permission to change the zone.',
          ZONE_ONLY_VTC: 'The zone is only available when “Applies to” is Taxi / VTC only.',
          TAB_APP: 'In the app',
          APP_TEXTS_HINT: 'They are shown on the “Apply” card, the detail and “Applied”.',
          TEXTS_LANGUAGE: 'Language of the texts',
          TITLE_LANG: 'Title ({{lang}})',
          TITLE_PLACEHOLDER: '€5 off your first Taxi/VTC trip',
          DETAILS: 'Details',
          APPLIES_TO_TEXT: 'Applies to (text)',
          EMPTY_TEXT_DELETES: 'Leaving a text empty deletes it.',
          STATUS_ALL: 'All',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          TYPE_ABSOLUTE: 'Fixed amount',
          TYPE_PERCENTAGE: 'Percentage',
          TYPE_BALANCE: 'Balance',
          TYPE_FREE_TRIPS: 'Free trips',
          SELECT_ALL: 'Select all',
          TRIP_VTC_ALL: 'Taxi / VTC (all providers)',
          TRIP_VTC: 'Taxi / VTC',
          TRIP_CARPOOLING: 'Carpooling',
          CODE_ONLY: 'Code only',
          CODE_ONLY_HINT: 'They type it in “I have a promo code”',
          SHOW_IN_APP: 'Visible in the app',
          SHOW_IN_APP_HINT: 'They activate it with “Apply”, without typing the code',
          COL_CODE: 'Code',
          COL_START_DATE: 'Start date',
          COL_END_DATE: 'End date',
          COL_VALUE: 'Value',
          COL_FREE_TRIPS: 'Number of free trips',
          COL_MAX_PER_USE: 'Max. discount/use',
          COL_TYPE: 'Coupon type',
          COL_STATUS: 'Status',
          DELETE_ERROR_TITLE: 'It can\'t be deleted',
          DELETE_IN_USE: 'Users have already applied or used this code, so it can\'t be deleted. To stop it being used, edit it and set today as the end date.',
          DELETE_ERROR: 'The promo code could not be deleted. Please try again.',
          EDIT_TITLE: 'Edit promo code',
          CREATE_TITLE: 'Create promo code',
          TITLE_ES_REQUIRED: 'To show it in the app, the Spanish title is required',
          TITLE_EQUALS_CODE: 'The title can\'t be the same as the code: the app wouldn\'t show the promotion',
          UPDATED: 'Promo code updated successfully',
          CREATED: 'Promo code created successfully',
          SAVE_ERROR: 'The promo code could not be saved',
          VALUE_HELP_ABSOLUTE: 'Total coupon amount. It is spent trip by trip until used up.',
          VALUE_HELP_BALANCE: 'Balance loaded to the user.',
          VALUE_HELP_PERCENTAGE: 'Percentage discounted from each trip.',
        },
      },
      ADMIN_HOME_MAP: {
        ROUTINES_24H: 'Routines in the last 24 h',
        LOAD_ERROR: 'The recent trips could not be loaded',
        ZOOM_IN: 'Zoom in',
        ZOOM_OUT: 'Zoom out',
      },
      ADMIN_FUNNEL: {
        DATE_RANGE_ERROR: 'The start date cannot be after the end date',
        LOAD_ERROR: 'Error loading the data',
        PDF_CATEGORY: 'Category',
        PDF_VALUE: 'Value',
      },
    },
    COMPANY: {
      PARKINGS: {
        COMMON: {
          BACK: 'Back',
          BACK_TO_LIST: 'Back to the list',
          RETRY: 'Retry',
          LOADING: 'Loading...',
          BREADCRUMB: 'Breadcrumb',
          CANCEL: 'Cancel',
          SAVE: 'Save',
          SAVE_CHANGES: 'Save changes',
          SAVING: 'Saving…',
          ACCEPT: 'OK',
          ACTIVE: 'Active',
          ACTIVE_F: 'Active',
          INACTIVE_F: 'Inactive',
          YES: 'Yes',
          NO: 'No',
          ALL_F: 'All',
          ALL_M: 'All',
          REMOVE_FILTER: 'Remove {{label}}',
          OPEN_CALENDAR: 'Open calendar',
          SELECT_DATE_TIME: 'Select date and time',
          PREFERENCES: 'Preferences',
          IMPORT_UNAVAILABLE: 'Import not available',
          IMPORT_UNAVAILABLE_TEXT: 'Bulk CSV import is not available yet. No data has been saved.',
          NOT_ASSIGNED: 'Not assigned',
          TOTAL: 'Total',
          TOTAL_COLON: 'Total:',
          VIEW_DATA: 'View the data',
        },
        FIELDS: {
          SPACE: 'Space',
          TYPE: 'Type',
          LOCATION: 'Location',
          OFFICE: 'Office',
          USER: 'User',
          ROLE: 'Role',
          PLATE: 'Licence plate',
          SHIFT: 'Shift',
          SHIFT_N: 'Shift {{n}}',
          DAYS: 'Days',
          RESERVED_DAYS: 'Reserved days',
          ASSIGNED_DAYS: 'Assigned days',
          SHARING: 'Sharing',
          CREDIT: 'Credit',
          EXPIRY: 'Expiry',
          START_DATE: 'Start date',
          END_DATE: 'End date',
          STATUS: 'Status',
          REASON: 'Reason',
          RESERVATION: 'Reservation',
          DAY: 'Day',
        },
        ERRORS: {
          OFFICE_REQUIRED: 'The office is required',
          USER_REQUIRED: 'The user is required',
          PLATE_REQUIRED: 'The licence plate is required',
          SHIFT_REQUIRED: 'The shift is required',
          DAYS_REQUIRED: 'The days are required',
          SPACE_NAME_REQUIRED: 'The space name is required',
          TYPE_REQUIRED: 'The space type is required',
          LOCATION_REQUIRED: 'The location is required',
          REASON_REQUIRED: 'The reason is required',
          SPACE_REQUIRED: 'The parking space is required',
          COUPON_REQUIRED: 'The coupon value is required',
        },
        DAYS: {
          MON: 'Monday',
          TUE: 'Tuesday',
          WED: 'Wednesday',
          THU: 'Thursday',
          FRI: 'Friday',
          SAT: 'Saturday',
          SUN: 'Sunday',
        },
        SHIFT_STATUS: {
          BUSY: 'Occupied',
          FREE: 'Free',
        },
        ROLES: {
          DRIVER: 'Driver',
          PASSENGER: 'Passenger',
        },
        SPACE_TYPES: {
          GENERAL: 'General',
          ELECTRIC: 'Electric car',
          MOTORBIKE: 'Motorbike',
          TRUCK: 'Truck',
          VIP: 'VIP',
          ZONE: 'Zone {{n}}',
        },
        SPACES: {
          CREATE: 'Create parking space',
          SEARCH: 'Search parking space',
          ITEMS: 'parking spaces',
          EDIT_TITLE: 'Edit parking space',
          CREATE_TITLE: 'Create parking space',
          CREATE_SUBTITLE: 'Add a parking space to an office.',
          SPACE_LABEL: 'Space {{name}}',
          DETAIL: 'Detail',
          SAVED_EDIT: 'Parking space updated successfully',
          SAVED_CREATE: 'Parking space created successfully',
          SAVE_ERROR: 'The parking space could not be saved',
          LOADING: 'Loading the parking space',
          DATA_TITLE: 'Space details',
          DATA_SUB: 'Office it belongs to, name, type and where it is.',
          PREFS_SUB: 'Only active spaces can be reserved.',
          CREATE_BTN: 'Create space',
          NOT_FOUND: 'The parking space was not found.',
          LOAD_ERROR: 'The parking space could not be loaded.',
          RESERVATIONS: 'Reservations',
          RESERVATIONS_SUB: 'Who has this space reserved, on which shift, which days and between which dates.',
          RESERVATIONS_ERROR: 'The reservations could not be loaded.',
          NO_RESERVATIONS: 'This space has no reservations.',
          RESERVATIONS_FOOT: 'Showing {{shown}} of {{total}} reservations',
        },
        RESERVATIONS: {
          CREATE: 'Reserve parking space',
          SEARCH: 'Search parking space',
          ITEMS: 'parking reservations',
          EDIT_TITLE: 'Edit reservation',
          CREATE_TITLE: 'Create reservation',
          FORM_SUBTITLE: 'Who reserves, on which dates and which space they take.',
          SAVED_EDIT: 'Reservation updated successfully',
          SAVED_CREATE: 'Reservation created successfully',
          SAVE_ERROR: 'The reservation could not be saved',
          MISSING_FIELDS: 'Required fields are missing',
          MISSING_FIELDS_TEXT: 'Fill in all the required fields before continuing.',
          WHO_TITLE: 'Who reserves',
          WHO_SUB: 'User type, office and the person\'s details.',
          USER_TYPE: 'User type',
          EMPLOYEE: 'Employee',
          EMPLOYEE_HINT: 'Someone from an office: you choose the office and the employee; their licence plate comes from their profile.',
          GUEST: 'Guest user',
          GUEST_SHORT: 'Guest',
          GUEST_HINT: 'External person: you type their name and licence plate.',
          DATES_TITLE: 'Dates and reason',
          DATES_SUB: 'From when until when the space is reserved, and why.',
          REASON: 'Reason for the reservation',
          REASON_PLACEHOLDER: 'Write the reason here...',
          SPACE_TITLE: 'Space',
          SPACE_SUB: 'Automatic assignment or manual choice of the space.',
          SPACE_SELECTION: 'Space selection',
          AUTOMATIC: 'Automatic',
          MANUAL: 'Manual',
          LOADING_SPACES: 'Loading spaces…',
          LOAD_SPACES: 'Load available spaces',
          SPACES_COUNT: 'Spaces: {{n}}',
          SELECT_SPACE: 'Select a space',
          PICK_SPACE_TO_SAVE: 'Choose a space to be able to save',
          DETAIL_TITLE: 'Reservation details',
          DETAIL_SUB: 'Who has the space, which one it is and on which dates.',
          NOT_FOUND: 'The reservation was not found.',
          LOAD_ERROR: 'The reservation could not be loaded.',
          OCCUPANCY_INDEX: 'Occupancy rate',
          PERIOD: 'Period',
          START: 'Start',
          END: 'End',
          REASON_TITLE: 'Reason',
        },
        CREDITS: {
          CREATE: 'Assign parking credit coupon',
          SEARCH: 'Search user',
          ITEMS: 'parking credits',
          EDIT_TITLE: 'Edit parking credit',
          CREATE_TITLE: 'Public parking - Assign credit',
          CREATE_SUBTITLE: 'Choose the person, the office, the days and the credit coupon.',
          SAVED_EDIT: 'Parking credit updated successfully',
          SAVED_CREATE: 'Parking credit assigned successfully',
          SAVE_ERROR: 'The parking credit could not be saved',
          PERSON_TITLE: 'Person',
          PERSON_SUB: 'Who the credit is assigned to, with which role and which vehicle.',
          PARKING_TITLE: 'Parking',
          PARKING_SUB: 'Office, shift and days on which they can use the car park.',
          CREDIT_TITLE: 'Credit',
          CREDIT_SUB: 'Coupon value and the period in which it is valid.',
          COUPON_VALUE: 'Coupon value',
          CREDITS_WORD: 'credits',
          PREFS_SUB: 'Whether the credit is active.',
          NOT_FOUND: 'The parking credit was not found.',
          LOAD_ERROR: 'The parking credit could not be loaded.',
          GENERAL_INFO: 'General information',
          OCCUPANCY_TITLE: 'Car park occupancy',
          OCCUPANCY_SUB: 'Days and shift on which they use the car park.',
          OCCUPANCY: 'Occupancy',
          ENTRY: 'Entry',
          EXIT: 'Exit',
          USAGE_TITLE: 'Credit usage/attendance',
          PAID_PARKING: 'Paid parking',
          USED: 'Used',
          NOT_USED: 'Not used',
          UNKNOWN: 'Unknown',
          USED_COLON: 'Used:',
          NOT_USED_COLON: 'Not used:',
          NO_USAGE: 'There is no usage data.',
          CREDITS_COL: 'Credits',
          USAGE_INSIGHT: '{{pct}}% of the credits have been used over these {{days}} days.',
          USAGE_LIST_TITLE: 'Parking credit usage',
          USAGE_LIST_SUB: 'Each day with its credit and whether it was used.',
          USAGE_ITEMS: 'days',
        },
      },
      INCENTIVE_STEPS: {
        OBJECTIVES: {
          PROFILE: 'Complete profile',
          ROUTINE: 'Create first routine',
          REQUEST: 'Send request',
          MATCH: 'Make a match',
          TRAVEL: 'Take first trip',
        },
        CREDIT_TYPES: {
          CREDITS: 'WAIIS credits',
          TRAVEL: 'Free trips',
          DISCOUNT: 'Trip discounts',
          BONUS: 'Accruable monthly bonus',
          EMPLOYEE: 'Bonus for referring colleagues',
          SHARED: 'Bonus for carpooling with colleagues',
        },
      },
      INCENTIVES_LIST: {
        SEARCH: 'Search',
        CREATE: 'Create incentive',
        EDIT: 'Edit incentive',
        COL_TYPE: 'Type',
        COL_FUNNEL_OBJECTIVE: 'Funnel objective',
        COL_USERS_REACHED: 'Users reached',
        COL_START_END_DATE: 'Start / End date',
        COL_INCENTIVE_TYPE: 'Incentive type',
        COL_CONVERSIONS: 'Conversions',
        COL_STATUS: 'Status',
        BONUS_PERCENTAGE_PER_TRIP: 'Percentage per trip',
        BONUS_FIXED_PER_TRIP: 'Fixed amount per trip',
        BONUS_TOTAL: 'Total bonus',
      },
      INCENTIVES_ADOPTION: {
        ERROR_TITLE: 'The campaign could not be saved',
        WHAT_TITLE: 'What are incentives?',
        WHAT_TEXT: 'Rewards and reminders your company can activate to motivate staff to use WAIIS: from an email notice to welcome credit in the app. Choose the best action for each stage of your employees\' adoption.',
        CAMPAIGN_TITLE: 'Configure the incentive campaign',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        EMPLOYEES: 'employees',
        EMPLOYEE: 'employee',
        WHAT_TO_SEND: 'What do you send to this group?',
        SEND_EMAIL: 'Send email',
        SEND_CREDIT: 'Send credit to the app',
        NO_COST: 'No cost',
        CUSTOM_AMOUNT: 'Custom amount per employee',
        STAGE_COST: 'Cost of this stage',
        PER_EMPLOYEE_X: 'per employee',
        EMAIL_SEND: 'Email send',
        STAGE_DISABLED: 'Stage disabled · not sent',
        TOTAL_CAMPAIGN_COST: 'Estimated total campaign cost',
        SEND_CAMPAIGN: 'Send campaign',
        DAYS: 'days',
        INACTIVITY_THRESHOLD: 'Inactivity threshold',
        INACTIVITY_SAVE_ERROR: 'Could not save the inactivity threshold.',
        SENT_TITLE: 'Campaign sent!',
        SENT_TEXT_COST: '{{count}} incentives queued. {{cost}} € charged to the corporate wallet.',
        SENT_TEXT_FREE: '{{count}} incentives queued. No cost.',
        INSUFFICIENT_BALANCE_TITLE: 'Insufficient balance',
        INSUFFICIENT_BALANCE_TEXT: 'The company does not have enough balance to cover the campaign cost. Top up the wallet before retrying.',
        GO_TO_WALLET: 'Go to wallet',
        SEND_ERROR: 'Could not send the campaign. Check the data and try again.',
        NOT_REGISTERED: 'Not registered',
        NOT_REGISTERED_DESC: 'Employees who do not yet have a linked WAIIS account. Send them an email reminder to sign up.',
        PENDING_DNI: 'Pending DNI verification',
        PENDING_DNI_DESC: 'Employees with an account but pending identity verification. You can send them a reminder email or welcome credit.',
        NO_TRIPS: 'No trips made',
        NO_TRIPS_DESC: 'Registered and verified employees who have not yet made any trip. Motivate them with an email or app credit.',
        SEG_INACTIVE: 'Inactive',
        SEG_INACTIVE_DESC: 'Employees who used WAIIS before but have had no activity for longer than the configured threshold. Re-engage them with a reminder or incentive.',
        PAGE_NAME: 'Incentives',
        ALL_OFFICES: 'All offices',
        HISTORY_TITLE: 'Campaign history',
        HISTORY_EMPTY: 'No campaigns sent yet.',
        HISTORY_STATUS_SENT: 'Sent',
        HISTORY_STATUS_IN_PROGRESS: 'In progress',
        HISTORY_STATUS_COMPLETED: 'Completed',
        HISTORY_STATUS_CANCELLED: 'Cancelled',
        SEND_CONFIRM_TITLE: 'Are you sure you want to send the campaign?',
        SEND_CONFIRM_TEXT: '{{segments}} campaign(s) will be launched for {{recipients}} employees, committing {{cost}} € from the wallet.',
        SEND_CONFIRM_OK: 'Send',
        SENT_SEGMENT_OK: '{{count}} employees · {{amount}} € committed',
        EMPTY_SEGMENT_ERROR: 'There is nobody to send to: the segment is empty or its employees are already in another active campaign.',
        FEATURE_LOCKED: 'The company plan does not include incentives.',
        CAMPAIGN_NOT_CANCELLABLE: 'The campaign is already closed and cannot be cancelled.',
        RECIPIENT_NOT_CANCELLABLE: 'This employee is no longer pending and cannot be cancelled.',
        DETAIL_COMMITTED: 'Committed',
        DETAIL_PAID: 'Paid out',
        RECIPIENTS_TITLE: 'Campaign employees',
        GROUP_CAMPAIGNS: 'Campaigns in this group',
        SEND_SCOPE_ALL: 'It will be sent to employees from every office',
        SEND_SCOPE_OFFICE: 'It will only be sent to employees from {{office}}',
        SEGMENT_UNKNOWN: 'Several segments',
        DETAIL_COMPLETED: 'Completed',
        CANCEL_GROUP: 'Cancel group',
        GROUP_NOT_CANCELLABLE: 'This group has no live campaign left to cancel.',
        CANCEL_GROUP_CONFIRM_TITLE: 'Cancel the whole group?',
        CANCEL_GROUP_CONFIRM_TEXT: 'The {{count}} campaigns still live will be cancelled and their committed amount released. Anything already paid is not affected.',
        CANCEL_GROUP_CONFIRM_OK: 'Cancel group',
        CANCEL_GROUP_OK_TITLE: 'Group cancelled',
        CANCEL_GROUP_OK_TEXT: '{{count}} campaigns cancelled · {{amount}} € released.',
        CANCEL_CHILD_CONFIRM_TEXT: 'The "{{segment}}" campaign and its {{count}} pending employees will be cancelled.',
        OFFICE: 'Office',
        SEGMENT_IN_PROGRESS: '{{count}} already in another active campaign',
        RECIPIENTS_EMPTY: 'There are no employees in this campaign yet.',
        RECIPIENT_EMPLOYEE: 'Employee',
        RECIPIENT_PAID_AT: 'Paid on',
        RECIPIENT_STATUS_PENDING: 'Pending',
        RECIPIENT_STATUS_COMPLETED: 'Completed',
        RECIPIENT_STATUS_CANCELLED: 'Cancelled',
        CANCEL_REASON_MANUAL: 'Cancelled manually',
        CANCEL_REASON_CAMPAIGN: 'Campaign cancelled',
        CANCEL_REASON_UNLINKED: 'Employee unlinked',
        CANCEL_CAMPAIGN: 'Cancel campaign',
        CANCEL_RECIPIENT: 'Cancel',
        CANCEL_CONFIRM_BACK: 'Back',
        CANCEL_CAMPAIGN_CONFIRM_TITLE: 'Cancel the whole campaign?',
        CANCEL_CAMPAIGN_CONFIRM_TEXT: 'The {{count}} employees still pending will be cancelled and their committed amount released. Those who already got paid are not affected.',
        CANCEL_CAMPAIGN_CONFIRM_OK: 'Cancel campaign',
        CANCEL_CAMPAIGN_OK_TITLE: 'Campaign cancelled',
        CANCEL_CAMPAIGN_OK_TEXT: '{{amount}} € of committed funds released.',
        CANCEL_RECIPIENT_CONFIRM_TITLE: 'Cancel this employee?',
        CANCEL_RECIPIENT_CONFIRM_TEXT: 'The incentive for {{email}} will be cancelled and its amount released.',
        CANCEL_RECIPIENT_CONFIRM_OK: 'Cancel employee',
        CLOSE: 'Close',
        HISTORY_STATUS_SCHEDULED: 'Scheduled',
        HISTORY_STATUS_FAILED: 'Failed',
        HISTORY_DETAIL_TITLE: 'Campaign detail',
        HISTORY_DATE: 'Created at',
        HISTORY_STATUS: 'Status',
        HISTORY_SENT_AT: 'Sent at',
        HISTORY_SEND_AT: 'Scheduled for',
        HISTORY_RECIPIENTS: 'Recipients',
        HISTORY_COST: 'Total cost',
        HISTORY_FAILURE_REASON: 'Failure reason',
        HISTORY_SCHEDULED_INFO: 'Scheduled campaign — not yet processed.',
        HISTORY_SEGMENT: 'Segment',
        HISTORY_CHANNEL: 'Channel',
        HISTORY_AMOUNT: 'Amount / employee',
      },
      INCENTIVE_FORM: {
        SELECTION: 'Selection',
        PREVIOUS: 'Previous',
        CONTINUE: 'Continue',
        SAVE: 'Save',
        SUCCESS_TITLE: 'Success!',
        UPDATED_SUCCESS: 'Incentive updated successfully',
        CREATED_SUCCESS: 'Incentive created successfully',
        ERROR_TITLE: 'Error',
        EDIT_TITLE: 'Edit incentive',
        CREATE_TITLE: 'Create incentive',
        TABS: {
          OBJECTIVES: 'Objectives',
          TYPES: 'Types',
          ACTIVATION: 'Activation',
          DURATION: 'Duration',
          COMMUNICATION: 'Communication',
          BONUSES: 'Bonuses',
        },
      },
      INCENTIVE_DETAILS: {
        BACK: 'Back',
        TITLE: 'Incentive details',
        TYPE: 'Type',
        OBJECTIVE: 'Objective',
        INCENTIVE_TYPE: 'Incentive type',
        ACTIVATION: 'Activation',
        START_END_DATE: 'Start / End date',
        COMMUNICATION: 'Communication',
        BASIC_INFO: 'Basic information',
        BONUS_TYPE: 'Bonus type',
        AMOUNT: 'Amount',
      },
      SUSTAINABILITY: {
        REPORT_TITLE: 'Sustainability report',
        REPORT_DETAILS: 'Report details',
        REPORT_SUB: 'Real usage data, updated every month.',
        PERIOD: 'Period:',
        CO2_AVOIDED_IN: 'CO₂e avoided in {{period}}',
        CO2_AVOIDED_DESC: 'CO₂e avoided by your employees\' carpooling in {{period}}.',
        ACCUMULATED: 'Year to date {{year}} · {{range}}',
        ACCUMULATED_SUB: 'CO₂e avoided so far this year',
        ACCUMULATED_FOOT: 'Total for the year, regardless of the selected month.',
        IMPACT_EQUIVALENCES: 'Impact equivalences',
        TREES_YEAR: '{{n}} trees/year',
        TREES_DESC: 'Equivalent to what they would absorb in a year.',
        KM: '{{n}} km',
        KM_DESC: 'Solo journeys that have been avoided.',
        OCCUPANTS: '{{n}} occupants',
        OCCUPANTS_DESC: 'Average number of people per shared vehicle.',
        TITLE: 'Sustainability',
        ALL_OFFICES: 'All centers',
        MOCK: 'Mock',
        MOCK_ACTIVE: 'Mock Active',
        SELECT_MONTH_YEAR: 'Select month and year',
        TOTAL_CARBON_FOOTPRINT: 'Total Carbon Footprint',
        COMPANY_WORKERS: 'Company Workers',
        SUM_EMISSIONS_GENERATED: 'Sum of emissions generated',
        SUSTAINABLE_MOBILITY_SAVINGS: 'Sustainable Mobility Savings',
        THIS_MONTH_SAVED: 'This month you saved',
        EQUIVALENT_TREES: '<strong>{{count}} trees</strong> planted',
        EQUIVALENT_FLIGHTS:
          '<strong>{{count}} flights</strong> Madrid-Barcelona avoided',
        EQUIVALENT_LED_HOURS:
          '<strong>{{hours}} hours</strong> of LED bulb lit',
        EQUIVALENT_MOBILE_CHARGES:
          '<strong>{{charges}} full</strong> mobile charges',
        FOOTPRINT_BY_OFFICE: 'Footprint by Office',
        EMISSIONS_BY_WORK_CENTER: 'Emissions by work center',
        FOOTPRINT_BY_DEPARTMENT: 'Footprint by Department',
        EMISSIONS_BY_DEPARTMENT: 'Emissions by department',
        NO_DATA: 'No data available for this period',
        MONTHLY_ECONOMIC_COST: 'Monthly Economic Cost',
        ESTIMATED_TRIPS: 'Estimated trips',
        TRAVEL_ALONE: 'Travel alone',
        CARPOOL: 'Carpool',
        PEOPLE_COUNT: '<strong>{{count}} people</strong>',
        TOTAL_COST: 'Total cost: <strong>{{cost}} €</strong>',
        AVERAGE_COST_MONTH:
          'Average cost: <strong class="text-warning">{{cost}} €/month</strong>',
        CARBON_FOOTPRINT: 'Carbon Footprint',
        MONTHLY_ESTIMATED: 'Monthly estimated',
        TOTAL_EMISSIONS_MONTHLY:
          'Total emissions: <strong>{{emissions}} kg CO₂/month</strong>',
        EMISSIONS_PER_PERSON:
          'Emissions per person: <strong class="text-info">{{emissions}} kg/person</strong>',
        FOOTPRINT_BY_WORKER: 'Footprint by Worker',
        INDIVIDUAL_EMISSIONS_LINKED:
          'Individual emissions linked to trips made',
        SEARCH_BY_WORKER: 'Search by worker',
        WORKER: 'Worker',
        DISTANCE_TRAVELED: 'Distance traveled',
        TRANSPORT_MODE: 'Transport mode used',
        EMISSION_FACTOR: 'Emission factor applied',
        EMISSION_SAVINGS: 'Emission savings',
      },
      TRAVEL: {
        ALL: 'All',
        MOCK: 'Mock',
        MOCK_ACTIVE: 'Mock Active',
        SELECT_MONTH_YEAR: 'Select month and year',
        TRAVELS: 'Travels',
        DISTANCE_DURATION_BY_USER: 'Distance and duration per user',
        ROUTINES_CREATED: 'Routines created',
        TRAVEL_HOURS: 'Trips by hour of the day',
        TRAVEL_DAYS: 'Trips by day of the week',
        KM_WITH_PASSENGER: 'Km driven with ≥1 passenger',
        AVG_PASSENGERS_PER_CAR: 'Average passengers per car',
        USER_ADDRESSES: 'User addresses',
        NO_DATA: 'No data available',
        LOADING: 'Loading...',
        // Statistics descriptions
        DRIVERS: 'Drivers',
        PASSENGERS: 'Passengers',
        // Travel table columns
        DATE: 'Date',
        DRIVER: 'Driver',
        PASSENGER: 'Passenger',
        PRICE: 'Price',
        DESTINATION: 'Destination',
        // Distance and duration table columns
        NAME: 'Name',
        AVERAGE_DISTANCE: 'Average Distance',
        AVERAGE_DURATION: 'Average Duration',
        TRIPS: 'Trips',
        // Routines table columns
        ORIGIN: 'Origin',
        ROUTINES: 'Routines',
        USERS: 'Users',
        // Chart labels
        HOURS: 'Hours',
        DAY: 'Day',
        // DataTables messages
        INFO: 'Showing _START_ to _END_ of _TOTAL_ entries',
        INFO_EMPTY: 'Showing 0 to 0 of 0 entries',
        INFO_FILTERED: '(filtered from _MAX_ total entries)',
        // Days of the week
        MONDAY: 'Monday',
        TUESDAY: 'Tuesday',
        WEDNESDAY: 'Wednesday',
        THURSDAY: 'Thursday',
        FRIDAY: 'Friday',
        SATURDAY: 'Saturday',
        SUNDAY: 'Sunday',
      },
      FUNNEL: {
        ERROR_DATE_RANGE: 'The start date cannot be later than the end date',
        ERROR_LOAD: 'Error loading the data',
        PDF_CATEGORY: 'Category',
        PDF_VALUE: 'Value',
        TITLE: 'Funnel',
        COMPANY_FALLBACK: 'Company',
        MOCK: 'Mock',
        MOCK_ACTIVE: 'Mock (Active)',
        OFFICE: 'Office:',
        ALL_OFFICES: 'All centers',
        START_DATE: 'Start date:',
        END_DATE: 'End date:',
        LOAD: 'Load',
        LOADING: 'Loading...',
        COMPARATIVE: 'Comparative',
        LEGEND_GLOBAL: 'Global',
        LEGEND_COMMERCIAL: 'Commercial',
        LEGEND_COMPANY: 'Company',
        FILTER_GLOBAL: 'Global',
        FILTER_COMMERCIAL: 'Commercial',
        FILTER_COMPANY: 'Company',
        PRESETS: {
          LAST_7_DAYS: 'Last 7 days',
          LAST_30_DAYS: 'Last 30 days',
          LAST_90_DAYS: 'Last 90 days',
          THIS_YEAR: 'This year',
          CUSTOM: 'Custom range',
        },
        STAGES: {
          REGISTERED: 'Registered',
          LINKED: 'Linked',
          WITH_ROUTINE: 'With routine',
          REQUEST_SENT_OR_RECEIVED: 'Request sent or received',
          SHARING: 'Sharing',
          TRIP_COMPLETED: 'Trip completed',
          SHARED_TRIP: 'Shared trip',
          RECURRENT: 'Recurrent',
          TOTAL_USERS: 'Total users',
          TOTAL_USERS_WITH_ROUTINE: 'Total users with routine',
          TOTAL_USERS_ROUTINE_COMPLETED: 'Total users with completed routine',
          TOTAL_USERS_ROUTINE_SHARED_COMPLETED:
            'Total users with completed shared routine',
        },
        STAGE_HINTS: {
          '0': 'Employees registered',
          '1': 'Have created a recurring route',
          '2': 'Have completed at least one trip (alone or shared)',
          '3': 'Have shared at least one trip',
          '4': '3 or more shared trips',
        },
        BASE: 'base 100%',
        VS_PREVIOUS_MONTH: 'vs previous period',
        DROP: 'drop',
        EMPLOYEES: 'employees',
        BIGGEST_LOSS: 'biggest loss',
        COMING_SOON: 'Coming soon',
        NO_DATA: 'No funnel data for the selected period.',
        MANAGE_INCENTIVES: 'Manage incentives',
        SEND_COMMUNICATION: 'Send communication to this group',
        INSIGHT: {
          TITLE: 'The biggest drop-off is between "{{from}}" and "{{to}}" (−{{percentage}}%).',
          DESCRIPTION:
            'This is the exact point to activate incentives: only {{converted}} of the {{base}} employees who reached this stage make it to {{toStage}}. Converting this group is the most cost-effective lever to increase usage adoption.',
        },
      },
      COMMON: {
        GENERATING_PDF: 'Generating PDF, please wait...',
        LOADING: 'Loading...',
        ACCEPT: 'Accept',
        CANCEL: 'Cancel',
        SAVE: 'Save',
        FILTERS: 'Filters',
        CLOSE: 'Close',
        SELECT_DATE: 'Select date',
        APPLY_FILTERS: 'Apply filters',
        CLEAR: 'Clear',
        EXPORT_CSV: 'Export CSV',
        IMPORT_CSV: 'Import CSV',
        ACTIVE: 'Active',
        WAIT: 'Please wait..',
        BASIC_INFO: 'Basic information',
        FISCAL_ADDRESS: 'Fiscal address',
        ADDRESS: 'Address',
        CITY: 'City',
        POSTAL_CODE: 'Postal code',
        OFFICE_NAME: 'Office name',
        OFFICE_NAME_REQUIRED: 'The legal name is required',
        CONTACT_PERSON: 'Contact person',
        CONTACT_PERSON_REQUIRED: 'The contact person is required',
        CONTACT_PHONE: 'Contact phone',
        CONTACT_PHONE_REQUIRED: 'The phone is required',
        CONTACT_EMAIL: 'Contact email',
        CONTACT_EMAIL_REQUIRED: 'The email is required',
        ADDRESS_REQUIRED: 'The address is required',
        CITY_REQUIRED: 'The city is required',
        POSTAL_CODE_REQUIRED: 'The postal code is required',
        USER: 'User',
        USER_REQUIRED: 'User is required',
        LICENSE_PLATE: 'License plate',
        LICENSE_PLATE_REQUIRED: 'The license plate is required',
        OFFICE: 'Office',
        OFFICE_REQUIRED: 'Office is required',
        SHIFT: 'Shift',
        SHIFT_REQUIRED: 'The shift is required',
        RESERVED_DAYS: 'Reserved days',
        RESERVED_DAYS_REQUIRED: 'The days are required',
        START_DATE: 'Start date',
        END_DATE: 'End date',
        DATETIME_PLACEHOLDER: 'Select date and time',
        CORRECT: 'Success',
        ERROR_BANG: 'Error!',
      },
      PARKING_REPORT: {
        WEEK_N: 'Week {{n}}',
        TOTAL_PARKING_SPACES: 'Total parking spaces',
        AVAILABLE_SPACES: 'Available spaces',
        OCCUPIED_SPACES: 'Occupied spaces',
        SELECT_MONTH_YEAR: 'Select month and year',
        OWN_COMPANY_PARKING: 'Company-owned parking',
        OCCUPATION: 'Occupation',
        DAY: 'Day',
        WEEK: 'Week',
        MONTH: 'Month',
        PAID_PARKING: 'Paid parking',
        CREDIT_USE_AND_COST: 'Credit use and cost',
        PARKING_SPACES_USAGE: 'Parking spaces usage',
        TOTAL_PARKING_SPACES_LABEL: 'Total parking spaces',
        PARKING_SPACES_ALLOCATION: 'Parking spaces allocation',
        TOTAL_USERS: 'Total users',
        MORNING_SHIFT: 'Morning shift',
        AFTERNOON_SHIFT: 'Afternoon shift',
        PARKING_CREDIT: 'Parking Credit',
        SHARED: 'Shared',
        INDIVIDUAL: 'Individual',
        USERS_WITH_ALLOCATED_SPACES: 'Users with allocated spaces',
        USERS_WITHOUT_ALLOCATED_SPACES: 'Users without allocated spaces',
      },
      USAGE_REPORT: {
        USAGE: 'Usage',
        ALL_CENTERS: 'All centers',
        LAST_7_DAYS: 'Last 7 days',
        LAST_30_DAYS: 'Last 30 days',
        LAST_90_DAYS: 'Last 90 days',
        LAST_YEAR: 'Last year',
        TOP_CARPOOLERS: 'Top carpoolers of the period',
        TOP_CARPOOLERS_SUBTITLE:
          '#1 is the person who has driven the most km with passengers, detected automatically by the app.',
        EMPLOYEE: 'EMPLOYEE',
        OFFICE: 'OFFICE',
        KM_WITH_PASSENGERS: 'KM WITH PASSENGERS',
        KM_DRIVEN_TOTAL: 'KM DRIVEN (TOTAL)',
        TRIPS: 'TRIPS',
        KM: 'km',
        RGPD_NOTE: 'Names anonymized under GDPR. Initials only.',
        LOADING: 'Loading statistics...',
        LOAD_ERROR_TEXT: 'Statistics could not be loaded',
        LOAD_ERROR_MESSAGE: 'Error loading usage statistics',
        ACTIVE_USERS_BREAKDOWN: 'Active users breakdown',
        DAU: 'Active users today (DAU)',
        WAU: 'Active this week (WAU)',
        MAU: 'Active this month (MAU)',
        SHARED_TRIPS_MONTH: 'Shared trips this month',
        ACTIVE_USERS_PERIOD: 'Active in period',
        SHARED_TRIPS_PERIOD: 'Shared trips in period',
        ACTIVE_USERS: 'Active users',
        DRIVERS: 'Drivers',
        PASSENGERS: 'Passengers',
        COMPLETED_TRIPS: 'Completed trips',
      },
      CONVERSION_REPORT: {
        ROUTE_OUTBOUND: 'Outbound',
        ROUTE_RETURN: 'Return',
        ROUTE_ROUND_TRIP: 'Round trip',
        SELECT_MONTH_YEAR: 'Select month and year',
        INDICATORS: 'Indicators',
        INDICATOR: 'INDICATOR',
        INTERPRETATION: 'INTERPRETATION',
        NUMBER_OF_USERS: 'NUMBER OF USERS',
        SMART_SURVEY: 'Smart survey',
        RESPONSES_BY_INDICATOR: 'Responses by indicator',
        MOST_COMMON_REASONS: 'Most common reasons for not sharing a vehicle',
        STATS: {
          ACTIVE_USERS: 'Active users',
          CONVERSION_RATE_CARPOOLING: 'Conversion rate to carpooling',
          AVG_DAYS_FIRST_MATCH: 'Average days until first match',
          REJECTED_MATCHES: 'Rejected matches',
        },
        INDICATORS_LIST: {
          REJECTS_ALL_MATCHES: 'Rejects all matches',
          NEVER_CREATES_TRIPS: 'Never creates trips',
          LIVES_IN_AREA_WITHOUT_USERS: 'Lives in an area without other nearby users',
          USERS_WITH_WORST_RATINGS: 'Users with the worst ratings',
          USERS_WITH_COMPLAINTS: 'Users with complaints',
          USERS_WITH_LOW_ROUTINE_LOYALTY: 'Users with low routine loyalty',
          USERS_WITHOUT_PERMISSIONS: 'Users without permissions enabled',
          USERS_WITH_HIGH_CANCELLATION: 'Users with high cancellation rate',
        },
        INTERPRETATIONS: {
          DISTRUST_LACK_OF_INTEREST: 'Distrust / lack of interest',
          DOES_NOT_UNDERSTAND_UTILITY: 'Does not understand the utility or unclear interface',
        },
        RESPONSES: {
          SCHEDULE_CHANGES: 'My schedule changes a lot',
          NOBODY_NEARBY: 'Nobody near my area',
          PREFER_ALONE: 'I prefer to go alone',
          DID_NOT_KNOW: "I did not know I could do it",
          OTHER_REASON: 'Other reason',
        },
        REASONS: {
          VERY_SHY: 'I am very shy',
          NOT_CONVENIENT: 'It is not convenient for me',
          CHILDREN_TO_SCHOOL: 'I have to take my children to school',
          UNCOMFORTABLE_WITH_STRANGER: 'I feel uncomfortable not knowing my companion',
          OTHER_REASONS: 'Other reasons',
        },
        USERS_LABEL: 'users',
      },
      USER_LIST: {
        EMPLOYEES: 'Employees',
        STAFF: 'Staff',
        GROUPS: 'Groups',
        COMING_SOON: 'Coming soon',
        ALL_CENTERS: 'All centers',
        LAST_7_DAYS: 'Last 7 days',
        LAST_30_DAYS: 'Last 30 days',
        LAST_90_DAYS: 'Last 90 days',
        LAST_YEAR: 'Last year',
        DECLARED_STAFF: 'Declared staff',
        REGISTERED_IN_WAIIS: 'Linked in WAIIS',
        REGISTRATION_OF_STAFF: 'Registration (of staff)',
        ACTIVE_IN_USE_CARPOOLING: 'Active in use (carpooling)',
        SEARCH_NAME_OR_EMAIL: 'Search name or email',
        UPLOAD_CSV: 'Upload CSV',
        ADD_MANUAL: 'Add manually',
        LINK_USERS: 'Link users',
        ADD_INVITE_EMPLOYEES: 'Add employees',
        PARTNER_MANAGED_CHIP: 'Sign-ups managed by {{partner}}',
        PARTNER_EMPTY_TITLE: 'Your team will appear here',
        PARTNER_EMPTY_TEXT: '{{partner}} adds your employees. Here you will see who signs up and who uses the app.',
        ADD_INVITE_EMPLOYEES_MODAL_TITLE: 'Add or invite employees',
        CREATE_USER: 'Create user',
        ALL: 'All',
        ACTIVE: 'Active',
        REGISTERED: 'Registered',
        UNREGISTERED: 'Unregistered',
        STATUS_WITH_ROUTINE: 'With routine',
        STATUS_LINKED: 'Linked',
        STATUS_INACTIVE_FILTER: 'Inactive',
        STATUS_PENDING: 'Pending acceptance',
        STATUS_REJECTED: 'Rejected',
        EMPLOYEE_GROUPS: 'Employee groups',
        EMPLOYEE_GROUPS_SUBTITLE:
          'Organize employees and assign ride-hailing policies by collective.',
        CREATE_GROUP: 'Create group',
        GROUP_NAME: 'Group name',
        LINKED_POLICIES: 'Linked policies',
        EDIT: 'Edit',
        DELETE: 'Delete',
        ACTIVE_LABEL: 'Active',
        NAME: 'Name',
        SURNAME: 'Surname',
        EMAIL: 'Email',
        DEPARTMENT: 'Department',
        OFFICE: 'Office',
        SHIFT: 'Shift',
        FIELD_REQUIRED: 'This field is required',
        EMAIL_FORMAT_ERROR: 'Enter a valid email, e.g. name@company.com',
        DNI: 'ID number',
        PERSONAL_EMAIL: 'Personal email',
        PHONE: 'Phone',
        PHONE_FORMAT_ERROR: 'Include the country code, e.g. +34600000000',
        COMPANY_PHONE: 'Company phone',
        PARKING_PLACE: 'Parking place',
        LOADING: 'Loading...',
        CANCEL: 'Cancel',
        ACCEPT: 'Accept',
        WAIT: 'Wait..',
        IMPORT_CSV_BY_OFFICE: 'Import CSV by office',
        LINK_USERS_BY_OFFICE: 'Link users by office',
        CSV_FILE: 'CSV file',
        DOWNLOAD_TEMPLATE: 'Download sample template',
        DOWNLOADING_TEMPLATE: 'Downloading template...',
        IMPORT: 'Import',
        LINK: 'Link',
        EDIT_USER: 'Edit User',
        CREATE_USER_TITLE: 'Create User',
        COLUMN_EMPLOYEE: 'Employee',
        COLUMN_OFFICE_AREA: 'Office · Area',
        COLUMN_STATUS: 'Status',
        STATUS_ACTIVE: 'Active',
        STATUS_INACTIVE: 'Inactive',
        SELECT_OFFICE_ALERT: 'You must select an office',
        SEARCH_EMPLOYEE: 'Search employee',
        CLEAR_SEARCH: 'Clear search',
        NO_OFFICES: 'No offices available',
        OFFICES_LOAD_ERROR: 'Offices could not be loaded',
        RETRY: 'Retry',
        SUCCESS_TITLE: 'Success!',
        USER_UPDATED: 'User updated successfully!',
        USER_CREATED: 'User created successfully!',
        ERROR_TITLE: 'Error!',
        CONFIRM_BUTTON: 'Accept',
        LINK_SUCCESS: 'Users linked successfully',
        DELETE_SUCCESS: 'Employee deleted successfully',
        IMPORT_SUCCESS: 'Users imported successfully',
        LINK_ERROR: 'An error occurred while linking users',
        IMPORT_ERROR: 'An error occurred while importing users',
        CSV_INVALID_EXTENSION: 'The file must be a CSV (.csv)',
        CSV_INVALID_HEADERS: "The file doesn't match the template. Download it again and don't change the column names or order.",
        CSV_MODAL_TITLE: 'Upload CSV',
        CSV_MODAL_SUB: 'Using the template: one row per employee. Before importing you see how many rows are valid.',
        CSV_DROP: 'Drag your CSV here',
        CSV_DROP_HINT: 'or click to choose it. Template columns: name, surname, dni, email, phone, department.',
        CSV_DROP_CHANGE: 'Drag another one or click to change it.',
        CSV_VALID_ROW: '1 valid row',
        CSV_VALID_ROWS: '{{count}} valid rows',
        CSV_INVALID_ROW: "1 row with errors won't be imported (line {{lines}}). It needs a name, surname, department and an ID number, email or phone.",
        CSV_INVALID_ROWS: "{{count}} rows with errors won't be imported (lines {{lines}}). They need a name, surname, department and an ID number, email or phone.",
        CSV_PREVIEW_NAME: 'Name',
        CSV_PREVIEW_EMAIL: 'Email',
        CSV_MORE_ROWS: '+ {{count}} more',
        CSV_EMPTY: 'The file is empty',
        ITEMS_USERS: 'users',
        ITEMS_EMPLOYEES: 'employees',
        EMAIL_PLACEHOLDER: 'name@company.com',
        MOCK_GROUPS: {
          EXECUTIVES: 'Executives',
          EXECUTIVES_DESC: 'Senior management and C-level',
          MANAGERS: 'Managers',
          MANAGERS_DESC: 'Area leads and project managers',
          OPERATIONS: 'Operations',
          OPERATIONS_DESC: 'Operations team and night shift',
          GENERAL: 'General',
          GENERAL_DESC: 'Employees with no specific group assigned',
          POLICY_BUSINESS: 'Business travel',
          POLICY_NIGHT: 'Night shift',
          POLICY_COMMUTE: 'Daily commute',
        },
      },
      USER_DETAILS: {
        LOADING: 'Loading...',
        BACK: 'Back',
        EMPLOYEES: 'Employees',
        EMPLOYEE_INFO: 'Employee information',
        PAYMENTS: 'Payments',
        TRIPS: 'Trips',
        SUCCESS_RATE: 'Success rate',
        COMPLETE_PROFILE: 'Complete profile',
        PROFILE_DETAILS: 'Profile Details',
        ID: 'ID',
        NAME_AND_SURNAME: 'Name and Surname',
        DNI: 'ID number',
        EMAIL: 'Email',
        PHONE: 'Phone',
        CONTACT_PHONE: 'Contact phone',
        CONTACT_PHONE_TOOLTIP: 'Number associated with the user',
        OFFICE: 'Office',
        DEPARTMENT: 'Department',
        DEPARTMENT_TOOLTIP: 'Company department',
        SHIFT: 'Shift',
        ROLE: 'Role',
        ORIGIN: 'Origin',
        DESTINATION: 'Destination',
        PARKING: 'Parking',
        LINKED: 'Linked',
        ROUTINE_STATUS: 'Routine status',
        VERIFIED: 'Verified',
        UNKNOWN: 'Unknown',
      },
    },
    USER: {
      INNER: {
        SIGN_OUT: 'Sign Out',
        DASHBOARD_COMPANY: 'Company Dashboard',
        DASHBOARD_ADMIN: 'Admin Dashboard',
        LANGUAGE: 'Language',
      },
      TRIPS_COLUMNS: {
        BUTTON: 'Columns',
        TITLE: 'Visible columns',
        ROUTE: 'Trip',
        ROLE: 'Role',
        ROUTINE: 'Routine',
        STATUS: 'Status',
        FOOTPRINT: 'Footprint',
        FRAUD: 'Fraud',
        HIDDEN_ONE: '1 hidden',
        HIDDEN_MANY: '{{count}} hidden',
        RESET: 'Reset',
      },
    },
    SUPPORT_MESSAGE: {
      SHOW_MESSAGE: 'View message',
      HIDE_MESSAGE: 'Hide message',
      LANG_LABEL: 'Message language',
      SHOW_ALL: 'Show all',
      SHOW_LESS: 'Show less',
    },
    PRICING_EXPLAINER: {
      BUTTON: 'How is it calculated?',
      TITLE: 'How the price is calculated',
      LOADING: 'Loading values…',
      ERROR: 'The current values could not be loaded.',
      RETRY: 'Try again',
      PRICE: 'Trip price: {{perKm}} ct/km up to 200 km, with a minimum of €{{fixed}}. From 200 km, {{from200}} ct/km are added (from 400 km, {{from400}}; from 600 km, {{from600}}).',
      CAE: 'CAE bonus: {{perKm}} ct/km (max. 200 km). On trips free for the passenger, {{withoutCost}} ct/km. Up to {{maxTrips}} bonus trips per day.',
      COMMISSION: 'WAIIS commission: {{single}} % on one-off trips; {{firstMonth}} % in the first month of a routine and {{longTerm}} % after, + VAT {{tax}} % on the commission.',
      FORMULA: 'Passenger pays = price − CAE bonus and aids + commission. The driver receives the trip price. If the trip loses its CAE (competitor app or failed face check), the driver receives what the passengers pay minus the commission.',
      TIMING: 'Charged {{chargeHours}} h before the driver departs; pay-by deadline up to {{blockHours}} h before.',
      THIS_TRIP: 'On this trip:',
      TRIP_KM: '{{km}}',
      TRIP_PRICE: 'price {{amount}}',
      TRIP_CAE: 'CAE bonus {{amount}}',
      TRIP_COMMISSION_NO_PERCENT: 'commission {{amount}}',
    },
    // Detalle de un viaje (/travel/:id): pooling-route-detail y su página.
    TRIP_DETAIL: {
      APP_SHOWS_VERIFYING: "In the app: «Verificando»",
      APP_VERIFYING_HINT: "The trip is verified, but the driver has not been paid yet (payout deferred by cash delay or reinforced verification). Until then the app shows «Verificando» to the driver and the passengers.",
      LOADING: 'Loading trip…',
      RETRY: 'Retry',
      ERROR_TIMEOUT: 'The server did not respond in time. Please try again.',
      ERROR_LOAD: 'The trip could not be loaded.',
      PAGE: {
        BREADCRUMB_ARIA: 'Breadcrumb',
        PARENT: 'Activity management',
        TRIPS: 'Trips',
        TRIP: 'Trip',
        USERS: 'Users',
        USER: 'User profile',
        BACK: 'Back',
      },
      HEAD: {
        ROUTE_OF: 'Route by',
        DATE: 'Date',
        DEPARTURE: 'Departure',
        DISTANCE: 'Distance',
        PARTICIPANTS: 'Participants',
        COPY_ID: 'Copy ID',
        ID_COPIED: 'ID copied',
        SHOW_TECH: 'Show technical details',
        HIDE_TECH: 'Hide technical details',
        ZONES: 'Zones',
        ZONES_TEXT: '0–35 accept · 36–55 step-up · 56–74 review · 75–100 reject',
        DRIVER_ONE: '1 driver',
        PASSENGERS_ONE: '1 passenger',
        PASSENGERS_MANY: '{{n}} passengers',
      },
      STATUS: {
        pending: 'Pending verification',
        in_progress: 'In progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
        verified: 'Verified',
        rejected: 'Rejected',
        in_review: 'Under review',
        enhanced_review: 'Under review',
        SCHEDULED: 'Scheduled',
      },
      VERDICT: {
        UPCOMING: 'Scheduled trip · not taken yet, it will be verified afterwards',
        IN_REVIEW: 'Under review · the money is on hold',
        NEEDS_REVIEW_ONE: 'Needs review · 1 person still to verify',
        NEEDS_REVIEW_MANY: 'Needs review · {{n}} people still to verify',
        REJECTED_BY_SUPPORT: 'Rejected by support',
        REJECTED_PART_ONE: '1 person automatically rejected',
        REJECTED_PART_MANY: '{{n}} people automatically rejected',
        REJECTED_AUTO: 'Automatically rejected',
        ALL_VERIFIED: 'All verified · no action needed',
        VERIFIED_PAYOUT_HELD: 'Verified · the driver has not been paid yet',
        VERIFIED_PAYOUT_HELD_UNTIL: 'Verified · the driver is paid on {{date}}',
      },
      KPI: {
        ARIA: 'Trip indicators',
        VERIFICATION: 'Verification',
        VERIFICATION_HINT: 'GPS footprint of each person on the trip',
        VERIFIED_PEOPLE: 'people verified',
        COPRESENCE: 'Co-presence',
        COPRESENCE_HINT: 'Overlap of the GPS footprints',
        COPRESENCE_LOW: 'low (under 70%)',
        COPRESENCE_OK: 'sufficient',
        RISK: 'Fraud risk',
        RECOMMENDATION: 'Recommendation: {{action}}',
        ZONE_ACCEPT: 'Accept',
        ZONE_STEPUP: 'Step-up',
        ZONE_REVIEW: 'Review',
        ZONE_REJECT: 'Reject',
      },
      RISK: {
        LOW: 'Low risk',
        MODERATE: 'Moderate risk',
        HIGH: 'High risk',
        VERY_HIGH: 'Very high risk',
        NOT_CALCULATED: 'Risk not calculated',
        ACTION_ACCEPT: 'Accept',
        ACTION_STEPUP: 'Ask for extra verification',
        ACTION_REVIEW: 'Review manually',
        ACTION_REJECT: 'Reject',
      },
      MAP: {
        TITLE: 'Trip map and GPS footprints',
        COPRESENCE_BADGE: 'Co-presence {{value}}',
        COPRESENCE_CAPTION_LOW: 'Co-presence {{value}} confirmed (<70% → review).',
        COPRESENCE_CAPTION_OK: 'Co-presence {{value}} sufficient (≥70%).',
        LAYER_TRACE: 'Actual route (GPS)',
        LAYER_REFERENCE: 'Planned route of the matched driver',
        LAYER_FOOTPRINT: 'Footprint · {{name}}',
        WINDOW_TITLE: 'Footprint window shown',
        WINDOW_HINT: 'Narrows down, per person, the part of the loaded GPS footprint (±2h around the planned route) drawn on the map.',
        SHOW_DETAIL: 'Show details',
        HIDE: 'Hide',
        DRIVER_WINDOW_START: 'Start of the driver window',
        DRIVER_WINDOW_END: 'End of the driver window',
        WINDOW_START: 'Start of the window for {{name}}',
        WINDOW_END: 'End of the window for {{name}}',
        RESET_WINDOW: 'Reset to the full window',
        ORIGIN: 'Origin',
        DESTINATION: 'Destination',
        PICKUP: 'Pick-up · {{name}}',
        DROPOFF: 'Drop-off · {{name}}',
        PASSENGER_FALLBACK: 'passenger',
        LOADING: 'Loading map…',
        LOAD_ERROR: 'The map could not be loaded.',
      },
      ROLE: {
        DRIVER: 'Driver',
        PASSENGER: 'Passenger',
      },
      UNVERIFIED: {
        TITLE_ONE: '1 person still to verify',
        TITLE_MANY: '{{n}} people still to verify',
        TITLE_WHY: 'Why it was not verified',
        VERIFIED_OK_ONE: '1 person verified without issues',
        VERIFIED_OK_MANY: '{{n}} people verified without issues',
        PENDING_ONE: '1 pending',
        PENDING_MANY: '{{n}} pending',
        SUPPORT_SAY: 'If they contact support, tell them:',
        COPY_MESSAGE: 'Copy message',
        MESSAGE_COPIED: 'Message copied',
        COPY: 'Copy',
        COPIED: 'Copied',
        NO_DATA_REASON: 'No data yet: the app has not sent any location or the verification has not run.',
        OPEN_CHAT: 'Open chat',
        OPEN_CHAT_WITH: 'Open support chat with {{name}}',
        CHAT_ERROR: 'The support chat could not be opened. Please try again.',
      },
      FLAG: {
        RESERVATION_OK: 'Booking and schedule match',
        RESERVATION_BAD: 'Booking or schedule do not match',
        RESERVATION_NONE: 'No booking or schedule data',
        ORIGIN_OK: 'Reached the expected origin',
        ORIGIN_BAD: 'Did not reach the expected origin',
        ORIGIN_NONE: 'No location data at the origin',
        DESTINATION_OK: 'Reached the expected destination',
        DESTINATION_BAD: 'Did not reach the expected destination',
        DESTINATION_NONE: 'No location data at the destination',
        COVERAGE: 'Location coverage: {{pct}}%',
        COVERAGE_NONE: 'No location coverage data',
      },
      // Motivo de rechazo de la huella (`rejection_reason`), en lenguaje de
      // backoffice. Si llega uno nuevo, se pinta el texto del backend.
      REJECTION_REASON: {
        location_data_missing: 'No location data during the trip',
        origin_not_confirmed: 'Departure from the origin not confirmed',
        destination_not_confirmed: 'Arrival at the destination not confirmed',
        location_trace_incomplete: 'Incomplete location trace',
        route_not_compatible: 'Route not consistent with a car trip',
        copresence_not_confirmed: 'Co-presence not confirmed',
        multiple_devices: 'Several phones at the same time',
        mock_location: 'Mock location',
        network_failed: 'The network did not allow the location to be checked',
        trip_limit: 'Bonus trip limit reached',
        pattern_review: 'Under review due to an unusual pattern',
        competitor_app: 'Competitor app detected',
        shared_with_riders: 'Trip with the passengers not confirmed',
        shared_with_driver: 'Trip with the driver not confirmed',
        location_permission_missing: 'No location permission',
      },
      VERIFICATION: {
        TITLE: 'Footprint verification',
        COL_PERSON: 'Person',
        COL_ROLE: 'Role',
        COL_METHOD: 'Method',
        COL_REASON: 'Reason',
        COL_COPRESENCE: 'Co-presence',
        COL_COMPETITOR: 'Competitor app',
        COL_ORIGIN: 'Origin',
        COL_DESTINATION: 'Destination',
        COL_RESULT: 'Result',
        DETECTED: 'Detected',
        NOT_DETECTED: 'Not detected',
        STATE: {
          pending: 'Not verified',
          verified: 'Verified',
          rejected: 'Rejected',
        },
        COMPETITOR_CHECK: {
          unknown: 'Not checked',
          verified_clean: 'Checked, no competitor apps',
          detected: 'Checked, competitor app detected',
        },
      },
      // Fraude a mitad de viaje (EvaluateFraudMidTrip) y verificación facial
      FRAUD_DATA: {
        TITLE: 'Data team signals',
        SIGNAL_TIP: '{{title}}: {{text}} {{direction}}',
        HIGHER_BETTER: 'Higher = better.',
        HIGHER_WORSE: 'Higher = worse.',
        COL_SIGNALS: 'Signals',
        COL_COLLUSION_DRIVER: 'Collusion with the driver',
      },
      FRAUD_MIDTRIP: {
        TITLE: 'Mid-trip fraud',
        FAILURES: 'Not passed: {{count}}',
        SUMMARY: {
          requested: 'Face check requested',
          would_request: 'Would have been requested (shadow)',
          not_sampled: 'Would have been requested, outside the draw',
          not_requested: 'Evaluated, nothing requested',
        },
        HIDDEN_RESULT_HINT: 'The face check result shown here is the real one. The app does not show it to the person: it always says they passed. The trip stays in verification until the «Held until» date, pass or fail; then it is not rejected: if someone did not pass, Waiis does not fund the CAE of their leg (if it is the driver, of the whole trip), as with a competitor app. The rider pays nothing more; the driver is paid only what the rider paid.',
        COL_MODE: 'Mode',
        COL_REASON: 'Reason',
        COL_RISK: 'Risk',
        COL_SIGNALS: 'Signals',
        COL_EVALUATIONS: 'Evaluations',
        COL_RELEASE: 'Held until',
        LAST_EVALUATION: 'last: {{date}}',
        WOULD_HAVE_BEEN: 'Without the draw: {{reason}}',
        COL_FACE: 'Face check',
        ERRORS: 'No data from: {{sources}}',
        FIRST_TRIP: 'First trip',
        POSSIBLE_FRAUD: 'Possible fraud',
        SIMILARITY: '{{value}} % similarity',
        ATTEMPTS: '{{count}} attempts',
        MODE: {
          shadow: 'Shadow',
          enforce: 'Enforce',
        },
        REASON: {
          group_already_requested: 'Already requested on this trip',
          first_trip: 'First trip with possible fraud',
          high_score: 'High risk',
          cooldown: 'High risk, but someone in the car was asked recently',
          low_risk: 'Low risk',
          not_sampled: 'Would have been requested, but it was not drawn',
          whitelisted: 'Someone in the car is whitelisted: nobody is asked',
        },
        FACE: {
          not_requested: 'Not requested',
          pending: 'Pending',
          passed: 'Passed',
          failed: 'Not passed',
          inconclusive: 'Inconclusive',
          no_show: 'Not done',
        },
        FACE_REASON: {
          face_mismatch: 'Face does not match the ID',
          liveness_failed: 'Liveness check failed',
          reference_face_not_detected: 'No face in the ID selfie',
          liveness_not_completed: 'Check not finished',
          liveness_session_expired: 'Check expired',
          provider_unavailable: 'AWS did not respond',
        },
        SIGNAL: {
          emulator: 'Emulator',
          same_phone_in_group: 'Same phone as someone in the car',
          gps_identical_with_participant: 'GPS identical to someone in the car',
          clone_environment: 'Cloned app',
          wifi_during_trip: 'On Wi-Fi during the trip',
          prior_face_failure: 'Failed a face check before',
          shared_ip_with_participant: 'Same IP as someone in the car',
          phone_shared_with_other_account: 'Phone shared with another account',
          data_team_score: 'Data team score',
          no_sim: 'No SIM',
          no_whatsapp: 'No WhatsApp',
          no_whatsapp_no_sim: 'No WhatsApp and no SIM',
          many_devices: 'Many phones',
          no_life_outside_trips: 'No activity outside trips',
          rejected_trips: 'Rejected trips',
          driver_concentration: 'Almost always with this driver',
          adb_enabled: 'USB debugging on',
          collusion_with_participant: 'High collusion with someone in the car',
          face_passed_recently: 'Face check passed recently (subtracts)',
          different_ip_from_driver: 'IP different from the driver\'s (subtracts)',
        },
      },
      PARTICIPANTS: {
        TITLE: 'Participants',
        MATCH: 'match',
        COL_PERSON: 'Person',
        COL_TRIP_TYPE: 'Trip type',
        COL_ROUTE: 'Origin and destination',
        COL_KM: 'Km',
        COL_COPRESENCE: 'Co-presence',
        NO_IDENTITY: 'Identity not verified',
        NO_IDENTITY_TIP: 'Took this trip without a verified identity',
        NO_ADDRESS: 'No address',
        EMPTY: 'No matched passengers.',
      },
      KIND: {
        NONE: 'No routine',
        NONE_HINT: 'The trip is not linked to any routine',
        ROUTINE: 'Routine',
        ROUTINE_HINT: 'Regular trip repeated on the routine days',
        PUNCTUAL: 'One-off',
        PUNCTUAL_HINT: 'Trip on a specific day, not repeated',
        LONG_HINT: 'Long-distance one-off trip (over 200 km) that the passenger searched for in the app',
        LONG_NOTE: 'Long distance',
      },
      MONEY: {
        BALANCED_TIP: 'Passengers pay + aid − commission = what the driver receives',
        UNBALANCED_TIP: 'What comes in and what goes out do not match',
        PASSENGERS_ONE: '1 passenger',
        DRIVER_IN_BALANCE: 'In their balance',
        DRIVER_TO_PAY: 'Verified, payout pending',
        DRIVER_REJECTED: 'Trip not verified: no payout',
        DRIVER_HELD_CASH: 'Cash delay until {{when}}',
        DRIVER_HELD_REINFORCED: 'Held (reinforced) until {{when}}',
        DRIVER_HELD_IDENTITY: 'Held until the passenger verifies their identity',
        DRIVER_AFTER_TRIP: 'Will be paid after the trip',
        DRIVER_PENDING: '{{amount}} still to be paid',
        BREAKDOWN_SUB: 'What each passenger pays, which aid they get and how much reaches the driver.',
        SUM_ARIA: 'Trip money breakdown',
        PASSENGERS_PAY: 'Passengers pay',
        MINUS: '−{{amount}}',
        PASSENGERS_TIMES: '{{n}} × {{amount}}',
        DRIVER_TO_VERIFY: 'Waiting for the trip to be verified',
        CAE_EXCLUDED: {
          NOTE: 'No CAE: {{reason}}',
          REASON: {
            COMPETITOR_APP: 'competitor app',
            COMPETITOR_APP_NAMED: 'competitor app ({{apps}})',
            IDENTITY_NOT_VERIFIED: 'face check not passed',
            OTHER: 'excluded from CAE',
          },
          TIP: {
            COMPETITOR_APP_DRIVER: 'A competitor app was detected on the driver when verifying the trip. The passenger keeps their discount, but Waiis does not pay the CAE bonus: the driver gets what the passenger paid minus the commission.',
            COMPETITOR_APP_RIDER: 'A competitor app was detected on the passenger when verifying the trip. They keep their discount, but Waiis does not pay the CAE bonus for their leg: the driver gets what that passenger paid minus the commission.',
            IDENTITY_NOT_VERIFIED_DRIVER: 'The driver did not pass the face check. The passenger keeps their discount, but Waiis does not pay the CAE bonus: the driver gets what the passenger paid minus the commission.',
            IDENTITY_NOT_VERIFIED_RIDER: 'The passenger did not pass the face check. They keep their discount, but Waiis does not pay the CAE bonus for their leg: the driver gets what that passenger paid minus the commission.',
            OTHER: 'Waiis does not pay the CAE bonus for this trip: the driver gets what the passenger paid minus the commission.',
          },
        },
      },
      RESOLUTION: {
        TITLE: 'Decide on the trip',
        LAST: 'Latest:',
        UPCOMING_NOTE: 'You will be able to validate or reject this trip once it has taken place.',
        DECISION: 'Decision',
        APPLY_TO: 'Apply to',
        NOTIFY: 'User notification',
        NOTIFY_NONE: 'Do not notify the user',
        NOTIFY_WITH: 'Notify: {{channel}}',
        CHANNEL: {
          none: 'Do not notify',
          push: 'Push',
          email: 'Email',
          push_email: 'Push + Email',
        },
        VERDICT: {
          validate: 'Validated',
          reject: 'Rejected',
          enhanced_review: 'Put under review',
        },
        VALIDATE_TITLE: 'Validate',
        VALIDATE_WHAT: 'You accept the trip as valid, just as if the automatic verification had approved it.',
        VALIDATE_MONEY: 'In about 5 minutes the driver receives the share of each validated passenger.',
        REJECT_TITLE: 'Reject',
        REJECT_WHAT: 'You treat the trip as not taken: it does not count as shared.',
        REJECT_MONEY: 'In about 5 minutes each rejected passenger gets back what they paid in their wallet, and the driver does not receive their share.',
        CONFIRM_REJECT_ONE: 'Reject 1 participant',
        CONFIRM_REJECT_MANY: 'Reject {{n}} participants',
        CONFIRM_REVIEW_ONE: 'Put 1 participant under review',
        CONFIRM_REVIEW_MANY: 'Put {{n}} participants under review',
        CONFIRM_VERIFY_ONE: 'Verify 1 participant and pay',
        CONFIRM_VERIFY_MANY: 'Verify {{n}} participants and pay',
        PROCESSING: 'Processing…',
        CHECKING: 'Checking…',
        PAID: 'Paid',
        SELECT_ONE: 'Select at least one participant.',
        APPLIED: '{{verdict}} · applied.',
        APPLIED_MANY: '{{verdict}} · applied to {{n}} participants.',
        APPLIED_PARTIAL: '{{verdict}} · applied to {{ok}} of {{total}}.',
        FAILED_FOR: 'Could not be applied to: {{names}}.',
        SAVE_ERROR: 'The resolution could not be saved.',
        VERIFIED_PAID: 'Verified and paid: {{names}}.',
        NOT_COMPLETED: 'Could not be completed: {{names}}.',
        CANCELLED: 'Cancelled: nothing has been done.',
      },
      PAYOUT: {
        CONFIRM_TITLE: 'Verify and pay · {{name}}',
        CONFIRM: 'Verify and pay',
        CANCEL: 'Cancel',
        OK: 'OK',
        PARTIAL_TITLE: 'Partial payment',
        PARTIAL_TEXT: '{{prior}} had already been withdrawn from the passenger ({{ref}}), but the calculation now gives {{now}}. Nothing has been done: check the movements manually.',
        ERROR_TIMEOUT: 'The server did not respond in time.',
        ERROR_GENERIC: 'The operation could not be completed.',
        ERROR_TITLE: 'Error · {{name}}',
        MISSING_TITLE: 'Missing data',
        MISSING_TEXT: 'The passenger route has no calculated amounts or distance; the payment cannot be calculated.',
        OPTION: '{{label}} · driver {{amount}}',
        OPTION_RIDER: 'passenger −{{amount}}',
        ESTIMATE_NOTE: 'This route has no calculated amounts: it is estimated with the passenger\'s CAE rate per km ({{km}}).',
        RIDER_BALANCE: 'Passenger balance:',
        COMPUTED: 'Calculated amounts',
        TO_DRIVER: 'To the driver:',
        RIDER_SHARE: 'passenger {{amount}}',
        DEBIT: 'Withdrawn from the passenger:',
        BALANCE: 'balance {{balance}}',
        UNCOVERED: 'The passenger does not have enough balance for their share ({{amount}}; balance {{balance}}): only the CAE is paid.',
        PRODUCT: {
          pvp: 'PVP',
          coste0: 'Coste 0',
        },
        ROUTINE_KIND: {
          routine: 'Routine',
          punctual: 'One-off',
        },
      },
    },
    TRIP_CHARGE: {
      COLUMN: 'Charge',
      FILTER_ALL: 'Charge: all',
      FILTER_LABEL: 'Charge status',
      STATUS: {
        scheduled: 'Scheduled',
        charged: 'Charged',
        paid_to_driver: 'Paid to driver',
        refunded_to_wallet: 'Refunded to balance',
        released: 'Cancelled',
        failed: 'Declined',
        debt: 'Debt',
        legacy_hold: 'Legacy hold',
        not_applicable: 'No charge',
      },
      FAILED_LONG: 'Charge declined',
      SCHEDULED_AT: 'To be charged {{when}}',
      DEADLINE_AT: 'Pay by {{when}}',
      DRIVER_CHARGED: '{{charged}}/{{total}} charged',
      DRIVER_FAILED_ONE: '{{n}} declined',
      DRIVER_FAILED_MANY: '{{n}} declined',
      DRIVER_PAID: 'Paid ({{total}})',
      DRIVER_PAID_HELD: 'Credited {{credited}}/{{total}}',
      DRIVER_PAID_HELD_SUB: '{{n}} awaiting payout',
      PAID_HELD_SUB: 'Awaiting payout to the driver',
      DRIVER_REFUNDED: 'Refunded',
      WHEN: {
        TODAY: 'today {{time}}',
        TOMORROW: 'tomorrow {{time}}',
        YESTERDAY: 'yesterday {{time}}',
        TODAY_AT: 'today at {{time}}',
        TOMORROW_AT: 'tomorrow at {{time}}',
        DATE_AT: 'on {{date}} at {{time}}',
      },
      FAILURE: {
        NO_CARD: 'No saved card',
        DECLINED: 'The card was declined',
        INSUFFICIENT_FUNDS: 'Insufficient funds',
        EXPIRED_CARD: 'Expired card',
        INCORRECT_CVC: 'Incorrect CVC',
        AUTHENTICATION_REQUIRED: 'The bank asks to confirm the payment (3D Secure)',
        PROCESSING_ERROR: 'Bank error while processing the payment',
        OTHER: 'Other reason ({{code}})',
      },
      FRAUD: {
        review: 'Fraud review',
        reinforced_review: 'Reinforced verification',
        blocked: 'Blocked',
      },
      ATTEMPT: 'attempt {{n}} of {{max}}',
      ATTEMPT_ONLY: 'attempt {{n}}',
      CARD_GENERIC: 'card',
      ALERT: {
        TITLE: 'Could not charge {{amount}} to {{name}}',
        TITLE_DEBT: '{{name}} still owes {{amount}}',
        CARD_ONLY: 'The card {{card}} was declined.',
        DEBT: 'WAIIS has already paid the driver and the passenger account is blocked until they pay.',
        CHIP_DEBT: 'Debt',
        CHIP_DEADLINE: 'Pay by · {{when}}',
        CHIP_DEADLINE_PASSED: 'Deadline passed · {{when}}',
        CHIP_RETRY: 'Retry · {{when}}',
        DEADLINE_PASSED: 'The deadline passed {{when}}: their routines have been paused.',
        NEXT_RETRY: 'Next charge retry: {{when}}.',
        NEXT_ATTEMPT: 'Next attempt: {{when}}.',
        DEADLINE: 'If it is not paid {{when}}, their routines are paused.',
      },
      OPEN_CHAT: 'Open chat with the message',
      CHAT_ERROR: 'The support chat could not be opened. Please try again.',
      AIDS: {
        CAE_BONUS: 'CAE bonus',
        CORPORATION_SUBSIDY: 'Company subsidy',
        WAIIS_CONTRIBUTION: 'WAIIS contribution',
        COUPON: 'Coupon',
        DRIVER_DISCOUNT: 'Driver discount',
      },
      MONEY: {
        TITLE: 'Trip money',
        HINT: 'Hover over a step to see what it means',
        HOW: 'How is it calculated?',
        SUMMARY: {
          PAY: 'Passengers pay',
          COMMISSION: 'Commission',
          DRIVER_RECEIVES: 'Driver receives',
          BALANCED: 'Balanced',
          UNBALANCED: 'Off by {{amount}}',
        },
        COL: {
          PERSON: 'Person',
          AMOUNT: 'Amount',
          STATUS: 'Status',
          STEPS: 'Steps',
        },
        ROLE: {
          PASSENGER: 'Passenger',
          DRIVER: 'Driver',
        },
        HOLD_HOURS: '{{n}} h',
        HOLD_DAY: '{{n}} day',
        HOLD_DAYS: '{{n}} days',
        HOLD_SHORT: {
          cash_delay: 'Cash · {{days}}',
          pending_identity: 'Identity',
        },
        FRAUD_SHORT: {
          review: 'In review',
          reinforced_review: 'Reinforced',
          blocked: 'Blocked',
        },
        SOURCE: {
          BOTH: 'balance + card',
          WALLET: 'balance',
          CARD: 'card',
        },
        SPLIT_BOTH: '{{wallet}} from balance · {{cardAmount}} from {{card}}',
        SPLIT_CARD: '{{amount}} from {{card}}',
        SPLIT_WALLET: '{{amount}} from balance',
        REASON: {
          CHARGED: 'Awaiting verification',
          PAID: 'Paid on {{day}}',
          PAID_HELD: 'Awaiting payout to the driver · {{when}}',
          PAID_HELD_NO_DATE: 'Awaiting payout to the driver',
          REFUNDED: 'Trip not verified',
          RELEASED: 'Trip cancelled',
          SCHEDULED: 'To be charged on {{when}}',
          DEBT: 'Owes {{amount}}',
          LEGACY: 'Legacy system',
          DRIVER_PENDING: 'When the trip is verified',
          DRIVER_IN_BALANCE: 'In balance since {{day}}',
          DRIVER_IN_BALANCE_NO_DATE: 'Already in balance',
          DRIVER_HELD_CASH: 'Cash delay · reaches the balance {{when}}',
          DRIVER_HELD_CASH_NO_DATE: 'Cash delay',
          DRIVER_HELD_REINFORCED: 'Held (reinforced) · reaches the balance {{when}}',
          DRIVER_HELD_REINFORCED_NO_DATE: 'Held (reinforced)',
          DRIVER_HELD_IDENTITY: 'Held (identity) · reaches the balance once the passenger verifies their identity',
          DRIVER_HELD_IDENTITY_NO_DATE: 'Held (identity)',
          DRIVER_RELEASE: 'Released on {{day}}',
        },
        DRIVER_STATUS: {
          HELD: 'Held',
          PENDING: 'To receive',
          IN_BALANCE: 'In balance',
        },
        STEP: {
          SCHEDULED: 'Scheduled',
          CHARGED: 'Held',
          FAILED: 'Declined',
          DEADLINE: 'Pay by',
          DEADLINE_PASSED: 'Deadline passed',
          RETRY: 'Retry',
          VERIFYING: 'Verifying',
          TO_DRIVER: 'To driver',
          REFUNDED: 'Back to balance',
          RELEASED: 'Cancelled',
          TRIP_DONE: 'Arrival',
          IN_BALANCE: 'In balance',
          WITHDRAWABLE: 'Withdrawable',
          HELD: 'Held',
          RELEASE: 'Released',
          IN_REVIEW: 'review',
          IN_PROGRESS: 'in progress',
          VERIFIED: 'verified',
          NOT_VERIFIED: 'not verified',
        },
        TIP: {
          SCHEDULED: 'Charged 24 h before the driver departs',
          CHARGED: 'The money has been taken; WAIIS holds it until the trip is verified',
          FAILED: 'The bank or Stripe declined the charge',
          DEADLINE: 'If they do not pay before this time, their routines are paused',
          DEADLINE_PASSED: 'Expired: their routines are paused',
          RETRY: 'We will retry the charge automatically',
          VERIFYING: 'We check with the GPS footprint that the trip happened',
          TO_DRIVER: 'The money goes to the driver balance',
          REFUNDED: 'The trip was not verified: the money goes back to their WAIIS balance',
          RELEASED: 'The charge was cancelled: nothing was charged',
          TRIP_DONE: 'Trip arrival time',
          IN_BALANCE: 'The money goes into their app balance',
          WITHDRAWABLE: 'They can move it to their bank account',
          HELD_CASH: 'Payment review: the trip is verified, but the money does not reach the balance until the date shown (2 days at most)',
          HELD_REINFORCED: 'Reinforced verification: the money does not reach the balance until the date shown',
          HELD_IDENTITY: 'Identity pending: the money does not reach the balance until the passenger verifies their identity',
          RELEASE: 'A passenger has reinforced verification: the money is released {{days}} days later',
        },
        WRITE: 'Message them',
        MORE: 'View details',
        LEGEND: {
          SHOW: 'What each step means',
          COLORS: 'Colours',
          PASSENGER: 'Passenger',
          DRIVER: 'Driver',
          BOTH: 'Both',
          DOT: {
            done: 'Done',
            failed: 'Failed',
            next: 'Now',
            todo: 'Pending',
          },
          SHORT: {
            SCHEDULED: 'charged 24 h before',
            CHARGED: 'WAIIS holds the money',
            FAILED: 'the bank declined it',
            DEADLINE: 'if unpaid, routines pause',
            RETRY: 'charged again automatically',
            TO_DRIVER: 'now the driver\'s',
            REFUNDED: 'not verified, refunded',
            RELEASED: 'nothing is charged',
            TRIP_DONE: 'arrival time',
            IN_BALANCE: 'has the money',
            RELEASE: 'waiting, reinforced verification',
            WITHDRAWABLE: 'can move it to the bank',
            VERIFYING: 'GPS check',
            VALIDATED: 'support approves it',
          },
        },
        MANUAL: {
          VALIDATED: 'Validated by support',
          VALIDATED_TIP: 'Support approved the trip: the money goes to the driver as if it had been verified automatically',
          REASON: 'Validated by support',
          REASON_BY: 'Validated by {{name}}',
        },
        TABLE_TOGGLE: 'View the breakdown table',
        DETAIL: {
          BREAKDOWN: 'Price {{base}}{{aids}} + commission {{commission}} = pays {{pays}}',
          TODO_LABEL: 'What do they need to do?',
          FROM_PASSENGER: 'From {{name}}: {{amount}}',
          PAYOUTS: 'View Payments',
          NO_DATA: 'This environment does not send charge data yet.',
        },
        TODO: {
          NO: 'Nothing.',
          SCHEDULED: 'Nothing. They will be charged automatically {{when}}.',
          SCHEDULED_NO_DATE: 'Nothing. They will be charged automatically 24 h before the driver departs.',
          CHARGED: 'Nothing. WAIIS holds the money until the trip is verified.',
          CHARGED_REVIEW: 'Nothing. WAIIS holds the money until the review is resolved.',
          REFUNDED: 'Nothing. The amount went back to their WAIIS balance.',
          LEGACY: 'Nothing. It is a legacy charge (card hold).',
          FAILED: 'Add another card. If they do not do it {{when}}, their routines are paused.',
          FAILED_NO_DEADLINE: 'Add another card so the charge can go through.',
          PAY_PENDING: 'Pay what is owed: the debt is charged automatically when a valid card is added.',
          DEBT: 'Add a valid card to pay what is owed and unblock the account.',
        },
        PAYMENT_STATUS: 'Payment status',
        PAYMENT_STATUS_VALUES: {
          ok: 'Up to date',
          warning: 'Warning',
          blocked: 'Blocked',
          cancelled: 'Cancelled',
        },
        VERIFICATION: 'Verification',
        VERIFICATION_VALUES: {
          NORMAL: 'Normal',
          REVIEW: 'Manual review',
          REINFORCED: 'Reinforced: the driver is paid {{days}} days later',
          REINFORCED_NO_DAYS: 'Reinforced: the driver is paid later',
          BLOCKED: 'Blocked for fraud',
        },
        STRIPE: 'View in Stripe',
        RECEIPT: 'View receipt',
      },
      ECONOMIC: {
        DRIVER_PAYOUT: 'Driver payout',
        COL: {
          PRICE: 'Trip price',
          AIDS: 'Aids',
          COMMISSION: 'WAIIS commission',
          PAYS: 'Passenger pays',
          TO_DRIVER: 'To driver',
          RECEIPT: 'Receipt',
          PAYMENT: 'Payment',
          TOTAL: 'Total',
          FREE: 'Free',
          EXPECTED: 'Expected {{amount}}',
        },
        STATE: {
          PAID: 'Charged',
          MISMATCH: 'Mismatch',
          EXPECTED: 'Expected',
          TO_CHARGE: 'To be charged',
        },
        UPCOMING: 'Expected amounts: the passenger is charged 24 h before the driver departs and the driver is paid when the trip is verified',
      },
      SOURCE: {
        WALLET: 'Balance',
        CARD: 'Card',
        BANK: 'Bank account',
        PAID_ON: 'Paid on {{date}}',
        PAYOUT: {
          paid: 'Paid',
          pending: 'Pending',
          in_review: 'In review',
          failed: 'Failed',
        },
      },
    },
    ROLE: {
      TOTAL_USERS: 'Total users with this role: {{count}}',
      NO_PERMISSIONS: 'No permissions given...',
      AND_MORE: 'and {{count}} more...',
      VIEW_ROLE: 'View Role',
      EDIT_ROLE: 'Edit Role',
      ADD_NEW_ROLE: 'Add New Role',
      DETAILS_TITLE: 'Role Details',
      CLOSE: 'Close',
      USER_INFORMATION: 'User Information',
      ROLE_NAME: 'Role Name',
      NAME_REQUIRED: 'Role name is required',
      NAME_MINLENGTH: 'Role name must be at least 4 characters long',
      DISCARD: 'Discard',
      SUBMIT: 'Submit',
      PLEASE_WAIT: 'Please wait...',
      USERS_ASSIGNED: 'Users Assigned',
      COL_NAME: 'Name',
      COL_ROLE: 'Role',
      COL_LAST_LOGIN: 'Last Login',
      COL_JOINED_DATE: 'Joined Date',
      SUCCESS: 'Success!',
      ERROR: 'Error!',
      CREATED_SUCCESS: 'Role created successfully!',
      UPDATED_SUCCESS: 'Role updated successfully!',
      CONFIRM: 'Ok, got it!',
    },
    PERMISSION: {
      SEARCH: 'Search Permissions',
      ADD_PERMISSIONS: 'Add Permissions',
      DETAILS_TITLE: 'Permission Details',
      CLOSE: 'Close',
      USER_INFORMATION: 'User Information',
      NAME: 'Name',
      NAME_REQUIRED: 'Permission name is required',
      NAME_MINLENGTH: 'Permission name must be at least 4 characters long',
      DISCARD: 'Discard',
      SUBMIT: 'Submit',
      PLEASE_WAIT: 'Please wait...',
      COL_NAME: 'Name',
      COL_ASSIGNED_TO: 'Assigned To',
      COL_CREATED_DATE: 'Created Date',
      SUCCESS: 'Success!',
      ERROR: 'Error!',
      CREATED_SUCCESS: 'Permission created successfully!',
      UPDATED_SUCCESS: 'Permission updated successfully!',
      CONFIRM: 'Ok, got it!',
    },
    SHARED: {
      FILTER_SIDEBAR: {
        FILTERS: 'Filters',
        DATE_PLACEHOLDER: 'Select date',
        APPLY: 'Apply filters',
        CLEAR: 'Clear',
        CLOSE: 'Close',
      },
      TABLE_EDITABLE: {
        CREATE: 'Create',
        ACTIONS: 'Actions',
        SAVING: 'Saving...',
        SAVE: 'Save',
        CANCEL: 'Cancel',
        EDIT: 'Edit',
        NO_DATA: 'No data available to display',
        SHOWING: 'Showing {{shown}} of {{total}}',
        ITEMS: 'records',
        HINT: 'Click the pencil to edit a row and save the changes with ✓.',
        SAVED: 'Saved',
        SAVE_ERROR: 'Could not save',
        CREDITS_TITLE: 'All credit types',
        CREDITS_ITEMS: 'credit types',
        COMMISSIONS_TITLE: 'All commissions',
        COMMISSIONS_ITEMS: 'commissions',
        COL_ID: 'ID',
        COL_TYPE: 'Type',
        COL_DESCRIPTION: 'Description',
        COL_VALUE: 'Value',
      },
      ENTITY_LABELS: {
        TITLE: 'Labels',
        REMOVE_ARIA: 'Remove label {{name}}',
        EMPTY: 'No labels',
        ADD: 'Add label',
        SEARCH_PLACEHOLDER: 'Search or create a label…',
        SHARED_SCOPE: 'shared',
        ALREADY_ASSIGNED: 'That label is already assigned.',
        NONE_AVAILABLE: 'No more labels available.',
        CREATE: 'Create “{{name}}”',
        ASSIGN_ERROR: 'Could not assign the label.',
        NAME_INVALID: 'The name must contain at least one letter or number.',
        CREATE_ERROR: 'Could not create the label.',
        REMOVE_ERROR: 'Could not remove the label.',
        CATALOG_ERROR: 'Could not load the label catalogue.',
      },
      QUILL: {
        NORMAL: 'Normal',
        HEADING_1: 'Heading 1',
        HEADING_2: 'Heading 2',
        HEADING_3: 'Heading 3',
        VISIT_URL: 'Visit URL:',
        ENTER_LINK: 'Enter link:',
        EDIT: 'Edit',
        REMOVE: 'Remove',
        SAVE: 'Save',
      },
      // Campo de fecha / hora (shared/components/bo-date-input)
      DATE_INPUT: {
        OPEN_CALENDAR: 'Open calendar',
        OPEN_TIME: 'Choose time',
        CALENDAR: 'Calendar',
        TIME: 'Time',
        HOURS: 'Hours',
        MINUTES: 'Minutes',
        HOUR_UP: 'One hour later',
        HOUR_DOWN: 'One hour earlier',
        MINUTE_UP: 'One minute later',
        MINUTE_DOWN: 'One minute earlier',
        TODAY: 'Today',
        NOW: 'Now',
        CLEAR: 'Clear',
        DONE: 'Done',
        FORMAT_DATE: 'dd/mm/yyyy',
        FORMAT_DATETIME: 'dd/mm/yyyy hh:mm',
        FORMAT_TIME: 'hh:mm',
        PREV_MONTH: 'Previous month',
        NEXT_MONTH: 'Next month',
        MONTH: 'Month',
        YEAR: 'Year',
      },
    },
    LAYOUT: {
      SHOW_SIDEBAR_MENU: 'Show sidebar menu',
      SHOW_HEADER_MENU: 'Show header menu',
      REFRESH_PROFILE: 'Refresh profile',
      HIDE_ENV_BAR: 'Hide environment bar',
    },
    ERROR_PAGES: {
      NOT_FOUND_TITLE: 'Oops!',
      NOT_FOUND_TEXT: 'We can’t find that page.',
      SERVER_TITLE: 'System error',
      SERVER_TEXT: 'Something went wrong. Please try again later.',
      HOME: 'Return home',
    },
  },
};
